export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** Binary content encoded as a Base64 string. Supply the encoded bytes without a data-URL prefix. */
  Binary: { input: string; output: string; }
  /**
   * CSS hexadecimal color string: #RGB, #RGBA, #RRGGBB or #RRGGBBAA. Returned in lowercase as
   * #RRGGBB when opaque, otherwise #RRGGBBAA; alpha 00 is transparent and ff is opaque.
   */
  Color: { input: string; output: string; }
  /** Calendar date as an ISO 8601 string, for example "2026-10-28". No time or time zone. */
  Date: { input: string; output: string; }
  /**
   * Date and time as an ISO 8601 string with a required UTC offset, for example
   * "2026-10-28T09:30:00Z" or "2026-10-28T10:30:00+01:00". Fractional seconds are supported.
   */
  DateTime: { input: string; output: string; }
  /**
   * A JSON value: an object, array, string, number, boolean or null. Fields using this scalar describe
   * their own payload shape; arbitrary JSON does not imply that every field accepts every shape.
   */
  Object: { input: Record<string, unknown>; output: Record<string, unknown>; }
  /**
   * Universally unique identifier represented as a hyphenated hexadecimal string,
   * for example "123e4567-e89b-12d3-a456-426614174000".
   */
  UUID: { input: string; output: string; }
};

/** A flat membership group. Membership alone does not share personal data or publish content. */
export type AccessGroup = {
  __typename?: 'AccessGroup';
  canDelete: Scalars['Boolean']['output'];
  canManageMembers: Scalars['Boolean']['output'];
  canManageRoles: Scalars['Boolean']['output'];
  /** Backend action eligibility for the current caller. */
  canUpdate: Scalars['Boolean']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** Whether the identity is maintained by the system; membership management may still be manual. */
  isSystem: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  /** Organizational source; its name and direct roster are maintained through this OrgUnit. */
  orgUnitId?: Maybe<Scalars['ID']['output']>;
};

/** The filterable fields of type AccessGroup */
export type AccessGroupFilterInput = {
  and?: InputMaybe<Array<AccessGroupFilterInput>>;
  not?: InputMaybe<AccessGroupFilterInput>;
  or?: InputMaybe<Array<AccessGroupFilterInput>>;
};

export type AccessGroupMember = {
  __typename?: 'AccessGroupMember';
  memberships: Array<AccessGroupMembership>;
  /** Subject to Person visibility and personal field-sharing consent. */
  person?: Maybe<Person>;
  personId: Scalars['ID']['output'];
};

/** The filterable fields of type AccessGroupMember */
export type AccessGroupMemberFilterInput = {
  and?: InputMaybe<Array<AccessGroupMemberFilterInput>>;
  not?: InputMaybe<AccessGroupMemberFilterInput>;
  or?: InputMaybe<Array<AccessGroupMemberFilterInput>>;
};

/** Manual membership only. There is no writable source, nested group, or direct Person-role input. */
export type AccessGroupMemberInput = {
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  groupId: Scalars['ID']['input'];
  personId: Scalars['ID']['input'];
};

export type AccessGroupMembersResult = {
  __typename?: 'AccessGroupMembersResult';
  hasNextPage: Scalars['Boolean']['output'];
  members: Array<AccessGroupMember>;
  nextAfter?: Maybe<Scalars['ID']['output']>;
};

/** The filterable fields of type AccessGroupMembersResult */
export type AccessGroupMembersResultFilterInput = {
  and?: InputMaybe<Array<AccessGroupMembersResultFilterInput>>;
  not?: InputMaybe<AccessGroupMembersResultFilterInput>;
  or?: InputMaybe<Array<AccessGroupMembersResultFilterInput>>;
};

/** One independent assertion of membership. Identity assertions can only be changed at their source. */
export type AccessGroupMembership = {
  __typename?: 'AccessGroupMembership';
  canRemove: Scalars['Boolean']['output'];
  source: GroupMembershipSource;
};

/** The filterable fields of type AccessGroupMembership */
export type AccessGroupMembershipFilterInput = {
  and?: InputMaybe<Array<AccessGroupMembershipFilterInput>>;
  not?: InputMaybe<AccessGroupMembershipFilterInput>;
  or?: InputMaybe<Array<AccessGroupMembershipFilterInput>>;
};

/** A Role assigned on a Group. Its id addresses this relationship within that Group. */
export type AccessGroupRoleAssignment = {
  __typename?: 'AccessGroupRoleAssignment';
  canRemove: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  roleId: Scalars['ID']['output'];
  roleName: Scalars['String']['output'];
  scope: AccessScope;
};

/** The filterable fields of type AccessGroupRoleAssignment */
export type AccessGroupRoleAssignmentFilterInput = {
  and?: InputMaybe<Array<AccessGroupRoleAssignmentFilterInput>>;
  not?: InputMaybe<AccessGroupRoleAssignmentFilterInput>;
  or?: InputMaybe<Array<AccessGroupRoleAssignmentFilterInput>>;
};

export type AccessGroupsResult = {
  __typename?: 'AccessGroupsResult';
  groups: Array<AccessGroup>;
  hasNextPage: Scalars['Boolean']['output'];
  nextAfter?: Maybe<Scalars['ID']['output']>;
};

/** The filterable fields of type AccessGroupsResult */
export type AccessGroupsResultFilterInput = {
  and?: InputMaybe<Array<AccessGroupsResultFilterInput>>;
  not?: InputMaybe<AccessGroupsResultFilterInput>;
  or?: InputMaybe<Array<AccessGroupsResultFilterInput>>;
};

export type AccessInspectionGroup = {
  __typename?: 'AccessInspectionGroup';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  orgUnitId?: Maybe<Scalars['ID']['output']>;
  roles: Array<AccessInspectionRole>;
  sources: Array<GroupMembershipSource>;
};

/** The filterable fields of type AccessInspectionGroup */
export type AccessInspectionGroupFilterInput = {
  and?: InputMaybe<Array<AccessInspectionGroupFilterInput>>;
  not?: InputMaybe<AccessInspectionGroupFilterInput>;
  or?: InputMaybe<Array<AccessInspectionGroupFilterInput>>;
};

export type AccessInspectionRole = {
  __typename?: 'AccessInspectionRole';
  assignmentId: Scalars['ID']['output'];
  code: Scalars['String']['output'];
  isSystem: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  permissionCodes: Array<Scalars['String']['output']>;
  roleId: Scalars['ID']['output'];
  scope: AccessScope;
};

/** The filterable fields of type AccessInspectionRole */
export type AccessInspectionRoleFilterInput = {
  and?: InputMaybe<Array<AccessInspectionRoleFilterInput>>;
  not?: InputMaybe<AccessInspectionRoleFilterInput>;
  or?: InputMaybe<Array<AccessInspectionRoleFilterInput>>;
};

export enum AccessLevel {
  Read = 'READ',
  Write = 'WRITE'
}

/** Read-only deployment configuration for login-derived Group membership. */
export type AccessMembershipPolicy = {
  __typename?: 'AccessMembershipPolicy';
  /** Verified email domains granting Employee membership; empty disables domain-based assignment. */
  employeeEmailDomains: Array<Scalars['String']['output']>;
};

/** The filterable fields of type AccessMembershipPolicy */
export type AccessMembershipPolicyFilterInput = {
  and?: InputMaybe<Array<AccessMembershipPolicyFilterInput>>;
  not?: InputMaybe<AccessMembershipPolicyFilterInput>;
  or?: InputMaybe<Array<AccessMembershipPolicyFilterInput>>;
};

/** A supported Permission. Read-only; description comes from the Genesis catalog. */
export type AccessPermission = {
  __typename?: 'AccessPermission';
  code: Scalars['String']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

/** The filterable fields of type AccessPermission */
export type AccessPermissionFilterInput = {
  and?: InputMaybe<Array<AccessPermissionFilterInput>>;
  not?: InputMaybe<AccessPermissionFilterInput>;
  or?: InputMaybe<Array<AccessPermissionFilterInput>>;
};

export type AccessPermissionsResult = {
  __typename?: 'AccessPermissionsResult';
  permissions: Array<AccessPermission>;
};

/** The filterable fields of type AccessPermissionsResult */
export type AccessPermissionsResultFilterInput = {
  and?: InputMaybe<Array<AccessPermissionsResultFilterInput>>;
  not?: InputMaybe<AccessPermissionsResultFilterInput>;
  or?: InputMaybe<Array<AccessPermissionsResultFilterInput>>;
};

/** Administrative snapshot of one active person's Group-derived access; resource-specific checks remain separate. */
export type AccessPersonInspection = {
  __typename?: 'AccessPersonInspection';
  globalPermissionCodes: Array<Scalars['String']['output']>;
  groups: Array<AccessInspectionGroup>;
  personId: Scalars['ID']['output'];
};

/** The filterable fields of type AccessPersonInspection */
export type AccessPersonInspectionFilterInput = {
  and?: InputMaybe<Array<AccessPersonInspectionFilterInput>>;
  not?: InputMaybe<AccessPersonInspectionFilterInput>;
  or?: InputMaybe<Array<AccessPersonInspectionFilterInput>>;
};

/** A reusable bundle of supported Permissions, assigned within an explicit scope on a Group. */
export type AccessRole = {
  __typename?: 'AccessRole';
  /** Distinct persons across all current Group memberships; not the sum of assignment rows. */
  assignedPersonCount: Scalars['Int']['output'];
  assignments: Array<AccessRoleAssignment>;
  canDelete: Scalars['Boolean']['output'];
  /** Backend lifecycle eligibility; mutation authorization is rechecked when saving. */
  canUpdate: Scalars['Boolean']['output'];
  code: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** At least one Group has this Role, including Groups with no current members. */
  isInUse: Scalars['Boolean']['output'];
  isSystem: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  permissions: Array<AccessPermission>;
  /** Scopes compatible with every Permission in this bundle. */
  supportedScopes: Array<AccessScopeKind>;
};

/** A scoped Role relationship on a Group; no standalone Grant catalog. */
export type AccessRoleAssignment = {
  __typename?: 'AccessRoleAssignment';
  groupId: Scalars['ID']['output'];
  groupName: Scalars['String']['output'];
  /** Addresses this relationship together with groupId. */
  id: Scalars['ID']['output'];
  personCount: Scalars['Int']['output'];
  scope: AccessScope;
};

/** The filterable fields of type AccessRoleAssignment */
export type AccessRoleAssignmentFilterInput = {
  and?: InputMaybe<Array<AccessRoleAssignmentFilterInput>>;
  not?: InputMaybe<AccessRoleAssignmentFilterInput>;
  or?: InputMaybe<Array<AccessRoleAssignmentFilterInput>>;
};

/** The filterable fields of type AccessRole */
export type AccessRoleFilterInput = {
  and?: InputMaybe<Array<AccessRoleFilterInput>>;
  not?: InputMaybe<AccessRoleFilterInput>;
  or?: InputMaybe<Array<AccessRoleFilterInput>>;
};

/** Advisory impact of a proposed bundle; saving rechecks current assignments. Other sources may retain removed rights. */
export type AccessRoleImpact = {
  __typename?: 'AccessRoleImpact';
  addedPermissions: Array<AccessPermission>;
  canSave: Scalars['Boolean']['output'];
  groups: Array<AccessRoleImpactGroup>;
  groupsHasNextPage: Scalars['Boolean']['output'];
  groupsNextAfter?: Maybe<Scalars['ID']['output']>;
  peopleHasNextPage: Scalars['Boolean']['output'];
  peopleNextAfter?: Maybe<Scalars['ID']['output']>;
  /** Active holder ids are configuration metadata, not permission to read their profiles. At most 50 per page. */
  personIds: Array<Scalars['ID']['output']>;
  removedPermissions: Array<AccessPermission>;
};

/** The filterable fields of type AccessRoleImpact */
export type AccessRoleImpactFilterInput = {
  and?: InputMaybe<Array<AccessRoleImpactFilterInput>>;
  not?: InputMaybe<AccessRoleImpactFilterInput>;
  or?: InputMaybe<Array<AccessRoleImpactFilterInput>>;
};

export type AccessRoleImpactGroup = {
  __typename?: 'AccessRoleImpactGroup';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

/** The filterable fields of type AccessRoleImpactGroup */
export type AccessRoleImpactGroupFilterInput = {
  and?: InputMaybe<Array<AccessRoleImpactGroupFilterInput>>;
  not?: InputMaybe<AccessRoleImpactGroupFilterInput>;
  or?: InputMaybe<Array<AccessRoleImpactGroupFilterInput>>;
};

/** Minimal identity for the read-only Role assignment list; ordinary Person read checks apply. */
export type AccessRoleMember = {
  __typename?: 'AccessRoleMember';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  /** Subject to Person visibility and personal field-sharing consent. */
  person?: Maybe<Person>;
};

/** The filterable fields of type AccessRoleMember */
export type AccessRoleMemberFilterInput = {
  and?: InputMaybe<Array<AccessRoleMemberFilterInput>>;
  not?: InputMaybe<AccessRoleMemberFilterInput>;
  or?: InputMaybe<Array<AccessRoleMemberFilterInput>>;
};

export type AccessRoleMembersResult = {
  __typename?: 'AccessRoleMembersResult';
  hasNextPage: Scalars['Boolean']['output'];
  members: Array<AccessRoleMember>;
  /** Last returned Person id, used unchanged as after for the next page. */
  nextAfter?: Maybe<Scalars['ID']['output']>;
};

/** The filterable fields of type AccessRoleMembersResult */
export type AccessRoleMembersResultFilterInput = {
  and?: InputMaybe<Array<AccessRoleMembersResultFilterInput>>;
  not?: InputMaybe<AccessRoleMembersResultFilterInput>;
  or?: InputMaybe<Array<AccessRoleMembersResultFilterInput>>;
};

export type AccessRolesResult = {
  __typename?: 'AccessRolesResult';
  roles: Array<AccessRole>;
};

/** The filterable fields of type AccessRolesResult */
export type AccessRolesResultFilterInput = {
  and?: InputMaybe<Array<AccessRolesResultFilterInput>>;
  not?: InputMaybe<AccessRolesResultFilterInput>;
  or?: InputMaybe<Array<AccessRolesResultFilterInput>>;
};

export type AccessScope = {
  __typename?: 'AccessScope';
  groupId?: Maybe<Scalars['ID']['output']>;
  groupName?: Maybe<Scalars['String']['output']>;
  kind: AccessScopeKind;
};

/** The filterable fields of type AccessScope */
export type AccessScopeFilterInput = {
  and?: InputMaybe<Array<AccessScopeFilterInput>>;
  not?: InputMaybe<AccessScopeFilterInput>;
  or?: InputMaybe<Array<AccessScopeFilterInput>>;
};

export type AccessScopeInput = {
  groupId?: InputMaybe<Scalars['ID']['input']>;
  kind: AccessScopeKind;
};

/** Closed set of supported Group Role assignment scopes. */
export enum AccessScopeKind {
  Global = 'GLOBAL',
  GroupMembers = 'GROUP_MEMBERS',
  ManagedPeople = 'MANAGED_PEOPLE'
}

/** Execute one of the actions offered by an actionable notification. */
export type ActOnNotificationInput = {
  /** The action to execute. */
  action: NotificationActionType;
  /** The notification to act on. */
  notificationId: Scalars['UUID']['input'];
};

export type ActiveQuestionnairesByElementInput = {
  element: CreativityElement;
};

export type AddContactsInput = {
  contacts: Array<Scalars['UUID']['input']>;
  groups?: InputMaybe<Array<Scalars['UUID']['input']>>;
  person?: InputMaybe<Scalars['UUID']['input']>;
  removeContactsFromOtherGroups?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AddContactsOutput = AddContactsResult | DailyQuotaExceeded | TooManyRecordsResult;

export type AddContactsResult = {
  __typename?: 'AddContactsResult';
  contactsAdded: Array<Scalars['UUID']['output']>;
};

/** The filterable fields of type AddContactsResult */
export type AddContactsResultFilterInput = {
  and?: InputMaybe<Array<AddContactsResultFilterInput>>;
  not?: InputMaybe<AddContactsResultFilterInput>;
  or?: InputMaybe<Array<AddContactsResultFilterInput>>;
};

export type AddPinsInput = {
  groups?: InputMaybe<Array<Scalars['UUID']['input']>>;
  person?: InputMaybe<Scalars['UUID']['input']>;
  persons?: InputMaybe<Array<Scalars['UUID']['input']>>;
  removePinsFromOtherGroups?: InputMaybe<Scalars['Boolean']['input']>;
  sharedItems?: InputMaybe<Array<Scalars['UUID']['input']>>;
};

export type AddPinsOutput = AddPinsResult | DailyQuotaExceeded | TooManyRecordsResult;

export type AddPinsResult = {
  __typename?: 'AddPinsResult';
  personsPinned?: Maybe<Array<Scalars['UUID']['output']>>;
  sharedItemsPinned?: Maybe<Array<Scalars['UUID']['output']>>;
};

/** The filterable fields of type AddPinsResult */
export type AddPinsResultFilterInput = {
  and?: InputMaybe<Array<AddPinsResultFilterInput>>;
  not?: InputMaybe<AddPinsResultFilterInput>;
  or?: InputMaybe<Array<AddPinsResultFilterInput>>;
};

export enum AdministrativeGender {
  Female = 'FEMALE',
  Male = 'MALE',
  Other = 'OTHER',
  Unknown = 'UNKNOWN'
}

/**
 * An AI agent product available as project context. An agent is not a Person or a team member and
 * occupies no team seat. Any authenticated caller can read agents; creating, updating and deleting
 * requires `write:reference-data`. Deletion is permanent; existing match design snapshots are retained.
 *
 * Page `agents` with `first`/`after` or `skip`/`take`, at most 100 per page. The default order is by name;
 * `order` and `where` customize ordering and filtering. `id: {in: [...]}` selects known ids.
 * `updateAgent` requires `name`, `vendor` and `integrations`. Other supplied fields replace their
 * previous values, including entire lists; omitted fields remain unchanged.
 *
 * Prose fields contain German and English, with null for an absent language. Their `localized` value
 * falls back to the other language. Product names, vendor names, tool names and integrations are
 * single-language product terms.
 */
export type Agent = Node & {
  __typename?: 'Agent';
  /** Capability areas described in plain text. */
  covers: Array<LocalizedText>;
  guardrails: Array<LocalizedText>;
  /** Filter with `id: {in: [...]}` to resolve a set of agents, e.g. `globalSearch` hits or a match's stored ids. */
  id: Scalars['ID']['output'];
  /** The integration surface as the vendor names it (MCP servers, connectors, plugins). Product tokens. */
  integrations: Array<Scalars['String']['output']>;
  /** The model, when known. */
  model?: Maybe<Scalars['String']['output']>;
  /** Product name. Must not be blank. `agents` orders by it unless `order` says otherwise. */
  name: Scalars['String']['output'];
  /** What the agent does. At least one of german / english must be non-blank. */
  role: LocalizedText;
  tools: Array<AgentTool>;
  /** The vendor's product page. */
  url?: Maybe<Scalars['String']['output']>;
  /** The vendor's name. Must not be blank. */
  vendor: Scalars['String']['output'];
};

export type AgentConnection = {
  __typename?: 'AgentConnection';
  edges: Array<AgentEdge>;
  nodes: Array<Agent>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AgentEdge = {
  __typename?: 'AgentEdge';
  cursor: Scalars['String']['output'];
  node: Agent;
};

/** The filterable fields of type Agent */
export type AgentFilterInput = {
  and?: InputMaybe<Array<AgentFilterInput>>;
  /** Filter with `id: {in: [...]}` to resolve a set of agents, e.g. `globalSearch` hits or a match's stored ids. */
  id?: InputMaybe<IdFilterInput>;
  /** Product name. Must not be blank. `agents` orders by it unless `order` says otherwise. */
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<AgentFilterInput>;
  or?: InputMaybe<Array<AgentFilterInput>>;
};

/** The parameters for requesting multiple instances of Agent. Mixing fields of cursor-based and offset-based pagination will result in an error. */
export type AgentQueryInput = {
  /** Cursor-based pagination: The immediate successor of this cursor will be the first entry of the requested page */
  after?: InputMaybe<Scalars['String']['input']>;
  /** Cursor-based pagination: The immediate predecessor of this cursor will be last entry of the requested page */
  before?: InputMaybe<Scalars['String']['input']>;
  /** Cursor-based pagination: Number of rows to be returned. Use in conjunction with 'after' */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** Cursor-based pagination: Number of rows to be returned. Use in conjunction with 'before' */
  last?: InputMaybe<Scalars['Int']['input']>;
  /** The sorting order of the instances */
  order?: InputMaybe<AgentSortInput>;
  /** Offset-based pagination: Number of rows to skip */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Offset-based pagination: Number of rows to be returned */
  take?: InputMaybe<Scalars['Int']['input']>;
  /** The filter to be applied */
  where?: InputMaybe<AgentFilterInput>;
};

export type AgentSortInput = {
  /** Filter with `id: {in: [...]}` to resolve a set of agents, e.g. `globalSearch` hits or a match's stored ids. */
  id?: InputMaybe<SortOrder>;
  /** Product name. Must not be blank. `agents` orders by it unless `order` says otherwise. */
  name?: InputMaybe<SortOrder>;
};

/** One tool of an Agent. */
export type AgentTool = {
  __typename?: 'AgentTool';
  description: LocalizedText;
  /** Product token, never translated. */
  name: Scalars['String']['output'];
};

/** The filterable fields of type AgentTool */
export type AgentToolFilterInput = {
  and?: InputMaybe<Array<AgentToolFilterInput>>;
  not?: InputMaybe<AgentToolFilterInput>;
  or?: InputMaybe<Array<AgentToolFilterInput>>;
};

export type ApplicationError = {
  correlationId?: Maybe<Scalars['String']['output']>;
  errorCode?: Maybe<Scalars['String']['output']>;
  errorId?: Maybe<Scalars['String']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
};

/** The filterable fields of type ApplicationError */
export type ApplicationErrorFilterInput = {
  and?: InputMaybe<Array<ApplicationErrorFilterInput>>;
  not?: InputMaybe<ApplicationErrorFilterInput>;
  or?: InputMaybe<Array<ApplicationErrorFilterInput>>;
};

/** Apply to a listing with at most five documents, each at most 10 MiB. */
export type ApplyToListingInput = {
  /**
   * The language the applicant explicitly chose in the form for mails about this application. Stored with the
   * application like the form language of a public application; absent means the instance language. Never derived from
   * the interface language of the person applying.
   */
  communicationLanguage?: InputMaybe<CommunicationLanguage>;
  /** Company name for a company application; omit for a personal application. */
  companyName?: InputMaybe<Scalars['String']['input']>;
  contact?: InputMaybe<ListingApplicationContactInput>;
  documents?: InputMaybe<Array<ListingApplicationDocumentInput>>;
  listingId: Scalars['UUID']['input'];
};

export type ApplyToListingOutput = ApplyToListingResult;

export type ApplyToListingResult = {
  __typename?: 'ApplyToListingResult';
  application: ListingApplication;
};

/** The filterable fields of type ApplyToListingResult */
export type ApplyToListingResultFilterInput = {
  and?: InputMaybe<Array<ApplyToListingResultFilterInput>>;
  not?: InputMaybe<ApplyToListingResultFilterInput>;
  or?: InputMaybe<Array<ApplyToListingResultFilterInput>>;
};

export type AssignAccessGroupRoleInput = {
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  groupId: Scalars['ID']['input'];
  roleId: Scalars['ID']['input'];
  scope: AccessScopeInput;
};

/** Assign a person's manager, or clear the assignment. Cycles are rejected. Requires `write:access-config`. */
export type AssignManagerInput = {
  /** If true, only the validation is performed but nothing is written. */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  /** The managing person, or null to clear the manager. */
  managerId?: InputMaybe<Scalars['ID']['input']>;
  /** The person whose manager is being set. */
  personId: Scalars['ID']['input'];
};

/** The result of assigning a person's manager — echoes the resulting assignment. */
export type AssignManagerOutput = {
  __typename?: 'AssignManagerOutput';
  /** The assigned manager's person id, or null if the manager was cleared. */
  managerId?: Maybe<Scalars['ID']['output']>;
  personId: Scalars['ID']['output'];
};

/** The filterable fields of type AssignManagerOutput */
export type AssignManagerOutputFilterInput = {
  and?: InputMaybe<Array<AssignManagerOutputFilterInput>>;
  not?: InputMaybe<AssignManagerOutputFilterInput>;
  or?: InputMaybe<Array<AssignManagerOutputFilterInput>>;
};

/** Assign a person to an organizational unit, or clear the assignment. Requires `write:access-config`. */
export type AssignOrgUnitInput = {
  /** If true, only the validation is performed but nothing is written. */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  /** The OrgUnit to assign, or null to clear the assignment. */
  orgUnitId?: InputMaybe<Scalars['ID']['input']>;
  /** The person whose org unit is being set. */
  personId: Scalars['ID']['input'];
};

/** The result of assigning a person's OrgUnit — echoes the resulting assignment. */
export type AssignOrgUnitOutput = {
  __typename?: 'AssignOrgUnitOutput';
  /** The assigned OrgUnit id, or null if the assignment was cleared. */
  orgUnitId?: Maybe<Scalars['ID']['output']>;
  personId: Scalars['ID']['output'];
};

/** The filterable fields of type AssignOrgUnitOutput */
export type AssignOrgUnitOutputFilterInput = {
  and?: InputMaybe<Array<AssignOrgUnitOutputFilterInput>>;
  not?: InputMaybe<AssignOrgUnitOutputFilterInput>;
  or?: InputMaybe<Array<AssignOrgUnitOutputFilterInput>>;
};

export type AssignQuestionnaireToGroupInput = {
  /**
   * If true, only the validation is performed but the membership is not changed - same meaning as on
   * UpdateDocumentInput, which is how a document changes its group.
   */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  /** Position within the target group. Null appends at the end. Ignored when ungrouping. */
  position?: InputMaybe<Scalars['Int']['input']>;
  /** Null removes the questionnaire from its group and clears its position. Moving to a different group always assigns a fresh position - the old one described a different group. */
  questionnaireGroupId?: InputMaybe<Scalars['UUID']['input']>;
  questionnaireId: Scalars['UUID']['input'];
};

export type AttachProjectDocumentInput = {
  files: Array<CreateFileDataInput>;
  matchId: Scalars['UUID']['input'];
};

export type AttachProjectDocumentOutput = AttachProjectDocumentResult;

export type AttachProjectDocumentResult = {
  __typename?: 'AttachProjectDocumentResult';
  match: Match;
};

/** The filterable fields of type AttachProjectDocumentResult */
export type AttachProjectDocumentResultFilterInput = {
  and?: InputMaybe<Array<AttachProjectDocumentResultFilterInput>>;
  not?: InputMaybe<AttachProjectDocumentResultFilterInput>;
  or?: InputMaybe<Array<AttachProjectDocumentResultFilterInput>>;
};

export type AudioElement = GrowElement & PlayableGrowElement & {
  __typename?: 'AudioElement';
  lengthMilliseconds?: Maybe<Scalars['Int']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  sources: Array<AudioElementSource>;
  thumbnail?: Maybe<Scalars['Binary']['output']>;
  title?: Maybe<LocalizedText>;
};

/** The filterable fields of type AudioElement */
export type AudioElementFilterInput = {
  and?: InputMaybe<Array<AudioElementFilterInput>>;
  not?: InputMaybe<AudioElementFilterInput>;
  or?: InputMaybe<Array<AudioElementFilterInput>>;
};

export type AudioElementSource = {
  __typename?: 'AudioElementSource';
  mimeType?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

/** The filterable fields of type AudioElementSource */
export type AudioElementSourceFilterInput = {
  and?: InputMaybe<Array<AudioElementSourceFilterInput>>;
  not?: InputMaybe<AudioElementSourceFilterInput>;
  or?: InputMaybe<Array<AudioElementSourceFilterInput>>;
};

/** Filtering for fields of type Boolean */
export type BooleanFilterInput = {
  /** Logical 'and' of one or more predicates */
  and?: InputMaybe<Array<BooleanFilterInput>>;
  /** If true, checks if the field has a value, or, if false, checks if the field is missing a value */
  any?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks if the field's value is equal to the given value */
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks if the field's value is not equal to the given value */
  ne?: InputMaybe<Scalars['Boolean']['input']>;
  /** Negates the predicate */
  not?: InputMaybe<BooleanFilterInput>;
  /** Logical 'or' of one or more predicates */
  or?: InputMaybe<Array<BooleanFilterInput>>;
};

/** Counts of records created (or that would have been created in a dry run) per entity collection. */
export type BulkImportPersonCounts = {
  __typename?: 'BulkImportPersonCounts';
  certificates: Scalars['Int']['output'];
  educations: Scalars['Int']['output'];
  experiences: Scalars['Int']['output'];
  expertises: Scalars['Int']['output'];
  languageSkills: Scalars['Int']['output'];
  personUpdated: Scalars['Boolean']['output'];
};

/** The filterable fields of type BulkImportPersonCounts */
export type BulkImportPersonCountsFilterInput = {
  and?: InputMaybe<Array<BulkImportPersonCountsFilterInput>>;
  not?: InputMaybe<BulkImportPersonCountsFilterInput>;
  or?: InputMaybe<Array<BulkImportPersonCountsFilterInput>>;
};

export type BulkImportPersonDetailData = {
  bio?: InputMaybe<Scalars['String']['input']>;
  currentEmployer?: InputMaybe<Scalars['String']['input']>;
  dateOfBirth?: InputMaybe<Scalars['Date']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  profession?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Input for the provider-agnostic bulk-import mutation. The caller provides the
 * target personId plus optional lists for each profile collection and an optional
 * personDetail fragment. Collections that are already non-empty for the target
 * person are left untouched and their name is appended to `skipped` in the result.
 * Non-fatal mapping issues surfaced by the caller (e.g. unrecognized language
 * proficiency while parsing a provider export) can be relayed via `clientWarnings`
 * so they appear in the aggregated result alongside any server-side warnings.
 */
export type BulkImportPersonInput = {
  certificates?: InputMaybe<Array<CreateCertificateDataInput>>;
  clientWarnings?: InputMaybe<Array<Scalars['String']['input']>>;
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  educations?: InputMaybe<Array<CreateEducationDataInput>>;
  experiences?: InputMaybe<Array<CreateExperienceDataInput>>;
  expertises?: InputMaybe<Array<CreateExpertiseDataInput>>;
  languageSkills?: InputMaybe<Array<CreateLanguageSkillDataInput>>;
  personDetail?: InputMaybe<BulkImportPersonDetailData>;
  personId: Scalars['ID']['input'];
};

/**
 * Result of a bulk person-data import. `skipped` lists the collection names that
 * were left untouched because the target person already had data of that kind
 * (current policy: never overwrite existing data). `warnings` aggregates
 * non-fatal issues — both mapping warnings relayed from the caller via
 * `clientWarnings` and any server-side issues (e.g. optimistic-lock loss during
 * personDetail update).
 */
export type BulkImportPersonResult = {
  __typename?: 'BulkImportPersonResult';
  counts: BulkImportPersonCounts;
  skipped: Array<Scalars['String']['output']>;
  warnings: Array<Scalars['String']['output']>;
};

/** The filterable fields of type BulkImportPersonResult */
export type BulkImportPersonResultFilterInput = {
  and?: InputMaybe<Array<BulkImportPersonResultFilterInput>>;
  not?: InputMaybe<BulkImportPersonResultFilterInput>;
  or?: InputMaybe<Array<BulkImportPersonResultFilterInput>>;
};

export enum CefrScale {
  A1 = 'A1',
  A2 = 'A2',
  B1 = 'B1',
  B2 = 'B2',
  C1 = 'C1',
  C2 = 'C2'
}

export type CefrScaleFilterInput = {
  /** Logical 'and' of one or more predicates */
  and?: InputMaybe<Array<CefrScaleFilterInput>>;
  /** Checks if the field has a value or not */
  any?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks if the field's value is equal to the given value */
  eq?: InputMaybe<CefrScale>;
  /** Checks if the field's value is in the list of the given values */
  in?: InputMaybe<Array<CefrScale>>;
  /** Checks if the field's value is not equal to the given value */
  ne?: InputMaybe<CefrScale>;
  /** Negates the predicate */
  not?: InputMaybe<CefrScaleFilterInput>;
  /** Logical 'or' of one or more predicates */
  or?: InputMaybe<Array<CefrScaleFilterInput>>;
};

/** A thing to pick in the toplist game: facts from Wikidata, keyed by its QID. */
export type CatalogItem = {
  __typename?: 'CatalogItem';
  domain: FavoriteDomain;
  id: Scalars['UUID']['output'];
  /** First release or publication, where the domain has one. */
  releaseYear?: Maybe<Scalars['Int']['output']>;
  /** At most three codes from a small list per domain: a film genre, a continent, a cuisine. */
  tags: Array<Scalars['String']['output']>;
  title: LocalizedText;
};

/** The filterable fields of type CatalogItem */
export type CatalogItemFilterInput = {
  and?: InputMaybe<Array<CatalogItemFilterInput>>;
  not?: InputMaybe<CatalogItemFilterInput>;
  or?: InputMaybe<Array<CatalogItemFilterInput>>;
};

export type CatalogItemsInput = {
  domain: FavoriteDomain;
};

export type Category = {
  itemCount?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
};

/** The filterable fields of type Category */
export type CategoryFilterInput = {
  and?: InputMaybe<Array<CategoryFilterInput>>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<CategoryFilterInput>;
  or?: InputMaybe<Array<CategoryFilterInput>>;
};

export type CategorySortInput = {
  name?: InputMaybe<SortOrder>;
};

export type Certificate = Node & SharableEntity & {
  __typename?: 'Certificate';
  /** Dynamic consent to all current and future eligible Groups, independent of public readership. */
  allGroups?: Maybe<Scalars['Boolean']['output']>;
  date?: Maybe<DateInstant>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  person: Person;
  /** Public readership, independent of Group recipients. Company and HR publication rules still apply. */
  publiclyReadable?: Maybe<Scalars['Boolean']['output']>;
  /** Group recipients; an empty list grants no ordinary Group readership. */
  sharedWith?: Maybe<Array<ContentSharingRecipient>>;
};

/** The filterable fields of type Certificate */
export type CertificateFilterInput = {
  and?: InputMaybe<Array<CertificateFilterInput>>;
  not?: InputMaybe<CertificateFilterInput>;
  or?: InputMaybe<Array<CertificateFilterInput>>;
};

export type ChatMessage = Node & {
  __typename?: 'ChatMessage';
  content: Scalars['String']['output'];
  conversationId: Scalars['UUID']['output'];
  id: Scalars['ID']['output'];
  senderId: Scalars['UUID']['output'];
  sentAt: Scalars['DateTime']['output'];
};

/** The filterable fields of type ChatMessage */
export type ChatMessageFilterInput = {
  and?: InputMaybe<Array<ChatMessageFilterInput>>;
  not?: InputMaybe<ChatMessageFilterInput>;
  or?: InputMaybe<Array<ChatMessageFilterInput>>;
};

/**
 * Place-of-residence requirement. A positive radiusKm applies a geographic radius in kilometres.
 * Omit it or use zero for an exact city-name match.
 */
export type CityConditionInput = {
  aiMode?: ConditionAiMode;
  radiusKm?: InputMaybe<Scalars['Int']['input']>;
  value: Scalars['String']['input'];
};

export type ClaimListingApplicationInput = {
  /** Token from the confirmation link's fragment. */
  token: Scalars['String']['input'];
};

export type ClaimListingApplicationResult = {
  __typename?: 'ClaimListingApplicationResult';
  outcome: ListingApplicationConfirmationOutcome;
};

/** The filterable fields of type ClaimListingApplicationResult */
export type ClaimListingApplicationResultFilterInput = {
  and?: InputMaybe<Array<ClaimListingApplicationResultFilterInput>>;
  not?: InputMaybe<ClaimListingApplicationResultFilterInput>;
  or?: InputMaybe<Array<ClaimListingApplicationResultFilterInput>>;
};

/**
 * Preview diff for one collection section (experiences, educations, languageSkills, certificates,
 * expertises): one row per proposed row, in the source's order. The exception is `languageSkills`,
 * where a language the source proposes more than once yields a SINGLE row — a person holds at most
 * one row per language, so a second one could never be created.
 */
export type CollectionDiff = {
  __typename?: 'CollectionDiff';
  rows: Array<CollectionRowDiff>;
};

/** The filterable fields of type CollectionDiff */
export type CollectionDiffFilterInput = {
  and?: InputMaybe<Array<CollectionDiffFilterInput>>;
  not?: InputMaybe<CollectionDiffFilterInput>;
  or?: InputMaybe<Array<CollectionDiffFilterInput>>;
};

/**
 * Preview diff for one collection row. `rowKey` is this row's identity within the preview:
 * `"<section>:<ordinal>"` (`certificates:0`, `certificates:1`, …), unique across the WHOLE preview
 * and never equal to a `PersonDetailFieldDiff.key`, so decisions and edits for every proposal of a
 * preview can share one namespace. Treat it as opaque — do not parse it, and do not store or cache
 * it: it identifies a row inside ONE preview and nothing beyond it. `existingRowId` identifies the
 * matched existing row (null for an ADD) and is what makes a re-preview recognize an already-saved
 * row, keeping re-import idempotent; no two rows of one preview ever carry the same one. `fields`
 * carries the per-field diff (existing vs incoming machine values) the client renders and can edit.
 * Existing rows with no incoming match are not emitted — they are always kept.
 */
export type CollectionRowDiff = {
  __typename?: 'CollectionRowDiff';
  action: ImportDiffAction;
  existingRowId?: Maybe<Scalars['ID']['output']>;
  fields: Array<RowFieldDiff>;
  rowKey: Scalars['String']['output'];
};

/** The filterable fields of type CollectionRowDiff */
export type CollectionRowDiffFilterInput = {
  and?: InputMaybe<Array<CollectionRowDiffFilterInput>>;
  not?: InputMaybe<CollectionRowDiffFilterInput>;
  or?: InputMaybe<Array<CollectionRowDiffFilterInput>>;
};

export type Colors = {
  __typename?: 'Colors';
  background?: Maybe<Scalars['Color']['output']>;
  text?: Maybe<Scalars['Color']['output']>;
};

/** The filterable fields of type Colors */
export type ColorsFilterInput = {
  and?: InputMaybe<Array<ColorsFilterInput>>;
  not?: InputMaybe<ColorsFilterInput>;
  or?: InputMaybe<Array<ColorsFilterInput>>;
};

export type Communication = {
  __typename?: 'Communication';
  language: Scalars['String']['output'];
  preferred?: Maybe<Scalars['Boolean']['output']>;
};

/** The filterable fields of type Communication */
export type CommunicationFilterInput = {
  and?: InputMaybe<Array<CommunicationFilterInput>>;
  not?: InputMaybe<CommunicationFilterInput>;
  or?: InputMaybe<Array<CommunicationFilterInput>>;
};

/**
 * Language of a mail to one recipient, DE or EN. Resolved on the server from the recorded application form
 * language for a mail to its applicant, otherwise from the instance language in system settings. Never derived
 * from the sender's session, nationality, name or other profile data. There is no personal mail-language
 * preference.
 */
export enum CommunicationLanguage {
  De = 'DE',
  En = 'EN'
}

/**
 * An organization with a profile, memberships and expertise. Creating a company requires
 * `create:company`; updating or deactivating it requires an admin membership in that company.
 * Platform permissions do not confer company administration rights.
 *
 * A company can be a candidate in a RANK_COMPANIES match, evaluated independently against its
 * requirements. Companies do not own or initiate matches.
 */
export type Company = Node & {
  __typename?: 'Company';
  /**
   * Whether the caller is an active admin of this Company. Group roles, HR and sharing overrides
   * confer no Company authority. Applies to profile and membership administration, including
   * reactivation; individual mutation validation and the freeze on inactive Company content still apply.
   */
  canAdminister: Scalars['Boolean']['output'];
  /**
   * Headcount. Available on `company`, `companies` nodes, `MatchCompany.company` and
   * `MatchResultCompany.company`; null on other Company references, even when a headcount is known.
   */
  employeeCount?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  /** Industry. The curated Industry reference entity, shared with Experience. */
  industry?: Maybe<Industry>;
  /**
   *   Company logo. Available on `company`, `myCompanies`, `companyIdentities`, and `SharedItem.company`
   *   when reading a single shared item or its create/update result. Null when no logo exists, and always
   *   null on other Company references, including company membership lists and shared-item lists.
   *
   * `profile` accepts "card" (maximum height 140 pixels) or "share_preview" (maximum height 250 pixels);
   *   omit it for the original. Content is returned as Base64 through File.content.
   *
   * Uploads accept PNG, JPEG, GIF, BMP, TIFF or WebP, at most 5 MiB. Actual content is checked regardless
   *   of the declared MIME type; SVG is rejected. On update, omitting logo preserves it and explicit null
   *   removes it.
   */
  logo?: Maybe<File>;
  /** Company name, non-blank and at most 255 characters after trimming. */
  name: Scalars['String']['output'];
  /**
   * Lifecycle state. New companies are ACTIVE. A company admin can set INACTIVE or reactivate it;
   * see CompanyStatus for the effects. Returned companies have a status, although this field is nullable.
   * Omitting status on update leaves it unchanged. Search and `companies` return only active companies.
   */
  status?: Maybe<CompanyStatus>;
  /**
   * Company profile text, up to 20,000 characters. Available on `company` and `companies` nodes;
   * null on all other Company references, even when a summary exists. On those two profile queries,
   * null means no summary is set. The summary is not searchable or filterable.
   */
  summary?: Maybe<Scalars['String']['output']>;
};


/**
 * An organization with a profile, memberships and expertise. Creating a company requires
 * `create:company`; updating or deactivating it requires an admin membership in that company.
 * Platform permissions do not confer company administration rights.
 *
 * A company can be a candidate in a RANK_COMPANIES match, evaluated independently against its
 * requirements. Companies do not own or initiate matches.
 */
export type CompanyLogoArgs = {
  profile?: InputMaybe<Scalars['String']['input']>;
};

export type CompanyCompetenciesInput = {
  companyId: Scalars['ID']['input'];
};

/**
 * A company's free-text expertise label. Labels are unique within a company, ignoring case and
 * surrounding whitespace. Identical labels at different companies are independent entries. No level
 * or proficiency score is attached to an entry.
 */
export type CompanyCompetency = {
  __typename?: 'CompanyCompetency';
  /** The expertise, exactly as the company admin typed it (trimmed). Unique per company, case-insensitively. */
  label: Scalars['String']['output'];
};

/**
 * Filter company expertise labels using string comparisons or full-text matching. Combine conditions
 * with `and` and `or`; use the containing list's `none` operator to exclude matching expertise.
 */
export type CompanyCompetencyFilterInput = {
  and?: InputMaybe<Array<CompanyCompetencyFilterInput>>;
  /** The expertise, exactly as the company admin typed it (trimmed). Unique per company, case-insensitively. */
  label?: InputMaybe<StringFilterInput>;
  /**
   * Full-text label search with German and English stemming and word-prefix matching, as in
   * `globalSearch`. Supply one search expression: spaces combine terms, double quotes enclose a phrase,
   * OR selects alternatives and a leading minus excludes a term. Prefixes extend words to the right;
   * matching does not translate between languages. Use `label` for literal string comparisons.
   */
  matches?: InputMaybe<Scalars['String']['input']>;
  not?: InputMaybe<CompanyCompetencyFilterInput>;
  or?: InputMaybe<Array<CompanyCompetencyFilterInput>>;
};

/** One company's expertise, as a fingerprint — see `companyCompetencyHashes`. */
export type CompanyCompetencyHash = {
  __typename?: 'CompanyCompetencyHash';
  companyId: Scalars['ID']['output'];
  /** sha-256 (hex) over that company's labels. A company listing nothing hashes the empty string. */
  labelsHash: Scalars['String']['output'];
};

/** The filterable fields of type CompanyCompetencyHash */
export type CompanyCompetencyHashFilterInput = {
  and?: InputMaybe<Array<CompanyCompetencyHashFilterInput>>;
  not?: InputMaybe<CompanyCompetencyHashFilterInput>;
  or?: InputMaybe<Array<CompanyCompetencyHashFilterInput>>;
};

export type CompanyCompetencyHashesResult = {
  __typename?: 'CompanyCompetencyHashesResult';
  hashes: Array<CompanyCompetencyHash>;
};

/** The filterable fields of type CompanyCompetencyHashesResult */
export type CompanyCompetencyHashesResultFilterInput = {
  and?: InputMaybe<Array<CompanyCompetencyHashesResultFilterInput>>;
  not?: InputMaybe<CompanyCompetencyHashesResultFilterInput>;
  or?: InputMaybe<Array<CompanyCompetencyHashesResultFilterInput>>;
};

/** Filtering options for a list of elements with type CompanyCompetency */
export type CompanyCompetencyListFilterInput = {
  /** All list items must match the predicate */
  all?: InputMaybe<CompanyCompetencyFilterInput>;
  /** If true, there should exist at least list item */
  any?: InputMaybe<Scalars['Boolean']['input']>;
  /** None of list items must match the predicate */
  none?: InputMaybe<CompanyCompetencyFilterInput>;
  /** At least one of list items must match the predicate */
  some?: InputMaybe<CompanyCompetencyFilterInput>;
};

export type CompanyCompetencyResult = {
  __typename?: 'CompanyCompetencyResult';
  competencies: Array<CompanyCompetency>;
};

/** The filterable fields of type CompanyCompetencyResult */
export type CompanyCompetencyResultFilterInput = {
  and?: InputMaybe<Array<CompanyCompetencyResultFilterInput>>;
  not?: InputMaybe<CompanyCompetencyResultFilterInput>;
  or?: InputMaybe<Array<CompanyCompetencyResultFilterInput>>;
};

export type CompanyConnection = {
  __typename?: 'CompanyConnection';
  edges: Array<CompanyEdge>;
  nodes: Array<Company>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CompanyContactPersonsInput = {
  companyId: Scalars['ID']['input'];
};

/** The complete set of a company's contact persons, limited to ten members and not paginated. */
export type CompanyContactPersonsResult = {
  __typename?: 'CompanyContactPersonsResult';
  contactPersons: Array<CompanyMembership>;
};

/** The filterable fields of type CompanyContactPersonsResult */
export type CompanyContactPersonsResultFilterInput = {
  and?: InputMaybe<Array<CompanyContactPersonsResultFilterInput>>;
  not?: InputMaybe<CompanyContactPersonsResultFilterInput>;
  or?: InputMaybe<Array<CompanyContactPersonsResultFilterInput>>;
};

export type CompanyEdge = {
  __typename?: 'CompanyEdge';
  cursor: Scalars['String']['output'];
  node: Company;
};

/** The filterable fields of type Company */
export type CompanyFilterInput = {
  and?: InputMaybe<Array<CompanyFilterInput>>;
  /**
   * Filter-only list of company expertise. Use `some` to require a matching label or `none` to exclude
   * companies with a matching label. Read the expertise through `companyCompetencies`.
   */
  competencies?: InputMaybe<CompanyCompetencyListFilterInput>;
  /**
   * Filter-only expertise label. Matches a company if any of its free-text expertise labels satisfies
   * the string filter; each company appears once. There is no localized or shared expertise catalogue.
   * Use `companyCompetencies` to read labels. To exclude companies with a matching label, use
   * `competencies: {none:...}`; negating this scalar filter can still match another label.
   */
  competencyFieldName?: InputMaybe<StringFilterInput>;
  /**
   * Headcount. Available on `company`, `companies` nodes, `MatchCompany.company` and
   * `MatchResultCompany.company`; null on other Company references, even when a headcount is known.
   */
  employeeCount?: InputMaybe<IntFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  /** Industry. The curated Industry reference entity, shared with Experience. */
  industry?: InputMaybe<IndustryFilterInput>;
  /** Company name, non-blank and at most 255 characters after trimming. */
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<CompanyFilterInput>;
  or?: InputMaybe<Array<CompanyFilterInput>>;
};

export type CompanyIdentitiesInput = {
  /** The companies to identify. At most 50; a longer list is rejected rather than truncated. */
  ids: Array<Scalars['ID']['input']>;
};

/**
 * Company identities and logos for supplied ids. Inactive companies are included; unknown ids are
 * skipped. This query does not support filters, ordering or pagination.
 */
export type CompanyIdentitiesResult = {
  __typename?: 'CompanyIdentitiesResult';
  companies: Array<Company>;
};

/** The filterable fields of type CompanyIdentitiesResult */
export type CompanyIdentitiesResultFilterInput = {
  and?: InputMaybe<Array<CompanyIdentitiesResultFilterInput>>;
  not?: InputMaybe<CompanyIdentitiesResultFilterInput>;
  or?: InputMaybe<Array<CompanyIdentitiesResultFilterInput>>;
};

export type CompanyInput = {
  id: Scalars['ID']['input'];
};

/**
 * One company requirement. Exactly one of industryId, minimumEmployees or expertise must be set.
 * Industry is an equality comparison; employee count is a non-negative minimum; expertise has no level.
 * The match's existing Agentic AI setting controls expertise evaluation.
 */
export type CompanyMatchConditionInput = {
  active?: Scalars['Boolean']['input'];
  expertise?: InputMaybe<Scalars['String']['input']>;
  industryId?: InputMaybe<Scalars['UUID']['input']>;
  minimumEmployees?: InputMaybe<Scalars['Int']['input']>;
  requirement?: InputMaybe<ConditionRequirement>;
};

/**
 * Forward cursor pagination for active company members, ordered by role and then person id.
 * Omitting first returns 20 members; the maximum is 100. Larger sizes are rejected with
 * `GENESIS001009` rather than truncated. Pass the previous page's end cursor as after.
 */
export type CompanyMembersInput = {
  /** Cursor-based pagination: The immediate successor of this cursor will be the first entry of the requested page */
  after?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['ID']['input'];
  /** Number of members to return, from 1 to 100. Omitted means 20; use after for the next page. */
  first?: InputMaybe<Scalars['Int']['input']>;
};

/** A person's company membership. `role` is a string; supported roles are `admin` and `member`. */
export type CompanyMembership = {
  __typename?: 'CompanyMembership';
  /** The Company, as identity only — `id`, `name`, `industry`. See Company.summary. */
  company: Company;
  /**
   * Whether this member is a company contact person. This is independent of their role and grants no
   * additional permissions. Set it through `setCompanyContactPerson`, which requires company admin
   * membership. Contact persons have the same visibility as company members. Use `companyContactPersons`
   * for the complete set; a page of `companyMembers` may contain only some contacts.
   */
  contactPerson: Scalars['Boolean']['output'];
  person: Person;
  role: Scalars['String']['output'];
};

/**
 * A page of active company members. `totalCount` counts the same visible members as the connection;
 * membership visibility is independent of the caller's personal-data sharing settings.
 */
export type CompanyMembershipConnection = {
  __typename?: 'CompanyMembershipConnection';
  edges: Array<CompanyMembershipEdge>;
  nodes: Array<CompanyMembership>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** The filterable fields of type CompanyMembershipConnection */
export type CompanyMembershipConnectionFilterInput = {
  and?: InputMaybe<Array<CompanyMembershipConnectionFilterInput>>;
  not?: InputMaybe<CompanyMembershipConnectionFilterInput>;
  or?: InputMaybe<Array<CompanyMembershipConnectionFilterInput>>;
};

export type CompanyMembershipEdge = {
  __typename?: 'CompanyMembershipEdge';
  cursor: Scalars['String']['output'];
  node: CompanyMembership;
};

/** The filterable fields of type CompanyMembershipEdge */
export type CompanyMembershipEdgeFilterInput = {
  and?: InputMaybe<Array<CompanyMembershipEdgeFilterInput>>;
  not?: InputMaybe<CompanyMembershipEdgeFilterInput>;
  or?: InputMaybe<Array<CompanyMembershipEdgeFilterInput>>;
};

/** The filterable fields of type CompanyMembership */
export type CompanyMembershipFilterInput = {
  and?: InputMaybe<Array<CompanyMembershipFilterInput>>;
  not?: InputMaybe<CompanyMembershipFilterInput>;
  or?: InputMaybe<Array<CompanyMembershipFilterInput>>;
};

export type CompanyMembershipInput = {
  companyId: Scalars['ID']['input'];
  personId: Scalars['ID']['input'];
  role: Scalars['String']['input'];
};

/** The parameters for requesting multiple instances of Company. Mixing fields of cursor-based and offset-based pagination will result in an error. */
export type CompanyQueryInput = {
  /** Cursor-based pagination: The immediate successor of this cursor will be the first entry of the requested page */
  after?: InputMaybe<Scalars['String']['input']>;
  /** Cursor-based pagination: The immediate predecessor of this cursor will be last entry of the requested page */
  before?: InputMaybe<Scalars['String']['input']>;
  /** Cursor-based pagination: Number of rows to be returned. Use in conjunction with 'after' */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** Cursor-based pagination: Number of rows to be returned. Use in conjunction with 'before' */
  last?: InputMaybe<Scalars['Int']['input']>;
  /** The sorting order of the instances */
  order?: InputMaybe<CompanySortInput>;
  /** Offset-based pagination: Number of rows to skip */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Offset-based pagination: Number of rows to be returned */
  take?: InputMaybe<Scalars['Int']['input']>;
  /** The filter to be applied */
  where?: InputMaybe<CompanyFilterInput>;
};

/** Contains information for linking 'Company' to other entities */
export type CompanyRelationInput = {
  /** The identifier of 'Company' */
  id: Scalars['ID']['input'];
};

export type CompanyResult = {
  __typename?: 'CompanyResult';
  company?: Maybe<Company>;
};

/** The filterable fields of type CompanyResult */
export type CompanyResultFilterInput = {
  and?: InputMaybe<Array<CompanyResultFilterInput>>;
  not?: InputMaybe<CompanyResultFilterInput>;
  or?: InputMaybe<Array<CompanyResultFilterInput>>;
};

export type CompanySortInput = {
  id?: InputMaybe<SortOrder>;
  /** Company name, non-blank and at most 255 characters after trimming. */
  name?: InputMaybe<SortOrder>;
};

/**
 * Company lifecycle. `deleteCompany` sets INACTIVE; it does not erase the company. Name, industry,
 * logo, employee count, summary, expertise, memberships and contact persons are retained.
 * Reactivation restores discoverability and permits content writes again.
 *
 * An inactive company and its content are excluded from search. Existing references remain readable:
 * its profile and company-owned items remain available, and callers retain access to pinned items.
 *
 * Publishing, editing or deleting its content, applying to its projects, rating its items and recording
 * views are rejected with `GENESIS001250`. Creating, editing or deleting comments is also rejected
 * when either the comment's company or the item's company is inactive. Reading comments is unaffected.
 * Documents attached to a shared item cannot be deleted while still attached; an inactive company's
 * item cannot be edited to detach them.
 */
export enum CompanyStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

export enum ConditionAiMode {
  FullAi = 'FULL_AI',
  NoAi = 'NO_AI'
}

export type ConditionCompositionInput = {
  operator: ConditionCompositionOperator;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export enum ConditionCompositionOperator {
  All = 'ALL',
  Any = 'ANY',
  Exact = 'EXACT',
  Max = 'MAX',
  Min = 'MIN'
}

export enum ConditionLanguageLevel {
  A1 = 'A1',
  A2 = 'A2',
  B1 = 'B1',
  B2 = 'B2',
  C1 = 'C1',
  C2 = 'C2',
  Native = 'NATIVE'
}

export enum ConditionOperator {
  Eq = 'EQ',
  Ge = 'GE',
  Gt = 'GT',
  Le = 'LE',
  Lt = 'LT',
  Ne = 'NE'
}

export enum ConditionRequirement {
  Must = 'MUST',
  Optional = 'OPTIONAL'
}

export type ContactPoint = {
  __typename?: 'ContactPoint';
  period?: Maybe<Period>;
  rank?: Maybe<Scalars['Int']['output']>;
  system?: Maybe<ContactPointSystem>;
  use?: Maybe<ContactPointUse>;
  value?: Maybe<Scalars['String']['output']>;
};

/** The filterable fields of type ContactPoint */
export type ContactPointFilterInput = {
  and?: InputMaybe<Array<ContactPointFilterInput>>;
  not?: InputMaybe<ContactPointFilterInput>;
  or?: InputMaybe<Array<ContactPointFilterInput>>;
};

export enum ContactPointSystem {
  Bluesky = 'BLUESKY',
  Discord = 'DISCORD',
  Email = 'EMAIL',
  Facebook = 'FACEBOOK',
  Fax = 'FAX',
  Instagram = 'INSTAGRAM',
  Linkedin = 'LINKEDIN',
  Mastodon = 'MASTODON',
  Mobile = 'MOBILE',
  Other = 'OTHER',
  Phone = 'PHONE',
  Pinterest = 'PINTEREST',
  Snapchat = 'SNAPCHAT',
  Threads = 'THREADS',
  Tiktok = 'TIKTOK',
  Twitch = 'TWITCH',
  Twitter = 'TWITTER',
  Website = 'WEBSITE',
  Youtube = 'YOUTUBE'
}

export enum ContactPointUse {
  Home = 'HOME',
  Mobile = 'MOBILE',
  Old = 'OLD',
  Temp = 'TEMP',
  Work = 'WORK'
}

export type ContactPowersDevStatsInput = {
  amount: Scalars['Int']['input'];
  days: Scalars['Int']['input'];
};

export type ContactTopElements = {
  __typename?: 'ContactTopElements';
  elements: Array<CreativityElement>;
  person: PersonLean;
};

/** The filterable fields of type ContactTopElements */
export type ContactTopElementsFilterInput = {
  and?: InputMaybe<Array<ContactTopElementsFilterInput>>;
  not?: InputMaybe<ContactTopElementsFilterInput>;
  or?: InputMaybe<Array<ContactTopElementsFilterInput>>;
};

export type ContactTopElementsInput = {
  amount: Scalars['Int']['input'];
};

export type ContactWithGrowScore = {
  __typename?: 'ContactWithGrowScore';
  person: Person;
  score: Scalars['Int']['output'];
  userRank: UserRank;
};

/** The filterable fields of type ContactWithGrowScore */
export type ContactWithGrowScoreFilterInput = {
  and?: InputMaybe<Array<ContactWithGrowScoreFilterInput>>;
  not?: InputMaybe<ContactWithGrowScoreFilterInput>;
  or?: InputMaybe<Array<ContactWithGrowScoreFilterInput>>;
};

export type Contacts = {
  __typename?: 'Contacts';
  bluesky?: Maybe<Scalars['String']['output']>;
  discord?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  facebook?: Maybe<Scalars['String']['output']>;
  github?: Maybe<Scalars['String']['output']>;
  instagram?: Maybe<Scalars['String']['output']>;
  mastodon?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  pinterest?: Maybe<Scalars['String']['output']>;
  snapchat?: Maybe<Scalars['String']['output']>;
  threads?: Maybe<Scalars['String']['output']>;
  tiktok?: Maybe<Scalars['String']['output']>;
  twitch?: Maybe<Scalars['String']['output']>;
  twitter?: Maybe<Scalars['String']['output']>;
  website?: Maybe<Scalars['String']['output']>;
  youtube?: Maybe<Scalars['String']['output']>;
};

/** The filterable fields of type Contacts */
export type ContactsFilterInput = {
  and?: InputMaybe<Array<ContactsFilterInput>>;
  not?: InputMaybe<ContactsFilterInput>;
  or?: InputMaybe<Array<ContactsFilterInput>>;
};

export type ContactsWithHighestScoreInput = {
  limit: Scalars['Int']['input'];
};

/** A Group selected for ordinary content sharing. Eligibility controls new choices, not existing readership. */
export type ContentSharingRecipient = Node & {
  __typename?: 'ContentSharingRecipient';
  eligible: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

/** The filterable fields of type ContentSharingRecipient */
export type ContentSharingRecipientFilterInput = {
  and?: InputMaybe<Array<ContentSharingRecipientFilterInput>>;
  not?: InputMaybe<ContentSharingRecipientFilterInput>;
  or?: InputMaybe<Array<ContentSharingRecipientFilterInput>>;
};

/** Contains information for linking 'ContentSharingRecipient' to other entities */
export type ContentSharingRecipientRelationInput = {
  /** The identifier of 'ContentSharingRecipient' */
  id: Scalars['ID']['input'];
};

export type ContractType = Node & {
  __typename?: 'ContractType';
  desc?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  localizedDesc?: Maybe<LocalizedText>;
  localizedName?: Maybe<LocalizedText>;
  name?: Maybe<Scalars['String']['output']>;
};

/** The filterable fields of type ContractType */
export type ContractTypeFilterInput = {
  and?: InputMaybe<Array<ContractTypeFilterInput>>;
  desc?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ContractTypeFilterInput>;
  or?: InputMaybe<Array<ContractTypeFilterInput>>;
};

/** Contains information for linking 'ContractType' to other entities */
export type ContractTypeRelationInput = {
  /** The identifier of 'ContractType' */
  id: Scalars['ID']['input'];
};

export type ContractTypeSortInput = {
  desc?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
};

export type ContractTypesResult = {
  __typename?: 'ContractTypesResult';
  contractTypes: Array<ContractType>;
};

/** The filterable fields of type ContractTypesResult */
export type ContractTypesResultFilterInput = {
  and?: InputMaybe<Array<ContractTypesResultFilterInput>>;
  not?: InputMaybe<ContractTypesResultFilterInput>;
  or?: InputMaybe<Array<ContractTypesResultFilterInput>>;
};

export type Conversation = Node & {
  __typename?: 'Conversation';
  createdAt: Scalars['DateTime']['output'];
  createdById: Scalars['UUID']['output'];
  id: Scalars['ID']['output'];
  participantIds: Array<Scalars['UUID']['output']>;
};

export type ConversationEvent = {
  __typename?: 'ConversationEvent';
  conversationId: Scalars['UUID']['output'];
  message?: Maybe<ChatMessage>;
  presence?: Maybe<PresenceIndicator>;
  readReceipt?: Maybe<ConversationReadReceipt>;
  type: ConversationEventType;
  typing?: Maybe<TypingIndicator>;
};

/** The filterable fields of type ConversationEvent */
export type ConversationEventFilterInput = {
  and?: InputMaybe<Array<ConversationEventFilterInput>>;
  not?: InputMaybe<ConversationEventFilterInput>;
  or?: InputMaybe<Array<ConversationEventFilterInput>>;
};

export enum ConversationEventType {
  MessageCreated = 'MESSAGE_CREATED',
  PresenceChanged = 'PRESENCE_CHANGED',
  ReadReceiptUpdated = 'READ_RECEIPT_UPDATED',
  TypingChanged = 'TYPING_CHANGED'
}

/** The filterable fields of type Conversation */
export type ConversationFilterInput = {
  and?: InputMaybe<Array<ConversationFilterInput>>;
  not?: InputMaybe<ConversationFilterInput>;
  or?: InputMaybe<Array<ConversationFilterInput>>;
};

export type ConversationLifecycleEvent = {
  __typename?: 'ConversationLifecycleEvent';
  conversation?: Maybe<Conversation>;
  conversationId: Scalars['UUID']['output'];
  type: ConversationLifecycleEventType;
};

/** The filterable fields of type ConversationLifecycleEvent */
export type ConversationLifecycleEventFilterInput = {
  and?: InputMaybe<Array<ConversationLifecycleEventFilterInput>>;
  not?: InputMaybe<ConversationLifecycleEventFilterInput>;
  or?: InputMaybe<Array<ConversationLifecycleEventFilterInput>>;
};

export enum ConversationLifecycleEventType {
  Created = 'CREATED',
  Deleted = 'DELETED'
}

export type ConversationMessagesInput = {
  afterMessageId?: InputMaybe<Scalars['UUID']['input']>;
  conversationId: Scalars['UUID']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type ConversationReadReceipt = {
  __typename?: 'ConversationReadReceipt';
  conversationId: Scalars['UUID']['output'];
  lastReadMessageId: Scalars['UUID']['output'];
  personId: Scalars['UUID']['output'];
  readAt: Scalars['DateTime']['output'];
};

/** The filterable fields of type ConversationReadReceipt */
export type ConversationReadReceiptFilterInput = {
  and?: InputMaybe<Array<ConversationReadReceiptFilterInput>>;
  not?: InputMaybe<ConversationReadReceiptFilterInput>;
  or?: InputMaybe<Array<ConversationReadReceiptFilterInput>>;
};

export type CountriesResult = {
  __typename?: 'CountriesResult';
  countries: Array<Country>;
};

/** The filterable fields of type CountriesResult */
export type CountriesResultFilterInput = {
  and?: InputMaybe<Array<CountriesResultFilterInput>>;
  not?: InputMaybe<CountriesResultFilterInput>;
  or?: InputMaybe<Array<CountriesResultFilterInput>>;
};

export type Country = Node & {
  __typename?: 'Country';
  hasStates?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  iso2?: Maybe<Scalars['String']['output']>;
  iso3?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  obsolete?: Maybe<Scalars['Boolean']['output']>;
  osmId?: Maybe<Scalars['Int']['output']>;
};

/** The filterable fields of type Country */
export type CountryFilterInput = {
  and?: InputMaybe<Array<CountryFilterInput>>;
  id?: InputMaybe<IdFilterInput>;
  iso2?: InputMaybe<StringFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<CountryFilterInput>;
  or?: InputMaybe<Array<CountryFilterInput>>;
};

/** Filtering options for a list of elements with type Country */
export type CountryListFilterInput = {
  /** All list items must match the predicate */
  all?: InputMaybe<CountryFilterInput>;
  /** If true, there should exist at least list item */
  any?: InputMaybe<Scalars['Boolean']['input']>;
  /** None of list items must match the predicate */
  none?: InputMaybe<CountryFilterInput>;
  /** At least one of list items must match the predicate */
  some?: InputMaybe<CountryFilterInput>;
};

/** Contains information for linking 'Country' to other entities */
export type CountryRelationInput = {
  /** The identifier of 'Country' */
  id: Scalars['ID']['input'];
};

export type CountryState = Node & {
  __typename?: 'CountryState';
  countryId: Scalars['UUID']['output'];
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  osmId?: Maybe<Scalars['Int']['output']>;
};

/** The filterable fields of type CountryState */
export type CountryStateFilterInput = {
  and?: InputMaybe<Array<CountryStateFilterInput>>;
  id?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<CountryStateFilterInput>;
  or?: InputMaybe<Array<CountryStateFilterInput>>;
};

/** Contains information for linking 'CountryState' to other entities */
export type CountryStateRelationInput = {
  /** The identifier of 'CountryState' */
  id: Scalars['ID']['input'];
};

export type CountryStatesByCountryInput = {
  countryId: Scalars['UUID']['input'];
};

export type CountryStatesByCountryResult = {
  __typename?: 'CountryStatesByCountryResult';
  states: Array<CountryState>;
};

/** The filterable fields of type CountryStatesByCountryResult */
export type CountryStatesByCountryResultFilterInput = {
  and?: InputMaybe<Array<CountryStatesByCountryResultFilterInput>>;
  not?: InputMaybe<CountryStatesByCountryResultFilterInput>;
  or?: InputMaybe<Array<CountryStatesByCountryResultFilterInput>>;
};

export type CreateAccessGroupInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
};

/** Create a new custom Role only. No existing Role, scope, Grant or membership can be addressed. */
export type CreateAccessRoleInput = {
  /** Optional description, up to 2000 characters. */
  description?: InputMaybe<Scalars['String']['input']>;
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  /** Display name, 1–120 characters after trimming. */
  name: Scalars['String']['input'];
  /** Existing Permission ids. At least one; duplicate ids are treated as one selection. */
  permissionIds: Array<Scalars['ID']['input']>;
};

/** The input data for creating an instance of Agent */
export type CreateAgentDataInput = {
  /** Capability areas described in plain text. */
  covers: Array<CreateLocalizedTextDataInput>;
  guardrails: Array<CreateLocalizedTextDataInput>;
  /** The integration surface as the vendor names it (MCP servers, connectors, plugins). Product tokens. */
  integrations: Array<Scalars['String']['input']>;
  /** The model, when known. */
  model?: InputMaybe<Scalars['String']['input']>;
  /** Product name. Must not be blank. `agents` orders by it unless `order` says otherwise. */
  name: Scalars['String']['input'];
  /** What the agent does. At least one of german / english must be non-blank. */
  role: CreateLocalizedTextDataInput;
  tools: Array<CreateAgentToolDataInput>;
  /** The vendor's product page. */
  url?: InputMaybe<Scalars['String']['input']>;
  /** The vendor's name. Must not be blank. */
  vendor: Scalars['String']['input'];
};

/** Data structure to create a new instance of Agent */
export type CreateAgentInput = {
  /** The actual data of Agent */
  data: CreateAgentDataInput;
  /** If true, only the validation is performed but the instance will not be created */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The result of creating an instance of Agent */
export type CreateAgentOutput = CreateAgentResult | ValidateAgentResult;

/** The result data structure of creating an instance of Agent */
export type CreateAgentResult = {
  __typename?: 'CreateAgentResult';
  /** The actual data returned for Agent */
  result: Agent;
};

/** The input data for creating an instance of AgentTool */
export type CreateAgentToolDataInput = {
  description: CreateLocalizedTextDataInput;
  /** Product token, never translated. */
  name: Scalars['String']['input'];
};

/** The input data for creating an instance of Certificate */
export type CreateCertificateDataInput = {
  /** Dynamic consent to all current and future eligible Groups, independent of public readership. */
  allGroups?: InputMaybe<Scalars['Boolean']['input']>;
  date?: InputMaybe<CreateDateInstantDataInput>;
  name: Scalars['String']['input'];
  person: PersonRelationInput;
  /** Public readership, independent of Group recipients. Company and HR publication rules still apply. */
  publiclyReadable?: InputMaybe<Scalars['Boolean']['input']>;
  /** Group recipients; an empty list grants no ordinary Group readership. */
  sharedWith?: InputMaybe<Array<InputMaybe<ContentSharingRecipientRelationInput>>>;
};

/** Data structure to create a new instance of Certificate */
export type CreateCertificateInput = {
  /** The actual data of Certificate */
  data: CreateCertificateDataInput;
  /** If true, only the validation is performed but the instance will not be created */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The result of creating an instance of Certificate */
export type CreateCertificateOutput = CreateCertificateResult | ValidateCertificateResult;

/** The result data structure of creating an instance of Certificate */
export type CreateCertificateResult = {
  __typename?: 'CreateCertificateResult';
  /** The actual data returned for Certificate */
  result: Certificate;
};

/** The input data for creating an instance of Colors */
export type CreateColorsDataInput = {
  background?: InputMaybe<Scalars['Color']['input']>;
  text?: InputMaybe<Scalars['Color']['input']>;
};

/** The input data for creating an instance of Company */
export type CreateCompanyDataInput = {
  /**
   * Headcount. Available on `company`, `companies` nodes, `MatchCompany.company` and
   * `MatchResultCompany.company`; null on other Company references, even when a headcount is known.
   */
  employeeCount?: InputMaybe<Scalars['Int']['input']>;
  /** Industry. The curated Industry reference entity, shared with Experience. */
  industry?: InputMaybe<IndustryRelationInput>;
  /**
   * Company logo. Available on `company`, `myCompanies`, `companyIdentities`, and `SharedItem.company`
   * when reading a single shared item or its create/update result. Null when no logo exists, and always
   * null on other Company references, including company membership lists and shared-item lists.
   *
   * `profile` accepts "card" (maximum height 140 pixels) or "share_preview" (maximum height 250 pixels);
   * omit it for the original. Content is returned as Base64 through File.content.
   *
   * Uploads accept PNG, JPEG, GIF, BMP, TIFF or WebP, at most 5 MiB. Actual content is checked regardless
   * of the declared MIME type; SVG is rejected. On update, omitting logo preserves it and explicit null
   * removes it.
   */
  logo?: InputMaybe<CreateFileDataInput>;
  /** Company name, non-blank and at most 255 characters after trimming. */
  name: Scalars['String']['input'];
  /**
   * Company profile text, up to 20,000 characters. Available on `company` and `companies` nodes;
   * null on all other Company references, even when a summary exists. On those two profile queries,
   * null means no summary is set. The summary is not searchable or filterable.
   */
  summary?: InputMaybe<Scalars['String']['input']>;
};

/** Data structure to create a new instance of Company */
export type CreateCompanyInput = {
  /** The actual data of Company */
  data: CreateCompanyDataInput;
  /** If true, only the validation is performed but the instance will not be created */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The result of creating an instance of Company */
export type CreateCompanyOutput = CreateCompanyResult | ValidateCompanyResult;

/** The result data structure of creating an instance of Company */
export type CreateCompanyResult = {
  __typename?: 'CreateCompanyResult';
  /** The actual data returned for Company */
  result: Company;
};

/** The input data for creating an instance of ContractType */
export type CreateContractTypeDataInput = {
  localizedDesc?: InputMaybe<CreateLocalizedTextDataInput>;
  localizedName?: InputMaybe<CreateLocalizedTextDataInput>;
};

/** Data structure to create a new instance of ContractType */
export type CreateContractTypeInput = {
  /** The actual data of ContractType */
  data: CreateContractTypeDataInput;
  /** If true, only the validation is performed but the instance will not be created */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The result of creating an instance of ContractType */
export type CreateContractTypeOutput = CreateContractTypeResult | ValidateContractTypeResult;

/** The result data structure of creating an instance of ContractType */
export type CreateContractTypeResult = {
  __typename?: 'CreateContractTypeResult';
  /** The actual data returned for ContractType */
  result: ContractType;
};

export type CreateConversationInput = {
  participantIds: Array<Scalars['UUID']['input']>;
};

/** The input data for creating an instance of CurriculumVitae */
export type CreateCurriculumVitaeDataInput = {
  apiVersion: Scalars['Int']['input'];
  /**
   * Client-defined JSON object controlling CV presentation for this apiVersion. Returned as supplied;
   * the server does not interpret its members. A supplied update replaces the complete configuration.
   */
  configuration?: InputMaybe<Scalars['Object']['input']>;
  /**
   * Client-defined JSON object containing CV content for this apiVersion. Returned as supplied;
   * the server does not interpret its members. A supplied update replaces the complete content.
   */
  content?: InputMaybe<Scalars['Object']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  person: PersonRelationInput;
};

/** Data structure to create a new instance of CurriculumVitae */
export type CreateCurriculumVitaeInput = {
  /** The actual data of CurriculumVitae */
  data: CreateCurriculumVitaeDataInput;
  /** If true, only the validation is performed but the instance will not be created */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The result of creating an instance of CurriculumVitae */
export type CreateCurriculumVitaeOutput = CreateCurriculumVitaeResult | ValidateCurriculumVitaeResult;

/** The result data structure of creating an instance of CurriculumVitae */
export type CreateCurriculumVitaeResult = {
  __typename?: 'CreateCurriculumVitaeResult';
  /** The actual data returned for CurriculumVitae */
  result: CurriculumVitae;
};

/** The input data for creating an instance of DateInstant */
export type CreateDateInstantDataInput = {
  date: Scalars['Date']['input'];
  precision: DatePrecision;
};

/** The input data for creating an instance of Deceased */
export type CreateDeceasedDataInput = {
  deceased?: InputMaybe<Scalars['Boolean']['input']>;
  deceasedDate?: InputMaybe<CreateDateInstantDataInput>;
};

/** The input data for creating an instance of Degree */
export type CreateDegreeDataInput = {
  localizedName?: InputMaybe<CreateLocalizedTextDataInput>;
};

/** Data structure to create a new instance of Degree */
export type CreateDegreeInput = {
  /** The actual data of Degree */
  data: CreateDegreeDataInput;
  /** If true, only the validation is performed but the instance will not be created */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The result of creating an instance of Degree */
export type CreateDegreeOutput = CreateDegreeResult | ValidateDegreeResult;

/** The result data structure of creating an instance of Degree */
export type CreateDegreeResult = {
  __typename?: 'CreateDegreeResult';
  /** The actual data returned for Degree */
  result: Degree;
};

/** The input data for creating an instance of DiscoveryCategory */
export type CreateDiscoveryCategoryDataInput = {
  name?: InputMaybe<CreateLocalizedTextDataInput>;
};

/** Data structure to create a new instance of DiscoveryCategory */
export type CreateDiscoveryCategoryInput = {
  /** The actual data of DiscoveryCategory */
  data: CreateDiscoveryCategoryDataInput;
  /** If true, only the validation is performed but the instance will not be created */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The result of creating an instance of DiscoveryCategory */
export type CreateDiscoveryCategoryOutput = CreateDiscoveryCategoryResult | ValidateDiscoveryCategoryResult;

/** The result data structure of creating an instance of DiscoveryCategory */
export type CreateDiscoveryCategoryResult = {
  __typename?: 'CreateDiscoveryCategoryResult';
  /** The actual data returned for DiscoveryCategory */
  result: DiscoveryCategory;
};

/** The input data for creating an instance of Document */
export type CreateDocumentDataInput = {
  category?: InputMaybe<DocumentClassifier>;
  content: CreateFileDataInput;
  fileName?: InputMaybe<Scalars['String']['input']>;
  group?: InputMaybe<DocumentGroupRelationInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  person: PersonRelationInput;
  /** Public readership, independent of Group recipients. Company and HR publication rules still apply. */
  publiclyReadable?: InputMaybe<Scalars['Boolean']['input']>;
  /** Group recipients; an empty list grants no ordinary Group readership. */
  sharedWith?: InputMaybe<Array<InputMaybe<ContentSharingRecipientRelationInput>>>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** The input data for creating an instance of DocumentGroup */
export type CreateDocumentGroupDataInput = {
  name: Scalars['String']['input'];
};

/** Data structure to create a new instance of DocumentGroup */
export type CreateDocumentGroupInput = {
  /** The actual data of the document group */
  data: CreateDocumentGroupDataInput;
  /** If true, only the validation is performed but the instance will not be created */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  /** The ID of the person the group belongs to */
  person?: InputMaybe<Scalars['String']['input']>;
};

/** The result of creating an instance of document group */
export type CreateDocumentGroupOutput = CreateDocumentGroupResult | TooManyRecordsResult | ValidateDocumentGroupResult;

/** The result data structure of creating an instance of DocumentGroup */
export type CreateDocumentGroupResult = {
  __typename?: 'CreateDocumentGroupResult';
  /** The actual data returned for DocumentGroup */
  result: DocumentGroup;
};

/** Data structure to create a new instance of Document */
export type CreateDocumentInput = {
  /** The actual data of Document */
  data: CreateDocumentDataInput;
  /** If true, only the validation is performed but the instance will not be created */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The result of creating an instance of Document */
export type CreateDocumentOutput = CreateDocumentResult | ValidateDocumentResult;

/** The result data structure of creating an instance of Document */
export type CreateDocumentResult = {
  __typename?: 'CreateDocumentResult';
  /** The actual data returned for Document */
  result: Document;
};

/** The input data for creating an instance of Education */
export type CreateEducationDataInput = {
  /** Dynamic consent to all current and future eligible Groups, independent of public readership. */
  allGroups?: InputMaybe<Scalars['Boolean']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<CountryRelationInput>;
  degree?: InputMaybe<DegreeRelationInput>;
  endDate?: InputMaybe<CreateDateInstantDataInput>;
  /** The field of study; null when unknown. */
  field?: InputMaybe<Scalars['String']['input']>;
  institution?: InputMaybe<Scalars['String']['input']>;
  person: PersonRelationInput;
  /** Public readership, independent of Group recipients. Company and HR publication rules still apply. */
  publiclyReadable?: InputMaybe<Scalars['Boolean']['input']>;
  /** Group recipients; an empty list grants no ordinary Group readership. */
  sharedWith?: InputMaybe<Array<InputMaybe<ContentSharingRecipientRelationInput>>>;
  /** When the education started; null when unknown. */
  startDate?: InputMaybe<CreateDateInstantDataInput>;
};

/** Data structure to create a new instance of Education */
export type CreateEducationInput = {
  /** The actual data of Education */
  data: CreateEducationDataInput;
  /** If true, only the validation is performed but the instance will not be created */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The result of creating an instance of Education */
export type CreateEducationOutput = CreateEducationResult | ValidateEducationResult;

/** The result data structure of creating an instance of Education */
export type CreateEducationResult = {
  __typename?: 'CreateEducationResult';
  /** The actual data returned for Education */
  result: Education;
};

/** The input data for creating an instance of ElementWeight */
export type CreateElementWeightDataInput = {
  element?: InputMaybe<CreativityElement>;
  weight?: InputMaybe<Scalars['Int']['input']>;
};

/** The input data for creating an instance of Experience */
export type CreateExperienceDataInput = {
  activities?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Dynamic consent to all current and future eligible Groups, independent of public readership. */
  allGroups?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Optional classification metadata, independent of proficiency and subject to this entry's sharing rules.
   * The object has integer version 1, entryOrigin (UNKNOWN, MANUAL, DOCUMENT_IMPORT, AI_SUGGESTION,
   * ESCO_SELECTION), and references. Null means no recorded metadata; updates replace the whole object,
   * omission preserves it. Each reference has uri, label, version (ESCO release, e.g. v1.2.1),
   * language (de/en), optional description, source (USER_SELECTED/AUTOMATIC), status (CONFIRMED/PROPOSED),
   * and basedOnText (the entry wording when confirmed). Changing that wording demotes the mapping to
   * PROPOSED; changing only proficiency or sharing preserves it. No competency level is inferred from ESCO.
   * Experience accepts at most five references with http://data.europa.eu/esco/occupation/{UUID} URIs.
   */
  classification?: InputMaybe<Scalars['Object']['input']>;
  country?: InputMaybe<CountryRelationInput>;
  department?: InputMaybe<Scalars['String']['input']>;
  employer?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<CreateDateInstantDataInput>;
  industry?: InputMaybe<IndustryRelationInput>;
  jobTitle: Scalars['String']['input'];
  location?: InputMaybe<Scalars['String']['input']>;
  person: PersonRelationInput;
  /** Public readership, independent of Group recipients. Company and HR publication rules still apply. */
  publiclyReadable?: InputMaybe<Scalars['Boolean']['input']>;
  /** Group recipients; an empty list grants no ordinary Group readership. */
  sharedWith?: InputMaybe<Array<InputMaybe<ContentSharingRecipientRelationInput>>>;
  startDate: CreateDateInstantDataInput;
};

/** Data structure to create a new instance of Experience */
export type CreateExperienceInput = {
  /** The actual data of Experience */
  data: CreateExperienceDataInput;
  /** If true, only the validation is performed but the instance will not be created */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The result of creating an instance of Experience */
export type CreateExperienceOutput = CreateExperienceResult | ValidateExperienceResult;

/** The result data structure of creating an instance of Experience */
export type CreateExperienceResult = {
  __typename?: 'CreateExperienceResult';
  /** The actual data returned for Experience */
  result: Experience;
};

/** The input data for creating an instance of Expertise */
export type CreateExpertiseDataInput = {
  /** Dynamic consent to all current and future eligible Groups, independent of public readership. */
  allGroups?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Optional classification metadata, independent of proficiency and subject to this entry's sharing rules.
   * The object has integer version 1, entryOrigin (UNKNOWN, MANUAL, DOCUMENT_IMPORT, AI_SUGGESTION,
   * ESCO_SELECTION), and references. Null means no recorded metadata; updates replace the whole object,
   * omission preserves it. Each reference has uri, label, version (ESCO release, e.g. v1.2.1),
   * language (de/en), optional description, source (USER_SELECTED/AUTOMATIC), status (CONFIRMED/PROPOSED),
   * and basedOnText (the entry wording when confirmed). Changing that wording demotes the mapping to
   * PROPOSED; changing only proficiency or sharing preserves it. No competency level is inferred from ESCO.
   * Expertise accepts at most one reference with an http://data.europa.eu/esco/skill/{UUID} URI.
   */
  classification?: InputMaybe<Scalars['Object']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  level: Scalars['Int']['input'];
  person: PersonRelationInput;
  position: Scalars['Int']['input'];
  /** Public readership, independent of Group recipients. Company and HR publication rules still apply. */
  publiclyReadable?: InputMaybe<Scalars['Boolean']['input']>;
  /** Group recipients; an empty list grants no ordinary Group readership. */
  sharedWith?: InputMaybe<Array<InputMaybe<ContentSharingRecipientRelationInput>>>;
};

/** Data structure to create a new instance of Expertise */
export type CreateExpertiseInput = {
  /** The actual data of Expertise */
  data: CreateExpertiseDataInput;
  /** If true, only the validation is performed but the instance will not be created */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The result of creating an instance of Expertise */
export type CreateExpertiseOutput = CreateExpertiseResult | ValidateExpertiseResult;

/** The result data structure of creating an instance of Expertise */
export type CreateExpertiseResult = {
  __typename?: 'CreateExpertiseResult';
  /** The actual data returned for Expertise */
  result: Expertise;
};

/** The input data for creating an instance of File */
export type CreateFileDataInput = {
  content?: InputMaybe<Scalars['Binary']['input']>;
  fileName?: InputMaybe<Scalars['String']['input']>;
  mimeType?: InputMaybe<Scalars['String']['input']>;
};

/** The input data for creating an instance of Gender */
export type CreateGenderDataInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  /** Canonical English name, independent of the requested language. Can match extracted values to ids. */
  nameEn?: InputMaybe<Scalars['String']['input']>;
};

/** Data structure to create a new instance of Gender */
export type CreateGenderInput = {
  /** The actual data of Gender */
  data: CreateGenderDataInput;
  /** If true, only the validation is performed but the instance will not be created */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The result of creating an instance of Gender */
export type CreateGenderOutput = CreateGenderResult | ValidateGenderResult;

/** The result data structure of creating an instance of Gender */
export type CreateGenderResult = {
  __typename?: 'CreateGenderResult';
  /** The actual data returned for Gender */
  result: Gender;
};

/** The input data for creating an instance of HumanName */
export type CreateHumanNameDataInput = {
  family?: InputMaybe<Scalars['String']['input']>;
  given?: InputMaybe<Array<Scalars['String']['input']>>;
  period?: InputMaybe<CreatePeriodDataInput>;
  prefix?: InputMaybe<Scalars['String']['input']>;
  suffix?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  use: NameUse;
};

/** The input data for creating an instance of Industry */
export type CreateIndustryDataInput = {
  localizedName?: InputMaybe<CreateLocalizedTextDataInput>;
};

/** Data structure to create a new instance of Industry */
export type CreateIndustryInput = {
  /** The actual data of Industry */
  data: CreateIndustryDataInput;
  /** If true, only the validation is performed but the instance will not be created */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The result of creating an instance of Industry */
export type CreateIndustryOutput = CreateIndustryResult | ValidateIndustryResult;

/** The result data structure of creating an instance of Industry */
export type CreateIndustryResult = {
  __typename?: 'CreateIndustryResult';
  /** The actual data returned for Industry */
  result: Industry;
};

/** The input data for creating an instance of JobDepartment */
export type CreateJobDepartmentDataInput = {
  localizedName?: InputMaybe<CreateLocalizedTextDataInput>;
};

/** Data structure to create a new instance of JobDepartment */
export type CreateJobDepartmentInput = {
  /** The actual data of JobDepartment */
  data: CreateJobDepartmentDataInput;
  /** If true, only the validation is performed but the instance will not be created */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The result of creating an instance of JobDepartment */
export type CreateJobDepartmentOutput = CreateJobDepartmentResult | ValidateJobDepartmentResult;

/** The result data structure of creating an instance of JobDepartment */
export type CreateJobDepartmentResult = {
  __typename?: 'CreateJobDepartmentResult';
  /** The actual data returned for JobDepartment */
  result: JobDepartment;
};

/** The input data for creating an instance of JobLocation */
export type CreateJobLocationDataInput = {
  localizedName?: InputMaybe<CreateLocalizedTextDataInput>;
};

/** Data structure to create a new instance of JobLocation */
export type CreateJobLocationInput = {
  /** The actual data of JobLocation */
  data: CreateJobLocationDataInput;
  /** If true, only the validation is performed but the instance will not be created */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The result of creating an instance of JobLocation */
export type CreateJobLocationOutput = CreateJobLocationResult | ValidateJobLocationResult;

/** The result data structure of creating an instance of JobLocation */
export type CreateJobLocationResult = {
  __typename?: 'CreateJobLocationResult';
  /** The actual data returned for JobLocation */
  result: JobLocation;
};

/** The input data for creating an instance of LanguageSkill */
export type CreateLanguageSkillDataInput = {
  /** Dynamic consent to all current and future eligible Groups, independent of public readership. */
  allGroups?: InputMaybe<Scalars['Boolean']['input']>;
  cefr?: InputMaybe<CefrScale>;
  /** BCP 47 language tag, for example "en" or "de". */
  languageTag: Scalars['String']['input'];
  nativeSpeaker: Scalars['Boolean']['input'];
  person: PersonRelationInput;
  /** Public readership, independent of Group recipients. Company and HR publication rules still apply. */
  publiclyReadable?: InputMaybe<Scalars['Boolean']['input']>;
  selfAssessed?: InputMaybe<Scalars['Boolean']['input']>;
  /** Group recipients; an empty list grants no ordinary Group readership. */
  sharedWith?: InputMaybe<Array<InputMaybe<ContentSharingRecipientRelationInput>>>;
};

/** Data structure to create a new instance of LanguageSkill */
export type CreateLanguageSkillInput = {
  /** The actual data of LanguageSkill */
  data: CreateLanguageSkillDataInput;
  /** If true, only the validation is performed but the instance will not be created */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The result of creating an instance of LanguageSkill */
export type CreateLanguageSkillOutput = CreateLanguageSkillResult | ValidateLanguageSkillResult;

/** The result data structure of creating an instance of LanguageSkill */
export type CreateLanguageSkillResult = {
  __typename?: 'CreateLanguageSkillResult';
  /** The actual data returned for LanguageSkill */
  result: LanguageSkill;
};

/** The input data for creating an instance of ListingAccess */
export type CreateListingAccessDataInput = {
  /**
   * Applications. NONE grants no read access, READ permits reading and WRITE also permits changing application
   * state with `setListingApplicationState`. Membership alone does not permit reading applications.
   */
  applications: ListingApplicationAccessLevel;
  /** Candidates. WRITE permits linking and unlinking matches. */
  candidates: AccessLevel;
  person: PersonRelationInput;
  /** Listing text and requirements. WRITE also permits every lifecycle transition. */
  plan: AccessLevel;
};

/** The input data for creating an instance of Listing */
export type CreateListingDataInput = {
  /**
   * Complete desired access list. A supplied list replaces existing grants; null or omission preserves them.
   * The creator retains WRITE on every listing area. Visible only to members. Updating this field requires the
   * same access-management capability and delegation checks as `setListingAccess`, independently of WRITE on
   * `plan`. A content editor without management rights is refused and nothing is written. Prefer
   * `setListingAccess`, which additionally rejects stale access revisions; this update field remains for
   * compatibility.
   */
  access?: InputMaybe<Array<CreateListingAccessDataInput>>;
  /** Replace categories. Omission preserves them; an empty list clears them. At most 100 ids. */
  categoryIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /**
   * Versioned JSON planning document containing listing text and requirements, following the same payload
   * model as `Project.data`.
   */
  data?: InputMaybe<Scalars['Object']['input']>;
  /**
   * Deadline after which an OPEN listing behaves as CLOSED; null means no deadline. Visible to all content
   * readers, including group recipients and public readers. Change through `updateListing` with WRITE on
   * `plan`.
   */
  deadline?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  /**
   * Additional images in insertion order, visible like the cover image. `updateListing` appends supplied
   * images; it does not replace existing ones. Remove with `imagesToDelete`. The cover image's format and size
   * limits apply; the number of images is not limited.
   */
  images?: InputMaybe<Array<CreateFileDataInput>>;
  /**
   * Remove additional images by `File.id` on update; ignored on creation. Ids not belonging to the listing are
   * ignored. Remove the cover separately with `mainImage: null`.
   */
  imagesToDelete?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /**
   * Cover image, visible to all permitted content readers including applicants. `profile` selects a resized
   * image (`card` or `share_preview`); omission returns the original. Set on creation or replace through
   * `updateListing` with WRITE on `plan`. Null on update removes it; omission preserves it. Raster images only
   * (PNG, JPEG, GIF, BMP, TIFF, WebP), at most 5 MiB, validated from the bytes rather than the declared MIME
   * type or filename.
   */
  mainImage?: InputMaybe<CreateFileDataInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  /**
   * Whether the listing is publicly readable, independently of group recipients and only while open. Visible
   * only to members.
   */
  publiclyReadable?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Retention period from 1 to 180 days, defaulting to 180 on creation. This is a product limit, not a legal
   * minimum. Visible only to members. Each application counts from its rejection or withdrawal; applications
   * still open at conclusion count from that conclusion. Later changes do not move deletion dates already
   * calculated.
   */
  retentionDays?: InputMaybe<Scalars['Int']['input']>;
  /** Group recipients, who read only while the listing is open. Visible only to members. */
  sharedWith?: InputMaybe<Array<InputMaybe<ContentSharingRecipientRelationInput>>>;
};

/** Data structure to create a new instance of Listing */
export type CreateListingInput = {
  /** The actual data of Listing */
  data: CreateListingDataInput;
  /** If true, only the validation is performed but the instance will not be created */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateListingMatchVersionInput = {
  design: Scalars['Object']['input'];
  listingId: Scalars['UUID']['input'];
  requestId: Scalars['UUID']['input'];
  sourceMatchId: Scalars['UUID']['input'];
};

/** The result of creating an instance of Listing */
export type CreateListingOutput = CreateListingResult | ValidateListingResult;

/** The result data structure of creating an instance of Listing */
export type CreateListingResult = {
  __typename?: 'CreateListingResult';
  /** The actual data returned for Listing */
  result: Listing;
};

/** The input data for creating an instance of LocalizedText */
export type CreateLocalizedTextDataInput = {
  english?: InputMaybe<Scalars['String']['input']>;
  german?: InputMaybe<Scalars['String']['input']>;
};

/** The input data for creating an instance of MaritalStatus */
export type CreateMaritalStatusDataInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  /** Canonical English name, independent of the requested language. Can match extracted values to ids. */
  nameEn?: InputMaybe<Scalars['String']['input']>;
};

/** Data structure to create a new instance of MaritalStatus */
export type CreateMaritalStatusInput = {
  /** The actual data of MaritalStatus */
  data: CreateMaritalStatusDataInput;
  /** If true, only the validation is performed but the instance will not be created */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The result of creating an instance of MaritalStatus */
export type CreateMaritalStatusOutput = CreateMaritalStatusResult | ValidateMaritalStatusResult;

/** The result data structure of creating an instance of MaritalStatus */
export type CreateMaritalStatusResult = {
  __typename?: 'CreateMaritalStatusResult';
  /** The actual data returned for MaritalStatus */
  result: MaritalStatus;
};

/** The input data for creating an instance of MatchAccess */
export type CreateMatchAccessDataInput = {
  design: AccessLevel;
  discover: AccessLevel;
  match: AccessLevel;
  person: PersonRelationInput;
  prepare: AccessLevel;
};

/** The input data for creating an instance of MatchCandidate */
export type CreateMatchCandidateDataInput = {
  locked?: InputMaybe<Scalars['Boolean']['input']>;
  match?: InputMaybe<MatchRelationInput>;
  person?: InputMaybe<PersonRelationInput>;
};

/** Data structure to create a new instance of MatchCandidate */
export type CreateMatchCandidateInput = {
  /** The actual data of MatchCandidate */
  data: CreateMatchCandidateDataInput;
  /** If true, only the validation is performed but the instance will not be created */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The result of creating an instance of MatchCandidate */
export type CreateMatchCandidateOutput = CreateMatchCandidateResult | ValidateMatchCandidateResult;

/** The result data structure of creating an instance of MatchCandidate */
export type CreateMatchCandidateResult = {
  __typename?: 'CreateMatchCandidateResult';
  /** The actual data returned for MatchCandidate */
  result: MatchCandidate;
};

/** The input data for creating multiple instances of MatchCandidate */
export type CreateMatchCandidatesDataInput = {
  locked: Scalars['Boolean']['input'];
  /** The person to add to the match's candidate pool. */
  person: PersonRelationInput;
};

/** Data structure to create a multiple instances of MatchCandidate */
export type CreateMatchCandidatesInput = {
  /** The actual data of MatchCandidate */
  data: Array<CreateMatchCandidatesDataInput>;
  /** If true, only the validation is performed but the instance will not be created */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  match: MatchRelationInput;
};

export type CreateMatchCandidatesOutput = {
  __typename?: 'CreateMatchCandidatesOutput';
  match?: Maybe<Scalars['UUID']['output']>;
};

/** The filterable fields of type CreateMatchCandidatesOutput */
export type CreateMatchCandidatesOutputFilterInput = {
  and?: InputMaybe<Array<CreateMatchCandidatesOutputFilterInput>>;
  not?: InputMaybe<CreateMatchCandidatesOutputFilterInput>;
  or?: InputMaybe<Array<CreateMatchCandidatesOutputFilterInput>>;
};

/** The input data for creating multiple instances of MatchCompany */
export type CreateMatchCompaniesDataInput = {
  company?: InputMaybe<CompanyRelationInput>;
};

export type CreateMatchCompaniesInput = {
  /** The actual data of MatchCompany */
  data: Array<CreateMatchCompaniesDataInput>;
  /** If true, only the validation is performed but the instance will not be created */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  /** The match whose company pool is being changed. Required to scope authorization to that match. */
  match: MatchRelationInput;
};

export type CreateMatchCompaniesOutput = {
  __typename?: 'CreateMatchCompaniesOutput';
  match?: Maybe<Scalars['UUID']['output']>;
};

/** The filterable fields of type CreateMatchCompaniesOutput */
export type CreateMatchCompaniesOutputFilterInput = {
  and?: InputMaybe<Array<CreateMatchCompaniesOutputFilterInput>>;
  not?: InputMaybe<CreateMatchCompaniesOutputFilterInput>;
  or?: InputMaybe<Array<CreateMatchCompaniesOutputFilterInput>>;
};

/** The input data for creating an instance of MatchCompany */
export type CreateMatchCompanyDataInput = {
  /**
   * The pinned company: its identity plus `employeeCount`, the value a size criterion is judged on.
   * `summary` is null here — see Company.employeeCount for the one exception this field makes.
   */
  company?: InputMaybe<CompanyRelationInput>;
  match?: InputMaybe<MatchRelationInput>;
};

/** Data structure to create a new instance of MatchCompany */
export type CreateMatchCompanyInput = {
  /** The actual data of MatchCompany */
  data: CreateMatchCompanyDataInput;
  /** If true, only the validation is performed but the instance will not be created */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The result of creating an instance of MatchCompany */
export type CreateMatchCompanyOutput = CreateMatchCompanyResult | ValidateMatchCompanyResult;

/** The result data structure of creating an instance of MatchCompany */
export type CreateMatchCompanyResult = {
  __typename?: 'CreateMatchCompanyResult';
  /** The actual data returned for MatchCompany */
  result: MatchCompany;
};

/** The input data for creating an instance of Match */
export type CreateMatchDataInput = {
  /**
   * Complete replacement of access grants on update. People omitted from a supplied list lose their
   * grants; an empty list revokes all grants. Omitted or null leaves existing grants unchanged.
   */
  access?: InputMaybe<Array<CreateMatchAccessDataInput>>;
  description?: InputMaybe<Scalars['String']['input']>;
  /**
   * Match configuration as a JSON object. On update, a supplied object replaces the design except for
   * attached `project.documents`, which are preserved. Omitted or null leaves the design unchanged.
   * Use the focused setMatch mutations to change individual parts without replacing unrelated data.
   *
   * The current format has `version: 2`. Version 1, including an omitted version, is accepted and
   * upgraded; version-1 power weights from 0–10 become 0–1000. Unsupported versions are rejected.
   * Common members are teamSize, teamCount (integers), teamProfile (id, name, elementWeights keyed by
   * CreativityElement), conditions and companyConditions (lists), aiCopilotText (string), and project
   * (name, shortDescription, description, documents). Document entries contain backdropFileId and name,
   * with optional size in bytes and mimeType. Maintain them through attachProjectDocument and
   * detachProjectDocument.
   *
   * Conditions contain __typename, operator, composition, active and optional requirement (MUST or
   * OPTIONAL). composition contains operator and optional value. Person-condition discriminators are
   * AgeCondition, AnnualSalaryCondition, ChildrenCountCondition, CertificateCondition,
   * CitizenshipCondition, CityCondition, CountryCondition, DriversLicenseCondition, EducationCondition,
   * ExperienceCondition, ExpertiseCondition, GenderCondition, IndustryExperienceCondition,
   * JobDepartmentCondition, JobLocationCondition, LanguageCondition, MaritalCondition and
   * NationalityCondition. Their values describe the corresponding requirement. For validated writes,
   * prefer `setMatchConditions` and its typed inputs. Company-condition discriminators are
   * CompanyIndustryCondition (industryId), CompanyEmployeeCountCondition (minimumEmployees), and
   * CompanyExpertiseCondition (expertise, aiMode); use `setMatchCompanyConditions` to replace them.
   *
   * AI options include agenticAiSupported (boolean), candidateAssessmentPrompt (string),
   * candidateAssessmentDetail (BULLETS, SENTENCES, LONG_TEXT), candidateAssessmentStrictness
   * (NORMAL, STRICT, EXTREME), candidateAssessmentOutcomeFocus (OPPORTUNITIES, BALANCED, RISKS), and
   * requirementLeniency (LENIENT, MUST_STRICT, STRICT). powerScoreLens is COMBINED (default),
   * SELF_ASSESSMENT or SMART_ANALYSIS. missingPowerScore is ZERO (default) or NEUTRAL, which uses 50
   * for an unmeasured power. Preserve members not being edited.
   *
   * Example: {"version":2,"teamSize":3,"teamCount":1,"conditions":[],"project":{"name":"Example project"}}.
   */
  design?: InputMaybe<Scalars['Object']['input']>;
  matchMode?: InputMaybe<MatchMode>;
  name?: InputMaybe<Scalars['String']['input']>;
  sharedItem?: InputMaybe<SharedItemRelationInput>;
};

/** Data structure to create a new instance of Match */
export type CreateMatchInput = {
  /** The actual data of Match */
  data: CreateMatchDataInput;
  /** If true, only the validation is performed but the instance will not be created */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The result of creating an instance of Match */
export type CreateMatchOutput = CreateMatchResult | ValidateMatchResult;

/** The result data structure of creating an instance of Match */
export type CreateMatchResult = {
  __typename?: 'CreateMatchResult';
  /** The actual data returned for Match */
  result: Match;
};

/** The input data for creating an instance of MatchResult */
export type CreateMatchResultDataInput = {
  candidateCount?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Snapshot of the design used for this result. Uses the JSON format described by Match.design;
   * subsequent edits to the match do not change this snapshot.
   */
  design?: InputMaybe<Scalars['Object']['input']>;
  /**
   * Presentation section identifiers associated with this result, shared by all its readers. An empty
   * list means no sections are hidden. Reads return an empty list rather than null. Identifiers are
   * opaque strings, returned unchanged and not validated against a fixed vocabulary.
   */
  hiddenSections?: InputMaybe<Array<Scalars['String']['input']>>;
  /**
   * Whether this result is saved. False denotes a draft visible only to its creator; set true to save
   * it and make it available to the match's authorized readers. Saved results cannot be changed back to
   * drafts. Later runs can replace drafts. Filter by true when requesting saved history.
   */
  kept?: InputMaybe<Scalars['Boolean']['input']>;
  matchId: Scalars['UUID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  teams?: InputMaybe<Array<CreateMatchResultTeamDataInput>>;
};

/** Data structure to create a new instance of MatchResult */
export type CreateMatchResultInput = {
  /** The actual data of MatchResult */
  data: CreateMatchResultDataInput;
  /** If true, only the validation is performed but the instance will not be created */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The result of creating an instance of MatchResult */
export type CreateMatchResultOutput = CreateMatchResultResult | ValidateMatchResultResult;

/** The result data structure of creating an instance of MatchResult */
export type CreateMatchResultResult = {
  __typename?: 'CreateMatchResultResult';
  /** The actual data returned for MatchResult */
  result: MatchResult;
};

/** The input data for creating an instance of MatchResultTeam */
export type CreateMatchResultTeamDataInput = {
  persons?: InputMaybe<Array<InputMaybe<PersonRelationInput>>>;
  /**
   * Team assessment JSON object with `version: 2`. Its members are factSkillResult, powersMatchResult,
   * teamMatchResult, infeasibility and rewardValue; members can be null when unavailable.
   *
   * factSkillResult contains criteria and teamMembers. Each member has personId and items; each item
   * contains criterion, matched, isMust, classification (SATISFIED, PARTIAL, VIOLATED or UNKNOWN),
   * fulfillment (0–1 or null when unknown), actual (string or null), and optional aiReason. A criterion
   * contains condition (the person-condition shape in Match.design), group and optional conditionKey.
   * Optional expertises entries contain description and level on a percentage scale, not the 1–7 scale.
   * Optional aiAssessment contains positive, negative and fazit (text), suitability (integer),
   * scoreDebug (text) and interviewQuestions (string list); its members may be absent or null.
   *
   * powersMatchResult contains criteria (element and group) and teamMembers (personId and items).
   * Each item has criterion and value: a power score, or null when unavailable.
   * teamMatchResult contains teamSize, maleCount, femaleCount, diverseCount, minAge, maxAge, averageAge,
   * mostFrequentJobLocationCount, mostFrequentJobDepartmentAge (a count despite its name), and
   * conditionResults (condition, matchedCount, fulfilled).
   *
   * infeasibility contains infeasibilityClass (LOCKED or POOL_TOO_TIGHT), reason (text) and relaxations
   * (condition, restrictionEnum, target and shortfall). A relaxation condition may be null when unknown.
   * LOCKED identifies incompatible locked candidates; POOL_TOO_TIGHT identifies insufficient candidates
   * meeting requirements. relaxations can be empty in either case. rewardValue is the raw optimization score;
   * it is not comparable across changes to the weight scale, power-score lens or missing-score policy.
   * Preserve the distinction between absent or null assessments and an assessment reporting zero.
   */
  result?: InputMaybe<Scalars['Object']['input']>;
};

/** The input data for creating an instance of OrgUnit */
export type CreateOrgUnitDataInput = {
  /**
   * Whether the unit is retired. Hidden units are excluded from `orgUnits` and cannot receive new
   * assignments. A unit with children or assigned people cannot be deleted; retire it instead.
   */
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  localizedName?: InputMaybe<CreateLocalizedTextDataInput>;
  /** The parent unit, or null for a root. Setting a parent that would form a cycle is refused. */
  parent?: InputMaybe<OrgUnitRelationInput>;
};

/** Data structure to create a new instance of OrgUnit */
export type CreateOrgUnitInput = {
  /** The actual data of OrgUnit */
  data: CreateOrgUnitDataInput;
  /** If true, only the validation is performed but the instance will not be created */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The result of creating an instance of OrgUnit */
export type CreateOrgUnitOutput = CreateOrgUnitResult | ValidateOrgUnitResult;

/** The result data structure of creating an instance of OrgUnit */
export type CreateOrgUnitResult = {
  __typename?: 'CreateOrgUnitResult';
  /** The actual data returned for OrgUnit */
  result: OrgUnit;
};

export type CreateOrganizationalRecordCommentDataInput = {
  content: Scalars['String']['input'];
  entry?: InputMaybe<OrganizationalRecordReferenceInput>;
  links?: InputMaybe<Array<OrganizationalRecordLinkTargetInput>>;
  organizationalRecord: OrganizationalRecordReferenceInput;
};

export type CreateOrganizationalRecordCommentInput = {
  data: CreateOrganizationalRecordCommentDataInput;
};

export type CreateOrganizationalRecordDocumentInput = {
  content: CreateFileDataInput;
  fileName: Scalars['String']['input'];
  recordId: Scalars['ID']['input'];
  title: Scalars['String']['input'];
};

export type CreateOrganizationalRecordEntryInput = {
  content: Scalars['String']['input'];
  kind: OrganizationalRecordEntryKind;
  /** At most 20 references to documents or other entries in this organizational record; duplicate targets collapse. */
  links?: InputMaybe<Array<OrganizationalRecordLinkTargetInput>>;
  recordId: Scalars['ID']['input'];
  title: Scalars['String']['input'];
};

/** The input data for creating an instance of Period */
export type CreatePeriodDataInput = {
  end?: InputMaybe<Scalars['DateTime']['input']>;
  /** Start of the period, including time and UTC offset. */
  start?: InputMaybe<Scalars['DateTime']['input']>;
};

/** The input data for creating an instance of Person */
export type CreatePersonDataInput = {
  administrativeGender?: InputMaybe<AdministrativeGender>;
  alternativeAvatar?: InputMaybe<CreateFileDataInput>;
  apartment?: InputMaybe<Scalars['String']['input']>;
  avatar?: InputMaybe<CreateFileDataInput>;
  bio?: InputMaybe<Scalars['String']['input']>;
  birthDate?: InputMaybe<Scalars['Date']['input']>;
  childCount?: InputMaybe<Scalars['Int']['input']>;
  citizenships?: InputMaybe<Array<InputMaybe<CountryRelationInput>>>;
  city?: InputMaybe<Scalars['String']['input']>;
  contractType?: InputMaybe<ContractTypeRelationInput>;
  country?: InputMaybe<CountryRelationInput>;
  countryState?: InputMaybe<CountryStateRelationInput>;
  currentActivity?: InputMaybe<Scalars['String']['input']>;
  currentEmployer?: InputMaybe<Scalars['String']['input']>;
  currentTasks?: InputMaybe<Scalars['String']['input']>;
  deceased?: InputMaybe<CreateDeceasedDataInput>;
  drivingLicence?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailPrimary: Scalars['String']['input'];
  gender?: InputMaybe<GenderRelationInput>;
  houseNumber?: InputMaybe<Scalars['String']['input']>;
  jobDepartment?: InputMaybe<JobDepartmentRelationInput>;
  jobLocation?: InputMaybe<JobLocationRelationInput>;
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  maritalStatus?: InputMaybe<MaritalStatusRelationInput>;
  miscellaneous?: InputMaybe<Scalars['String']['input']>;
  name: CreateHumanNameDataInput;
  nationality?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  profession?: InputMaybe<Scalars['String']['input']>;
  pronouns?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
  workingTimeModel?: InputMaybe<WorkingTimeModelRelationInput>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

/** The input data for creating an instance of PersonGroup */
export type CreatePersonGroupDataInput = {
  name: Scalars['String']['input'];
};

/** Data structure to create a new instance of PersonGroup */
export type CreatePersonGroupInput = {
  /** The actual data of the document group */
  data: CreatePersonGroupDataInput;
  /** If true, only the validation is performed but the instance will not be created */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  /** The ID of the person the group belongs to */
  person?: InputMaybe<Scalars['String']['input']>;
};

export type CreatePersonGroupOutput = CreatePersonGroupResult | TooManyRecordsResult | ValidatePersonGroupResult;

/** The result data structure of creating an instance of PersonGroup */
export type CreatePersonGroupResult = {
  __typename?: 'CreatePersonGroupResult';
  /** The actual data returned for PersonGroup */
  result: PersonGroup;
};

/** Data structure to create a new instance of Person */
export type CreatePersonInput = {
  /** The actual data of Person */
  data: CreatePersonDataInput;
  /** If true, only the validation is performed but the instance will not be created */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  /** Must match the subject Id from identity provider */
  person: Scalars['String']['input'];
};

/** The result of creating an instance of Person */
export type CreatePersonOutput = CreatePersonResult | ValidatePersonResult;

/** The result data structure of creating an instance of Person */
export type CreatePersonResult = {
  __typename?: 'CreatePersonResult';
  /** The actual data returned for Person */
  result: Person;
};

/** Recipient Group selections. Omitted attributes are unchanged; an empty list revokes their consent. */
export type CreatePersonSharedAttributesDataInput = {
  /** Replace the complete set of attributes in dynamic All mode. Omit to preserve other modes; an explicit Group selection disables All for that attribute. */
  allGroupsAttributes?: InputMaybe<Array<Scalars['String']['input']>>;
  sharedAge?: InputMaybe<Array<Scalars['String']['input']>>;
  sharedApartmentNumber?: InputMaybe<Array<Scalars['String']['input']>>;
  sharedBio?: InputMaybe<Array<Scalars['String']['input']>>;
  sharedBirthdate?: InputMaybe<Array<Scalars['String']['input']>>;
  sharedChildCount?: InputMaybe<Array<Scalars['String']['input']>>;
  sharedCitizenships?: InputMaybe<Array<Scalars['String']['input']>>;
  sharedCity?: InputMaybe<Array<Scalars['String']['input']>>;
  sharedContractType?: InputMaybe<Array<Scalars['String']['input']>>;
  sharedCountry?: InputMaybe<Array<Scalars['String']['input']>>;
  sharedCurrentActivity?: InputMaybe<Array<Scalars['String']['input']>>;
  sharedCurrentEmployer?: InputMaybe<Array<Scalars['String']['input']>>;
  sharedCurrentTasks?: InputMaybe<Array<Scalars['String']['input']>>;
  sharedDriversLicense?: InputMaybe<Array<Scalars['String']['input']>>;
  sharedEmail?: InputMaybe<Array<Scalars['String']['input']>>;
  sharedGender?: InputMaybe<Array<Scalars['String']['input']>>;
  sharedHouseNumber?: InputMaybe<Array<Scalars['String']['input']>>;
  sharedMaritalStatus?: InputMaybe<Array<Scalars['String']['input']>>;
  sharedMiscellaneous?: InputMaybe<Array<Scalars['String']['input']>>;
  sharedNationality?: InputMaybe<Array<Scalars['String']['input']>>;
  sharedPhone?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Recipient Group IDs for powers consent. An empty list selects no recipients. */
  sharedPowers?: InputMaybe<Array<Scalars['String']['input']>>;
  sharedProfession?: InputMaybe<Array<Scalars['String']['input']>>;
  sharedState?: InputMaybe<Array<Scalars['String']['input']>>;
  sharedStreet?: InputMaybe<Array<Scalars['String']['input']>>;
  sharedWebsite?: InputMaybe<Array<Scalars['String']['input']>>;
  sharedWorkingTimeModel?: InputMaybe<Array<Scalars['String']['input']>>;
  sharedZipCode?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** The input data for creating an instance of PinGroup */
export type CreatePinGroupDataInput = {
  name: Scalars['String']['input'];
  pinType: PinType;
};

/** Data structure to create a new instance of PersonGroup */
export type CreatePinGroupInput = {
  /** The actual data of the pin group */
  data: CreatePinGroupDataInput;
  /** If true, only the validation is performed but the instance will not be created */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  /** The ID of the person the group belongs to */
  person?: InputMaybe<Scalars['String']['input']>;
};

export type CreatePinGroupOutput = CreatePinGroupResult | TooManyRecordsResult | ValidatePinGroupResult;

/** The result data structure of creating an instance of PinGroup */
export type CreatePinGroupResult = {
  __typename?: 'CreatePinGroupResult';
  /** The actual data returned for PinGroup */
  result: PinGroup;
};

/** The input data for creating an instance of ProjectAccess */
export type CreateProjectAccessDataInput = {
  /** Who is asked and who accepts. */
  candidates: AccessLevel;
  person: PersonRelationInput;
  /** Occasion, breakdown, classification, requirements. */
  plan: AccessLevel;
  /** Entries in the timeline - the editor role. */
  timeline: AccessLevel;
};

/** The input data for creating an instance of Project */
export type CreateProjectDataInput = {
  /**
   * Complete replacement of project access grants on update. Omitted or null preserves them; an empty
   * list removes them. A personal project's creator always retains WRITE on all surfaces and supplied
   * entries for that creator are ignored. A company project's creator has no such protected grant.
   */
  access?: InputMaybe<Array<CreateProjectAccessDataInput>>;
  /**
   * Company owning the project, or null for a personal project. Set only at creation, by an admin of
   * an active company; ownership cannot later change. Company admins can read the project and, acting
   * as the company, change or delete it. Other access grants remain independent. Inactive companies
   * freeze project writes. `createdBy` identifies the creator without granting company administration.
   */
  company?: InputMaybe<CompanyRelationInput>;
  /**
   * Planning data as a JSON object. Updates merge top-level keys; supplied values replace complete
   * nested objects or lists, and omitted keys remain unchanged. Null or an empty object leaves existing
   * keys unchanged. Explicit null values inside the object are retained. New objects default to
   * `version: 1` when version is omitted.
   *
   * Common members are `anlass` and `status` (strings), `sections` (string list), `packages` and `events`
   * (lists), `requirements` (object), and `documentStorageIds` (UUID string list). Packages contain
   * id, name, start, end and tasks; tasks contain id, title, assigneeId, start and end. Events contain
   * id, title, date and kind. Dates use YYYY-MM-DD. Requirements can contain expertise entries
   * (id, description, level, requirement, personCount) and elementWeights keyed by CreativityElement.
   * Expertise level uses 1–7, or 0 for no minimum; requirement is MUST or OPTIONAL. Power weights use
   * 0–1000. Additional client-defined members are retained. Links in this object are not validated as
   * relationships; use `linkProjectMatch` for match relationships.
   *
   * Example: {"version":1,"packages":[],"events":[],"requirements":{"expertise":[],"elementWeights":{}}}.
   */
  data?: InputMaybe<Scalars['Object']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Create a project. */
export type CreateProjectInput = {
  /**
   *   Company the caller declares they are acting as. Optional on creation. If supplied with
   *   `data.company`, it must identify that company; a mismatch is `GENESIS001259`. If no company is set,
   *   any declaration is rejected with `GENESIS001260`.
   *
   * Company admin authorization is checked before reporting a mismatch. This declaration does not
   *   grant permission to create content on behalf of a company.
   */
  actingAsCompanyId?: InputMaybe<Scalars['UUID']['input']>;
  /** The actual data of Project */
  data: CreateProjectDataInput;
  /** If true, only the validation is performed but the instance will not be created */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The result of creating an instance of Project */
export type CreateProjectOutput = CreateProjectResult | ValidateProjectResult;

/** The result data structure of creating an instance of Project */
export type CreateProjectResult = {
  __typename?: 'CreateProjectResult';
  /** The actual data returned for Project */
  result: Project;
};

/** The input data for creating an instance of SharedItemComment */
export type CreateSharedItemCommentDataInput = {
  /**
   * Company on whose behalf this comment was written, or null for a personal comment. Set at creation
   * by a company admin and cannot be changed. Current admins can edit company comments regardless of
   * who authored them. `person` identifies the author independently; the company remains identifiable
   * if the author is erased. The company's logo is always null on this reference.
   */
  company?: InputMaybe<CompanyRelationInput>;
  content?: InputMaybe<Scalars['String']['input']>;
  person?: InputMaybe<PersonRelationInput>;
  /** The item receiving this comment. Set at creation and cannot be changed. */
  sharedItem?: InputMaybe<SharedItemRelationInput>;
  sharedItemId?: InputMaybe<Scalars['UUID']['input']>;
};

/** Create a shared item comment. */
export type CreateSharedItemCommentInput = {
  /**
   *   Company the caller declares they are acting as. Optional on creation. If supplied with
   *   `data.company`, it must identify that company; a mismatch is `GENESIS001259`. If no company is set,
   *   any declaration is rejected with `GENESIS001260`.
   *
   * Company admin authorization is checked before reporting a mismatch. This declaration does not
   *   grant permission to create content on behalf of a company.
   */
  actingAsCompanyId?: InputMaybe<Scalars['UUID']['input']>;
  /** The actual data of SharedItemComment */
  data: CreateSharedItemCommentDataInput;
  /** If true, only the validation is performed but the instance will not be created */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The result of creating an instance of SharedItemComment */
export type CreateSharedItemCommentOutput = CreateSharedItemCommentResult | ValidateSharedItemCommentResult;

/** The result data structure of creating an instance of SharedItemComment */
export type CreateSharedItemCommentResult = {
  __typename?: 'CreateSharedItemCommentResult';
  /** The actual data returned for SharedItemComment */
  result: SharedItemComment;
};

/** The input data for creating an instance of SharedItem */
export type CreateSharedItemDataInput = {
  /** Replace classification IDs; omitted preserves them, an empty list clears them. PROJECT items only. */
  categoryIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /**
   * Company that owns this item, or null for personal content. Set only at creation by an admin of
   * that company; ownership cannot be transferred later. `createdBy` still identifies the human author.
   * The company must be active; inactive-company content writes are rejected with `GENESIS001250`.
   *
   * The nested company filter supports these example criteria:
   * - `{company: {name: {any: true}}}` selects company-owned items.
   * - `{company: {name: {any: false}}}` selects personal items.
   * - `{company: {name: {contains: "Example Company"}}}` selects by company name.
   * - `{company: {id: {eq: "123e4567-e89b-12d3-a456-426614174000"}}}` selects by id.
   *
   * Filtering does not widen visibility. `sharedItems` excludes inactive-company content even when a
   * company is explicitly selected; `companyOwnedSharedItems` can still return that company's items.
   */
  company?: InputMaybe<CompanyRelationInput>;
  darkMode?: InputMaybe<CreateColorsDataInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  files?: InputMaybe<Array<CreateFileDataInput>>;
  filesToDelete?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  images?: InputMaybe<Array<CreateFileDataInput>>;
  imagesToDelete?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  itemType?: InputMaybe<SharedItemType>;
  lightMode?: InputMaybe<CreateColorsDataInput>;
  mainImage?: InputMaybe<CreateFileDataInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** Public readership, independent of Group recipients. Company and HR publication rules still apply. */
  publiclyReadable?: InputMaybe<Scalars['Boolean']['input']>;
  /** Group recipients; an empty list grants no ordinary Group readership. */
  sharedWith?: InputMaybe<Array<InputMaybe<ContentSharingRecipientRelationInput>>>;
  shortDescription?: InputMaybe<Scalars['String']['input']>;
};

/** Create a shared item. */
export type CreateSharedItemInput = {
  /**
   *   Company the caller declares they are acting as. Optional on creation. If supplied with
   *   `data.company`, it must identify that company; a mismatch is `GENESIS001259`. If no company is set,
   *   any declaration is rejected with `GENESIS001260`.
   *
   * Company admin authorization is checked before reporting a mismatch. This declaration does not
   *   grant permission to create content on behalf of a company.
   */
  actingAsCompanyId?: InputMaybe<Scalars['UUID']['input']>;
  /** The actual data of SharedItem */
  data: CreateSharedItemDataInput;
  /** If true, only the validation is performed but the instance will not be created */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  /** Reject unless the saved ordinary item has no third-party recipients. Prevents a changed default from widening an explicit private choice. Not supported for Company items. */
  privateToOwner?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The result of creating an instance of SharedItem */
export type CreateSharedItemOutput = CreateSharedItemResult | ValidateSharedItemResult;

/** The result data structure of creating an instance of SharedItem */
export type CreateSharedItemResult = {
  __typename?: 'CreateSharedItemResult';
  /** The actual data returned for SharedItem */
  result: SharedItem;
};

/** The input data for creating an instance of StudioNotebook */
export type CreateStudioNotebookDataInput = {
  /** Complete notebook text in Markdown. */
  content?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Data structure to create a new instance of StudioNotebook */
export type CreateStudioNotebookInput = {
  /** The actual data of StudioNotebook */
  data: CreateStudioNotebookDataInput;
  /** If true, only the validation is performed but the instance will not be created */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The result of creating an instance of StudioNotebook */
export type CreateStudioNotebookOutput = CreateStudioNotebookResult | ValidateStudioNotebookResult;

/** The result data structure of creating an instance of StudioNotebook */
export type CreateStudioNotebookResult = {
  __typename?: 'CreateStudioNotebookResult';
  /** The actual data returned for StudioNotebook */
  result: StudioNotebook;
};

/** The input data for creating an instance of TeamProfile */
export type CreateTeamProfileDataInput = {
  localizedName?: InputMaybe<CreateLocalizedTextDataInput>;
  weights: Array<CreateElementWeightDataInput>;
};

/** Data structure to create a new instance of TeamProfile */
export type CreateTeamProfileInput = {
  /** The actual data of TeamProfile */
  data: CreateTeamProfileDataInput;
  /** If true, only the validation is performed but the instance will not be created */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The result of creating an instance of TeamProfile */
export type CreateTeamProfileOutput = CreateTeamProfileResult | ValidateTeamProfileResult;

/** The result data structure of creating an instance of TeamProfile */
export type CreateTeamProfileResult = {
  __typename?: 'CreateTeamProfileResult';
  /** The actual data returned for TeamProfile */
  result: TeamProfile;
};

/** The input data for creating an instance of WorkingTimeModel */
export type CreateWorkingTimeModelDataInput = {
  localizedDesc?: InputMaybe<CreateLocalizedTextDataInput>;
  localizedName?: InputMaybe<CreateLocalizedTextDataInput>;
};

/** Data structure to create a new instance of WorkingTimeModel */
export type CreateWorkingTimeModelInput = {
  /** The actual data of WorkingTimeModel */
  data: CreateWorkingTimeModelDataInput;
  /** If true, only the validation is performed but the instance will not be created */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The result of creating an instance of WorkingTimeModel */
export type CreateWorkingTimeModelOutput = CreateWorkingTimeModelResult | ValidateWorkingTimeModelResult;

/** The result data structure of creating an instance of WorkingTimeModel */
export type CreateWorkingTimeModelResult = {
  __typename?: 'CreateWorkingTimeModelResult';
  /** The actual data returned for WorkingTimeModel */
  result: WorkingTimeModel;
};

export enum CreativityCategory {
  CognitiveIntelligence = 'COGNITIVE_INTELLIGENCE',
  EmotionalIntelligence = 'EMOTIONAL_INTELLIGENCE',
  FictionalIntelligence = 'FICTIONAL_INTELLIGENCE',
  IdentityCore = 'IDENTITY_CORE',
  MolecularIntelligence = 'MOLECULAR_INTELLIGENCE'
}

export enum CreativityElement {
  Abstraction = 'ABSTRACTION',
  Adaption = 'ADAPTION',
  Aggression = 'AGGRESSION',
  Alertness = 'ALERTNESS',
  Altruism = 'ALTRUISM',
  Angst = 'ANGST',
  Audio = 'AUDIO',
  Autonomy = 'AUTONOMY',
  Balance = 'BALANCE',
  Beauty = 'BEAUTY',
  Biorhythm = 'BIORHYTHM',
  Candor = 'CANDOR',
  Charisma = 'CHARISMA',
  Composition = 'COMPOSITION',
  Concentration = 'CONCENTRATION',
  Cooperation = 'COOPERATION',
  Coordination = 'COORDINATION',
  Courage = 'COURAGE',
  Curiosity = 'CURIOSITY',
  Diligence = 'DILIGENCE',
  Disgust = 'DISGUST',
  Dolor = 'DOLOR',
  Doubt = 'DOUBT',
  Empathy = 'EMPATHY',
  Expression = 'EXPRESSION',
  Fairness = 'FAIRNESS',
  Faith = 'FAITH',
  Fidelity = 'FIDELITY',
  FlightMotion = 'FLIGHT_MOTION',
  Gender = 'GENDER',
  Greed = 'GREED',
  Grief = 'GRIEF',
  Habit = 'HABIT',
  Homeostasis = 'HOMEOSTASIS',
  Honesty = 'HONESTY',
  Hope = 'HOPE',
  Hormones = 'HORMONES',
  Humor = 'HUMOR',
  Ignorance = 'IGNORANCE',
  Imagination = 'IMAGINATION',
  Immunity = 'IMMUNITY',
  Improvisation = 'IMPROVISATION',
  Infatuation = 'INFATUATION',
  Inspiration = 'INSPIRATION',
  Intention = 'INTENTION',
  Introversion = 'INTROVERSION',
  Intuition = 'INTUITION',
  Joy = 'JOY',
  Language = 'LANGUAGE',
  Love = 'LOVE',
  Lust = 'LUST',
  Memory = 'MEMORY',
  Metabolism = 'METABOLISM',
  Mindfulness = 'MINDFULNESS',
  Modesty = 'MODESTY',
  Motorics = 'MOTORICS',
  Objectiation = 'OBJECTIATION',
  Olfaction = 'OLFACTION',
  Opposition = 'OPPOSITION',
  Orientation = 'ORIENTATION',
  Passion = 'PASSION',
  Patience = 'PATIENCE',
  Perception = 'PERCEPTION',
  Perseverance = 'PERSEVERANCE',
  Reflexes = 'REFLEXES',
  Respiration = 'RESPIRATION',
  Responsibility = 'RESPONSIBILITY',
  Satisfaction = 'SATISFACTION',
  SelfAwareness = 'SELF_AWARENESS',
  Sensitivity = 'SENSITIVITY',
  Skillfulness = 'SKILLFULNESS',
  Sleep = 'SLEEP',
  Spontaneity = 'SPONTANEITY',
  Strategy = 'STRATEGY',
  Taste = 'TASTE',
  Temper = 'TEMPER',
  Tenderness = 'TENDERNESS',
  Tolerance = 'TOLERANCE',
  Touch = 'TOUCH',
  Vision = 'VISION',
  Willpower = 'WILLPOWER',
  Wisdom = 'WISDOM'
}

export type CurriculumVitae = Node & {
  __typename?: 'CurriculumVitae';
  apiVersion: Scalars['Int']['output'];
  /**
   * Client-defined JSON object controlling CV presentation for this apiVersion. Returned as supplied;
   * the server does not interpret its members. A supplied update replaces the complete configuration.
   */
  configuration?: Maybe<Scalars['Object']['output']>;
  /**
   * Client-defined JSON object containing CV content for this apiVersion. Returned as supplied;
   * the server does not interpret its members. A supplied update replaces the complete content.
   */
  content?: Maybe<Scalars['Object']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  person: Person;
};

export type CurriculumVitaeConnection = {
  __typename?: 'CurriculumVitaeConnection';
  edges: Array<CurriculumVitaeEdge>;
  nodes: Array<CurriculumVitae>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CurriculumVitaeEdge = {
  __typename?: 'CurriculumVitaeEdge';
  cursor: Scalars['String']['output'];
  node: CurriculumVitae;
};

/** The filterable fields of type CurriculumVitae */
export type CurriculumVitaeFilterInput = {
  and?: InputMaybe<Array<CurriculumVitaeFilterInput>>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<CurriculumVitaeFilterInput>;
  or?: InputMaybe<Array<CurriculumVitaeFilterInput>>;
};

/** The parameters for requesting multiple instances of CurriculumVitae. Mixing fields of cursor-based and offset-based pagination will result in an error. */
export type CurriculumVitaeQueryInput = {
  /** Cursor-based pagination: The immediate successor of this cursor will be the first entry of the requested page */
  after?: InputMaybe<Scalars['String']['input']>;
  /** Cursor-based pagination: The immediate predecessor of this cursor will be last entry of the requested page */
  before?: InputMaybe<Scalars['String']['input']>;
  /** Cursor-based pagination: Number of rows to be returned. Use in conjunction with 'after' */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** Cursor-based pagination: Number of rows to be returned. Use in conjunction with 'before' */
  last?: InputMaybe<Scalars['Int']['input']>;
  /** The sorting order of the instances */
  order?: InputMaybe<CurriculumVitaeSortInput>;
  /** Offset-based pagination: Number of rows to skip */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Offset-based pagination: Number of rows to be returned */
  take?: InputMaybe<Scalars['Int']['input']>;
  /** The filter to be applied */
  where?: InputMaybe<CurriculumVitaeFilterInput>;
};

export type CurriculumVitaeSortInput = {
  createdAt?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
};

export type CvBatchImportResult = {
  __typename?: 'CvBatchImportResult';
  results: Array<CvFileResult>;
};

/** The filterable fields of type CvBatchImportResult */
export type CvBatchImportResultFilterInput = {
  and?: InputMaybe<Array<CvBatchImportResultFilterInput>>;
  not?: InputMaybe<CvBatchImportResultFilterInput>;
  or?: InputMaybe<Array<CvBatchImportResultFilterInput>>;
};

/** One document in an admin batch CV import. */
export type CvFileInput = {
  file: Scalars['Binary']['input'];
  fileName: Scalars['String']['input'];
};

/** Per-file result of importCvBatch. */
export type CvFileResult = {
  __typename?: 'CvFileResult';
  /** Resulting person's primary email — the scanned address, or a generated cv-import+<id>@smycles.invalid when the CV had none; null on FAILED. */
  email?: Maybe<Scalars['String']['output']>;
  fileName: Scalars['String']['output'];
  /** Resulting person's given name, for a display label; null on FAILED or when unknown. */
  firstName?: Maybe<Scalars['String']['output']>;
  /** Resulting person's family name; null on FAILED or when unknown. */
  lastName?: Maybe<Scalars['String']['output']>;
  /** How the person was matched (e.g. "primary_email"); null when created or failed. */
  matchedBy?: Maybe<Scalars['String']['output']>;
  /** Error reason (FAILED) or non-fatal warnings (e.g. an unresolved gender), joined; null when clean. */
  message?: Maybe<Scalars['String']['output']>;
  outcome: CvImportOutcome;
  /** The created/updated person; null when outcome is FAILED. */
  personId?: Maybe<Scalars['ID']['output']>;
};

/** The filterable fields of type CvFileResult */
export type CvFileResultFilterInput = {
  and?: InputMaybe<Array<CvFileResultFilterInput>>;
  not?: InputMaybe<CvFileResultFilterInput>;
  or?: InputMaybe<Array<CvFileResultFilterInput>>;
};

/** What happened to a single CV in a batch import. */
export enum CvImportOutcome {
  /** No unambiguous match; a new candidate Person was created. */
  Created = 'CREATED',
  /** Extraction or persistence failed for this file; nothing was written. */
  Failed = 'FAILED',
  /** The CV matched an existing person by primary email; missing fields/collections were filled. */
  Updated = 'UPDATED'
}

export type DailyQuotaExceeded = {
  __typename?: 'DailyQuotaExceeded';
  limit?: Maybe<Scalars['Int']['output']>;
};

/** The filterable fields of type DailyQuotaExceeded */
export type DailyQuotaExceededFilterInput = {
  and?: InputMaybe<Array<DailyQuotaExceededFilterInput>>;
  not?: InputMaybe<DailyQuotaExceededFilterInput>;
  or?: InputMaybe<Array<DailyQuotaExceededFilterInput>>;
};

export type DateInstant = {
  __typename?: 'DateInstant';
  date: Scalars['Date']['output'];
  precision: DatePrecision;
};

/** The filterable fields of type DateInstant */
export type DateInstantFilterInput = {
  and?: InputMaybe<Array<DateInstantFilterInput>>;
  not?: InputMaybe<DateInstantFilterInput>;
  or?: InputMaybe<Array<DateInstantFilterInput>>;
};

export enum DatePrecision {
  Day = 'DAY',
  Month = 'MONTH',
  Year = 'YEAR'
}

/** Filtering for fields of type Date */
export type DateTimeFilterInput = {
  /** Logical 'and' of one or more predicates */
  and?: InputMaybe<Array<DateTimeFilterInput>>;
  /** If true, checks if the field has a value, or, if false, checks if the field is missing a value */
  any?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks if the field's value is equal to the given value */
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  /** Checks if the field's value is greater than or equal to the given value */
  ge?: InputMaybe<Scalars['DateTime']['input']>;
  /** Checks if the field's value is greater than to the given value */
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Checks if the field's value is less than or equal to the given value */
  le?: InputMaybe<Scalars['DateTime']['input']>;
  /** Checks if the field's value is less than to the given value */
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Checks if the field's value is not equal to the given value */
  ne?: InputMaybe<Scalars['DateTime']['input']>;
  /** Negates the predicate */
  not?: InputMaybe<DateTimeFilterInput>;
  /** Logical 'or' of one or more predicates */
  or?: InputMaybe<Array<DateTimeFilterInput>>;
};

export type DateTimeInstant = {
  __typename?: 'DateTimeInstant';
  dateTime?: Maybe<Scalars['DateTime']['output']>;
  precision?: Maybe<DateTimePrecision>;
};

/** The filterable fields of type DateTimeInstant */
export type DateTimeInstantFilterInput = {
  and?: InputMaybe<Array<DateTimeInstantFilterInput>>;
  not?: InputMaybe<DateTimeInstantFilterInput>;
  or?: InputMaybe<Array<DateTimeInstantFilterInput>>;
};

export enum DateTimePrecision {
  Day = 'DAY',
  Hour = 'HOUR',
  Minute = 'MINUTE',
  Month = 'MONTH',
  Precise = 'PRECISE',
  Second = 'SECOND',
  Year = 'YEAR'
}

export type Deceased = {
  __typename?: 'Deceased';
  deceased?: Maybe<Scalars['Boolean']['output']>;
  deceasedDate?: Maybe<DateInstant>;
};

/** The filterable fields of type Deceased */
export type DeceasedFilterInput = {
  and?: InputMaybe<Array<DeceasedFilterInput>>;
  not?: InputMaybe<DeceasedFilterInput>;
  or?: InputMaybe<Array<DeceasedFilterInput>>;
};

export type Degree = Node & {
  __typename?: 'Degree';
  id: Scalars['ID']['output'];
  localizedName?: Maybe<LocalizedText>;
  name?: Maybe<Scalars['String']['output']>;
};

/** The filterable fields of type Degree */
export type DegreeFilterInput = {
  and?: InputMaybe<Array<DegreeFilterInput>>;
  id?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<DegreeFilterInput>;
  or?: InputMaybe<Array<DegreeFilterInput>>;
};

/** Contains information for linking 'Degree' to other entities */
export type DegreeRelationInput = {
  /** The identifier of 'Degree' */
  id: Scalars['ID']['input'];
};

export type DegreeSortInput = {
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
};

export type DegreesResult = {
  __typename?: 'DegreesResult';
  degrees: Array<Degree>;
};

/** The filterable fields of type DegreesResult */
export type DegreesResultFilterInput = {
  and?: InputMaybe<Array<DegreesResultFilterInput>>;
  not?: InputMaybe<DegreesResultFilterInput>;
  or?: InputMaybe<Array<DegreesResultFilterInput>>;
};

/** Deletion requires an empty group without role assignments. Base groups cannot be deleted. */
export type DeleteAccessGroupInput = {
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
};

/** Delete a custom Role with no Group assignments. */
export type DeleteAccessRoleInput = {
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
};

/** Data structure for deleting an instance of Agent */
export type DeleteAgentInput = {
  /** If true, only the validation is performed but the instance will not be deleted */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  /** The id of the instance to delete */
  id: Scalars['ID']['input'];
};

/** The result of deleting an instance of Agent */
export type DeleteAgentOutput = {
  __typename?: 'DeleteAgentOutput';
  /** The id of the instance that was deleted */
  id: Scalars['ID']['output'];
};

/** Data structure for deleting an instance of Certificate */
export type DeleteCertificateInput = {
  /** If true, only the validation is performed but the instance will not be deleted */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  /** The id of the instance to delete */
  id: Scalars['ID']['input'];
};

/** The result of deleting an instance of Certificate */
export type DeleteCertificateOutput = {
  __typename?: 'DeleteCertificateOutput';
  /** The id of the instance that was deleted */
  id: Scalars['ID']['output'];
};

/** Data structure for deleting an instance of Company */
export type DeleteCompanyInput = {
  /** If true, only the validation is performed but the instance will not be deleted */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  /** The id of the instance to delete */
  id: Scalars['ID']['input'];
};

/** The result of deleting an instance of Company */
export type DeleteCompanyOutput = {
  __typename?: 'DeleteCompanyOutput';
  /** The id of the instance that was deleted */
  id: Scalars['ID']['output'];
};

/** Data structure for deleting an instance of ContractType */
export type DeleteContractTypeInput = {
  /** If true, only the validation is performed but the instance will not be deleted */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  /** The id of the instance to delete */
  id: Scalars['ID']['input'];
};

/** The result of deleting an instance of ContractType */
export type DeleteContractTypeOutput = {
  __typename?: 'DeleteContractTypeOutput';
  /** The id of the instance that was deleted */
  id: Scalars['ID']['output'];
};

/** Data structure for deleting an instance of CurriculumVitae */
export type DeleteCurriculumVitaeInput = {
  /** If true, only the validation is performed but the instance will not be deleted */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  /** The id of the instance to delete */
  id: Scalars['ID']['input'];
};

/** The result of deleting an instance of CurriculumVitae */
export type DeleteCurriculumVitaeOutput = {
  __typename?: 'DeleteCurriculumVitaeOutput';
  /** The id of the instance that was deleted */
  id: Scalars['ID']['output'];
};

/** Data structure for deleting an instance of Degree */
export type DeleteDegreeInput = {
  /** If true, only the validation is performed but the instance will not be deleted */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  /** The id of the instance to delete */
  id: Scalars['ID']['input'];
};

/** The result of deleting an instance of Degree */
export type DeleteDegreeOutput = {
  __typename?: 'DeleteDegreeOutput';
  /** The id of the instance that was deleted */
  id: Scalars['ID']['output'];
};

/** Data structure for deleting an instance of DiscoveryCategory */
export type DeleteDiscoveryCategoryInput = {
  /** If true, only the validation is performed but the instance will not be deleted */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  /** The id of the instance to delete */
  id: Scalars['ID']['input'];
};

/** The result of deleting an instance of DiscoveryCategory */
export type DeleteDiscoveryCategoryOutput = {
  __typename?: 'DeleteDiscoveryCategoryOutput';
  /** The id of the instance that was deleted */
  id: Scalars['ID']['output'];
};

/** Data structure for deleting an instance of DocumentGroup */
export type DeleteDocumentGroupInput = {
  /** If true, only the validation is performed but the instance will not be deleted */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  /** The id of the instance to delete */
  id: Scalars['ID']['input'];
};

/** The result of deleting an instance of DocumentGroup */
export type DeleteDocumentGroupOutput = {
  __typename?: 'DeleteDocumentGroupOutput';
  /** The id of the instance that was deleted */
  id: Scalars['ID']['output'];
};

/** Data structure for deleting an instance of Document */
export type DeleteDocumentInput = {
  /** If true, only the validation is performed but the instance will not be deleted */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  /** The id of the instance to delete */
  id: Scalars['ID']['input'];
};

/** The result of deleting an instance of Document */
export type DeleteDocumentOutput = {
  __typename?: 'DeleteDocumentOutput';
  /** The id of the instance that was deleted */
  id: Scalars['ID']['output'];
};

/** Data structure for deleting an instance of Education */
export type DeleteEducationInput = {
  /** If true, only the validation is performed but the instance will not be deleted */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  /** The id of the instance to delete */
  id: Scalars['ID']['input'];
};

/** The result of deleting an instance of Education */
export type DeleteEducationOutput = {
  __typename?: 'DeleteEducationOutput';
  /** The id of the instance that was deleted */
  id: Scalars['ID']['output'];
};

/** Data structure for deleting an instance of Experience */
export type DeleteExperienceInput = {
  /** If true, only the validation is performed but the instance will not be deleted */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  /** The id of the instance to delete */
  id: Scalars['ID']['input'];
};

/** The result of deleting an instance of Experience */
export type DeleteExperienceOutput = {
  __typename?: 'DeleteExperienceOutput';
  /** The id of the instance that was deleted */
  id: Scalars['ID']['output'];
};

/** Data structure for deleting an instance of Expertise */
export type DeleteExpertiseInput = {
  /** If true, only the validation is performed but the instance will not be deleted */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  /** The id of the instance to delete */
  id: Scalars['ID']['input'];
};

/** The result of deleting an instance of Expertise */
export type DeleteExpertiseOutput = {
  __typename?: 'DeleteExpertiseOutput';
  /** The id of the instance that was deleted */
  id: Scalars['ID']['output'];
};

/** Data structure for deleting an instance of Gender */
export type DeleteGenderInput = {
  /** If true, only the validation is performed but the instance will not be deleted */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  /** The id of the instance to delete */
  id: Scalars['ID']['input'];
};

/** The result of deleting an instance of Gender */
export type DeleteGenderOutput = {
  __typename?: 'DeleteGenderOutput';
  /** The id of the instance that was deleted */
  id: Scalars['ID']['output'];
};

/** Data structure for deleting an instance of Industry */
export type DeleteIndustryInput = {
  /** If true, only the validation is performed but the instance will not be deleted */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  /** The id of the instance to delete */
  id: Scalars['ID']['input'];
};

/** The result of deleting an instance of Industry */
export type DeleteIndustryOutput = {
  __typename?: 'DeleteIndustryOutput';
  /** The id of the instance that was deleted */
  id: Scalars['ID']['output'];
};

/** Data structure for deleting an instance of JobDepartment */
export type DeleteJobDepartmentInput = {
  /** If true, only the validation is performed but the instance will not be deleted */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  /** The id of the instance to delete */
  id: Scalars['ID']['input'];
};

/** The result of deleting an instance of JobDepartment */
export type DeleteJobDepartmentOutput = {
  __typename?: 'DeleteJobDepartmentOutput';
  /** The id of the instance that was deleted */
  id: Scalars['ID']['output'];
};

/** Data structure for deleting an instance of JobLocation */
export type DeleteJobLocationInput = {
  /** If true, only the validation is performed but the instance will not be deleted */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  /** The id of the instance to delete */
  id: Scalars['ID']['input'];
};

/** The result of deleting an instance of JobLocation */
export type DeleteJobLocationOutput = {
  __typename?: 'DeleteJobLocationOutput';
  /** The id of the instance that was deleted */
  id: Scalars['ID']['output'];
};

/** Data structure for deleting an instance of LanguageSkill */
export type DeleteLanguageSkillInput = {
  /** If true, only the validation is performed but the instance will not be deleted */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  /** The id of the instance to delete */
  id: Scalars['ID']['input'];
};

/** The result of deleting an instance of LanguageSkill */
export type DeleteLanguageSkillOutput = {
  __typename?: 'DeleteLanguageSkillOutput';
  /** The id of the instance that was deleted */
  id: Scalars['ID']['output'];
};

/** Data structure for deleting an instance of Listing */
export type DeleteListingInput = {
  /** If true, only the validation is performed but the instance will not be deleted */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  /** The id of the instance to delete */
  id: Scalars['ID']['input'];
};

/** The result of deleting an instance of Listing */
export type DeleteListingOutput = {
  __typename?: 'DeleteListingOutput';
  /** The id of the instance that was deleted */
  id: Scalars['ID']['output'];
};

/** Data structure for deleting an instance of MaritalStatus */
export type DeleteMaritalStatusInput = {
  /** If true, only the validation is performed but the instance will not be deleted */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  /** The id of the instance to delete */
  id: Scalars['ID']['input'];
};

/** The result of deleting an instance of MaritalStatus */
export type DeleteMaritalStatusOutput = {
  __typename?: 'DeleteMaritalStatusOutput';
  /** The id of the instance that was deleted */
  id: Scalars['ID']['output'];
};

/** Data structure for deleting an instance of MatchCandidate */
export type DeleteMatchCandidateInput = {
  /** If true, only the validation is performed but the instance will not be deleted */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  /** The id of the instance to delete */
  id: Scalars['ID']['input'];
};

/** The result of deleting an instance of MatchCandidate */
export type DeleteMatchCandidateOutput = {
  __typename?: 'DeleteMatchCandidateOutput';
  /** The id of the instance that was deleted */
  id: Scalars['ID']['output'];
};

export type DeleteMatchCandidatesInput = {
  candidates: Array<Scalars['UUID']['input']>;
  match: Scalars['UUID']['input'];
};

export type DeleteMatchCandidatesOutput = DeleteMatchCandidatesResult;

export type DeleteMatchCandidatesResult = {
  __typename?: 'DeleteMatchCandidatesResult';
  candidatesRemoved: Array<Scalars['UUID']['output']>;
};

/** The filterable fields of type DeleteMatchCandidatesResult */
export type DeleteMatchCandidatesResultFilterInput = {
  and?: InputMaybe<Array<DeleteMatchCandidatesResultFilterInput>>;
  not?: InputMaybe<DeleteMatchCandidatesResultFilterInput>;
  or?: InputMaybe<Array<DeleteMatchCandidatesResultFilterInput>>;
};

export type DeleteMatchCompaniesInput = {
  companies: Array<Scalars['UUID']['input']>;
  /** The match whose company pool is being changed. The caller must have permission to change that pool. */
  match: Scalars['UUID']['input'];
};

export type DeleteMatchCompaniesOutput = DeleteMatchCompaniesResult;

export type DeleteMatchCompaniesResult = {
  __typename?: 'DeleteMatchCompaniesResult';
  companiesRemoved: Array<Scalars['UUID']['output']>;
};

/** The filterable fields of type DeleteMatchCompaniesResult */
export type DeleteMatchCompaniesResultFilterInput = {
  and?: InputMaybe<Array<DeleteMatchCompaniesResultFilterInput>>;
  not?: InputMaybe<DeleteMatchCompaniesResultFilterInput>;
  or?: InputMaybe<Array<DeleteMatchCompaniesResultFilterInput>>;
};

/** Data structure for deleting an instance of MatchCompany */
export type DeleteMatchCompanyInput = {
  /** If true, only the validation is performed but the instance will not be deleted */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  /** The id of the instance to delete */
  id: Scalars['ID']['input'];
};

/** The result of deleting an instance of MatchCompany */
export type DeleteMatchCompanyOutput = {
  __typename?: 'DeleteMatchCompanyOutput';
  /** The id of the instance that was deleted */
  id: Scalars['ID']['output'];
};

/** Data structure for deleting an instance of Match */
export type DeleteMatchInput = {
  /** If true, only the validation is performed but the instance will not be deleted */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  /** The id of the instance to delete */
  id: Scalars['ID']['input'];
};

/** The result of deleting an instance of Match */
export type DeleteMatchOutput = {
  __typename?: 'DeleteMatchOutput';
  /** The id of the instance that was deleted */
  id: Scalars['ID']['output'];
};

/** Data structure for deleting an instance of MatchResult */
export type DeleteMatchResultInput = {
  /** If true, only the validation is performed but the instance will not be deleted */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  /** The id of the instance to delete */
  id: Scalars['ID']['input'];
};

/** The result of deleting an instance of MatchResult */
export type DeleteMatchResultOutput = {
  __typename?: 'DeleteMatchResultOutput';
  /** The id of the instance that was deleted */
  id: Scalars['ID']['output'];
};

/** Data structure for deleting an instance of OrgUnit */
export type DeleteOrgUnitInput = {
  /** If true, only the validation is performed but the instance will not be deleted */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  /** The id of the instance to delete */
  id: Scalars['ID']['input'];
};

/** The result of deleting an instance of OrgUnit */
export type DeleteOrgUnitOutput = {
  __typename?: 'DeleteOrgUnitOutput';
  /** The id of the instance that was deleted */
  id: Scalars['ID']['output'];
};

/** Data structure for deleting an instance of PersonGroup */
export type DeletePersonGroupInput = {
  /** If true, only the validation is performed but the instance will not be deleted */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  /** The id of the instance to delete */
  id: Scalars['ID']['input'];
};

/** The result of deleting an instance of PersonGroup */
export type DeletePersonGroupOutput = {
  __typename?: 'DeletePersonGroupOutput';
  /** The id of the instance that was deleted */
  id: Scalars['ID']['output'];
};

/** Data structure for deleting an instance of Person */
export type DeletePersonInput = {
  /** If true, only the validation is performed but the instance will not be deleted */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  /** The id of the instance to delete */
  id: Scalars['ID']['input'];
};

/** The result of deleting an instance of Person */
export type DeletePersonOutput = {
  __typename?: 'DeletePersonOutput';
  /** The id of the instance that was deleted */
  id: Scalars['ID']['output'];
};

/** Data structure for deleting an instance of PinGroup */
export type DeletePinGroupInput = {
  /** If true, only the validation is performed but the instance will not be deleted */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  /** The id of the instance to delete */
  id: Scalars['ID']['input'];
};

/** The result of deleting an instance of PinGroup */
export type DeletePinGroupOutput = {
  __typename?: 'DeletePinGroupOutput';
  /** The id of the instance that was deleted */
  id: Scalars['ID']['output'];
};

/** Delete a project. */
export type DeleteProjectInput = {
  /**
   * Company projects require current company admin membership and this declaration identifying that
   * company. A personal project can be deleted only by its creator, without a declaration. A missing
   * or mismatched company declaration is rejected; a mismatch is `GENESIS001259`, and a declaration on
   * personal content is `GENESIS001260`. Authorization is checked before context errors.
   */
  actingAsCompanyId?: InputMaybe<Scalars['UUID']['input']>;
  /** If true, only the validation is performed but the instance will not be deleted */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  /** The id of the instance to delete */
  id: Scalars['ID']['input'];
};

/** The result of deleting an instance of Project */
export type DeleteProjectOutput = {
  __typename?: 'DeleteProjectOutput';
  /** The id of the instance that was deleted */
  id: Scalars['ID']['output'];
};

/** Delete a shared item comment. */
export type DeleteSharedItemCommentInput = {
  /**
   *   Required for a company-owned comment and must identify that company; omitted or mismatched values
   *   are rejected with `GENESIS001259`. Omit for a personal comment; a declaration there is rejected with
   *   `GENESIS001260`. This declaration does not grant permission to delete the comment.
   *
   * Authorization is checked first: company content requires current company admin membership;
   *   personal content requires authorship or `write:person`. An unknown comment, or one on an item the caller cannot see, is
   *   reported as `No such entity`. Other unauthorized callers receive an authorization error before
   *   context or company-status errors.
   */
  actingAsCompanyId?: InputMaybe<Scalars['UUID']['input']>;
  /** If true, only the validation is performed but the instance will not be deleted */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  /** The id of the instance to delete */
  id: Scalars['ID']['input'];
};

/** The result of deleting an instance of SharedItemComment */
export type DeleteSharedItemCommentOutput = {
  __typename?: 'DeleteSharedItemCommentOutput';
  /** The id of the instance that was deleted */
  id: Scalars['ID']['output'];
};

/** Delete a shared item. */
export type DeleteSharedItemInput = {
  /**
   *   Required for a company-owned item and must identify that company; omitted or mismatched values
   *   are rejected with `GENESIS001259`. Omit for a personal item; a declaration there is rejected with
   *   `GENESIS001260`. This declaration does not grant permission to delete the item.
   *
   * Authorization is checked first: company content requires current company admin membership;
   *   personal content requires authorship or `write:person`. An unknown item is
   *   reported as `No such entity`. Other unauthorized callers receive an authorization error before
   *   context or company-status errors.
   */
  actingAsCompanyId?: InputMaybe<Scalars['UUID']['input']>;
  /** If true, only the validation is performed but the instance will not be deleted */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  /** The id of the instance to delete */
  id: Scalars['ID']['input'];
};

/** The result of deleting an instance of SharedItem */
export type DeleteSharedItemOutput = {
  __typename?: 'DeleteSharedItemOutput';
  /** The id of the instance that was deleted */
  id: Scalars['ID']['output'];
};

/** Data structure for deleting an instance of StudioNotebook */
export type DeleteStudioNotebookInput = {
  /** If true, only the validation is performed but the instance will not be deleted */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  /** The id of the instance to delete */
  id: Scalars['ID']['input'];
};

/** The result of deleting an instance of StudioNotebook */
export type DeleteStudioNotebookOutput = {
  __typename?: 'DeleteStudioNotebookOutput';
  /** The id of the instance that was deleted */
  id: Scalars['ID']['output'];
};

/** Data structure for deleting an instance of TeamProfile */
export type DeleteTeamProfileInput = {
  /** If true, only the validation is performed but the instance will not be deleted */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  /** The id of the instance to delete */
  id: Scalars['ID']['input'];
};

/** The result of deleting an instance of TeamProfile */
export type DeleteTeamProfileOutput = {
  __typename?: 'DeleteTeamProfileOutput';
  /** The id of the instance that was deleted */
  id: Scalars['ID']['output'];
};

/** Data structure for deleting an instance of WorkingTimeModel */
export type DeleteWorkingTimeModelInput = {
  /** If true, only the validation is performed but the instance will not be deleted */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  /** The id of the instance to delete */
  id: Scalars['ID']['input'];
};

/** The result of deleting an instance of WorkingTimeModel */
export type DeleteWorkingTimeModelOutput = {
  __typename?: 'DeleteWorkingTimeModelOutput';
  /** The id of the instance that was deleted */
  id: Scalars['ID']['output'];
};

export type DetachProjectDocumentInput = {
  backdropFileId: Scalars['UUID']['input'];
  matchId: Scalars['UUID']['input'];
};

export type DetachProjectDocumentOutput = DetachProjectDocumentResult;

export type DetachProjectDocumentResult = {
  __typename?: 'DetachProjectDocumentResult';
  match: Match;
};

/** The filterable fields of type DetachProjectDocumentResult */
export type DetachProjectDocumentResultFilterInput = {
  and?: InputMaybe<Array<DetachProjectDocumentResultFilterInput>>;
  not?: InputMaybe<DetachProjectDocumentResultFilterInput>;
  or?: InputMaybe<Array<DetachProjectDocumentResultFilterInput>>;
};

/** The platform of a mobile device for push notifications. */
export enum DevicePlatform {
  Android = 'ANDROID',
  Ios = 'IOS'
}

export type DiscoveryCategoriesResult = {
  __typename?: 'DiscoveryCategoriesResult';
  categories: Array<DiscoveryCategory>;
};

/** The filterable fields of type DiscoveryCategoriesResult */
export type DiscoveryCategoriesResultFilterInput = {
  and?: InputMaybe<Array<DiscoveryCategoriesResultFilterInput>>;
  not?: InputMaybe<DiscoveryCategoriesResultFilterInput>;
  or?: InputMaybe<Array<DiscoveryCategoriesResultFilterInput>>;
};

/** Applicant-facing classification, independent of access, departments and publication. */
export type DiscoveryCategory = Node & {
  __typename?: 'DiscoveryCategory';
  id: Scalars['ID']['output'];
  name?: Maybe<LocalizedText>;
};

/** The filterable fields of type DiscoveryCategory */
export type DiscoveryCategoryFilterInput = {
  and?: InputMaybe<Array<DiscoveryCategoryFilterInput>>;
  id?: InputMaybe<IdFilterInput>;
  not?: InputMaybe<DiscoveryCategoryFilterInput>;
  or?: InputMaybe<Array<DiscoveryCategoryFilterInput>>;
};

/** Filtering options for a list of elements with type DiscoveryCategory */
export type DiscoveryCategoryListFilterInput = {
  /** All list items must match the predicate */
  all?: InputMaybe<DiscoveryCategoryFilterInput>;
  /** If true, there should exist at least list item */
  any?: InputMaybe<Scalars['Boolean']['input']>;
  /** None of list items must match the predicate */
  none?: InputMaybe<DiscoveryCategoryFilterInput>;
  /** At least one of list items must match the predicate */
  some?: InputMaybe<DiscoveryCategoryFilterInput>;
};

export type Document = Node & SharableEntity & {
  __typename?: 'Document';
  category?: Maybe<DocumentClassifier>;
  content: File;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  fileName?: Maybe<Scalars['String']['output']>;
  group?: Maybe<DocumentGroup>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  person: Person;
  powersExtractedAt?: Maybe<Scalars['DateTime']['output']>;
  preview?: Maybe<File>;
  /** Public readership, independent of Group recipients. Company and HR publication rules still apply. */
  publiclyReadable?: Maybe<Scalars['Boolean']['output']>;
  /** Group recipients; an empty list grants no ordinary Group readership. */
  sharedWith?: Maybe<Array<ContentSharingRecipient>>;
  skillsExtractedAt?: Maybe<Scalars['DateTime']['output']>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
};


export type DocumentPreviewArgs = {
  profile: Scalars['String']['input'];
};

export enum DocumentClassifier {
  CurriculumVitae = 'CURRICULUM_VITAE'
}

export type DocumentClassifierFilterInput = {
  /** Logical 'and' of one or more predicates */
  and?: InputMaybe<Array<DocumentClassifierFilterInput>>;
  /** Checks if the field has a value or not */
  any?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks if the field's value is equal to the given value */
  eq?: InputMaybe<DocumentClassifier>;
  /** Checks if the field's value is in the list of the given values */
  in?: InputMaybe<Array<DocumentClassifier>>;
  /** Checks if the field's value is not equal to the given value */
  ne?: InputMaybe<DocumentClassifier>;
  /** Negates the predicate */
  not?: InputMaybe<DocumentClassifierFilterInput>;
  /** Logical 'or' of one or more predicates */
  or?: InputMaybe<Array<DocumentClassifierFilterInput>>;
};

export type DocumentConnection = {
  __typename?: 'DocumentConnection';
  edges: Array<DocumentEdge>;
  nodes: Array<Document>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type DocumentEdge = {
  __typename?: 'DocumentEdge';
  cursor: Scalars['String']['output'];
  node: Document;
};

/** The filterable fields of type Document */
export type DocumentFilterInput = {
  and?: InputMaybe<Array<DocumentFilterInput>>;
  category?: InputMaybe<DocumentClassifierFilterInput>;
  fileName?: InputMaybe<StringFilterInput>;
  group?: InputMaybe<DocumentGroupFilterInput>;
  hasGroup?: InputMaybe<BooleanFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<DocumentFilterInput>;
  or?: InputMaybe<Array<DocumentFilterInput>>;
  tags?: InputMaybe<StringListFilterInput>;
};

export type DocumentGroup = Category & Node & {
  __typename?: 'DocumentGroup';
  id: Scalars['ID']['output'];
  itemCount?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
};

/** The filterable fields of type DocumentGroup */
export type DocumentGroupFilterInput = {
  and?: InputMaybe<Array<DocumentGroupFilterInput>>;
  id?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<DocumentGroupFilterInput>;
  or?: InputMaybe<Array<DocumentGroupFilterInput>>;
};

export type DocumentGroupInput = {
  person?: InputMaybe<Scalars['String']['input']>;
};

export type DocumentGroupOutput = DocumentGroupResult;

/** Contains information for linking 'DocumentGroup' to other entities */
export type DocumentGroupRelationInput = {
  /** The identifier of 'DocumentGroup' */
  id: Scalars['ID']['input'];
};

export type DocumentGroupResult = {
  __typename?: 'DocumentGroupResult';
  documentGroups: Array<DocumentGroup>;
};

/** The filterable fields of type DocumentGroupResult */
export type DocumentGroupResultFilterInput = {
  and?: InputMaybe<Array<DocumentGroupResultFilterInput>>;
  not?: InputMaybe<DocumentGroupResultFilterInput>;
  or?: InputMaybe<Array<DocumentGroupResultFilterInput>>;
};

export type DocumentGroupSortInput = {
  name?: InputMaybe<SortOrder>;
};

/** Document pagination. Omitted personId preserves the caller's own document workspace. */
export type DocumentQueryInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<DocumentSortInput>;
  /** Reading another person's documents requires an explicit personal-information override. */
  personId?: InputMaybe<Scalars['ID']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DocumentFilterInput>;
};

export type DocumentSortInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
};

/** The text of one document as `documentText` reads it. */
export type DocumentText = {
  __typename?: 'DocumentText';
  documentId: Scalars['UUID']['output'];
  fileName: Scalars['String']['output'];
  /** In page order; one page for a document without pages (a DOCX or a text file). */
  pages: Array<DocumentTextPage>;
};

/** The filterable fields of type DocumentText */
export type DocumentTextFilterInput = {
  and?: InputMaybe<Array<DocumentTextFilterInput>>;
  not?: InputMaybe<DocumentTextFilterInput>;
  or?: InputMaybe<Array<DocumentTextFilterInput>>;
};

export type DocumentTextPage = {
  __typename?: 'DocumentTextPage';
  markdown: Scalars['String']['output'];
  /** Zero-based page number. */
  pageNo: Scalars['Int']['output'];
};

/** The filterable fields of type DocumentTextPage */
export type DocumentTextPageFilterInput = {
  and?: InputMaybe<Array<DocumentTextPageFilterInput>>;
  not?: InputMaybe<DocumentTextPageFilterInput>;
  or?: InputMaybe<Array<DocumentTextPageFilterInput>>;
};

/** Realtime event of a background documents-extraction job (powers + skills). */
export type DocumentsExtractionEvent = {
  __typename?: 'DocumentsExtractionEvent';
  jobId: Scalars['UUID']['output'];
  /** Human-readable detail, e.g. the failure reason or the stage that started. */
  message?: Maybe<Scalars['String']['output']>;
  /**
   * Final pipeline result. Set on COMPLETED, and on FAILED when the pipeline itself produced
   * a result (per-document errors, counters); null when the job failed before running.
   */
  result?: Maybe<ProcessDocumentsResult>;
  type: ExtractionEventType;
};

/** The filterable fields of type DocumentsExtractionEvent */
export type DocumentsExtractionEventFilterInput = {
  and?: InputMaybe<Array<DocumentsExtractionEventFilterInput>>;
  not?: InputMaybe<DocumentsExtractionEventFilterInput>;
  or?: InputMaybe<Array<DocumentsExtractionEventFilterInput>>;
};

/**
 * One entry of a person's educational history. Field of study and start date are optional: unknown is null, never a
 * placeholder. An education names at least a field of study, an institution or a degree.
 */
export type Education = Node & SharableEntity & {
  __typename?: 'Education';
  /** Dynamic consent to all current and future eligible Groups, independent of public readership. */
  allGroups?: Maybe<Scalars['Boolean']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Country>;
  degree?: Maybe<Degree>;
  endDate?: Maybe<DateInstant>;
  /** The field of study; null when unknown. */
  field?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  institution?: Maybe<Scalars['String']['output']>;
  person: Person;
  /** Public readership, independent of Group recipients. Company and HR publication rules still apply. */
  publiclyReadable?: Maybe<Scalars['Boolean']['output']>;
  /** Group recipients; an empty list grants no ordinary Group readership. */
  sharedWith?: Maybe<Array<ContentSharingRecipient>>;
  /** When the education started; null when unknown. */
  startDate?: Maybe<DateInstant>;
};

/** The filterable fields of type Education */
export type EducationFilterInput = {
  and?: InputMaybe<Array<EducationFilterInput>>;
  degree?: InputMaybe<DegreeFilterInput>;
  not?: InputMaybe<EducationFilterInput>;
  or?: InputMaybe<Array<EducationFilterInput>>;
};

export type ElementEvaluationResult = {
  __typename?: 'ElementEvaluationResult';
  answeredQuestionCount: Scalars['Int']['output'];
  element: CreativityElement;
  lastEvaluationOn?: Maybe<Scalars['Date']['output']>;
  questionCount: Scalars['Int']['output'];
  result?: Maybe<Scalars['Int']['output']>;
  resultText?: Maybe<Scalars['String']['output']>;
};

/** The filterable fields of type ElementEvaluationResult */
export type ElementEvaluationResultFilterInput = {
  and?: InputMaybe<Array<ElementEvaluationResultFilterInput>>;
  not?: InputMaybe<ElementEvaluationResultFilterInput>;
  or?: InputMaybe<Array<ElementEvaluationResultFilterInput>>;
};

/** Stable identifiers for groups of powers. Display labels may differ from these wire values. */
export enum ElementGroup {
  Communication = 'COMMUNICATION',
  FutureOrientation = 'FUTURE_ORIENTATION',
  Inventiveness = 'INVENTIVENESS',
  Resilience = 'RESILIENCE',
  ResultOrientation = 'RESULT_ORIENTATION',
  TeamSpirit = 'TEAM_SPIRIT'
}

export type ElementWeight = {
  __typename?: 'ElementWeight';
  element?: Maybe<CreativityElement>;
  weight?: Maybe<Scalars['Int']['output']>;
};

/** The filterable fields of type ElementWeight */
export type ElementWeightFilterInput = {
  and?: InputMaybe<Array<ElementWeightFilterInput>>;
  not?: InputMaybe<ElementWeightFilterInput>;
  or?: InputMaybe<Array<ElementWeightFilterInput>>;
};

export type EmailTemplate = {
  __typename?: 'EmailTemplate';
  body?: Maybe<Scalars['String']['output']>;
  defaultBody: Scalars['String']['output'];
  /** The built-in text of this variant. */
  defaultSubject: Scalars['String']['output'];
  kind: EmailTemplateKind;
  /**
   * The language of this variant. Null for a template that is one text for every recipient: the invitation, which
   * Keycloak sends in every realm locale.
   */
  language?: Maybe<CommunicationLanguage>;
  legacyBody?: Maybe<Scalars['String']['output']>;
  /**
   * The combined DE/EN text stored for this kind before the templates were split by language, the same on both
   * variants of a kind; null when there is none, for the invitation, and while the store is UNAVAILABLE.
   */
  legacySubject?: Maybe<Scalars['String']['output']>;
  maxBodyLength: Scalars['Int']['output'];
  /**
   * Length limits Genesis enforces after {appName} substitution. Clients validate against these values
   * instead of hard-coding them.
   */
  maxSubjectLength: Scalars['Int']['output'];
  placeholders: Array<EmailTemplatePlaceholder>;
  /**
   * Which text a recipient of this variant gets now. Null while `storageStatus` is UNAVAILABLE, because the stored
   * texts are unknown then.
   */
  source?: Maybe<EmailTemplateSource>;
  storageStatus: EmailTemplateStorageStatus;
  /** The stored text of exactly this variant; null where the next level applies (see `source`). */
  subject?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

/** The filterable fields of type EmailTemplate */
export type EmailTemplateFilterInput = {
  and?: InputMaybe<Array<EmailTemplateFilterInput>>;
  not?: InputMaybe<EmailTemplateFilterInput>;
  or?: InputMaybe<Array<EmailTemplateFilterInput>>;
};

/** Null subject and body reset the variant: the next level applies again (`EmailTemplate.source`). */
export type EmailTemplateInput = {
  body?: InputMaybe<Scalars['String']['input']>;
  kind: EmailTemplateKind;
  /**
   * The variant to write. Omitted: the language-neutral text, which is the invitation's only text. For a kind with
   * language variants the neutral text is the combined legacy text: it can only be discarded (null subject and body),
   * never written again.
   */
  language?: InputMaybe<CommunicationLanguage>;
  subject?: InputMaybe<Scalars['String']['input']>;
};

export enum EmailTemplateKind {
  Invitation = 'INVITATION',
  ListingApplicationConfirmation = 'LISTING_APPLICATION_CONFIRMATION',
  /** Automatic receipt after public application confirmation. Contains no link. */
  ListingApplicationReceipt = 'LISTING_APPLICATION_RECEIPT',
  /** Opt-in notification of a new application. Contains a link but no applicant data. */
  ListingApplicationReceivedNotice = 'LISTING_APPLICATION_RECEIVED_NOTICE',
  /** Interview invitation explicitly sent by HR for an application. */
  ListingInterview = 'LISTING_INTERVIEW',
  /** Opt-in notification of a match result. Contains a link but no result content. */
  ListingMatchResultNotice = 'LISTING_MATCH_RESULT_NOTICE',
  /** Offer message explicitly sent by HR, without a contract document. */
  ListingOffer = 'LISTING_OFFER',
  ListingPowerQuiz = 'LISTING_POWER_QUIZ',
  /** Rejection message explicitly sent by HR. Does not change application state. */
  ListingRejection = 'LISTING_REJECTION'
}

export type EmailTemplatePlaceholder = {
  __typename?: 'EmailTemplatePlaceholder';
  required: Scalars['Boolean']['output'];
  token: Scalars['String']['output'];
};

/** The filterable fields of type EmailTemplatePlaceholder */
export type EmailTemplatePlaceholderFilterInput = {
  and?: InputMaybe<Array<EmailTemplatePlaceholderFilterInput>>;
  not?: InputMaybe<EmailTemplatePlaceholderFilterInput>;
  or?: InputMaybe<Array<EmailTemplatePlaceholderFilterInput>>;
};

/**
 * The mail one recipient of `language` would get, rendered by the same code that sends it: the plain text body as
 * SMTP carries it. The listing title, the reference and the link are sample values.
 */
export type EmailTemplatePreview = {
  __typename?: 'EmailTemplatePreview';
  body: Scalars['String']['output'];
  language: CommunicationLanguage;
  source: EmailTemplateSource;
  /** UNAVAILABLE: the store could not be read, so this is the built-in text a send would fall back to as well. */
  storageStatus: EmailTemplateStorageStatus;
  subject: Scalars['String']['output'];
};

/** The filterable fields of type EmailTemplatePreview */
export type EmailTemplatePreviewFilterInput = {
  and?: InputMaybe<Array<EmailTemplatePreviewFilterInput>>;
  not?: InputMaybe<EmailTemplatePreviewFilterInput>;
  or?: InputMaybe<Array<EmailTemplatePreviewFilterInput>>;
};

/**
 * A draft of one language variant, rendered exactly as Genesis would send it if the draft were saved. Null subject and
 * body mean "no text of this language", as in `EmailTemplateInput`.
 */
export type EmailTemplatePreviewInput = {
  body?: InputMaybe<Scalars['String']['input']>;
  kind: EmailTemplateKind;
  language: CommunicationLanguage;
  subject?: InputMaybe<Scalars['String']['input']>;
};

/** Source of the template text used for a recipient's language and template kind. */
export enum EmailTemplateSource {
  /** The administrator's text for exactly this language. */
  Custom = 'CUSTOM',
  /** The built-in text for this language. */
  Default = 'DEFAULT',
  /**
   * The administrator's combined DE/EN text from before the templates were split by language. Kept unchanged, never
   * translated, until a text for this language replaces it or an administrator discards it.
   */
  Legacy = 'LEGACY'
}

/**
 * Availability of saved email templates. AVAILABLE permits reading and updating them. DISABLED means
 * template storage is not enabled. UNAVAILABLE means saved values cannot currently be read; subject
 * and body are null in that state.
 */
export enum EmailTemplateStorageStatus {
  Available = 'AVAILABLE',
  Disabled = 'DISABLED',
  Unavailable = 'UNAVAILABLE'
}

export type EscoConcept = {
  __typename?: 'EscoConcept';
  description?: Maybe<Scalars['String']['output']>;
  /** True for an essential occupation skill, false for an optional one, null for search results. */
  essential?: Maybe<Scalars['Boolean']['output']>;
  label: Scalars['String']['output'];
  language: Scalars['String']['output'];
  uri: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

/** The filterable fields of type EscoConcept */
export type EscoConceptFilterInput = {
  and?: InputMaybe<Array<EscoConceptFilterInput>>;
  not?: InputMaybe<EscoConceptFilterInput>;
  or?: InputMaybe<Array<EscoConceptFilterInput>>;
};

export enum EscoKind {
  Occupation = 'OCCUPATION',
  Skill = 'SKILL'
}

export type EscoSearchInput = {
  kind: EscoKind;
  language: Scalars['String']['input'];
  text: Scalars['String']['input'];
};

export type EscoSearchResult = {
  __typename?: 'EscoSearchResult';
  concepts: Array<EscoConcept>;
  /** More concepts exist beyond this bounded response. There is no cursor; refine the search text. */
  hasNextPage: Scalars['Boolean']['output'];
  status: SuggestionStatus;
};

/** The filterable fields of type EscoSearchResult */
export type EscoSearchResultFilterInput = {
  and?: InputMaybe<Array<EscoSearchResultFilterInput>>;
  not?: InputMaybe<EscoSearchResultFilterInput>;
  or?: InputMaybe<Array<EscoSearchResultFilterInput>>;
};

export enum EvidencePolarity {
  Contra = 'CONTRA',
  Pro = 'PRO'
}

export enum EvidenceStrength {
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM'
}

export type Experience = Node & SharableEntity & {
  __typename?: 'Experience';
  activities?: Maybe<Array<Scalars['String']['output']>>;
  /** Dynamic consent to all current and future eligible Groups, independent of public readership. */
  allGroups?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Optional classification metadata, independent of proficiency and subject to this entry's sharing rules.
   * The object has integer version 1, entryOrigin (UNKNOWN, MANUAL, DOCUMENT_IMPORT, AI_SUGGESTION,
   * ESCO_SELECTION), and references. Null means no recorded metadata; updates replace the whole object,
   * omission preserves it. Each reference has uri, label, version (ESCO release, e.g. v1.2.1),
   * language (de/en), optional description, source (USER_SELECTED/AUTOMATIC), status (CONFIRMED/PROPOSED),
   * and basedOnText (the entry wording when confirmed). Changing that wording demotes the mapping to
   * PROPOSED; changing only proficiency or sharing preserves it. No competency level is inferred from ESCO.
   * Experience accepts at most five references with http://data.europa.eu/esco/occupation/{UUID} URIs.
   */
  classification?: Maybe<Scalars['Object']['output']>;
  country?: Maybe<Country>;
  department?: Maybe<Scalars['String']['output']>;
  employer?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<DateInstant>;
  id: Scalars['ID']['output'];
  industry?: Maybe<Industry>;
  jobTitle: Scalars['String']['output'];
  location?: Maybe<Scalars['String']['output']>;
  person: Person;
  /** Public readership, independent of Group recipients. Company and HR publication rules still apply. */
  publiclyReadable?: Maybe<Scalars['Boolean']['output']>;
  /** Group recipients; an empty list grants no ordinary Group readership. */
  sharedWith?: Maybe<Array<ContentSharingRecipient>>;
  startDate: DateInstant;
};

/** The filterable fields of type Experience */
export type ExperienceFilterInput = {
  and?: InputMaybe<Array<ExperienceFilterInput>>;
  industry?: InputMaybe<IndustryFilterInput>;
  not?: InputMaybe<ExperienceFilterInput>;
  or?: InputMaybe<Array<ExperienceFilterInput>>;
};

/** Filtering options for a list of elements with type Experience */
export type ExperienceListFilterInput = {
  /** All list items must match the predicate */
  all?: InputMaybe<ExperienceFilterInput>;
  /** If true, there should exist at least list item */
  any?: InputMaybe<Scalars['Boolean']['input']>;
  /** None of list items must match the predicate */
  none?: InputMaybe<ExperienceFilterInput>;
  /** At least one of list items must match the predicate */
  some?: InputMaybe<ExperienceFilterInput>;
};

export type Expertise = Node & SharableEntity & {
  __typename?: 'Expertise';
  /** Dynamic consent to all current and future eligible Groups, independent of public readership. */
  allGroups?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Optional classification metadata, independent of proficiency and subject to this entry's sharing rules.
   * The object has integer version 1, entryOrigin (UNKNOWN, MANUAL, DOCUMENT_IMPORT, AI_SUGGESTION,
   * ESCO_SELECTION), and references. Null means no recorded metadata; updates replace the whole object,
   * omission preserves it. Each reference has uri, label, version (ESCO release, e.g. v1.2.1),
   * language (de/en), optional description, source (USER_SELECTED/AUTOMATIC), status (CONFIRMED/PROPOSED),
   * and basedOnText (the entry wording when confirmed). Changing that wording demotes the mapping to
   * PROPOSED; changing only proficiency or sharing preserves it. No competency level is inferred from ESCO.
   * Expertise accepts at most one reference with an http://data.europa.eu/esco/skill/{UUID} URI.
   */
  classification?: Maybe<Scalars['Object']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  level: Scalars['Int']['output'];
  person: Person;
  position: Scalars['Int']['output'];
  /** Public readership, independent of Group recipients. Company and HR publication rules still apply. */
  publiclyReadable?: Maybe<Scalars['Boolean']['output']>;
  /** Group recipients; an empty list grants no ordinary Group readership. */
  sharedWith?: Maybe<Array<ContentSharingRecipient>>;
};

export type ExpertiseConditionInput = {
  aiMode: ConditionAiMode;
  /**
   * Optional version-1 classification object with the same shape as Expertise.classification.
   * A confirmed skill URI identifies the required competency independently of its label or language.
   * Only a matching confirmed URI is accepted as concept evidence; absent evidence remains unknown.
   * Required proficiency is checked separately; ESCO occupation relations do not imply proficiency.
   */
  classification?: InputMaybe<Scalars['Object']['input']>;
  expertise: Scalars['String']['input'];
  level: Scalars['Int']['input'];
};

/** The filterable fields of type Expertise */
export type ExpertiseFilterInput = {
  and?: InputMaybe<Array<ExpertiseFilterInput>>;
  description?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ExpertiseFilterInput>;
  or?: InputMaybe<Array<ExpertiseFilterInput>>;
};

/** Filtering options for a list of elements with type Expertise */
export type ExpertiseListFilterInput = {
  /** All list items must match the predicate */
  all?: InputMaybe<ExpertiseFilterInput>;
  /** If true, there should exist at least list item */
  any?: InputMaybe<Scalars['Boolean']['input']>;
  /** None of list items must match the predicate */
  none?: InputMaybe<ExpertiseFilterInput>;
  /** At least one of list items must match the predicate */
  some?: InputMaybe<ExpertiseFilterInput>;
};

export type ExtractionChanges = {
  __typename?: 'ExtractionChanges';
  /** Expertises this run newly created. */
  addedExpertises: Array<ExtractionExpertiseChange>;
  /** Powers for which this run wrote a score. */
  scoredPowers: Array<ExtractionPowerChange>;
};

/** The filterable fields of type ExtractionChanges */
export type ExtractionChangesFilterInput = {
  and?: InputMaybe<Array<ExtractionChangesFilterInput>>;
  not?: InputMaybe<ExtractionChangesFilterInput>;
  or?: InputMaybe<Array<ExtractionChangesFilterInput>>;
};

/** Type of a realtime event emitted for a background documents-extraction job. */
export enum ExtractionEventType {
  /** Terminal: the job finished; result is present. */
  Completed = 'COMPLETED',
  /** Terminal: the job failed; message carries the reason. */
  Failed = 'FAILED',
  /** Coarse progress signal; message says which stage started. */
  Progress = 'PROGRESS',
  /** Snapshot only: the job is still queued and has not started running. */
  Queued = 'QUEUED',
  /** The job started running. */
  Started = 'STARTED'
}

export type ExtractionExpertiseChange = {
  __typename?: 'ExtractionExpertiseChange';
  description: Scalars['String']['output'];
  /** Null if the expertise has since been deleted. */
  expertiseId?: Maybe<Scalars['ID']['output']>;
  level: Scalars['Int']['output'];
};

/** The filterable fields of type ExtractionExpertiseChange */
export type ExtractionExpertiseChangeFilterInput = {
  and?: InputMaybe<Array<ExtractionExpertiseChangeFilterInput>>;
  not?: InputMaybe<ExtractionExpertiseChangeFilterInput>;
  or?: InputMaybe<Array<ExtractionExpertiseChangeFilterInput>>;
};

/** Handle for a background extraction job started via startDocumentsExtraction. */
export type ExtractionJob = {
  __typename?: 'ExtractionJob';
  /** Expertises this run created and powers it scored; set once the job is COMPLETED. */
  changes?: Maybe<ExtractionChanges>;
  /** When the job was accepted. */
  createdAt: Scalars['DateTime']['output'];
  /** Whether the powers extraction was requested for this run. */
  extractPowers: Scalars['Boolean']['output'];
  /** Whether the skills extraction was requested for this run. */
  extractSkills: Scalars['Boolean']['output'];
  id: Scalars['UUID']['output'];
  /** Final result; set for COMPLETED, and for FAILED when the pipeline itself produced a result. */
  result?: Maybe<ProcessDocumentsResult>;
  status: ExtractionJobStatus;
};

/** The filterable fields of type ExtractionJob */
export type ExtractionJobFilterInput = {
  and?: InputMaybe<Array<ExtractionJobFilterInput>>;
  not?: InputMaybe<ExtractionJobFilterInput>;
  or?: InputMaybe<Array<ExtractionJobFilterInput>>;
};

/** Lifecycle status of a background documents-extraction job. */
export enum ExtractionJobStatus {
  /** Terminal: the job finished; the result is available. */
  Completed = 'COMPLETED',
  /** Terminal: the job failed; the message carries the reason. */
  Failed = 'FAILED',
  /** The job was accepted and has not started running yet (for example while another extraction for this person is running). */
  Queued = 'QUEUED',
  /** The job is currently extracting. */
  Running = 'RUNNING'
}

export type ExtractionPowerChange = {
  __typename?: 'ExtractionPowerChange';
  element: CreativityElement;
  /** Latest smart-analysis score before the run; null if the power had none. */
  previousScore?: Maybe<Scalars['Int']['output']>;
  score: Scalars['Int']['output'];
};

/** The filterable fields of type ExtractionPowerChange */
export type ExtractionPowerChangeFilterInput = {
  and?: InputMaybe<Array<ExtractionPowerChangeFilterInput>>;
  not?: InputMaybe<ExtractionPowerChangeFilterInput>;
  or?: InputMaybe<Array<ExtractionPowerChangeFilterInput>>;
};

/**
 * One of a person's ranked favourites: a catalogue item or a title of the person's own, exactly one of the two.
 * Readable by its owner, and by others as far as its Toplist is shared.
 */
export type Favorite = {
  __typename?: 'Favorite';
  domain: FavoriteDomain;
  id: Scalars['UUID']['output'];
  /** The catalogue item; null for a title of the person's own. */
  item?: Maybe<CatalogItem>;
  /** 1 is the favourite. */
  position: Scalars['Int']['output'];
  /** The person's own title for something the catalogue lacks; null for a catalogue item. It never enters the catalogue. */
  title?: Maybe<Scalars['String']['output']>;
};

/** What a catalogue item and a favourite are about; each has its own toplist game (toplist.movies, toplist.cities,...). */
export enum FavoriteDomain {
  Book = 'BOOK',
  /** Travel destinations: cities. */
  City = 'CITY',
  Dish = 'DISH',
  Hobby = 'HOBBY',
  Movie = 'MOVIE',
  MusicArtist = 'MUSIC_ARTIST',
  Series = 'SERIES',
  Sport = 'SPORT'
}

/** The filterable fields of type Favorite */
export type FavoriteFilterInput = {
  and?: InputMaybe<Array<FavoriteFilterInput>>;
  not?: InputMaybe<FavoriteFilterInput>;
  or?: InputMaybe<Array<FavoriteFilterInput>>;
};

/**
 * A supported feature enabled by its explicit Permission in a Group-assigned Role.
 * Eligibility never grants data visibility or personal consent. Configure through accessRoles and
 * Group role assignments.
 */
export type Feature = {
  __typename?: 'Feature';
  /** The stable key of the feature. */
  key: Scalars['String']['output'];
  /** The explicit Role Permission enabling this feature. Global scope is required. */
  permissionCode: Scalars['String']['output'];
};

/** The filterable fields of type Feature */
export type FeatureFilterInput = {
  and?: InputMaybe<Array<FeatureFilterInput>>;
  not?: InputMaybe<FeatureFilterInput>;
  or?: InputMaybe<Array<FeatureFilterInput>>;
};

/** The supported features and their explicit Permissions. Config-admin read. */
export type FeaturesResult = {
  __typename?: 'FeaturesResult';
  features: Array<Feature>;
};

/** The filterable fields of type FeaturesResult */
export type FeaturesResultFilterInput = {
  and?: InputMaybe<Array<FeaturesResultFilterInput>>;
  not?: InputMaybe<FeaturesResultFilterInput>;
  or?: InputMaybe<Array<FeaturesResultFilterInput>>;
};

export type File = {
  __typename?: 'File';
  content?: Maybe<Scalars['Binary']['output']>;
  fileExtension?: Maybe<Scalars['String']['output']>;
  fileName?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  mimeType?: Maybe<Scalars['String']['output']>;
};

/** The filterable fields of type File */
export type FileFilterInput = {
  and?: InputMaybe<Array<FileFilterInput>>;
  not?: InputMaybe<FileFilterInput>;
  or?: InputMaybe<Array<FileFilterInput>>;
};

/**
 * Status of one file submitted through `startFileImport`. The same id addresses the detailed result
 * through `importJob` and `importJobEvents` for YAML, or `extractionJob` and
 * `documentsExtractionEvents` for document extraction.
 */
export type FileImportJob = {
  __typename?: 'FileImportJob';
  createdAt: Scalars['DateTime']['output'];
  fileName: Scalars['String']['output'];
  fileType: ImportFileType;
  /** Job id, also accepted by the corresponding route-specific status query. */
  id: Scalars['UUID']['output'];
  /** Failure reason on FAILED, latest progress detail while RUNNING; null otherwise. */
  message?: Maybe<Scalars['String']['output']>;
  /** Documents processed so far; null on routes that do not report a document count. */
  processedDocuments?: Maybe<Scalars['Int']['output']>;
  /**
   * Link to this file import's result. For YAML, this is also the link in its import notifications.
   * Extraction notifications can carry a different link to the corresponding profile analysis result.
   */
  resultLink: Scalars['String']['output'];
  route: FileImportRoute;
  /** Rows the importer affected; null on routes that do not write rows (extraction). */
  rowsAffected?: Maybe<Scalars['Int']['output']>;
  status: FileImportJobStatus;
  /** Total documents to process; null on routes that do not report a document count. */
  totalDocuments?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

/** The filterable fields of type FileImportJob */
export type FileImportJobFilterInput = {
  and?: InputMaybe<Array<FileImportJobFilterInput>>;
  not?: InputMaybe<FileImportJobFilterInput>;
  or?: InputMaybe<Array<FileImportJobFilterInput>>;
};

/** Route-independent lifecycle of a job started through the shared drop. */
export enum FileImportJobStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Queued = 'QUEUED',
  Running = 'RUNNING'
}

/** Processing route selected for a file import. */
export enum FileImportRoute {
  /** Document extraction. This route is not currently accepted by `startFileImport`. */
  DocumentExtraction = 'DOCUMENT_EXTRACTION',
  /** YAML import, also available through `startImportDocuments`. */
  YamlImport = 'YAML_IMPORT'
}

export type FloatFilterInput = {
  /** Logical 'and' of one or more predicates */
  and?: InputMaybe<Array<FloatFilterInput>>;
  /** If true, checks if the field has a value, or, if false, checks if the field is missing a value */
  any?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks if the field's value is equal to the given value */
  eq?: InputMaybe<Scalars['Float']['input']>;
  /** Checks if the field's value is greater than or equal to the given value */
  ge?: InputMaybe<Scalars['Float']['input']>;
  /** Checks if the field's value is greater than to the given value */
  gt?: InputMaybe<Scalars['Float']['input']>;
  /** Checks if the field's value is less than or equal to the given value */
  le?: InputMaybe<Scalars['Float']['input']>;
  /** Checks if the field's value is less than to the given value */
  lt?: InputMaybe<Scalars['Float']['input']>;
  /** Checks if the field's value is not equal to the given value */
  ne?: InputMaybe<Scalars['Float']['input']>;
  /** Negates the predicate */
  not?: InputMaybe<FloatFilterInput>;
  /** Logical 'or' of one or more predicates */
  or?: InputMaybe<Array<FloatFilterInput>>;
};

/**
 * One game of Grow · Play as the game catalogue holds it. While paused (active false) the game starts no new session;
 * sessions already IN_PROGRESS go on, may be resumed through startGameSession and may be finished.
 */
export type GameCatalogEntry = {
  __typename?: 'GameCatalogEntry';
  active: Scalars['Boolean']['output'];
  /** Kind and instance, e.g. toplist.movies or roleplay.window-seat. */
  gameKey: Scalars['String']['output'];
  instance: Scalars['String']['output'];
  kind: Scalars['String']['output'];
};

/** The filterable fields of type GameCatalogEntry */
export type GameCatalogEntryFilterInput = {
  and?: InputMaybe<Array<GameCatalogEntryFilterInput>>;
  not?: InputMaybe<GameCatalogEntryFilterInput>;
  or?: InputMaybe<Array<GameCatalogEntryFilterInput>>;
};

/**
 * One play of one game by one person, readable and writable by that person only. The head every game kind shares;
 * what a kind keeps beyond it, and what finishing writes, belongs to that kind's own operations.
 */
export type GameSession = {
  __typename?: 'GameSession';
  /** Set exactly when the session is no longer IN_PROGRESS. */
  finishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Kind and instance, e.g. toplist.movies or roleplay.window-seat. */
  gameKey: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  lastActivityAt: Scalars['DateTime']['output'];
  startedAt: Scalars['DateTime']['output'];
  status: GameSessionStatus;
  /** Active play time reported by the client, in milliseconds. */
  timeTakenMs: Scalars['Int']['output'];
};

/** The filterable fields of type GameSession */
export type GameSessionFilterInput = {
  and?: InputMaybe<Array<GameSessionFilterInput>>;
  not?: InputMaybe<GameSessionFilterInput>;
  or?: InputMaybe<Array<GameSessionFilterInput>>;
};

export enum GameSessionStatus {
  /** Replaced by a restart. */
  Abandoned = 'ABANDONED',
  Completed = 'COMPLETED',
  /** Idle for longer than its game kind allows, or, for a roleplay session, its story was deleted when its retention period ended. */
  Expired = 'EXPIRED',
  InProgress = 'IN_PROGRESS'
}

export type Gender = Node & {
  __typename?: 'Gender';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  /** Canonical English name, independent of the requested language. Can match extracted values to ids. */
  nameEn?: Maybe<Scalars['String']['output']>;
};

/** The filterable fields of type Gender */
export type GenderFilterInput = {
  and?: InputMaybe<Array<GenderFilterInput>>;
  id?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<GenderFilterInput>;
  or?: InputMaybe<Array<GenderFilterInput>>;
};

/** Contains information for linking 'Gender' to other entities */
export type GenderRelationInput = {
  /** The identifier of 'Gender' */
  id: Scalars['ID']['input'];
};

export type GenderSortInput = {
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
};

export type GendersResult = {
  __typename?: 'GendersResult';
  genders: Array<Gender>;
};

/** The filterable fields of type GendersResult */
export type GendersResultFilterInput = {
  and?: InputMaybe<Array<GendersResultFilterInput>>;
  not?: InputMaybe<GendersResultFilterInput>;
  or?: InputMaybe<Array<GendersResultFilterInput>>;
};

export type GenerateAiRequirementsInput = {
  /**
   * When true, the proposed conditions are returned on the (unpersisted) Match.design so the client can
   * diff/accept them; the match is left unchanged. Defaults to false (generate and persist).
   */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  matchId: Scalars['UUID']['input'];
};

export type GenerateAiRequirementsOutput = GenerateAiRequirementsResult;

export type GenerateAiRequirementsResult = {
  __typename?: 'GenerateAIRequirementsResult';
  match: Match;
};

/** The filterable fields of type GenerateAIRequirementsResult */
export type GenerateAiRequirementsResultFilterInput = {
  and?: InputMaybe<Array<GenerateAiRequirementsResultFilterInput>>;
  not?: InputMaybe<GenerateAiRequirementsResultFilterInput>;
  or?: InputMaybe<Array<GenerateAiRequirementsResultFilterInput>>;
};

export type GenerateTransientMatchResultInput = {
  matchId: Scalars['UUID']['input'];
  /**
   * Optional, fresh per call. Subscribe to operationProgress with it to follow the run in stages. A
   * progressId that is already in use leaves this run without progress; the run itself is unaffected.
   */
  progressId?: InputMaybe<Scalars['UUID']['input']>;
};

export type GlobalSearchInput = {
  /** Optional structured Company filter. Intersected with the full-text results by company id before paging, and restricts results to COMPANY. Mutually exclusive with personFilter and sharedItemFilter. */
  companyFilter?: InputMaybe<CompanyFilterInput>;
  /** Optional filter to restrict results to specific entity types. */
  entityTypes?: InputMaybe<Array<SearchEntityType>>;
  /** Structured Person filter applied before pagination. Mutually exclusive with sharedItemFilter and companyFilter. */
  personFilter?: InputMaybe<PersonFilterInput>;
  /** Optional account-binding criterion, applied before paging. Requires provision:invitee and restricts results to people; not evidence of authentication. */
  personLoginStatus?: InputMaybe<Array<PersonLoginStatus>>;
  /** Person search scope. IDENTITY searches names and stored email only, requires provision:invitee, and restricts results to people. */
  personSearchScope?: InputMaybe<PersonSearchScope>;
  /**
   * Full-text search expression. Spaces combine terms, double quotes enclose a phrase, OR selects
   * alternatives and a leading minus excludes a term. Null or blank selects by filters and entity type
   * only, with rank 0 and stable label, then entity-id ordering.
   */
  query?: InputMaybe<Scalars['String']['input']>;
  /** Structured SharedItem filter applied before pagination. Mutually exclusive with personFilter and companyFilter. */
  sharedItemFilter?: InputMaybe<SharedItemFilterInput>;
  /** Number of rows to skip (offset-based pagination). Defaults to 0. */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Maximum number of results to return. Defaults to 50. */
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type GlobalSearchOutput = {
  __typename?: 'GlobalSearchOutput';
  /** True if more results exist beyond the current page. */
  hasNextPage: Scalars['Boolean']['output'];
  results: Array<GlobalSearchResult>;
};

/** The filterable fields of type GlobalSearchOutput */
export type GlobalSearchOutputFilterInput = {
  and?: InputMaybe<Array<GlobalSearchOutputFilterInput>>;
  not?: InputMaybe<GlobalSearchOutputFilterInput>;
  or?: InputMaybe<Array<GlobalSearchOutputFilterInput>>;
};

export type GlobalSearchResult = {
  __typename?: 'GlobalSearchResult';
  entityId: Scalars['ID']['output'];
  entityType: SearchEntityType;
  /** Human-readable display label for this result. */
  label?: Maybe<Scalars['String']['output']>;
  /** Administrative login details for a Person result. Requires provision:invitee and respects Person visibility. */
  loginAssignment?: Maybe<PersonLoginAssignment>;
  /** The person who owns this entity. Null for matches, shared items, companies and agents. */
  personId?: Maybe<Scalars['ID']['output']>;
  /** Relevance score from full-text search ranking. */
  rank: Scalars['Float']['output'];
};

/** The filterable fields of type GlobalSearchResult */
export type GlobalSearchResultFilterInput = {
  and?: InputMaybe<Array<GlobalSearchResultFilterInput>>;
  not?: InputMaybe<GlobalSearchResultFilterInput>;
  or?: InputMaybe<Array<GlobalSearchResultFilterInput>>;
};

export enum GroupMembershipSource {
  Identity = 'IDENTITY',
  Manual = 'MANUAL',
  Organization = 'ORGANIZATION'
}

export type GrowElement = {
  order?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<LocalizedText>;
};

/** The filterable fields of type GrowElement */
export type GrowElementFilterInput = {
  and?: InputMaybe<Array<GrowElementFilterInput>>;
  not?: InputMaybe<GrowElementFilterInput>;
  or?: InputMaybe<Array<GrowElementFilterInput>>;
};

export type GrowRanking = {
  __typename?: 'GrowRanking';
  score: Scalars['Int']['output'];
  selfAssessmentCompleted: Scalars['Boolean']['output'];
  userRank: UserRank;
};

/** The filterable fields of type GrowRanking */
export type GrowRankingFilterInput = {
  and?: InputMaybe<Array<GrowRankingFilterInput>>;
  not?: InputMaybe<GrowRankingFilterInput>;
  or?: InputMaybe<Array<GrowRankingFilterInput>>;
};

export type GrowResource = {
  __typename?: 'GrowResource';
  audio?: Maybe<Array<AudioElement>>;
  element?: Maybe<CreativityElement>;
  text?: Maybe<Array<TextElement>>;
  videos?: Maybe<Array<VideoElement>>;
};

/** The filterable fields of type GrowResource */
export type GrowResourceFilterInput = {
  and?: InputMaybe<Array<GrowResourceFilterInput>>;
  not?: InputMaybe<GrowResourceFilterInput>;
  or?: InputMaybe<Array<GrowResourceFilterInput>>;
};

export type GrowResourceQueryInput = {
  element: CreativityElement;
};

export type HeartbeatConversationPresenceInput = {
  conversationId: Scalars['UUID']['input'];
  online?: InputMaybe<Scalars['Boolean']['input']>;
};

export type HumanName = {
  __typename?: 'HumanName';
  family?: Maybe<Scalars['String']['output']>;
  given?: Maybe<Array<Scalars['String']['output']>>;
  period?: Maybe<Period>;
  prefix?: Maybe<Scalars['String']['output']>;
  suffix?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  use: NameUse;
};

/** The filterable fields of type HumanName */
export type HumanNameFilterInput = {
  and?: InputMaybe<Array<HumanNameFilterInput>>;
  family?: InputMaybe<StringFilterInput>;
  given?: InputMaybe<StringListFilterInput>;
  not?: InputMaybe<HumanNameFilterInput>;
  or?: InputMaybe<Array<HumanNameFilterInput>>;
};

export type HumanNameSortInput = {
  family?: InputMaybe<SortOrder>;
  given?: InputMaybe<SortOrder>;
};

export type IdFilterInput = {
  /** Logical 'and' of one or more predicates */
  and?: InputMaybe<Array<IdFilterInput>>;
  /** Checks if the field's value is equal to the given value */
  eq?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks if the field's value is in the list of the given values */
  in?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** Checks if the field's value is not equal to the given value */
  ne?: InputMaybe<Scalars['UUID']['input']>;
  /** Negates the predicate */
  not?: InputMaybe<IdFilterInput>;
  /** Logical 'or' of one or more predicates */
  or?: InputMaybe<Array<IdFilterInput>>;
};

/**
 * One multi-file drop, as the client groups it. The id is client-generated; Genesis counts accepted
 * jobs. Batches are scoped to the caller: two principals using the same id get two distinct batches.
 */
export type ImportBatchInput = {
  /** Shared by every file of the drop. */
  id: Scalars['UUID']['input'];
};

/** How a single preview item differs between existing genesis data and incoming LinkedIn data. */
export enum ImportDiffAction {
  /** Target is empty / has no matching row; the LinkedIn value would be added. Default resolution: USE_LINKEDIN. */
  Add = 'ADD',
  /** Target and LinkedIn differ; the user must choose. Default resolution: KEEP_EXISTING. */
  Conflict = 'CONFLICT',
  /** Target and LinkedIn agree; nothing to decide. */
  Unchanged = 'UNCHANGED'
}

/** The operation a document declared, before resolving the target entity. */
export enum ImportDocumentOperation {
  Delete = 'DELETE',
  Insert = 'INSERT',
  Merge = 'MERGE',
  Update = 'UPDATE'
}

/**
 * Result of the importDocuments mutation: the total number of rows the importer
 * inserted / updated / deleted across every document in the YAML payload, plus the
 * per-unit breakdown. `rowsAffected` counts only units that actually persisted, so a
 * partially failed import never reads as if the whole file had been stored.
 */
export type ImportDocumentsResult = {
  __typename?: 'ImportDocumentsResult';
  /** Whether this run was a simulation that was deliberately rolled back. */
  dryRun: Scalars['Boolean']['output'];
  failedUnits: Scalars['Int']['output'];
  mode: ImportMode;
  /** Per-Person action resolved against existing data, available for simulations and committed imports. */
  personActions: Array<ImportPersonActionPreview>;
  /**
   * Rows the import touched. When dryRun is true this is the number of rows the
   * import WOULD have touched: the transaction was rolled back, so nothing was
   * stored. Clients must present it as a simulation, never as a saved result.
   */
  rowsAffected: Scalars['Int']['output'];
  skippedUnits: Scalars['Int']['output'];
  succeededUnits: Scalars['Int']['output'];
  totalUnits: Scalars['Int']['output'];
  /** Per-unit outcomes in payload order. */
  units: Array<ImportUnitResult>;
  /** Non-fatal problems; empty in the normal case. */
  warnings: Array<ImportWarning>;
};

/** The filterable fields of type ImportDocumentsResult */
export type ImportDocumentsResultFilterInput = {
  and?: InputMaybe<Array<ImportDocumentsResultFilterInput>>;
  not?: InputMaybe<ImportDocumentsResultFilterInput>;
  or?: InputMaybe<Array<ImportDocumentsResultFilterInput>>;
};

/**
 * Type of a file recognized by the drop (`startFileImport`). The type is decided from the
 * file name extension, the client-declared MIME type and the actual leading bytes together; any
 * contradiction between the three is rejected before a job is started. Only YAML is currently
 * accepted — PDF and DOCX are recognized but rejected, see `startFileImport`.
 */
export enum ImportFileType {
  /** An OOXML word-processing document (.docx). Recognized, currently rejected by the drop. */
  Docx = 'DOCX',
  /** A PDF document (CV, application form, …). Recognized, currently rejected by the drop. */
  Pdf = 'PDF',
  /** A multi-document genesis importer YAML payload. */
  Yaml = 'YAML'
}

/** Restorable progress and result snapshot for one YAML import run. */
export type ImportJob = {
  __typename?: 'ImportJob';
  createdAt: Scalars['DateTime']['output'];
  currentKind?: Maybe<Scalars['String']['output']>;
  /** Whether this job was a simulation that was deliberately rolled back. */
  dryRun: Scalars['Boolean']['output'];
  failedUnits: Scalars['Int']['output'];
  fileName: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  message?: Maybe<Scalars['String']['output']>;
  mode: ImportMode;
  /**
   * Per-Person action resolved against existing data, restorable after navigating
   * away for both simulations and committed imports.
   */
  personActions: Array<ImportPersonActionPreview>;
  /** Safe structured failure guidance; populated when status is FAILED. */
  problem?: Maybe<ImportProblem>;
  processedDocuments: Scalars['Int']['output'];
  /**
   * Rows actually persisted so far; final committed count when status is COMPLETED.
   * When dryRun is true nothing was committed, so a COMPLETED job reports the rows the
   * import WOULD have touched and clients must label it as a simulation. In
   * KEEP_SUCCESSFUL only units that actually committed are counted. A FAILED job
   * always reports 0.
   */
  rowsAffected: Scalars['Int']['output'];
  skippedUnits: Scalars['Int']['output'];
  stage: ImportJobStage;
  status: ImportJobStatus;
  succeededUnits: Scalars['Int']['output'];
  totalDocuments: Scalars['Int']['output'];
  /** Total number of units (documents) in the payload; 0 until indexing finished. */
  totalUnits: Scalars['Int']['output'];
  /**
   * Per-unit outcomes in payload order. Populated only after completion or failure; while running,
   * progress is reported through the counters.
   */
  units: Array<ImportUnitResult>;
  updatedAt: Scalars['DateTime']['output'];
  /** Non-fatal problems; empty in the normal case. */
  warnings: Array<ImportWarning>;
};

/** The filterable fields of type ImportJob */
export type ImportJobFilterInput = {
  and?: InputMaybe<Array<ImportJobFilterInput>>;
  not?: InputMaybe<ImportJobFilterInput>;
  or?: InputMaybe<Array<ImportJobFilterInput>>;
};

/** Current stage of a detached YAML import job. */
export enum ImportJobStage {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Importing = 'IMPORTING',
  Indexing = 'INDEXING',
  Queued = 'QUEUED'
}

/** Lifecycle of a detached YAML import job. */
export enum ImportJobStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Queued = 'QUEUED',
  Running = 'RUNNING'
}

/**
 * How an import handles a unit it cannot write. ALL_OR_NOTHING is the default: a failure rolls back
 * the whole file. KEEP_SUCCESSFUL retains successfully committed units. In both modes the complete
 * payload is validated first: syntax errors, unknown kinds or fields, and malformed UUIDs prevent
 * all writes.
 */
export enum ImportMode {
  AllOrNothing = 'ALL_OR_NOTHING',
  KeepSuccessful = 'KEEP_SUCCESSFUL'
}

/**
 * Import behavior. Omitted options or fields use the declared defaults. Mode and dryRun are
 * independent. KEEP_SUCCESSFUL with dryRun validates the whole file atomically, including references
 * between documents, and retains no imported data.
 */
export type ImportOptionsInput = {
  /**
   * Validate without retaining imported data. Uses the same authorization, reference resolution and
   * constraints as an actual import. Uploaded files are removed afterwards; existing files that a real
   * import would replace are retained. Cleanup failures are reported as warnings.
   */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  /** Choosing a partial import is an explicit act; the default is the atomic behaviour. */
  mode?: InputMaybe<ImportMode>;
};

/** The proposed change to an existing or new Person. */
export enum ImportPersonAction {
  Create = 'CREATE',
  Delete = 'DELETE',
  /** A deleted Person is reactivated by an explicit merge. */
  Restore = 'RESTORE',
  Update = 'UPDATE'
}

/**
 * The proposed or completed action for one Person document, available for dry runs and committed
 * imports. Contains personal data and is accessible only to the import job's owner, for the same
 * retention period as the job.
 */
export type ImportPersonActionPreview = {
  __typename?: 'ImportPersonActionPreview';
  action: ImportPersonAction;
  /** Zero-based position of the document inside the YAML file, in file order. */
  documentPosition: Scalars['Int']['output'];
  /** The stored display name, for an UPDATE or DELETE. */
  existingDisplayName?: Maybe<Scalars['String']['output']>;
  /** The stored primary email, for an UPDATE or DELETE. */
  existingPrimaryEmail?: Maybe<Scalars['String']['output']>;
  /** The display name the document carries, if it carries one. */
  incomingDisplayName?: Maybe<Scalars['String']['output']>;
  /** The primary email the document carries, if it carries one. */
  incomingPrimaryEmail?: Maybe<Scalars['String']['output']>;
  operation: ImportDocumentOperation;
  /**
   * The UUID the document supplies. Null when the document supplies none;
   * newly assigned identities are reported by the corresponding unit result.
   */
  personId?: Maybe<Scalars['UUID']['output']>;
  warnings: Array<ImportPersonWarningCode>;
};

/** The filterable fields of type ImportPersonActionPreview */
export type ImportPersonActionPreviewFilterInput = {
  and?: InputMaybe<Array<ImportPersonActionPreviewFilterInput>>;
  not?: InputMaybe<ImportPersonActionPreviewFilterInput>;
  or?: InputMaybe<Array<ImportPersonActionPreviewFilterInput>>;
};

/** Machine-readable warning code on a previewed Person action. */
export enum ImportPersonWarningCode {
  /**
   * The document addresses an existing person by UUID and BOTH identity fields it
   * carries — display name and primary email — differ from what is stored. This is
   * a statement of fact, not a verdict: a legitimate rename and a UUID pasted onto
   * the wrong row look identical from here, so the backend reports both identities
   * and the admin decides. It never fails the simulation.
   */
  PersonIdentityMismatch = 'PERSON_IDENTITY_MISMATCH'
}

/** Safe structured details from which a client can build actionable, localized guidance. */
export type ImportProblem = {
  __typename?: 'ImportProblem';
  /** One-based YAML column, when the parser supplied a location. */
  column?: Maybe<Scalars['Int']['output']>;
  /** Heading id in ImportSpecification.markdown, without the leading '#'. */
  documentationAnchor: Scalars['String']['output'];
  /** Accepted members or values when the importer knows them. */
  expectedValues: Array<Scalars['String']['output']>;
  /** Field path, or the unknown member name, when it can be determined safely. */
  fieldPath?: Maybe<Scalars['String']['output']>;
  /** One-based YAML line, when the parser supplied a location. */
  line?: Maybe<Scalars['Int']['output']>;
  reason: ImportProblemReason;
  /** Rejected scalar value, truncated to a safe display length. */
  rejectedValue?: Maybe<Scalars['String']['output']>;
  /** Importer-provided replacement when one is known. */
  suggestedValue?: Maybe<Scalars['String']['output']>;
};

/** The filterable fields of type ImportProblem */
export type ImportProblemFilterInput = {
  and?: InputMaybe<Array<ImportProblemFilterInput>>;
  not?: InputMaybe<ImportProblemFilterInput>;
  or?: InputMaybe<Array<ImportProblemFilterInput>>;
};

/** Stable, localizable reason for an import problem. Never contains a server exception message. */
export enum ImportProblemReason {
  DependencyFailed = 'DEPENDENCY_FAILED',
  Duplicate = 'DUPLICATE',
  InvalidFormat = 'INVALID_FORMAT',
  InvalidReference = 'INVALID_REFERENCE',
  InvalidValue = 'INVALID_VALUE',
  MissingValue = 'MISSING_VALUE',
  PermissionDenied = 'PERMISSION_DENIED',
  PersistenceError = 'PERSISTENCE_ERROR',
  UnexpectedError = 'UNEXPECTED_ERROR',
  UnknownProperty = 'UNKNOWN_PROPERTY',
  UnsupportedModification = 'UNSUPPORTED_MODIFICATION'
}

/**
 * The YAML import format accepted by this deployment. `jsonSchema` describes supported members,
 * types, document kinds, reference targets and `x-genesis-*` metadata for operations, required fields
 * and limits. `markdown` and `examples` provide human-readable guidance and sample payloads.
 */
export type ImportSpecification = {
  __typename?: 'ImportSpecification';
  /** Runnable example payloads, including Person and SharedItem. */
  examples: Array<ImportSpecificationExample>;
  /** The import format version; the value every document's `version` must carry. */
  formatVersion: Scalars['String']['output'];
  /** JSON Schema (draft 2020-12) of one import document, as a JSON string. */
  jsonSchema: Scalars['String']['output'];
  /** The same specification as human-readable Markdown. */
  markdown: Scalars['String']['output'];
};

/** One generated example payload of the YAML import format. */
export type ImportSpecificationExample = {
  __typename?: 'ImportSpecificationExample';
  /** What the example demonstrates. */
  description: Scalars['String']['output'];
  /** File name of the example payload. */
  fileName: Scalars['String']['output'];
  /** The payload itself. */
  yaml: Scalars['String']['output'];
};

/** The filterable fields of type ImportSpecificationExample */
export type ImportSpecificationExampleFilterInput = {
  and?: InputMaybe<Array<ImportSpecificationExampleFilterInput>>;
  not?: InputMaybe<ImportSpecificationExampleFilterInput>;
  or?: InputMaybe<Array<ImportSpecificationExampleFilterInput>>;
};

/** The filterable fields of type ImportSpecification */
export type ImportSpecificationFilterInput = {
  and?: InputMaybe<Array<ImportSpecificationFilterInput>>;
  not?: InputMaybe<ImportSpecificationFilterInput>;
  or?: InputMaybe<Array<ImportSpecificationFilterInput>>;
};

/** Coarse classification of why an import unit did not succeed. */
export enum ImportUnitErrorCode {
  /** Not attempted: a unit this one depends on did not succeed. */
  DependencyFailed = 'DEPENDENCY_FAILED',
  /** An entity with the same id or unique value already exists. Use `merge` to re-import existing entities. */
  Duplicate = 'DUPLICATE',
  /** The document was understood but rejected (value out of range, missing mandatory field, …). */
  InvalidInput = 'INVALID_INPUT',
  /** A reference in the document does not resolve to anything that exists. */
  InvalidReference = 'INVALID_REFERENCE',
  /** The write failed because a constraint or concurrent update prevented saving. */
  PersistenceError = 'PERSISTENCE_ERROR',
  /** Anything the classification does not recognise. */
  UnexpectedError = 'UNEXPECTED_ERROR'
}

/**
 * What one unit of an import did. A unit is one YAML document — the granularity the
 * importer resolves references at, and therefore the smallest slice that can be
 * committed without leaving a half-written entity behind.
 */
export type ImportUnitResult = {
  __typename?: 'ImportUnitResult';
  /** For SKIPPED_DEPENDENCY: the position of the unit whose failure caused the skip. */
  dependsOnPosition?: Maybe<Scalars['Int']['output']>;
  /**
   * Id of the imported entity. Null for failures, skips, deletes, dry runs, or kinds that do not return
   * an entity id. Use this field to address the entity; `label` is display text and `id` identifies the
   * import unit rather than reliably identifying the entity.
   */
  entityId?: Maybe<Scalars['UUID']['output']>;
  errorCode?: Maybe<ImportUnitErrorCode>;
  /** Stable technical identity: `Kind/name`, `Kind/uuid`, or `Kind#position`. */
  id: Scalars['String']['output'];
  /** The document's `kind:` as written in the payload. */
  kind: Scalars['String']['output'];
  /** Short content-derived display label, such as a person's name or an expertise description. Not unique. */
  label: Scalars['String']['output'];
  /** Short, human-readable reason. Null for a successful unit. */
  message?: Maybe<Scalars['String']['output']>;
  /** Blobs this unit's compensating cleanup could not remove. Empty in the normal case. */
  orphanedStorageIds: Array<Scalars['UUID']['output']>;
  /** Zero-based index of the document in the payload, independent of the order units were written in. */
  position: Scalars['Int']['output'];
  /** Localized clients should render this instead of the technical message below. */
  problem?: Maybe<ImportProblem>;
  /** Rows this unit persisted. Always 0 unless it succeeded. */
  rowsAffected: Scalars['Int']['output'];
  status: ImportUnitStatus;
};

/** The filterable fields of type ImportUnitResult */
export type ImportUnitResultFilterInput = {
  and?: InputMaybe<Array<ImportUnitResultFilterInput>>;
  not?: InputMaybe<ImportUnitResultFilterInput>;
  or?: InputMaybe<Array<ImportUnitResultFilterInput>>;
};

/** Outcome of one independently committed import unit (one YAML document). */
export enum ImportUnitStatus {
  /** Attempted and rolled back on its own; its blobs were compensated. */
  Failed = 'FAILED',
  /** Never attempted, because a unit it depends on did not succeed. */
  SkippedDependency = 'SKIPPED_DEPENDENCY',
  /** Committed. Nothing that happens afterwards changes this. */
  Succeeded = 'SUCCEEDED'
}

/** Structured, non-fatal warning attached to an import or simulation result. */
export type ImportWarning = {
  __typename?: 'ImportWarning';
  /** How many blobs this warning is about. */
  blobCount: Scalars['Int']['output'];
  code: ImportWarningCode;
  /** The storage ids an operator needs in order to remove them by hand. */
  storageIds: Array<Scalars['UUID']['output']>;
};

/** Stable warning codes for problems that did not fail the import or dry run. */
export enum ImportWarningCode {
  /**
   * Blobs this run uploaded could not be removed again afterwards and remain
   * stored. Only reachable on a rolled-back run (a failure or a dry run), where
   * the uploads have to be compensated because no row points at them any more.
   */
  BlobCleanupIncomplete = 'BLOB_CLEANUP_INCOMPLETE'
}

/** The filterable fields of type ImportWarning */
export type ImportWarningFilterInput = {
  and?: InputMaybe<Array<ImportWarningFilterInput>>;
  not?: InputMaybe<ImportWarningFilterInput>;
  or?: InputMaybe<Array<ImportWarningFilterInput>>;
};

export type IndustriesResult = {
  __typename?: 'IndustriesResult';
  industries: Array<Industry>;
};

/** The filterable fields of type IndustriesResult */
export type IndustriesResultFilterInput = {
  and?: InputMaybe<Array<IndustriesResultFilterInput>>;
  not?: InputMaybe<IndustriesResultFilterInput>;
  or?: InputMaybe<Array<IndustriesResultFilterInput>>;
};

export type Industry = Node & {
  __typename?: 'Industry';
  id: Scalars['ID']['output'];
  localizedName?: Maybe<LocalizedText>;
  name?: Maybe<Scalars['String']['output']>;
};

export type IndustryExperienceConditionInput = {
  industryId: Scalars['UUID']['input'];
  minimumYears: Scalars['Float']['input'];
};

/** The filterable fields of type Industry */
export type IndustryFilterInput = {
  and?: InputMaybe<Array<IndustryFilterInput>>;
  id?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<IndustryFilterInput>;
  or?: InputMaybe<Array<IndustryFilterInput>>;
};

/** Contains information for linking 'Industry' to other entities */
export type IndustryRelationInput = {
  /** The identifier of 'Industry' */
  id: Scalars['ID']['input'];
};

export type IndustrySortInput = {
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
};

export type IntFilterInput = {
  and?: InputMaybe<Array<IntFilterInput>>;
  /** If true, checks if the field has a value, or, if false, checks if the field is missing a value */
  any?: InputMaybe<Scalars['Boolean']['input']>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  ge?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  le?: InputMaybe<Scalars['Int']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  not?: InputMaybe<IntFilterInput>;
  or?: InputMaybe<Array<IntFilterInput>>;
};

export type IntegerConditionInput = {
  kind: IntegerConditionKind;
  value: Scalars['Int']['input'];
};

export enum IntegerConditionKind {
  Age = 'AGE',
  AnnualSalary = 'ANNUAL_SALARY',
  ChildrenCount = 'CHILDREN_COUNT'
}

/**
 * Invite one EXISTING Person: bind a new external login to the Genesis Person already in hand.
 *
 * Distinct from `provisionInvitee` on purpose. That one takes an email and knows no Person; this one
 * takes the Person and binds the account it creates to that exact `personId`, leaving the id, the
 * profile and every relation in place.
 */
export type InviteExistingPersonInput = {
  /** The confirmed recipient. A reserved placeholder address is refused. */
  email: Scalars['String']['input'];
  /** The Person to bind a login to. Their id never changes. */
  personId: Scalars['UUID']['input'];
  /** Idempotency key minted by the client, one per user-confirmed attempt. */
  requestId: Scalars['UUID']['input'];
};

export type JobDepartment = Node & {
  __typename?: 'JobDepartment';
  id: Scalars['ID']['output'];
  localizedName?: Maybe<LocalizedText>;
  name?: Maybe<Scalars['String']['output']>;
};

/** The filterable fields of type JobDepartment */
export type JobDepartmentFilterInput = {
  and?: InputMaybe<Array<JobDepartmentFilterInput>>;
  id?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<JobDepartmentFilterInput>;
  or?: InputMaybe<Array<JobDepartmentFilterInput>>;
};

/** Contains information for linking 'JobDepartment' to other entities */
export type JobDepartmentRelationInput = {
  /** The identifier of 'JobDepartment' */
  id: Scalars['ID']['input'];
};

export type JobDepartmentSortInput = {
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
};

export type JobDepartmentsResult = {
  __typename?: 'JobDepartmentsResult';
  jobDepartments: Array<JobDepartment>;
};

/** The filterable fields of type JobDepartmentsResult */
export type JobDepartmentsResultFilterInput = {
  and?: InputMaybe<Array<JobDepartmentsResultFilterInput>>;
  not?: InputMaybe<JobDepartmentsResultFilterInput>;
  or?: InputMaybe<Array<JobDepartmentsResultFilterInput>>;
};

export type JobLocation = Node & {
  __typename?: 'JobLocation';
  id: Scalars['ID']['output'];
  localizedName?: Maybe<LocalizedText>;
  name?: Maybe<Scalars['String']['output']>;
};

/** The filterable fields of type JobLocation */
export type JobLocationFilterInput = {
  and?: InputMaybe<Array<JobLocationFilterInput>>;
  id?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<JobLocationFilterInput>;
  or?: InputMaybe<Array<JobLocationFilterInput>>;
};

/** Contains information for linking 'JobLocation' to other entities */
export type JobLocationRelationInput = {
  /** The identifier of 'JobLocation' */
  id: Scalars['ID']['input'];
};

export type JobLocationSortInput = {
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
};

export type JobLocationsResult = {
  __typename?: 'JobLocationsResult';
  jobLocations: Array<JobLocation>;
};

/** The filterable fields of type JobLocationsResult */
export type JobLocationsResultFilterInput = {
  and?: InputMaybe<Array<JobLocationsResultFilterInput>>;
  not?: InputMaybe<JobLocationsResultFilterInput>;
  or?: InputMaybe<Array<JobLocationsResultFilterInput>>;
};

export type LanguageConditionInput = {
  languageTag: Scalars['String']['input'];
  level: ConditionLanguageLevel;
};

export type LanguageSkill = Node & {
  __typename?: 'LanguageSkill';
  /** Dynamic consent to all current and future eligible Groups, independent of public readership. */
  allGroups?: Maybe<Scalars['Boolean']['output']>;
  cefr?: Maybe<CefrScale>;
  id: Scalars['ID']['output'];
  /** BCP 47 language tag, for example "en" or "de". */
  languageTag: Scalars['String']['output'];
  nativeSpeaker: Scalars['Boolean']['output'];
  person: Person;
  /** Public readership, independent of Group recipients. Company and HR publication rules still apply. */
  publiclyReadable?: Maybe<Scalars['Boolean']['output']>;
  selfAssessed?: Maybe<Scalars['Boolean']['output']>;
  /** Group recipients; an empty list grants no ordinary Group readership. */
  sharedWith?: Maybe<Array<ContentSharingRecipient>>;
};

/** The filterable fields of type LanguageSkill */
export type LanguageSkillFilterInput = {
  and?: InputMaybe<Array<LanguageSkillFilterInput>>;
  cefr?: InputMaybe<CefrScaleFilterInput>;
  /** BCP 47 language tag, for example "en" or "de". */
  languageTag?: InputMaybe<StringFilterInput>;
  nativeSpeaker?: InputMaybe<BooleanFilterInput>;
  not?: InputMaybe<LanguageSkillFilterInput>;
  or?: InputMaybe<Array<LanguageSkillFilterInput>>;
};

/** Filtering options for a list of elements with type LanguageSkill */
export type LanguageSkillListFilterInput = {
  /** All list items must match the predicate */
  all?: InputMaybe<LanguageSkillFilterInput>;
  /** If true, there should exist at least list item */
  any?: InputMaybe<Scalars['Boolean']['input']>;
  /** None of list items must match the predicate */
  none?: InputMaybe<LanguageSkillFilterInput>;
  /** At least one of list items must match the predicate */
  some?: InputMaybe<LanguageSkillFilterInput>;
};

/** Link a match to a listing, analogous to `LinkProjectMatchInput` for projects. */
export type LinkListingMatchInput = {
  listingId: Scalars['UUID']['input'];
  matchId: Scalars['UUID']['input'];
};

export type LinkListingMatchOutput = LinkListingMatchResult;

export type LinkListingMatchResult = {
  __typename?: 'LinkListingMatchResult';
  listing: Listing;
};

/** The filterable fields of type LinkListingMatchResult */
export type LinkListingMatchResultFilterInput = {
  and?: InputMaybe<Array<LinkListingMatchResultFilterInput>>;
  not?: InputMaybe<LinkListingMatchResultFilterInput>;
  or?: InputMaybe<Array<LinkListingMatchResultFilterInput>>;
};

export type LinkProjectMatchInput = {
  /**
   *   Company context for the write. On a company project, supplying a declaration uses company-admin
   *   authorization and requires an active company. Omitting it uses personal authorization: WRITE on
   *   `plan`, or ownership of a personal project. A declaration naming another company is `GENESIS001259`;
   *   any declaration on a personal project is `GENESIS001260`.
   *
   * Authorization for the chosen route is checked first. Unauthorized callers receive an authorization
   *   error, or `No such entity` for an invisible project, before context or company-status errors.
   */
  actingAsCompanyId?: InputMaybe<Scalars['UUID']['input']>;
  matchId: Scalars['UUID']['input'];
  projectId: Scalars['UUID']['input'];
};

export type LinkProjectMatchOutput = LinkProjectMatchResult;

export type LinkProjectMatchResult = {
  __typename?: 'LinkProjectMatchResult';
  project: Project;
};

/** The filterable fields of type LinkProjectMatchResult */
export type LinkProjectMatchResultFilterInput = {
  and?: InputMaybe<Array<LinkProjectMatchResultFilterInput>>;
  not?: InputMaybe<LinkProjectMatchResultFilterInput>;
  or?: InputMaybe<Array<LinkProjectMatchResultFilterInput>>;
};

/**
 * LinkedIn import credentials and optional scope. Supply the access token obtained through the
 * client's OAuth flow; do not supply an authorization code. The token authorizes retrieval of the
 * member's DMA snapshot. Omitting scope selects all supported collections and fields.
 */
export type LinkedInImportInput = {
  accessToken: Scalars['String']['input'];
  scope?: InputMaybe<LinkedInImportScope>;
};

/**
 * Selects the profile collections and fields to import from the LinkedIn DMA snapshot. Omitted or
 * null flags mean true. Setting a flag to false skips that part. Existing non-empty collections remain
 * unchanged under the bulk import merge policy.
 */
export type LinkedInImportScope = {
  importBio?: InputMaybe<Scalars['Boolean']['input']>;
  importCertificates?: InputMaybe<Scalars['Boolean']['input']>;
  importCurrentEmployer?: InputMaybe<Scalars['Boolean']['input']>;
  importEducations?: InputMaybe<Scalars['Boolean']['input']>;
  importExperiences?: InputMaybe<Scalars['Boolean']['input']>;
  importExpertises?: InputMaybe<Scalars['Boolean']['input']>;
  importJobTitle?: InputMaybe<Scalars['Boolean']['input']>;
  importLanguageSkills?: InputMaybe<Scalars['Boolean']['input']>;
  importProfession?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * An opportunity people or companies can apply to, such as a job, incubator programme or funding call. It is a
 * kind of project, not a `SharedItem`. Listing membership, area levels and linked matches are independent of
 * its lifecycle, publication time, deadline and retention. Authenticated listing reads require
 * `feature:share.listings`, even for members. Members with that feature read listings in every state. Group
 * recipients and public-content readers of a `publiclyReadable` listing reach only effectively OPEN listings
 * and only their content: id, reference, name, description, data, categories, state, publication time,
 * deadline and images. Other fields are null for those readers. Anonymous readers use `publicListings`. Only
 * the creator may permanently delete a listing. Deletion removes its access, match links, recipients,
 * categories, images and listing data but preserves the linked matches.
 */
export type Listing = Node & {
  __typename?: 'Listing';
  /**
   * Complete desired access list. A supplied list replaces existing grants; null or omission preserves them.
   * The creator retains WRITE on every listing area. Visible only to members. Updating this field requires the
   * same access-management capability and delegation checks as `setListingAccess`, independently of WRITE on
   * `plan`. A content editor without management rights is refused and nothing is written. Prefer
   * `setListingAccess`, which additionally rejects stale access revisions; this update field remains for
   * compatibility.
   */
  access?: Maybe<Array<ListingAccess>>;
  /**
   * Access-list revision checked by `setListingAccess.expectedRevision`. Changes whenever an entry changes.
   * Members only.
   */
  accessRevision?: Maybe<Scalars['String']['output']>;
  actions: ListingActions;
  /** Internal application stages and optional quiz request, visible only to listing members. */
  applicationProcess?: Maybe<Scalars['Object']['output']>;
  /** Categories for applicants. They grant no access and do not publish the listing. */
  categories: Array<DiscoveryCategory>;
  /** Most recent conclusion time, when retention last started. Members only. */
  concludedOn?: Maybe<Scalars['DateTime']['output']>;
  /** Listing contact person, visible to every permitted reader. */
  contactPerson?: Maybe<Person>;
  /** Members only. */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** Members only. */
  createdBy?: Maybe<Person>;
  /**
   * Versioned JSON planning document containing listing text and requirements, following the same payload
   * model as `Project.data`.
   */
  data?: Maybe<Scalars['Object']['output']>;
  /**
   * Deadline after which an OPEN listing behaves as CLOSED; null means no deadline. Visible to all content
   * readers, including group recipients and public readers. Change through `updateListing` with WRITE on
   * `plan`.
   */
  deadline?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /**
   * Additional images in insertion order, visible like the cover image. `updateListing` appends supplied
   * images; it does not replace existing ones. Remove with `imagesToDelete`. The cover image's format and size
   * limits apply; the number of images is not limited.
   */
  images?: Maybe<Array<File>>;
  /**
   * Cover image, visible to all permitted content readers including applicants. `profile` selects a resized
   * image (`card` or `share_preview`); omission returns the original. Set on creation or replace through
   * `updateListing` with WRITE on `plan`. Null on update removes it; omission preserves it. Raster images only
   * (PNG, JPEG, GIF, BMP, TIFF, WebP), at most 5 MiB, validated from the bytes rather than the declared MIME
   * type or filename.
   */
  mainImage?: Maybe<File>;
  /**
   * Linked matches as narrow references containing id, name and link creation time. Visible to all listing
   * members at any `candidates` level. Maintain with `linkListingMatch` and `unlinkListingMatch`.
   */
  matches?: Maybe<Array<Match>>;
  /**
   * The caller's email preferences for this listing, both initially disabled. Never returns another person's
   * choices. Change with `setListingMailNotification`.
   */
  myMailNotification: ListingMailNotification;
  name?: Maybe<Scalars['String']['output']>;
  /**
   * Whether the listing is publicly readable, independently of group recipients and only while open. Visible
   * only to members.
   */
  publiclyReadable?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Last publication time, null before first publication. Retained on withdrawal and does not determine the
   * effective state.
   */
  publishedOn?: Maybe<Scalars['DateTime']['output']>;
  /**
   * Stable human-readable reference, for example `2026-0042`. The year is the creation year in Europe/Berlin;
   * the sequence starts at 1 each year with at least four digits and grows beyond 9999. Assigned at creation,
   * unique and immutable, never writable and never reused after deletion. The technical identifier remains
   * `id`. Every content reader, including group recipients, public readers and applicants, can read it. Filter
   * by exact reference with `where: {reference: {eq: "2026-0042"}}`.
   */
  reference: Scalars['String']['output'];
  /**
   * Retention period from 1 to 180 days, defaulting to 180 on creation. This is a product limit, not a legal
   * minimum. Visible only to members. Each application counts from its rejection or withdrawal; applications
   * still open at conclusion count from that conclusion. Later changes do not move deletion dates already
   * calculated.
   */
  retentionDays?: Maybe<Scalars['Int']['output']>;
  /** Group recipients, who read only while the listing is open. Visible only to members. */
  sharedWith?: Maybe<Array<ContentSharingRecipient>>;
  /** Effective state including the deadline. Explicit transitions use `setListingState`. */
  state?: Maybe<ListingState>;
  /** Members only. */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Members only. */
  updatedBy?: Maybe<Person>;
};


/**
 * An opportunity people or companies can apply to, such as a job, incubator programme or funding call. It is a
 * kind of project, not a `SharedItem`. Listing membership, area levels and linked matches are independent of
 * its lifecycle, publication time, deadline and retention. Authenticated listing reads require
 * `feature:share.listings`, even for members. Members with that feature read listings in every state. Group
 * recipients and public-content readers of a `publiclyReadable` listing reach only effectively OPEN listings
 * and only their content: id, reference, name, description, data, categories, state, publication time,
 * deadline and images. Other fields are null for those readers. Anonymous readers use `publicListings`. Only
 * the creator may permanently delete a listing. Deletion removes its access, match links, recipients,
 * categories, images and listing data but preserves the linked matches.
 */
export type ListingMainImageArgs = {
  profile?: InputMaybe<Scalars['String']['input']>;
};

/**
 * A person's access to a listing, with separate levels on `plan`, `candidates` and `applications`. Listings
 * have no `timeline` area. Areas belonging to another kind of project grant no rights and cannot be written
 * here.
 */
export type ListingAccess = {
  __typename?: 'ListingAccess';
  /**
   * Applications. NONE grants no read access, READ permits reading and WRITE also permits changing application
   * state with `setListingApplicationState`. Membership alone does not permit reading applications.
   */
  applications: ListingApplicationAccessLevel;
  /**
   * Whether the caller may change or remove this entry through `setListingAccess`: the creator may change
   * every entry except their own; delegated managers may change only entries without `managesAccess`. The
   * mutation uses the same rules.
   */
  canChange: Scalars['Boolean']['output'];
  /** Candidates. WRITE permits linking and unlinking matches. */
  candidates: AccessLevel;
  /**
   * May manage listing access with `setListingAccess`, independently of area levels. WRITE on `plan` does not
   * manage access; managing access grants no content, application, profile or record rights. Only the creator
   * appoints managers and this value is always true for the creator. Written only through `ListingAccessInput`
   * in `setListingAccess`. `createListing` and `updateListing` with `access` create new entries without
   * management rights and preserve existing management rights.
   */
  managesAccess: Scalars['Boolean']['output'];
  person: Person;
  /** Listing text and requirements. WRITE also permits every lifecycle transition. */
  plan: AccessLevel;
};

/** The filterable fields of type ListingAccess */
export type ListingAccessFilterInput = {
  and?: InputMaybe<Array<ListingAccessFilterInput>>;
  not?: InputMaybe<ListingAccessFilterInput>;
  or?: InputMaybe<Array<ListingAccessFilterInput>>;
};

/** One desired access entry in `setListingAccess`. */
export type ListingAccessInput = {
  /**
   * Use NONE for content editors without application access. Delegated managers may grant or raise at most
   * their own level (`Listing.actions.grantableApplications`); an unchanged higher entry remains allowed.
   */
  applications: ListingApplicationAccessLevel;
  candidates: AccessLevel;
  /** May manage access. Only the creator may change this capability; new entries receive it only explicitly. */
  managesAccess: Scalars['Boolean']['input'];
  personId: Scalars['UUID']['input'];
  plan: AccessLevel;
};

/**
 * Actions available to the caller, calculated by the same authorization rules as the mutations. Clients must
 * use these capabilities instead of deriving them from roles, access levels or state. Every action except
 * `canApply` requires `feature:share.listings`; `canApply` requires `feature:share.applications`.
 */
export type ListingActions = {
  __typename?: 'ListingActions';
  /**
   * Apply with `applyToListing`: requires `feature:share.applications`, an effectively OPEN listing readable
   * from outside its membership through group or public access and no application by this person that has not
   * been withdrawn.
   */
  canApply: Scalars['Boolean']['output'];
  /**
   * Appoint or remove access managers by changing `managesAccess` in `setListingAccess`. Only the creator may
   * do this; delegated managers cannot change managers or the creator.
   */
  canAppointManagers: Scalars['Boolean']['output'];
  /** Change the search target: requires content editing rights and no existing applications or linked matches. */
  canChangeSearchTarget: Scalars['Boolean']['output'];
  /** Close from OPEN to CLOSED. */
  canClose: Scalars['Boolean']['output'];
  /** Conclude from CLOSED to CONCLUDED, starting the retention period. */
  canConclude: Scalars['Boolean']['output'];
  /** Permanently delete with `deleteListing`. Only the creator may do this. */
  canDelete: Scalars['Boolean']['output'];
  /**
   * Manage the access list with `setListingAccess`: the creator or an explicitly delegated access manager
   * (`ListingAccess.managesAccess`), independently of the level on `plan`. Uses the mutation's authorization
   * rules.
   */
  canManageAccess: Scalars['Boolean']['output'];
  /**
   * Link and unlink matches with `linkListingMatch` and `unlinkListingMatch`. Requires WRITE on `candidates`.
   * Linking also requires visibility of the particular match, checked by the mutation.
   */
  canManageMatches: Scalars['Boolean']['output'];
  /** Publish from DRAFT to OPEN. An expired deadline must be moved in the same request. */
  canPublish: Scalars['Boolean']['output'];
  /**
   * Read this listing's applications, their counts, runs and notifications: the creator or someone with at
   * least READ on `applications`. Membership alone is insufficient. False means no access, not no
   * applications. Every application read uses this condition.
   */
  canReadApplications: Scalars['Boolean']['output'];
  /** Reopen from CLOSED or CONCLUDED to OPEN. An expired deadline must be moved in the same request. */
  canReopen: Scalars['Boolean']['output'];
  /**
   * Edit text, requirements, deadline, retention, recipients and categories with `updateListing` without
   * `access`. Requires WRITE on `plan`.
   */
  canUpdate: Scalars['Boolean']['output'];
  /** Withdraw from OPEN to DRAFT. Content, access and publication time remain. */
  canWithdraw: Scalars['Boolean']['output'];
  /**
   * Highest `applications` level the caller can newly grant or raise an entry to through `setListingAccess`:
   * WRITE for the creator, the manager's own level for a delegated manager, otherwise NONE. Unchanged higher
   * entries remain allowed; lowering and removing are not constrained by this ceiling. The mutation enforces
   * the same rule with GENESIS001290.
   */
  grantableApplications: ListingApplicationAccessLevel;
};

/** The filterable fields of type ListingActions */
export type ListingActionsFilterInput = {
  and?: InputMaybe<Array<ListingActionsFilterInput>>;
  not?: InputMaybe<ListingActionsFilterInput>;
  or?: InputMaybe<Array<ListingActionsFilterInput>>;
};

/**
 * The application relationship between a person and a listing. Contact details belong to the person and
 * documents to their organizational record. `listingApplications` requires `feature:share.listings` and
 * returns only applications the caller may read as listing creator or with at least READ on `applications`.
 * Membership alone is insufficient. Filter by fields such as `listingId` and `state`. Read the caller's own
 * applications with `myListingApplications` and `feature:share.applications`.
 */
export type ListingApplication = Node & {
  __typename?: 'ListingApplication';
  actions: ListingApplicationActions;
  /**
   * Language that would be used for a mail to this applicant now: the application's recorded form language,
   * otherwise the instance language in system settings. Each sent mail retains its own language and later
   * changes do not rewrite it. Null only when no form language exists and the stored instance language is
   * invalid, a configuration error that prevents sending mail for this application.
   */
  communicationLanguage?: Maybe<CommunicationLanguage>;
  /** Company represented by the application; the person remains its contact and owner. */
  companyId?: Maybe<Scalars['ID']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** Time of acceptance, rejection or withdrawal; otherwise null, including after reopening a decision. */
  decidedOn?: Maybe<Scalars['DateTime']['output']>;
  /**
   * Submitted documents. Requires `read:organizational-record` or `write:organizational-record`. Null for
   * every other reader, including listing members and the applicant themselves. An empty list means no
   * documents were submitted.
   */
  documents?: Maybe<Array<ListingApplicationDocument>>;
  id: Scalars['ID']['output'];
  /**
   * The listing. Members read it as through `listing`; the applicant reads only its content, in every listing
   * state.
   */
  listing: Listing;
  /** Listing receiving this application. */
  listingId: Scalars['ID']['output'];
  /**
   * Application mails, newest first: explicitly sent interview, offer and rejection messages and the automatic
   * receipt after public confirmation. A receipt appears once its text has been generated. Visible to readers
   * of the listing's applications; null for the applicant. Each mail retains its sent text and delivery state
   * and is deleted with the application.
   */
  mails?: Maybe<Array<ListingApplicationMail>>;
  /**
   * The applicant. Profile fields follow `read:external-information` or personal consent. An application
   * grants no profile access by itself.
   */
  person?: Maybe<Person>;
  /** Last quiz request; null for applicant readers. */
  powerQuizRequest?: Maybe<ListingApplicationQuizRequest>;
  /** Time the application was received. */
  receivedOn?: Maybe<Scalars['DateTime']['output']>;
  /** Internal phase; null for applicant readers. */
  stageId?: Maybe<Scalars['String']['output']>;
  state: ListingApplicationState;
};

/**
 * Access to a listing's `applications` area. Unlike `AccessLevel`, this includes NONE because applications are
 * personal data restricted to explicit readers. Other listing areas, projects and matches retain
 * `AccessLevel`.
 */
export enum ListingApplicationAccessLevel {
  /** No application access, including counts, runs and notifications. */
  None = 'NONE',
  /** Read applications. */
  Read = 'READ',
  /** Read and edit applications, including state, stage and quiz requests. */
  Write = 'WRITE'
}

/**
 * Actions available to the caller on this application, calculated by the same rules as the mutations. Clients
 * must use these capabilities rather than derive permissions themselves.
 */
export type ListingApplicationActions = {
  __typename?: 'ListingApplicationActions';
  /** Accept, IN_REVIEW to ACCEPTED. Requires WRITE on `applications` and `feature:share.listings`. */
  canAccept: Scalars['Boolean']['output'];
  canMoveStage: Scalars['Boolean']['output'];
  /** Reject, IN_REVIEW to REJECTED. Requires WRITE on `applications` and `feature:share.listings`. */
  canReject: Scalars['Boolean']['output'];
  /**
   * Reopen a decision, ACCEPTED or REJECTED to IN_REVIEW. Clears decision time and deletion deadline. Requires
   * WRITE on `applications` and `feature:share.listings`.
   */
  canReopenReview: Scalars['Boolean']['output'];
  /**
   * Request the Power Quiz with `requestListingApplicationPowerQuiz`. Requires `feature:share.listings`, WRITE
   * on `applications`, quiz requests enabled in the listing process, an application neither rejected nor
   * withdrawn and an active applicant with a login. Whether that login has an email address is checked by the
   * mutation.
   */
  canRequestPowerQuiz: Scalars['Boolean']['output'];
  /** Start review, RECEIVED to IN_REVIEW. Requires WRITE on `applications` and `feature:share.listings`. */
  canStartReview: Scalars['Boolean']['output'];
  /**
   * Withdraw through `withdrawListingApplication`: only the applicant, from RECEIVED or IN_REVIEW, with
   * `feature:share.applications`.
   */
  canWithdraw: Scalars['Boolean']['output'];
  /**
   * Mail kinds the caller may currently preview and send. Requires `feature:share.listings`, WRITE on
   * `applications` and a compatible application state. Empty when none are available. The preview checks
   * whether a proven recipient address exists. Never includes RECEIPT, which is sent automatically.
   */
  mailKinds: Array<ListingApplicationMailKind>;
};

/** The filterable fields of type ListingApplicationActions */
export type ListingApplicationActionsFilterInput = {
  and?: InputMaybe<Array<ListingApplicationActionsFilterInput>>;
  not?: InputMaybe<ListingApplicationActionsFilterInput>;
  or?: InputMaybe<Array<ListingApplicationActionsFilterInput>>;
};

/** Confirmation outcome returned to the token holder. Never exposes a person, account or application id. */
export enum ListingApplicationConfirmationOutcome {
  /** The same applicant already applied to this listing. Token consumed, nothing changed. */
  AlreadyApplied = 'ALREADY_APPLIED',
  /** Application created. */
  Confirmed = 'CONFIRMED',
  /** An account belongs to this mailbox. Sign in to continue. Nothing created; token remains valid. */
  LoginRequired = 'LOGIN_REQUIRED',
  /** Token unknown, expired or consumed, or the listing no longer accepts this application. */
  NotConfirmable = 'NOT_CONFIRMABLE',
  /**
   * Temporarily unavailable because of an identity-service failure or concurrent change. Nothing created;
   * token remains valid.
   */
  RetryLater = 'RETRY_LATER',
  /** The signed-in account does not match this mailbox. Nothing changed; token remains valid. */
  WrongAccount = 'WRONG_ACCOUNT'
}

export type ListingApplicationConnection = {
  __typename?: 'ListingApplicationConnection';
  edges: Array<ListingApplicationEdge>;
  nodes: Array<ListingApplication>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/**
 * Application contact details. Fill only empty fields of the applicant's profile, never overwrite existing
 * values and are not copied into the application. Empty input values are ignored.
 */
export type ListingApplicationContactInput = {
  apartment?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  countryId?: InputMaybe<Scalars['UUID']['input']>;
  familyName?: InputMaybe<Scalars['String']['input']>;
  givenName?: InputMaybe<Scalars['String']['input']>;
  houseNumber?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

/**
 * A submitted application document. It belongs to the applicant's organizational record and follows that
 * record's access rules and lifecycle.
 */
export type ListingApplicationDocument = {
  __typename?: 'ListingApplicationDocument';
  /** Submitted document category, for example `CURRICULUM_VITAE`; null if unspecified. */
  classifier?: Maybe<DocumentClassifier>;
  document: OrganizationalRecordDocument;
};

/** The filterable fields of type ListingApplicationDocument */
export type ListingApplicationDocumentFilterInput = {
  and?: InputMaybe<Array<ListingApplicationDocumentFilterInput>>;
  not?: InputMaybe<ListingApplicationDocumentFilterInput>;
  or?: InputMaybe<Array<ListingApplicationDocumentFilterInput>>;
};

/**
 * Inline application document, as in `createOrganizationalRecordDocument`. Stored in the applicant's
 * organizational record; submission does not grant the applicant permission to read it afterward. A
 * `CURRICULUM_VITAE` document additionally prefills empty profile fields after saving.
 */
export type ListingApplicationDocumentInput = {
  classifier?: InputMaybe<DocumentClassifier>;
  content: CreateFileDataInput;
  fileName: Scalars['String']['input'];
  /** Title in the organizational record; defaults to the filename. */
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ListingApplicationEdge = {
  __typename?: 'ListingApplicationEdge';
  cursor: Scalars['String']['output'];
  node: ListingApplication;
};

/** The filterable fields of type ListingApplication */
export type ListingApplicationFilterInput = {
  and?: InputMaybe<Array<ListingApplicationFilterInput>>;
  id?: InputMaybe<IdFilterInput>;
  /** Listing receiving this application. */
  listingId?: InputMaybe<IdFilterInput>;
  not?: InputMaybe<ListingApplicationFilterInput>;
  or?: InputMaybe<Array<ListingApplicationFilterInput>>;
  state?: InputMaybe<ListingApplicationStateFilterInput>;
};

/** An application mail, retaining the text that was sent. */
export type ListingApplicationMail = {
  __typename?: 'ListingApplicationMail';
  body: Scalars['String']['output'];
  /** Time sending finished with acceptance, failure, unknown outcome or cancellation. */
  finishedOn?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['UUID']['output'];
  kind: ListingApplicationMailKind;
  language: CommunicationLanguage;
  /** Set for FAILED_BEFORE_SEND, DELIVERY_UNKNOWN and CANCELLED. */
  problem?: Maybe<MailDeliveryProblem>;
  recipientSource: ListingApplicationMailRecipientSource;
  /** The requesting sender, read under ordinary person rules. Null for automatic RECEIPT messages. */
  requestedBy?: Maybe<Person>;
  requestedOn: Scalars['DateTime']['output'];
  status: MailDeliveryStatus;
  subject: Scalars['String']['output'];
};

/** The filterable fields of type ListingApplicationMail */
export type ListingApplicationMailFilterInput = {
  and?: InputMaybe<Array<ListingApplicationMailFilterInput>>;
  not?: InputMaybe<ListingApplicationMailFilterInput>;
  or?: InputMaybe<Array<ListingApplicationMailFilterInput>>;
};

/**
 * Kind of application mail. HR explicitly sends INTERVIEW, OFFER and REJECTION; RECEIPT is automatic. No mail
 * changes application state and changing state does not send a mail. Withdrawn applications receive none.
 */
export enum ListingApplicationMailKind {
  /** Interview invitation. Only for RECEIVED or IN_REVIEW applications. */
  Interview = 'INTERVIEW',
  /** Offer message without a contract document. For open or accepted applications. */
  Offer = 'OFFER',
  /**
   * Exactly one receipt per application newly created by public confirmation, sent to the address proven in
   * that confirmation. Confirms only receipt, including after a decision or listing closure, but never after
   * withdrawal. Sent automatically; HR cannot preview or send it and `previewListingApplicationMail` rejects
   * this kind.
   */
  Receipt = 'RECEIPT',
  /** Rejection message. For open or rejected applications. */
  Rejection = 'REJECTION'
}

/**
 * Binding preview of a mail to the applicant. Exactly this text, recipient and language will be used if the
 * caller confirms through `sendListingApplicationMail` before `expiresOn` and the recipient, language,
 * template, application and permissions have not changed.
 */
export type ListingApplicationMailPreview = {
  __typename?: 'ListingApplicationMailPreview';
  body: Scalars['String']['output'];
  expiresOn?: Maybe<Scalars['DateTime']['output']>;
  kind: ListingApplicationMailKind;
  /** Mail language: recorded application form language, otherwise the instance language. HR cannot override it. */
  language: CommunicationLanguage;
  /** Masked recipient address. The application does not grant access to profile fields. */
  maskedRecipient?: Maybe<Scalars['String']['output']>;
  /** Null when no proven recipient address is available; `unavailableReason` explains why. */
  previewId?: Maybe<Scalars['UUID']['output']>;
  recipientSource?: Maybe<ListingApplicationMailRecipientSource>;
  subject: Scalars['String']['output'];
  unavailableReason?: Maybe<ListingApplicationMailUnavailableReason>;
};

/** The filterable fields of type ListingApplicationMailPreview */
export type ListingApplicationMailPreviewFilterInput = {
  and?: InputMaybe<Array<ListingApplicationMailPreviewFilterInput>>;
  not?: InputMaybe<ListingApplicationMailPreviewFilterInput>;
  or?: InputMaybe<Array<ListingApplicationMailPreviewFilterInput>>;
};

/**
 * Evidence establishing the recipient's email address. Never a freely chosen address or an address read from
 * the profile.
 */
export enum ListingApplicationMailRecipientSource {
  /** Address proven by the confirmation link of this specific application. */
  FormConfirmation = 'FORM_CONFIRMATION',
  /** Verified email address of the applicant's active login, as confirmed by the identity provider. */
  VerifiedLogin = 'VERIFIED_LOGIN'
}

/** Reason no proven recipient address is available. No mail is sent in this case. */
export enum ListingApplicationMailUnavailableReason {
  /** The login has no verified email address. */
  LoginNotVerified = 'LOGIN_NOT_VERIFIED',
  /** The login is disabled or no longer exists. */
  LoginUnavailable = 'LOGIN_UNAVAILABLE',
  /** Neither a confirmation proof for this application nor a login is available. */
  NoProvenAddress = 'NO_PROVEN_ADDRESS',
  /** The applicant is no longer active. */
  PersonInactive = 'PERSON_INACTIVE'
}

/** The parameters for requesting multiple instances of ListingApplication. Mixing fields of cursor-based and offset-based pagination will result in an error. */
export type ListingApplicationQueryInput = {
  /** Cursor-based pagination: The immediate successor of this cursor will be the first entry of the requested page */
  after?: InputMaybe<Scalars['String']['input']>;
  /** Cursor-based pagination: The immediate predecessor of this cursor will be last entry of the requested page */
  before?: InputMaybe<Scalars['String']['input']>;
  /** Cursor-based pagination: Number of rows to be returned. Use in conjunction with 'after' */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** Cursor-based pagination: Number of rows to be returned. Use in conjunction with 'before' */
  last?: InputMaybe<Scalars['Int']['input']>;
  /** The sorting order of the instances */
  order?: InputMaybe<ListingApplicationSortInput>;
  /** Offset-based pagination: Number of rows to skip */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Offset-based pagination: Number of rows to be returned */
  take?: InputMaybe<Scalars['Int']['input']>;
  /** The filter to be applied */
  where?: InputMaybe<ListingApplicationFilterInput>;
};

/**
 * Most recent voluntary Power Quiz request for this application, including its resolved communication
 * language.
 */
export type ListingApplicationQuizRequest = {
  __typename?: 'ListingApplicationQuizRequest';
  /** Language fixed when this request was reserved; null if no language was recorded. */
  communicationLanguage?: Maybe<CommunicationLanguage>;
  requestId: Scalars['UUID']['output'];
  requestedOn: Scalars['DateTime']['output'];
  sentOn?: Maybe<Scalars['DateTime']['output']>;
  status: Scalars['String']['output'];
};

/** The filterable fields of type ListingApplicationQuizRequest */
export type ListingApplicationQuizRequestFilterInput = {
  and?: InputMaybe<Array<ListingApplicationQuizRequestFilterInput>>;
  not?: InputMaybe<ListingApplicationQuizRequestFilterInput>;
  or?: InputMaybe<Array<ListingApplicationQuizRequestFilterInput>>;
};

export type ListingApplicationSortInput = {
  createdAt?: InputMaybe<SortOrder>;
  /** Time of acceptance, rejection or withdrawal; otherwise null, including after reopening a decision. */
  decidedOn?: InputMaybe<SortOrder>;
  /** Time the application was received. */
  receivedOn?: InputMaybe<SortOrder>;
};

/**
 * Application state. Authorized listing members move RECEIVED to IN_REVIEW, IN_REVIEW to ACCEPTED or REJECTED
 * and either decision back to IN_REVIEW. The applicant may withdraw from RECEIVED or IN_REVIEW; withdrawal is
 * final.
 */
export enum ListingApplicationState {
  /** Accepted. WRITE on `applications` permits returning to IN_REVIEW. */
  Accepted = 'ACCEPTED',
  /** Under review. */
  InReview = 'IN_REVIEW',
  /** Received, the initial state of an authenticated application. */
  Received = 'RECEIVED',
  /** Rejected. WRITE on `applications` permits returning to IN_REVIEW. */
  Rejected = 'REJECTED',
  /** Withdrawn by the applicant, permanently. A new application to the same listing is then possible. */
  Withdrawn = 'WITHDRAWN'
}

export type ListingApplicationStateFilterInput = {
  /** Logical 'and' of one or more predicates */
  and?: InputMaybe<Array<ListingApplicationStateFilterInput>>;
  /** Checks if the field has a value or not */
  any?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks if the field's value is equal to the given value */
  eq?: InputMaybe<ListingApplicationState>;
  /** Checks if the field's value is in the list of the given values */
  in?: InputMaybe<Array<ListingApplicationState>>;
  /** Checks if the field's value is not equal to the given value */
  ne?: InputMaybe<ListingApplicationState>;
  /** Negates the predicate */
  not?: InputMaybe<ListingApplicationStateFilterInput>;
  /** Logical 'or' of one or more predicates */
  or?: InputMaybe<Array<ListingApplicationStateFilterInput>>;
};

export type ListingConnection = {
  __typename?: 'ListingConnection';
  edges: Array<ListingEdge>;
  nodes: Array<Listing>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ListingEdge = {
  __typename?: 'ListingEdge';
  cursor: Scalars['String']['output'];
  node: Listing;
};

/** The filterable fields of type Listing */
export type ListingFilterInput = {
  and?: InputMaybe<Array<ListingFilterInput>>;
  /** Categories for applicants. They grant no access and do not publish the listing. */
  categories?: InputMaybe<DiscoveryCategoryListFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ListingFilterInput>;
  or?: InputMaybe<Array<ListingFilterInput>>;
  /**
   * Stable human-readable reference, for example `2026-0042`. The year is the creation year in Europe/Berlin;
   * the sequence starts at 1 each year with at least four digits and grows beyond 9999. Assigned at creation,
   * unique and immutable, never writable and never reused after deletion. The technical identifier remains
   * `id`. Every content reader, including group recipients, public readers and applicants, can read it. Filter
   * by exact reference with `where: {reference: {eq: "2026-0042"}}`.
   */
  reference?: InputMaybe<StringFilterInput>;
  /** Effective state including the deadline. Explicit transitions use `setListingState`. */
  state?: InputMaybe<ListingStateFilterInput>;
};

/**
 * The caller's email notification preferences for one listing; both initially disabled. Enabling either
 * subscribes to the listing. Messages go only to an active person with `feature:share.listings` and
 * application read access, at the verified address of their login. Result notifications additionally require
 * match visibility and, if the result used the organizational record, record read access. Emails contain only
 * the listing and a link; details require sign-in.
 */
export type ListingMailNotification = {
  __typename?: 'ListingMailNotification';
  /** An email for each new application, from people or companies. */
  applicationReceived: Scalars['Boolean']['output'];
  /** An email when a listing match version first produces a result, not for applicants added later. */
  matchResultAvailable: Scalars['Boolean']['output'];
};

/** The filterable fields of type ListingMailNotification */
export type ListingMailNotificationFilterInput = {
  and?: InputMaybe<Array<ListingMailNotificationFilterInput>>;
  not?: InputMaybe<ListingMailNotificationFilterInput>;
  or?: InputMaybe<Array<ListingMailNotificationFilterInput>>;
};

export type ListingMatchVersion = {
  __typename?: 'ListingMatchVersion';
  canRetry: Scalars['Boolean']['output'];
  listingId: Scalars['UUID']['output'];
  number: Scalars['Int']['output'];
  startedAt: Scalars['DateTime']['output'];
  state: ListingMatchVersionState;
};

/** The filterable fields of type ListingMatchVersion */
export type ListingMatchVersionFilterInput = {
  and?: InputMaybe<Array<ListingMatchVersionFilterInput>>;
  not?: InputMaybe<ListingMatchVersionFilterInput>;
  or?: InputMaybe<Array<ListingMatchVersionFilterInput>>;
};

export enum ListingMatchVersionState {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
  Failed = 'FAILED',
  Running = 'RUNNING'
}

/** The parameters for requesting multiple instances of Listing. Mixing fields of cursor-based and offset-based pagination will result in an error. */
export type ListingQueryInput = {
  /** Cursor-based pagination: The immediate successor of this cursor will be the first entry of the requested page */
  after?: InputMaybe<Scalars['String']['input']>;
  /** Cursor-based pagination: The immediate predecessor of this cursor will be last entry of the requested page */
  before?: InputMaybe<Scalars['String']['input']>;
  /** Cursor-based pagination: Number of rows to be returned. Use in conjunction with 'after' */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** Cursor-based pagination: Number of rows to be returned. Use in conjunction with 'before' */
  last?: InputMaybe<Scalars['Int']['input']>;
  /** The sorting order of the instances */
  order?: InputMaybe<ListingSortInput>;
  /** Offset-based pagination: Number of rows to skip */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Offset-based pagination: Number of rows to be returned */
  take?: InputMaybe<Scalars['Int']['input']>;
  /** The filter to be applied */
  where?: InputMaybe<ListingFilterInput>;
};

export type ListingRoleRequirementInput = {
  /** Client-chosen key, at most 64 characters. */
  key: Scalars['String']['input'];
  /** Readable requirement, including its level, at most 300 characters. Never person data. */
  label: Scalars['String']['input'];
  /** Whether the requirement is a must. */
  must: Scalars['Boolean']['input'];
};

/** Result of `suggestListingRoles`. `roles` is empty for `EMPTY` and `UNAVAILABLE`. */
export type ListingRoleSuggestion = {
  __typename?: 'ListingRoleSuggestion';
  roles: Array<SuggestedListingRole>;
  status: SuggestionStatus;
};

/** The filterable fields of type ListingRoleSuggestion */
export type ListingRoleSuggestionFilterInput = {
  and?: InputMaybe<Array<ListingRoleSuggestionFilterInput>>;
  not?: InputMaybe<ListingRoleSuggestionFilterInput>;
  or?: InputMaybe<Array<ListingRoleSuggestionFilterInput>>;
};

export type ListingSortInput = {
  /** Members only. */
  createdAt?: InputMaybe<SortOrder>;
  /**
   * Deadline after which an OPEN listing behaves as CLOSED; null means no deadline. Visible to all content
   * readers, including group recipients and public readers. Change through `updateListing` with WRITE on
   * `plan`.
   */
  deadline?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  /**
   * Last publication time, null before first publication. Retained on withdrawal and does not determine the
   * effective state.
   */
  publishedOn?: InputMaybe<SortOrder>;
  /** Members only. */
  updatedAt?: InputMaybe<SortOrder>;
};

/**
 * Effective lifecycle state of a listing. Once its deadline passes, an OPEN listing behaves as CLOSED on every
 * read and write even if its stored state is still OPEN. This does not require a scheduled transition.
 */
export enum ListingState {
  /** Closed manually or by its deadline. */
  Closed = 'CLOSED',
  /** Concluded: the process has ended and the retention period has started. */
  Concluded = 'CONCLUDED',
  /** Draft, the initial state. Only members can read it. */
  Draft = 'DRAFT',
  /** Open. Group recipients and, when publicly readable, the public can read its content. */
  Open = 'OPEN'
}

export type ListingStateFilterInput = {
  /** Logical 'and' of one or more predicates */
  and?: InputMaybe<Array<ListingStateFilterInput>>;
  /** Checks if the field has a value or not */
  any?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks if the field's value is equal to the given value */
  eq?: InputMaybe<ListingState>;
  /** Checks if the field's value is in the list of the given values */
  in?: InputMaybe<Array<ListingState>>;
  /** Checks if the field's value is not equal to the given value */
  ne?: InputMaybe<ListingState>;
  /** Negates the predicate */
  not?: InputMaybe<ListingStateFilterInput>;
  /** Logical 'or' of one or more predicates */
  or?: InputMaybe<Array<ListingStateFilterInput>>;
};

export type LocalizedText = {
  __typename?: 'LocalizedText';
  english?: Maybe<Scalars['String']['output']>;
  german?: Maybe<Scalars['String']['output']>;
  localized?: Maybe<Scalars['String']['output']>;
};

/** The filterable fields of type LocalizedText */
export type LocalizedTextFilterInput = {
  and?: InputMaybe<Array<LocalizedTextFilterInput>>;
  english?: InputMaybe<StringFilterInput>;
  german?: InputMaybe<StringFilterInput>;
  localized?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<LocalizedTextFilterInput>;
  or?: InputMaybe<Array<LocalizedTextFilterInput>>;
};

export type LocalizedTextSortInput = {
  english?: InputMaybe<SortOrder>;
  german?: InputMaybe<SortOrder>;
  localized?: InputMaybe<SortOrder>;
};

/** Reason delivery failed or has an uncertain outcome. */
export enum MailDeliveryProblem {
  /** Application state no longer permits this mail. */
  ApplicationState = 'APPLICATION_STATE',
  /** Pre-send checks could not complete, for example because the identity service was unavailable. */
  CheckFailed = 'CHECK_FAILED',
  /** Sending was interrupted, for example by a restart. */
  Interrupted = 'INTERRUPTED',
  /** Mail delivery is not configured on this server. */
  NotConfigured = 'NOT_CONFIGURED',
  /** Connection lost during message handoff. */
  OutcomeUnknown = 'OUTCOME_UNKNOWN',
  /** The proven recipient address changed or is no longer available. */
  RecipientChanged = 'RECIPIENT_CHANGED',
  /** The recipient has since disabled this notification. */
  RecipientOptedOut = 'RECIPIENT_OPTED_OUT',
  /** The recipient may no longer read the relevant applications or match result. */
  RecipientWithoutAccess = 'RECIPIENT_WITHOUT_ACCESS',
  /** The requesting person no longer has permission to send this mail. */
  RequesterWithoutAccess = 'REQUESTER_WITHOUT_ACCESS',
  /** Mail server unavailable or refusing before handoff, including after repeated attempts. */
  SmtpUnavailable = 'SMTP_UNAVAILABLE'
}

/**
 * Mail delivery state. SMTP_ACCEPTED means only that the mail server accepted the message. It does not
 * establish delivery or opening.
 */
export enum MailDeliveryStatus {
  /** Not sent because permissions, application state or recipient changed before sending. */
  Cancelled = 'CANCELLED',
  /** Unknown outcome after handoff began. Never retried automatically. */
  DeliveryUnknown = 'DELIVERY_UNKNOWN',
  /** Not sent: failed before handing the message to the mail server. */
  FailedBeforeSend = 'FAILED_BEFORE_SEND',
  /** Waiting to be sent. */
  Queued = 'QUEUED',
  /** Currently being sent. */
  Sending = 'SENDING',
  /** Accepted by the mail server; delivery is not confirmed. */
  SmtpAccepted = 'SMTP_ACCEPTED'
}

export type MaritalStatus = Node & {
  __typename?: 'MaritalStatus';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  /** Canonical English name, independent of the requested language. Can match extracted values to ids. */
  nameEn?: Maybe<Scalars['String']['output']>;
};

/** The filterable fields of type MaritalStatus */
export type MaritalStatusFilterInput = {
  and?: InputMaybe<Array<MaritalStatusFilterInput>>;
  id?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<MaritalStatusFilterInput>;
  or?: InputMaybe<Array<MaritalStatusFilterInput>>;
};

/** Contains information for linking 'MaritalStatus' to other entities */
export type MaritalStatusRelationInput = {
  /** The identifier of 'MaritalStatus' */
  id: Scalars['ID']['input'];
};

export type MaritalStatusSortInput = {
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
};

export type MaritalStatusesResult = {
  __typename?: 'MaritalStatusesResult';
  maritalStatuses: Array<MaritalStatus>;
};

/** The filterable fields of type MaritalStatusesResult */
export type MaritalStatusesResultFilterInput = {
  and?: InputMaybe<Array<MaritalStatusesResultFilterInput>>;
  not?: InputMaybe<MaritalStatusesResultFilterInput>;
  or?: InputMaybe<Array<MaritalStatusesResultFilterInput>>;
};

export type MarkConversationReadInput = {
  conversationId: Scalars['UUID']['input'];
  lastReadMessageId: Scalars['UUID']['input'];
};

export type Match = Node & {
  __typename?: 'Match';
  /**
   * Complete replacement of access grants on update. People omitted from a supplied list lose their
   * grants; an empty list revokes all grants. Omitted or null leaves existing grants unchanged.
   */
  access?: Maybe<Array<MatchAccess>>;
  actions: MatchActions;
  /**
   * Auto-match switch, null while disabled. New listing applications are evaluated on behalf of `enabledBy`
   * and appended to the latest result while its requirements remain unchanged. Company applications evaluate
   * their company in RANK_COMPANIES matches. Change with `setMatchAutoMatch`.
   */
  autoMatch?: Maybe<MatchAutoMatch>;
  /**
   * Automatic runs, newest first, one per application. `limit` defaults to 100 and is capped at 500. Match
   * readers see only runs whose applications they may read (`Listing.actions.canReadApplications` on the
   * listing). Runs whose application has been deleted are omitted.
   */
  autoMatchRuns?: Maybe<Array<MatchAutoRun>>;
  candidateCount?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<Person>;
  description?: Maybe<Scalars['String']['output']>;
  /**
   *   Match configuration as a JSON object. On update, a supplied object replaces the design except for
   *   attached `project.documents`, which are preserved. Omitted or null leaves the design unchanged.
   *   Use the focused setMatch mutations to change individual parts without replacing unrelated data.
   *
   * The current format has `version: 2`. Version 1, including an omitted version, is accepted and
   *   upgraded; version-1 power weights from 0–10 become 0–1000. Unsupported versions are rejected.
   *   Common members are teamSize, teamCount (integers), teamProfile (id, name, elementWeights keyed by
   *   CreativityElement), conditions and companyConditions (lists), aiCopilotText (string), and project
   *   (name, shortDescription, description, documents). Document entries contain backdropFileId and name,
   *   with optional size in bytes and mimeType. Maintain them through attachProjectDocument and
   *   detachProjectDocument.
   *
   * Conditions contain __typename, operator, composition, active and optional requirement (MUST or
   *   OPTIONAL). composition contains operator and optional value. Person-condition discriminators are
   *   AgeCondition, AnnualSalaryCondition, ChildrenCountCondition, CertificateCondition,
   *   CitizenshipCondition, CityCondition, CountryCondition, DriversLicenseCondition, EducationCondition,
   *   ExperienceCondition, ExpertiseCondition, GenderCondition, IndustryExperienceCondition,
   *   JobDepartmentCondition, JobLocationCondition, LanguageCondition, MaritalCondition and
   *   NationalityCondition. Their values describe the corresponding requirement. For validated writes,
   *   prefer `setMatchConditions` and its typed inputs. Company-condition discriminators are
   *   CompanyIndustryCondition (industryId), CompanyEmployeeCountCondition (minimumEmployees), and
   *   CompanyExpertiseCondition (expertise, aiMode); use `setMatchCompanyConditions` to replace them.
   *
   * AI options include agenticAiSupported (boolean), candidateAssessmentPrompt (string),
   *   candidateAssessmentDetail (BULLETS, SENTENCES, LONG_TEXT), candidateAssessmentStrictness
   *   (NORMAL, STRICT, EXTREME), candidateAssessmentOutcomeFocus (OPPORTUNITIES, BALANCED, RISKS), and
   *   requirementLeniency (LENIENT, MUST_STRICT, STRICT). powerScoreLens is COMBINED (default),
   *   SELF_ASSESSMENT or SMART_ANALYSIS. missingPowerScore is ZERO (default) or NEUTRAL, which uses 50
   *   for an unmeasured power. Preserve members not being edited.
   *
   * Example: {"version":2,"teamSize":3,"teamCount":1,"conditions":[],"project":{"name":"Example project"}}.
   */
  design?: Maybe<Scalars['Object']['output']>;
  id: Scalars['ID']['output'];
  /** The immutable listing match version this match belongs to, or null for an ordinary match. */
  listingVersion?: Maybe<ListingMatchVersion>;
  /**
   * Listings linked to this match, the reverse of `Listing.matches`. Each listing's fields follow the same
   * rules as `listing(id)`, including `reference` and `name`. Only listings in which the caller is a member
   * are returned; group recipients and public readers learn no links here. Without `feature:share.listings` or
   * visibility of the match itself, the list is empty. Reaching a narrow match reference through
   * `Listing.matches` does not grant match visibility. Inaccessible listings are silently omitted. Maintain
   * links with `linkListingMatch` and `unlinkListingMatch`.
   */
  listings?: Maybe<Array<Listing>>;
  matchMode?: Maybe<MatchMode>;
  name?: Maybe<Scalars['String']['output']>;
  /**
   * Projects linked to this match. Maintain links through `linkProjectMatch` and `unlinkProjectMatch`;
   * read the reverse relationship through `Project.matches`.
   */
  projects?: Maybe<Array<Project>>;
  sharedItem?: Maybe<SharedItem>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<Person>;
};


export type MatchAutoMatchRunsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type MatchAccess = {
  __typename?: 'MatchAccess';
  design: AccessLevel;
  discover: AccessLevel;
  match: AccessLevel;
  person: Person;
  prepare: AccessLevel;
};

/** The filterable fields of type MatchAccess */
export type MatchAccessFilterInput = {
  and?: InputMaybe<Array<MatchAccessFilterInput>>;
  not?: InputMaybe<MatchAccessFilterInput>;
  or?: InputMaybe<Array<MatchAccessFilterInput>>;
};

/**
 * Effective authorization for this Match and the current caller. Independent of platform features,
 * Group roles and personal sharing. Result actions still respect each draft's creator-only privacy.
 */
export type MatchActions = {
  __typename?: 'MatchActions';
  /**
   * Delete the match (`deleteMatch`): its creator only, and never a listing match version in any state, which leaves
   * only with its listing.
   */
  canDelete: Scalars['Boolean']['output'];
  /** Existing visibility-based authorization to generate a transient result; does not imply permission to save it. */
  canGenerateResult: Scalars['Boolean']['output'];
  canLinkSharedItem: Scalars['Boolean']['output'];
  canManageAccess: Scalars['Boolean']['output'];
  /**
   * Switch auto-match on or off with `setMatchAutoMatch`. Requires `feature:match`, ownership or WRITE on
   * discover and a RANK or RANK_COMPANIES match. Switching on also requires read access to every linked
   * listing's applications (`Listing.actions.canReadApplications`), because applicants enter the pool on the
   * caller's behalf. Switching off does not require application access. False for other match modes.
   */
  canSetAutoMatch: Scalars['Boolean']['output'];
  canUpdateDesign: Scalars['Boolean']['output'];
  canUpdateDiscover: Scalars['Boolean']['output'];
  canUpdatePrepare: Scalars['Boolean']['output'];
  canUpdateResults: Scalars['Boolean']['output'];
};

/** The filterable fields of type MatchActions */
export type MatchActionsFilterInput = {
  and?: InputMaybe<Array<MatchActionsFilterInput>>;
  not?: InputMaybe<MatchActionsFilterInput>;
  or?: InputMaybe<Array<MatchActionsFilterInput>>;
};

/** The auto-match switch of a match. Present only while it is on. */
export type MatchAutoMatch = {
  __typename?: 'MatchAutoMatch';
  /** When it was switched on. */
  enabledAt: Scalars['DateTime']['output'];
  /** Who switched it on. Every automatic run acts on this person's behalf and sees what this person sees. */
  enabledBy?: Maybe<Person>;
};

/** The filterable fields of type MatchAutoMatch */
export type MatchAutoMatchFilterInput = {
  and?: InputMaybe<Array<MatchAutoMatchFilterInput>>;
  not?: InputMaybe<MatchAutoMatchFilterInput>;
  or?: InputMaybe<Array<MatchAutoMatchFilterInput>>;
};

/**
 * One automatic evaluation of one applicant for one match: the applicant alone against the match's current
 * requirements, on behalf of the person the run acted for. It creates no match of its own.
 */
export type MatchAutoRun = {
  __typename?: 'MatchAutoRun';
  /** The application that started the run; null once the application is gone. */
  applicationId?: Maybe<Scalars['UUID']['output']>;
  /** The evaluated company for a company application; the person remains its contact. */
  companyId?: Maybe<Scalars['UUID']['output']>;
  /** Whether the evaluated row was appended to the match's latest saved result. */
  copied: Scalars['Boolean']['output'];
  /** The saved result the row was appended to; null when nothing was copied or that result is gone. */
  copiedResultId?: Maybe<Scalars['UUID']['output']>;
  createdAt: Scalars['DateTime']['output'];
  finishedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  /** The applicant, read through the shared loader: its fields follow `read:external-information` or consent. */
  person?: Maybe<Person>;
  reason?: Maybe<MatchAutoRunReason>;
  /** The person the run acted for: who held the match's switch when the run started, or who retried the run. */
  requestedBy?: Maybe<Person>;
  /** Whether `retryMatchAutoRun` accepts this run now. */
  retryable: Scalars['Boolean']['output'];
  /** True when the run is `PENDING` or `RUNNING` and has not moved for 15 minutes. Derived when read. */
  stalled: Scalars['Boolean']['output'];
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  status: MatchAutoRunStatus;
};

/** The filterable fields of type MatchAutoRun */
export type MatchAutoRunFilterInput = {
  and?: InputMaybe<Array<MatchAutoRunFilterInput>>;
  not?: InputMaybe<MatchAutoRunFilterInput>;
  or?: InputMaybe<Array<MatchAutoRunFilterInput>>;
};

/** Why an auto run ended the way it did. A fixed contract: new values are appended, never renamed. */
export enum MatchAutoRunReason {
  /** DONE, not copied: the latest saved result already contains the applicant. */
  AlreadyInResult = 'ALREADY_IN_RESULT',
  /** SKIPPED: the match reached its limit of automatic runs within 24 hours; it can be retried by hand. */
  DailyLimit = 'DAILY_LIMIT',
  /** FAILED: the evaluation itself failed; it can be retried. */
  Error = 'ERROR',
  /** DONE, not copied: the match has no saved result yet. The next full run contains the applicant, who is in the pool. */
  NoSavedResult = 'NO_SAVED_RESULT',
  /**
   * DONE, not copied: the latest saved result used the organisational record and the person the run acted for may not
   * read it, or the other way round, so the two evaluations rest on different evidence.
   */
  OrganizationalRecordMismatch = 'ORGANIZATIONAL_RECORD_MISMATCH',
  /** FAILED: the person the run acted for may not read the applicant's profile (no consent, no read override). */
  ProfileNotReadable = 'PROFILE_NOT_READABLE',
  /**
   * FAILED: the person the run acted for no longer sees the match, is no longer an active person, or may not read the
   * applications of the listing.
   */
  RequesterWithoutAccess = 'REQUESTER_WITHOUT_ACCESS',
  /** DONE, not copied: the latest saved result has no single ranking team to append to. */
  ResultNotAppendable = 'RESULT_NOT_APPENDABLE'
}

/**
 * Where an auto run stands. `DONE` means the applicant was evaluated; `copied` says whether the row reached the
 * latest saved result, `reason` why not. `DESIGN_CHANGED` means the requirements of the latest saved result differ
 * from the ones the run used: nothing was copied, the match needs a full run (the client says "requirements changed,
 * match again"). A run a restart interrupted is resumed by itself, a `RUNNING` one as its next attempt; one that hangs
 * anyway reports `stalled` and can be retried. `SKIPPED` without a reason: the run waited while the match's auto-match
 * was switched off and was not evaluated.
 */
export enum MatchAutoRunStatus {
  DesignChanged = 'DESIGN_CHANGED',
  Done = 'DONE',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Running = 'RUNNING',
  Skipped = 'SKIPPED',
  Withdrawn = 'WITHDRAWN'
}

export type MatchCandidate = Node & {
  __typename?: 'MatchCandidate';
  id: Scalars['ID']['output'];
  locked?: Maybe<Scalars['Boolean']['output']>;
  matchId?: Maybe<Scalars['ID']['output']>;
  person?: Maybe<Person>;
};

export type MatchCandidateConnection = {
  __typename?: 'MatchCandidateConnection';
  edges: Array<MatchCandidateEdge>;
  nodes: Array<MatchCandidate>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type MatchCandidateEdge = {
  __typename?: 'MatchCandidateEdge';
  cursor: Scalars['String']['output'];
  node: MatchCandidate;
};

/** The filterable fields of type MatchCandidate */
export type MatchCandidateFilterInput = {
  and?: InputMaybe<Array<MatchCandidateFilterInput>>;
  id?: InputMaybe<IdFilterInput>;
  locked?: InputMaybe<BooleanFilterInput>;
  matchId?: InputMaybe<IdFilterInput>;
  not?: InputMaybe<MatchCandidateFilterInput>;
  or?: InputMaybe<Array<MatchCandidateFilterInput>>;
  person?: InputMaybe<PersonFilterInput>;
};

/** The parameters for requesting multiple instances of MatchCandidate. Mixing fields of cursor-based and offset-based pagination will result in an error. */
export type MatchCandidateQueryInput = {
  /** Cursor-based pagination: The immediate successor of this cursor will be the first entry of the requested page */
  after?: InputMaybe<Scalars['String']['input']>;
  /** Cursor-based pagination: The immediate predecessor of this cursor will be last entry of the requested page */
  before?: InputMaybe<Scalars['String']['input']>;
  /** Cursor-based pagination: Number of rows to be returned. Use in conjunction with 'after' */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** Cursor-based pagination: Number of rows to be returned. Use in conjunction with 'before' */
  last?: InputMaybe<Scalars['Int']['input']>;
  /** The sorting order of the instances */
  order?: InputMaybe<MatchCandidateSortInput>;
  /** Offset-based pagination: Number of rows to skip */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Offset-based pagination: Number of rows to be returned */
  take?: InputMaybe<Scalars['Int']['input']>;
  /** The filter to be applied */
  where?: InputMaybe<MatchCandidateFilterInput>;
};

export type MatchCandidateSortInput = {
  createdAt?: InputMaybe<SortOrder>;
  formattedName?: InputMaybe<SortOrder>;
};

/**
 * A company in a match's candidate pool. Companies are evaluated as candidates; they do not own
 * or initiate matches.
 */
export type MatchCompany = Node & {
  __typename?: 'MatchCompany';
  /**
   * The pinned company: its identity plus `employeeCount`, the value a size criterion is judged on.
   * `summary` is null here — see Company.employeeCount for the one exception this field makes.
   */
  company?: Maybe<Company>;
  id: Scalars['ID']['output'];
  match?: Maybe<Match>;
  matchId?: Maybe<Scalars['ID']['output']>;
};

export type MatchCompanyConnection = {
  __typename?: 'MatchCompanyConnection';
  edges: Array<MatchCompanyEdge>;
  nodes: Array<MatchCompany>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type MatchCompanyEdge = {
  __typename?: 'MatchCompanyEdge';
  cursor: Scalars['String']['output'];
  node: MatchCompany;
};

/** The filterable fields of type MatchCompany */
export type MatchCompanyFilterInput = {
  and?: InputMaybe<Array<MatchCompanyFilterInput>>;
  /**
   * The pinned company: its identity plus `employeeCount`, the value a size criterion is judged on.
   * `summary` is null here — see Company.employeeCount for the one exception this field makes.
   */
  company?: InputMaybe<CompanyFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  matchId?: InputMaybe<IdFilterInput>;
  not?: InputMaybe<MatchCompanyFilterInput>;
  or?: InputMaybe<Array<MatchCompanyFilterInput>>;
};

/** The parameters for requesting multiple instances of MatchCompany. Mixing fields of cursor-based and offset-based pagination will result in an error. */
export type MatchCompanyQueryInput = {
  /** Cursor-based pagination: The immediate successor of this cursor will be the first entry of the requested page */
  after?: InputMaybe<Scalars['String']['input']>;
  /** Cursor-based pagination: The immediate predecessor of this cursor will be last entry of the requested page */
  before?: InputMaybe<Scalars['String']['input']>;
  /** Cursor-based pagination: Number of rows to be returned. Use in conjunction with 'after' */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** Cursor-based pagination: Number of rows to be returned. Use in conjunction with 'before' */
  last?: InputMaybe<Scalars['Int']['input']>;
  /** The sorting order of the instances */
  order?: InputMaybe<MatchCompanySortInput>;
  /** Offset-based pagination: Number of rows to skip */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Offset-based pagination: Number of rows to be returned */
  take?: InputMaybe<Scalars['Int']['input']>;
  /** The filter to be applied */
  where?: InputMaybe<MatchCompanyFilterInput>;
};

export type MatchCompanySortInput = {
  createdAt?: InputMaybe<SortOrder>;
};

/**
 * One requirement to set on a match. The shared fields (operator, composition, active, requirement)
 * apply to every kind; EXACTLY ONE of the payload fields (integer / string / city / reference /
 * expertise / text / industryExperience / language) must be set — genesis rejects zero or multiple. The payload's
 * `kind` (where present) selects the concrete condition within its family.
 */
export type MatchConditionInput = {
  active: Scalars['Boolean']['input'];
  city?: InputMaybe<CityConditionInput>;
  composition: ConditionCompositionInput;
  expertise?: InputMaybe<ExpertiseConditionInput>;
  industryExperience?: InputMaybe<IndustryExperienceConditionInput>;
  integer?: InputMaybe<IntegerConditionInput>;
  language?: InputMaybe<LanguageConditionInput>;
  operator: ConditionOperator;
  reference?: InputMaybe<ReferenceConditionInput>;
  requirement?: InputMaybe<ConditionRequirement>;
  string?: InputMaybe<StringConditionInput>;
  text?: InputMaybe<TextConditionInput>;
};

export type MatchConnection = {
  __typename?: 'MatchConnection';
  edges: Array<MatchEdge>;
  nodes: Array<Match>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type MatchEdge = {
  __typename?: 'MatchEdge';
  cursor: Scalars['String']['output'];
  node: Match;
};

/** The filterable fields of type Match */
export type MatchFilterInput = {
  and?: InputMaybe<Array<MatchFilterInput>>;
  description?: InputMaybe<StringFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<MatchFilterInput>;
  or?: InputMaybe<Array<MatchFilterInput>>;
};

/**
 * Match mode, set at creation and immutable afterwards. OPTIMIZE chooses a team to maximize team
 * quality. ASSESS evaluates the selected team. RANK evaluates the contribution of individual
 * candidates to the existing team. RANK_COMPANIES evaluates each company independently against
 * company requirements and returns a company ranking.
 */
export enum MatchMode {
  Assess = 'ASSESS',
  Optimize = 'OPTIMIZE',
  Rank = 'RANK',
  RankCompanies = 'RANK_COMPANIES'
}

/** The parameters for requesting multiple instances of Match. Mixing fields of cursor-based and offset-based pagination will result in an error. */
export type MatchQueryInput = {
  /** Cursor-based pagination: The immediate successor of this cursor will be the first entry of the requested page */
  after?: InputMaybe<Scalars['String']['input']>;
  /** Cursor-based pagination: The immediate predecessor of this cursor will be last entry of the requested page */
  before?: InputMaybe<Scalars['String']['input']>;
  /** Cursor-based pagination: Number of rows to be returned. Use in conjunction with 'after' */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** Cursor-based pagination: Number of rows to be returned. Use in conjunction with 'before' */
  last?: InputMaybe<Scalars['Int']['input']>;
  /** The sorting order of the instances */
  order?: InputMaybe<MatchSortInput>;
  /** Offset-based pagination: Number of rows to skip */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Offset-based pagination: Number of rows to be returned */
  take?: InputMaybe<Scalars['Int']['input']>;
  /** The filter to be applied */
  where?: InputMaybe<MatchFilterInput>;
};

/** Contains information for linking 'Match' to other entities */
export type MatchRelationInput = {
  /** The identifier of 'Match' */
  id: Scalars['ID']['input'];
};

export type MatchResult = Node & {
  __typename?: 'MatchResult';
  candidateCount?: Maybe<Scalars['Int']['output']>;
  /**
   * Company ranking in position order for RANK_COMPANIES. Empty for person-mode results. Entries are
   * read-only and are produced by the match run.
   */
  companies?: Maybe<Array<MatchResultCompany>>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<Person>;
  /**
   * Snapshot of the design used for this result. Uses the JSON format described by Match.design;
   * subsequent edits to the match do not change this snapshot.
   */
  design?: Maybe<Scalars['Object']['output']>;
  /**
   * Presentation section identifiers associated with this result, shared by all its readers. An empty
   * list means no sections are hidden. Reads return an empty list rather than null. Identifiers are
   * opaque strings, returned unchanged and not validated against a fixed vocabulary.
   */
  hiddenSections?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['ID']['output'];
  /**
   * Whether this result is saved. False denotes a draft visible only to its creator; set true to save
   * it and make it available to the match's authorized readers. Saved results cannot be changed back to
   * drafts. Later runs can replace drafts. Filter by true when requesting saved history.
   */
  kept?: Maybe<Scalars['Boolean']['output']>;
  /** Id of the match this result belongs to. */
  matchId?: Maybe<Scalars['UUID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  teams?: Maybe<Array<MatchResultTeam>>;
  /**
   * True when organizational-record information contributed to the AI assessment. Such results are
   * visible only to callers with `read:organizational-record`; other callers cannot list, read, update
   * or delete them. Merely loading or submitting organizational information does not set this flag.
   */
  usesOrganizationalRecord?: Maybe<Scalars['Boolean']['output']>;
};

/**
 * One company's position in a saved ranking. A company ranking evaluates each candidate independently.
 * Ranking entries are read-only and are created by the match run.
 */
export type MatchResultCompany = {
  __typename?: 'MatchResultCompany';
  /** Ranked company identity and employeeCount. The summary is null on this reference. */
  company?: Maybe<Company>;
  /** Id of this ranking entry; distinct from the company's id. */
  entryId: Scalars['UUID']['output'];
  /** 1-based place in the ranking, contiguous within one result. Stored, not derived from `result`. */
  position: Scalars['Int']['output'];
  /**
   *   Company assessment JSON object with `version: 1` and a `criteria` list. Each entry contains
   *   condition (the company requirement, including __typename), isMust (boolean), classification
   *   (SATISFIED, PARTIAL, VIOLATED or UNKNOWN), fulfillment (0–1, or null if unknown), actual (string or
   *   null), and optional aiReason (string). The condition uses the company-condition shape described by
   *   Match.design. The ranking position is reported separately by MatchResultCompany.position.
   *
   * UNKNOWN means there was insufficient information to assess the criterion; it is distinct from a
   *   measured failure. PARTIAL denotes incomplete fulfillment and does not satisfy a MUST requirement.
   *   A company's expertise is assessed by its label, without a company proficiency level.
   *
   * `actual` records the value at the time of the run: an industry id, employee count as text, or the
   *   matching expertise label. Explicit null means no usable value was found; a missing actual member
   *   means the result did not record actual values. Only the matching expertise is included, not the
   *   company's complete expertise list. Later profile changes do not alter the saved assessment.
   *   Example: {"version":1,"criteria":[]}.
   */
  result?: Maybe<Scalars['Object']['output']>;
};

/** The filterable fields of type MatchResultCompany */
export type MatchResultCompanyFilterInput = {
  and?: InputMaybe<Array<MatchResultCompanyFilterInput>>;
  not?: InputMaybe<MatchResultCompanyFilterInput>;
  or?: InputMaybe<Array<MatchResultCompanyFilterInput>>;
};

export type MatchResultConnection = {
  __typename?: 'MatchResultConnection';
  edges: Array<MatchResultEdge>;
  nodes: Array<MatchResult>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type MatchResultEdge = {
  __typename?: 'MatchResultEdge';
  cursor: Scalars['String']['output'];
  node: MatchResult;
};

/** The filterable fields of type MatchResult */
export type MatchResultFilterInput = {
  and?: InputMaybe<Array<MatchResultFilterInput>>;
  /**
   * Whether this result is saved. False denotes a draft visible only to its creator; set true to save
   * it and make it available to the match's authorized readers. Saved results cannot be changed back to
   * drafts. Later runs can replace drafts. Filter by true when requesting saved history.
   */
  kept?: InputMaybe<BooleanFilterInput>;
  matchId?: InputMaybe<UuidFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<MatchResultFilterInput>;
  notes?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<MatchResultFilterInput>>;
};

/** The parameters for requesting multiple instances of MatchResult. Mixing fields of cursor-based and offset-based pagination will result in an error. */
export type MatchResultQueryInput = {
  /** Cursor-based pagination: The immediate successor of this cursor will be the first entry of the requested page */
  after?: InputMaybe<Scalars['String']['input']>;
  /** Cursor-based pagination: The immediate predecessor of this cursor will be last entry of the requested page */
  before?: InputMaybe<Scalars['String']['input']>;
  /** Cursor-based pagination: Number of rows to be returned. Use in conjunction with 'after' */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** Cursor-based pagination: Number of rows to be returned. Use in conjunction with 'before' */
  last?: InputMaybe<Scalars['Int']['input']>;
  /** The sorting order of the instances */
  order?: InputMaybe<MatchResultSortInput>;
  /** Offset-based pagination: Number of rows to skip */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Offset-based pagination: Number of rows to be returned */
  take?: InputMaybe<Scalars['Int']['input']>;
  /** The filter to be applied */
  where?: InputMaybe<MatchResultFilterInput>;
};

export type MatchResultSortInput = {
  createdAt?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
};

export type MatchResultTeam = {
  __typename?: 'MatchResultTeam';
  /**
   * The rows an auto run appended to this team after the result was saved, one per person, so a client can mark
   * them as new. Empty for every row
   * a full run wrote, and on every draft.
   */
  autoAdded?: Maybe<Array<MatchResultTeamAddition>>;
  persons?: Maybe<Array<Maybe<Person>>>;
  /**
   *   Team assessment JSON object with `version: 2`. Its members are factSkillResult, powersMatchResult,
   *   teamMatchResult, infeasibility and rewardValue; members can be null when unavailable.
   *
   * factSkillResult contains criteria and teamMembers. Each member has personId and items; each item
   *   contains criterion, matched, isMust, classification (SATISFIED, PARTIAL, VIOLATED or UNKNOWN),
   *   fulfillment (0–1 or null when unknown), actual (string or null), and optional aiReason. A criterion
   *   contains condition (the person-condition shape in Match.design), group and optional conditionKey.
   *   Optional expertises entries contain description and level on a percentage scale, not the 1–7 scale.
   *   Optional aiAssessment contains positive, negative and fazit (text), suitability (integer),
   *   scoreDebug (text) and interviewQuestions (string list); its members may be absent or null.
   *
   * powersMatchResult contains criteria (element and group) and teamMembers (personId and items).
   *   Each item has criterion and value: a power score, or null when unavailable.
   *   teamMatchResult contains teamSize, maleCount, femaleCount, diverseCount, minAge, maxAge, averageAge,
   *   mostFrequentJobLocationCount, mostFrequentJobDepartmentAge (a count despite its name), and
   *   conditionResults (condition, matchedCount, fulfilled).
   *
   * infeasibility contains infeasibilityClass (LOCKED or POOL_TOO_TIGHT), reason (text) and relaxations
   *   (condition, restrictionEnum, target and shortfall). A relaxation condition may be null when unknown.
   *   LOCKED identifies incompatible locked candidates; POOL_TOO_TIGHT identifies insufficient candidates
   *   meeting requirements. relaxations can be empty in either case. rewardValue is the raw optimization score;
   *   it is not comparable across changes to the weight scale, power-score lens or missing-score policy.
   *   Preserve the distinction between absent or null assessments and an assessment reporting zero.
   */
  result?: Maybe<Scalars['Object']['output']>;
  teamId: Scalars['UUID']['output'];
};

/** One row an auto run appended to a saved ranking. */
export type MatchResultTeamAddition = {
  __typename?: 'MatchResultTeamAddition';
  /** When the row was appended. */
  addedAt: Scalars['DateTime']['output'];
  /** The run that appended it; null once that run is gone. */
  autoRunId?: Maybe<Scalars['UUID']['output']>;
  /** The appended person; their row in `MatchResultTeam.result` is keyed by this id. */
  personId: Scalars['UUID']['output'];
};

/** The filterable fields of type MatchResultTeamAddition */
export type MatchResultTeamAdditionFilterInput = {
  and?: InputMaybe<Array<MatchResultTeamAdditionFilterInput>>;
  not?: InputMaybe<MatchResultTeamAdditionFilterInput>;
  or?: InputMaybe<Array<MatchResultTeamAdditionFilterInput>>;
};

/** The filterable fields of type MatchResultTeam */
export type MatchResultTeamFilterInput = {
  and?: InputMaybe<Array<MatchResultTeamFilterInput>>;
  not?: InputMaybe<MatchResultTeamFilterInput>;
  or?: InputMaybe<Array<MatchResultTeamFilterInput>>;
};

export type MatchSortInput = {
  createdAt?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export enum MicrosoftAccountKind {
  Company = 'COMPANY',
  Personal = 'PERSONAL'
}

export type MicrosoftCalendarConfiguration = {
  __typename?: 'MicrosoftCalendarConfiguration';
  clientId: Scalars['String']['output'];
  redirectUri: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
};

/** The filterable fields of type MicrosoftCalendarConfiguration */
export type MicrosoftCalendarConfigurationFilterInput = {
  and?: InputMaybe<Array<MicrosoftCalendarConfigurationFilterInput>>;
  not?: InputMaybe<MicrosoftCalendarConfigurationFilterInput>;
  or?: InputMaybe<Array<MicrosoftCalendarConfigurationFilterInput>>;
};

export type MicrosoftCalendarConnection = {
  __typename?: 'MicrosoftCalendarConnection';
  checkedAt?: Maybe<Scalars['String']['output']>;
  configured: Scalars['Boolean']['output'];
  connected: Scalars['Boolean']['output'];
  displayName?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  mailAvailable: Scalars['Boolean']['output'];
  state: Scalars['String']['output'];
  teamsAvailable: Scalars['Boolean']['output'];
};

/** The filterable fields of type MicrosoftCalendarConnection */
export type MicrosoftCalendarConnectionFilterInput = {
  and?: InputMaybe<Array<MicrosoftCalendarConnectionFilterInput>>;
  not?: InputMaybe<MicrosoftCalendarConnectionFilterInput>;
  or?: InputMaybe<Array<MicrosoftCalendarConnectionFilterInput>>;
};

export type MicrosoftCalendarEvent = {
  __typename?: 'MicrosoftCalendarEvent';
  allDay: Scalars['Boolean']['output'];
  end: Scalars['String']['output'];
  id: Scalars['String']['output'];
  privateEvent: Scalars['Boolean']['output'];
  showAs: Scalars['String']['output'];
  start: Scalars['String']['output'];
  subject: Scalars['String']['output'];
  webUrl: Scalars['String']['output'];
};

/** The filterable fields of type MicrosoftCalendarEvent */
export type MicrosoftCalendarEventFilterInput = {
  and?: InputMaybe<Array<MicrosoftCalendarEventFilterInput>>;
  not?: InputMaybe<MicrosoftCalendarEventFilterInput>;
  or?: InputMaybe<Array<MicrosoftCalendarEventFilterInput>>;
};

export type MicrosoftCalendarView = {
  __typename?: 'MicrosoftCalendarView';
  end: Scalars['String']['output'];
  events: Array<MicrosoftCalendarEvent>;
  fetchedAt: Scalars['String']['output'];
  organizerEmail: Scalars['String']['output'];
  start: Scalars['String']['output'];
  truncated: Scalars['Boolean']['output'];
};

/** The filterable fields of type MicrosoftCalendarView */
export type MicrosoftCalendarViewFilterInput = {
  and?: InputMaybe<Array<MicrosoftCalendarViewFilterInput>>;
  not?: InputMaybe<MicrosoftCalendarViewFilterInput>;
  or?: InputMaybe<Array<MicrosoftCalendarViewFilterInput>>;
};

export type MicrosoftMessageInput = {
  accountKind?: InputMaybe<MicrosoftAccountKind>;
  end?: InputMaybe<Scalars['String']['input']>;
  message: Scalars['String']['input'];
  organizerEmail: Scalars['String']['input'];
  recipients: Array<Scalars['String']['input']>;
  requestId: Scalars['String']['input'];
  start?: InputMaybe<Scalars['String']['input']>;
  subject: Scalars['String']['input'];
  teams: Scalars['Boolean']['input'];
};

export type MicrosoftMessageResult = {
  __typename?: 'MicrosoftMessageResult';
  joinUrl?: Maybe<Scalars['String']['output']>;
  outcome: Scalars['String']['output'];
  webUrl?: Maybe<Scalars['String']['output']>;
};

/** The filterable fields of type MicrosoftMessageResult */
export type MicrosoftMessageResultFilterInput = {
  and?: InputMaybe<Array<MicrosoftMessageResultFilterInput>>;
  not?: InputMaybe<MicrosoftMessageResultFilterInput>;
  or?: InputMaybe<Array<MicrosoftMessageResultFilterInput>>;
};

export type Mutation = {
  __typename?: 'Mutation';
  /** Executes a notification action, such as accepting or rejecting a contact request. */
  actOnNotification: Notification;
  addAccessGroupMember: AccessGroupMember;
  addCompanyMember: CompanyMembership;
  addContacts?: Maybe<AddContactsOutput>;
  addPins?: Maybe<AddPinsOutput>;
  applyOrganizationalPowerAnalysis: OrganizationalPowerAnalysis;
  /**
   * Apply as the caller to an effectively OPEN listing readable from outside its membership. Requires
   * `feature:share.applications`. Contact details fill empty person fields, documents enter the organizational
   * record and a CV subsequently prefills the profile. A second application is rejected unless the previous
   * one was withdrawn.
   */
  applyToListing: ApplyToListingOutput;
  assignAccessGroupRole: AccessGroupRoleAssignment;
  /** Assign or clear a person's manager. Requires `write:access-config`; cycles are rejected. */
  assignManager: AssignManagerOutput;
  /** Assign or clear a person's organizational unit. Requires `write:access-config`. */
  assignOrgUnit: AssignOrgUnitOutput;
  /** Assigns a questionnaire to a group, moves it to a different one, or removes it from its group. Requires the `write:questionnaire` permission. */
  assignQuestionnaireToGroup: Questionnaire;
  /**
   * Upload files and append their references to `Match.design.project.documents`. Files belong to the
   * match owner regardless of the caller. Uploads are not deduplicated: identical content produces
   * distinct file references. Requires design-write access.
   */
  attachProjectDocument: AttachProjectDocumentOutput;
  /**
   * Bulk-imports a person's Experience / Education / LanguageSkill / Certificate /
   * Expertise collections plus an optional personDetail fragment in a single
   * transaction. Per-collection merge policy: only populate collections that are
   * currently empty for the target person; non-empty collections are left
   * untouched and their name is returned in `skipped`. Used by provider-specific
   * importers (LinkedIn, vCard, CSV, …) to populate a profile in one round-trip
   * with atomic rollback on any server-side failure.
   */
  bulkImportPerson: BulkImportPersonResult;
  checkMicrosoftCalendar: MicrosoftCalendarConnection;
  /**
   * Continue a public application after sign-in when confirmation returned LOGIN_REQUIRED. The email token
   * proves the mailbox and sign-in proves the account. The reserved application, documents and contact details
   * are assigned to the caller only if their account belongs to that mailbox or they are the applicant
   * previously proven through it. Otherwise returns WRONG_ACCOUNT without consuming the token. Requires no
   * feature permission, like the public application itself.
   */
  claimListingApplication: ClaimListingApplicationResult;
  /**
   * Completes a roleplay session once its story has ended and every reading has been delivered: in one transaction, it
   * writes a Smart Analysis value for every chosen power whose readings reach the session's `thresholdPercent` and
   * marks the session COMPLETED. A power below the threshold gets no value, and a session with no such power still
   * completes, with no value. A value is the questionnaire's score over the readings, a reverse-keyed statement counting
   * 100 minus its agreement, with the mean reading confidence as its confidence. A session that is no longer open, a
   * COMPLETED one included, is returned unchanged, so a repeated report writes nothing. A story other than the
   * registered one is refused (GENESIS001346); an unknown id, or a subject that is not the session's person, too
   * (GENESIS001343). Allowed while the game is paused. Requires `report:roleplay-session`, a permission held by a
   * service account, not by people.
   */
  completeRoleplaySession: GameSession;
  connectMicrosoftCalendar: MicrosoftCalendarConnection;
  createAccessGroup: AccessGroup;
  /** Creates a custom Role and its Permission bundle atomically, guarded by write:access-config. */
  createAccessRole: AccessRole;
  /** Creates a new agent instance */
  createAgent: CreateAgentOutput;
  /** Creates a new certificate instance */
  createCertificate: CreateCertificateOutput;
  /** Creates a new company instance */
  createCompany: CreateCompanyOutput;
  /** Creates a new contracttype instance */
  createContractType: CreateContractTypeOutput;
  createConversation: Conversation;
  /** Creates a new curriculumvitae instance */
  createCurriculumVitae: CreateCurriculumVitaeOutput;
  /** Creates a new degree instance */
  createDegree: CreateDegreeOutput;
  /** Creates a new discoverycategory instance */
  createDiscoveryCategory: CreateDiscoveryCategoryOutput;
  /** Creates a new document instance */
  createDocument: CreateDocumentOutput;
  /** Creates a new documentgroup instance */
  createDocumentGroup: CreateDocumentGroupOutput;
  /** Creates a new education instance */
  createEducation: CreateEducationOutput;
  /** Creates a new experience instance */
  createExperience: CreateExperienceOutput;
  /** Creates a new expertise instance */
  createExpertise: CreateExpertiseOutput;
  /** Creates a new gender instance */
  createGender: CreateGenderOutput;
  /** Creates a new industry instance */
  createIndustry: CreateIndustryOutput;
  /** Creates a new jobdepartment instance */
  createJobDepartment: CreateJobDepartmentOutput;
  /** Creates a new joblocation instance */
  createJobLocation: CreateJobLocationOutput;
  /** Creates a new languageskill instance */
  createLanguageSkill: CreateLanguageSkillOutput;
  /** Creates a new listing instance */
  createListing: CreateListingOutput;
  createListingMatchVersion: Match;
  /** Creates a new maritalstatus instance */
  createMaritalStatus: CreateMaritalStatusOutput;
  /** Creates a new match instance */
  createMatch: CreateMatchOutput;
  /** Creates a new matchcandidate instance */
  createMatchCandidate: CreateMatchCandidateOutput;
  createMatchCandidates?: Maybe<CreateMatchCandidatesOutput>;
  createMatchCompanies?: Maybe<CreateMatchCompaniesOutput>;
  /** Creates a new matchcompany instance */
  createMatchCompany: CreateMatchCompanyOutput;
  /** Creates a new matchresult instance */
  createMatchResult: CreateMatchResultOutput;
  /** Creates a new orgunit instance */
  createOrgUnit: CreateOrgUnitOutput;
  /**
   * Creates the organisational record about one subject, or returns the existing one: exactly one of `personId` and
   * `companyId` must be set. Requires `write:organizational-record`.
   */
  createOrganizationalRecord: OrganizationalRecord;
  createOrganizationalRecordComment: OrganizationalRecordComment;
  createOrganizationalRecordDocument: OrganizationalRecordDocument;
  createOrganizationalRecordEntry: OrganizationalRecordEntry;
  /** Creates a new person instance */
  createPerson: CreatePersonOutput;
  /** Creates a new persongroup instance */
  createPersonGroup: CreatePersonGroupOutput;
  /** Creates a new pingroup instance */
  createPinGroup: CreatePinGroupOutput;
  /** Creates a new project instance */
  createProject: CreateProjectOutput;
  /** Creates a new shareditem instance */
  createSharedItem: CreateSharedItemOutput;
  /** Creates a new shareditemcomment instance */
  createSharedItemComment: CreateSharedItemCommentOutput;
  /** Creates a new studionotebook instance */
  createStudioNotebook: CreateStudioNotebookOutput;
  /** Creates a new teamprofile instance */
  createTeamProfile: CreateTeamProfileOutput;
  /** Creates a new workingtimemodel instance */
  createWorkingTimeModel: CreateWorkingTimeModelOutput;
  deleteAccessGroup: Scalars['Boolean']['output'];
  deleteAccessRole: Scalars['Boolean']['output'];
  /** Deletes existing instances of agent */
  deleteAgent: DeleteAgentOutput;
  /**
   * Deletes every notification from the current user's inbox except those still awaiting a
   * decision from the user, such as an unanswered contact request: those are kept so they stay
   * answerable (see Notification.deletable). Only notifications of the supplied types are
   * affected, and an explicitly empty supportedTypes list affects nothing. Returns the number of
   * notifications deleted.
   */
  deleteAllNotifications: Scalars['Int']['output'];
  /** Deletes existing instances of certificate */
  deleteCertificate: DeleteCertificateOutput;
  /** Deletes existing instances of company */
  deleteCompany: DeleteCompanyOutput;
  /** Deletes existing instances of contracttype */
  deleteContractType: DeleteContractTypeOutput;
  deleteConversation: Scalars['Boolean']['output'];
  /** Deletes existing instances of curriculumvitae */
  deleteCurriculumVitae: DeleteCurriculumVitaeOutput;
  /** Deletes existing instances of degree */
  deleteDegree: DeleteDegreeOutput;
  /** Deletes existing instances of discoverycategory */
  deleteDiscoveryCategory: DeleteDiscoveryCategoryOutput;
  /** Deletes existing instances of document */
  deleteDocument: DeleteDocumentOutput;
  /** Deletes existing instances of documentgroup */
  deleteDocumentGroup: DeleteDocumentGroupOutput;
  /** Deletes existing instances of education */
  deleteEducation: DeleteEducationOutput;
  /** Deletes existing instances of experience */
  deleteExperience: DeleteExperienceOutput;
  /** Deletes existing instances of expertise */
  deleteExpertise: DeleteExpertiseOutput;
  /** Deletes existing instances of gender */
  deleteGender: DeleteGenderOutput;
  /** Deletes existing instances of industry */
  deleteIndustry: DeleteIndustryOutput;
  /** Deletes existing instances of jobdepartment */
  deleteJobDepartment: DeleteJobDepartmentOutput;
  /** Deletes existing instances of joblocation */
  deleteJobLocation: DeleteJobLocationOutput;
  /** Deletes existing instances of languageskill */
  deleteLanguageSkill: DeleteLanguageSkillOutput;
  /** Deletes existing instances of listing */
  deleteListing: DeleteListingOutput;
  /** Deletes existing instances of maritalstatus */
  deleteMaritalStatus: DeleteMaritalStatusOutput;
  /** Deletes existing instances of match */
  deleteMatch: DeleteMatchOutput;
  /** Deletes existing instances of matchcandidate */
  deleteMatchCandidate: DeleteMatchCandidateOutput;
  deleteMatchCandidates?: Maybe<DeleteMatchCandidatesOutput>;
  deleteMatchCompanies?: Maybe<DeleteMatchCompaniesOutput>;
  /** Deletes existing instances of matchcompany */
  deleteMatchCompany: DeleteMatchCompanyOutput;
  /** Deletes existing instances of matchresult */
  deleteMatchResult: DeleteMatchResultOutput;
  /** Removes one of the caller's favourites. */
  deleteMyFavorite: Scalars['UUID']['output'];
  /** Deletes a notification from the current user's inbox. */
  deleteNotification: Notification;
  /** Deletes existing instances of orgunit */
  deleteOrgUnit: DeleteOrgUnitOutput;
  deleteOrganizationalRecordComment: Scalars['ID']['output'];
  deleteOrganizationalRecordDocument: Scalars['ID']['output'];
  deleteOrganizationalRecordEntry: Scalars['ID']['output'];
  /** Deletes existing instances of person */
  deletePerson: DeletePersonOutput;
  /** Deletes existing instances of persongroup */
  deletePersonGroup: DeletePersonGroupOutput;
  /** Deletes existing instances of pingroup */
  deletePinGroup: DeletePinGroupOutput;
  /** Deletes existing instances of project */
  deleteProject: DeleteProjectOutput;
  /** Hard-deletes a questionnaire tree if no results exist for it; otherwise marks it as DELETED. Returns true if hard-deleted, false if soft-deleted. */
  deleteQuestionnaire: Scalars['Boolean']['output'];
  /** Deletes a group and ungroups its questionnaires; the questionnaires and every answer given to them survive (same shape as deleteDocumentGroup). Requires the `write:questionnaire` permission. */
  deleteQuestionnaireGroup: Scalars['Boolean']['output'];
  /**
   * Deletes any person's roleplay session together with its readings and chosen powers and returns its id; an id that
   * is not a roleplay session is refused (GENESIS001343). Requires `delete:roleplay-session`; the player has no way to
   * delete a session. The values a finished session wrote stay. A copy of the deleted data is retained in the change
   * history, so this is not an erasure in the data-protection sense.
   */
  deleteRoleplaySession: Scalars['UUID']['output'];
  /** Deletes existing instances of shareditem */
  deleteSharedItem: DeleteSharedItemOutput;
  /** Deletes existing instances of shareditemcomment */
  deleteSharedItemComment: DeleteSharedItemCommentOutput;
  /** Deletes existing instances of studionotebook */
  deleteStudioNotebook: DeleteStudioNotebookOutput;
  /** Deletes existing instances of teamprofile */
  deleteTeamProfile: DeleteTeamProfileOutput;
  /** Deletes existing instances of workingtimemodel */
  deleteWorkingTimeModel: DeleteWorkingTimeModelOutput;
  /**
   * Remove a document from `Match.design.project.documents` by backdropFileId. An absent reference is
   * a no-op. File deletion is asynchronous. Requires design-write access.
   */
  detachProjectDocument: DetachProjectDocumentOutput;
  disconnectMicrosoftCalendar: Scalars['Boolean']['output'];
  /**
   * Reports that the session's story was deleted because its retention period ended: an IN_PROGRESS session becomes
   * EXPIRED and its readings and chosen powers are deleted, while the session itself stays readable, as for a session a new game
   * replaced. A session that is no longer open, a COMPLETED one included, is returned unchanged and keeps what it holds,
   * so a repeated report changes nothing. An unknown id, or a subject that is not the session's person, is refused
   * (GENESIS001343). Requires `report:roleplay-session`, a permission held by a service account, not by people.
   */
  expireRoleplaySession: GameSession;
  /**
   * Preview profile information from one document, such as a CV or biography, against the caller's
   * existing profile. Returns proposed field and collection changes without saving them. Apply chosen
   * changes with the ordinary profile mutations, such as updatePerson and createExperience.
   */
  extractProfileFromDocument: ProfileImportPreview;
  /**
   * Replaces the caller's favourites of the session's domain with entries, best first, and completes the session in
   * one transaction. A toplist finishes with exactly ten entries. The same catalogue item twice, or the same own title
   * twice regardless of case and surrounding spaces, is refused. The toplist's sharing is kept: a replay replaces the
   * entries, never who may read them. On a session that is already complete it writes nothing and returns the
   * favourites.
   */
  finishToplistSession: Array<Favorite>;
  /** Propose person requirements from listing text and accessible documents. Never persists. */
  generateAIListingRequirements: Listing;
  generateAIRequirements?: Maybe<GenerateAiRequirementsOutput>;
  /** Run the team-matching solver for the given match and persist the result as an unsaved draft (kept:false), replacing any prior draft for this (match, user). Not idempotent — the solve runs once and writes. */
  generateTransientMatchResult?: Maybe<MatchResult>;
  heartbeatConversationPresence: PresenceIndicator;
  /** Requires `write:import`. Extracts each uploaded CV and persists it — updating the person matched by primary email (filling only empty fields/collections) or creating a new candidate Person when there is no unambiguous match. Returns a per-file outcome; a failed file never aborts the others. */
  importCvBatch: CvBatchImportResult;
  /**
   * Import a multi-document YAML payload as the authenticated caller. Supports the kinds and
   * insert/update/merge/delete operations described by `importSpecification`. Requires
   * `write:reference-data`. By default, any failure rolls back the entire import; options can select
   * partial import or a dry run. Authorship of imported changes is attributed to the caller.
   */
  importDocuments: ImportDocumentsResult;
  /**
   * Import the authenticated user's LinkedIn profile using the supplied access token to fetch the DMA
   * snapshot. Uses the same merge policy as `bulkImportPerson` in one transaction; returns skipped
   * collections and warnings. The input token is obtained by the client, not exchanged from a code here.
   */
  importLinkedInProfile: BulkImportPersonResult;
  /**
   *   Bind a new external login to an existing Person and send an onboarding email. Requires
   *   `provision:invitee` and write access to that Person. The id, profile and relationships are preserved,
   *   except that the primary email is updated to the confirmed login address. The binding is saved
   *   before sending, so a send failure leaves it available for recovery.
   *
   * A repeated or concurrent call with the same requestId never creates another account or deliberately
   *   sends another email. An address used by another account returns EMAIL_CONFLICT; identities are not
   *   merged by email.
   */
  inviteExistingPerson: PersonLoginInvitationOutput;
  /**
   * Link an existing match to a listing. Requires `feature:share.listings`, WRITE on `candidates` and
   * visibility of the match as its creator or an access-list member at any level. Listing members can then
   * read its name in `Listing.matches`. An invisible match responds like an unknown match. Repeating the same
   * link has no effect.
   */
  linkListingMatch: LinkListingMatchOutput;
  /**
   * Link an existing match to a project. Repeating the same link has no effect. Requires WRITE on the
   * project's plan, or company admin membership with matching `actingAsCompanyId` for a company project.
   * Listing ids are unknown here; use `linkListingMatch` for listings.
   */
  linkProjectMatch: LinkProjectMatchOutput;
  /**
   * Locks the powers of one of the caller's IN_PROGRESS roleplay sessions, so they can no longer be changed. Send it
   * right before the first move: the story does not accept a first move while the powers are unlocked. Locking a locked
   * session returns it unchanged. Refused for a session that is no longer open (GENESIS001287) and for any id that is
   * not one of the caller's roleplay sessions (GENESIS001343). Records no activity.
   */
  lockRoleplaySessionPowers: RoleplaySession;
  /**
   * Marks every unread notification in the current user's inbox as read. Only notifications of the
   * supplied types are affected, mirroring the filter applied by notifications and
   * unreadNotificationCount; an explicitly empty supportedTypes list affects nothing. Returns the
   * number of notifications that changed from unread to read.
   */
  markAllNotificationsRead: Scalars['Int']['output'];
  markConversationRead: ConversationReadReceipt;
  /** Marks a notification as read. */
  markNotificationRead: Notification;
  /**
   * Computes a non-destructive preview of a LinkedIn import for the authenticated user:
   * fetches the full DMA snapshot, maps it, and diffs it against existing data per field
   * and per collection row. Nothing is written and no server-side state is kept. The client
   * reviews and edits the returned proposals, then persists the accepted ones through the
   * ordinary profile mutations (updatePerson, createExperience, …) — the same write path as
   * manual editing. Re-run before saving to keep a retry idempotent: already-saved rows come
   * back UNCHANGED (matched by natural key).
   */
  previewLinkedInImport: ProfileImportPreview;
  /**
   * Prepare and retain a binding interview, offer or rejection mail preview for two hours. Sends nothing.
   * Requires `feature:share.listings`, application read access and WRITE on `applications`.
   */
  previewListingApplicationMail: ListingApplicationMailPreview;
  /**
   * Analyze documents for powers and skills synchronously; the request can take minutes. Use
   * `startDocumentsExtraction` with `documentsExtractionEvents` for asynchronous processing.
   */
  processDocuments?: Maybe<ProcessDocumentsOutput>;
  /**
   * Provision an external invitee and send an onboarding link valid for 72 hours. Requires
   * `provision:invitee`. A new address creates an enabled account with no credentials; onboarding asks
   * for profile completion, password setup and email verification. A pending invitee receives a new
   * link. An established account returns CONFLICT and remains unchanged. This operation cannot grant
   * internal membership.
   */
  provisionInvitee: ProvisionInviteeOutput;
  /** Makes a group visible in Grow. Requires the `write:questionnaire` permission. */
  publishQuestionnaireGroup: QuestionnaireGroup;
  rateSharedItem?: Maybe<RateSharedItemOutput>;
  /** Registers a device token for push notifications. Overwrites if the token already exists for another user. */
  registerDeviceToken: Scalars['Boolean']['output'];
  /**
   * Registers the story of a roleplay session. An IN_PROGRESS session without a story, or one whose registered story has
   * not delivered a reading yet, takes this story; registering the same story again changes nothing. A different story
   * for a session that already holds readings is refused (GENESIS001346). A session that is no longer open is returned
   * unchanged. An unknown id, or a subject that is not the session's person, is refused (GENESIS001343). Records no
   * activity. Requires `report:roleplay-session`, a permission held by a service account, not by people.
   */
  registerRoleplayStory: GameSession;
  removeAccessGroupMember: AccessGroupMember;
  removeAccessGroupRole: Scalars['Boolean']['output'];
  removeCompanyCompetency: Scalars['Boolean']['output'];
  removeCompanyMember: Scalars['Boolean']['output'];
  removeContacts?: Maybe<RemoveContactsOutput>;
  removePins?: Maybe<RemovePinsOutput>;
  /**
   * Delivers the readings of one assessed turn and records activity: `lastActivityAt` moves to now, while `timeTakenMs`
   * stays as it is. The whole report is refused (GENESIS001346), and nothing of it stored, unless the story is the
   * registered one, the turn is 0 or more, it holds at most 200 readings of different statements, every statement
   * belongs to one of the session's chosen powers, every agreement is 0, 25, 50, 75 or 100, and every confidence is
   * above 0 and at most 1. Per statement, a reading replaces the stored one only when its turn is newer; an equal or
   * older turn changes nothing and is no error, so a repeated delivery is harmless. An empty list only records activity.
   * An accepted report locks the session's powers. A session that is no longer open is returned unchanged and stores
   * nothing. An unknown id, or a subject that is not the session's person, is refused (GENESIS001343). Requires
   * `report:roleplay-session`, a permission held by a service account, not by people.
   */
  reportRoleplayReadings: GameSession;
  /** Creates a contact-request notification for another user. */
  requestContact: Notification;
  /** Creates contact-request notifications for multiple users. */
  requestContacts: Array<Notification>;
  /** Explicit voluntary quiz email to the bound account; requestId is replay-safe. APPLICATIONS write required. */
  requestListingApplicationPowerQuiz: SetListingApplicationStateOutput;
  /**
   * Re-sends a still-pending invitation for an existing Person, to the confirmed recipient. Changing the recipient rewrites the pending account's address and resets its verified flag;
   * an account that has meanwhile been set up is refused (`ACCOUNT_CHANGED`) rather than being sent a
   * password action, which would be a reset vector.
   */
  resendExistingPersonInvitation: PersonLoginInvitationOutput;
  /**
   * Abandons the caller's open session of this game, if any, and starts a new one in the same transaction. Refused
   * while the game is paused, before anything changes (GENESIS001288). The abandoned session stays readable with status
   * ABANDONED; its game kind may delete what it kept for it (a roleplay session loses its readings and chosen
   * powers).
   */
  restartGameSession: GameSession;
  /**
   * Abandons the caller's open session of this roleplay game, if any, and starts a new one with a fresh draw of five
   * powers, unlocked, in the same transaction. Refused while the game is paused, before anything changes
   * (GENESIS001288). The abandoned session stays readable with status ABANDONED and loses its readings and chosen
   * powers.
   */
  restartRoleplaySession: RoleplaySession;
  retryListingMatchVersion: Match;
  /**
   * Runs an auto run again, on behalf of the caller: a failed, skipped, stalled or design-changed run, or a done run
   * that copied nothing. Needs sight of the match. Ignores the daily limit, which only bounds automatic runs.
   */
  retryMatchAutoRun: RetryMatchAutoRunOutput;
  /** Upserts a questionnaire and its questions + answer choices. Null UUIDs mean create; existing UUIDs update in place. Existing questions and choices omitted from the payload remain unchanged. */
  saveQuestionnaire: SaveQuestionnaireOutput;
  /** Creates or updates a questionnaire group, including its artwork. A newly created group is always DRAFT. Creating past the configured group limit answers with TooManyRecordsResult instead; updating an existing group is never limited, and the limit is reported for a dry run too. Requires the `write:questionnaire` permission. */
  saveQuestionnaireGroup: SaveQuestionnaireGroupOutput;
  /** Persists the current user's chosen answer for one or more questionnaire questions. For each item, replaces any prior answer the user gave to the same question. */
  saveQuestionnaireResults: Scalars['Boolean']['output'];
  saveSelfAssessmentResults: Scalars['Boolean']['output'];
  /**
   * Replace the caller's open toplist session snapshot and active play time. snapshot is a client-defined
   * JSON object, at most 64 KiB when encoded as JSON. snapshotVersion must be at least 1; timeTakenMs
   * is active play time in milliseconds. The supplied snapshot replaces the previous one completely.
   */
  saveToplistProgress: ToplistSession;
  sendChatMessage: ChatMessage;
  /**
   * Queue exactly the caller's own unexpired preview after rechecking permissions, state, recipient, language,
   * template and application. The same `requestId` queues at most once. Does not change application state.
   */
  sendListingApplicationMail: SendListingApplicationMailOutput;
  sendMicrosoftMessage: MicrosoftMessageResult;
  setCompanyCompetency: CompanyCompetency;
  /**
   * Mark or unmark an existing company member as a contact person. Requires admin membership in that
   * company. At most ten members may be marked; exceeding the cap is a validation error. Unmarking is
   * not limited by the cap. Contact status grants no additional permissions or profile visibility.
   */
  setCompanyContactPerson: CompanyMembership;
  setCompanyMemberRole: CompanyMembership;
  setConversationTyping: TypingIndicator;
  /**
   * Pauses (active false) or resumes a game of the catalogue for everyone. A paused game starts no new session; running
   * ones go on and may be finished. Requires `pause:game`.
   */
  setGameActive: GameCatalogEntry;
  setGroupSharingEligibility: PersonalSharingRecipient;
  /**
   * Replace the listing's access list. Requires `feature:share.listings` and
   * `Listing.actions.canManageAccess`, independently of WRITE on `plan`. Only the creator changes
   * `managesAccess`; delegated managers change only entries without that capability. Authorization is checked
   * again while the listing is locked and a stale `expectedRevision` is rejected.
   */
  setListingAccess: SetListingAccessOutput;
  /** Configures private phases and optional quiz requests. PLAN write required. */
  setListingApplicationProcess: Listing;
  /** Moves an active application to a configured private phase. APPLICATIONS write required. */
  setListingApplicationStage: SetListingApplicationStateOutput;
  /**
   * Change application state. Requires `feature:share.listings` and WRITE on the listing's `applications`
   * area.
   */
  setListingApplicationState: SetListingApplicationStateOutput;
  /** Replace company criteria in listing data; existing match versions are unchanged. */
  setListingCompanyConditions: Listing;
  /** Replace person criteria in listing data; existing match versions are unchanged. */
  setListingConditions: Listing;
  /**
   * Set the caller's own email notification preferences for a listing. Enabling requires
   * `feature:share.listings` and application read access; disabling both is always allowed. Messages are sent
   * only while those permissions still hold.
   */
  setListingMailNotification: ListingMailNotification;
  /** Change listing state. Requires `feature:share.listings` and WRITE on `plan`. */
  setListingState: SetListingStateOutput;
  /**
   * Switch auto-match on or off. Requires `feature:match`, match visibility, ownership or WRITE on discover
   * and a RANK or RANK_COMPANIES match. Enabling also requires read access to every linked listing's
   * applications. While enabled, new applicants are evaluated on behalf of the caller. Disabling does not
   * require application read access.
   */
  setMatchAutoMatch: SetMatchAutoMatchOutput;
  /**
   * Replace `Match.design.companyConditions` on a RANK_COMPANIES match. Other design fields and documents
   * are preserved. Each condition supplies exactly one company payload. Expertise evaluation uses the
   * match's existing AI setting. Requires design-write access.
   */
  setMatchCompanyConditions: SetMatchCompanyConditionsOutput;
  /**
   * Replace `Match.design.conditions`, preserving other design fields and documents. Each condition
   * must supply exactly one payload field; zero or multiple are rejected. Requires design-write access.
   */
  setMatchConditions: SetMatchConditionsOutput;
  /**
   * Set `Match.design.aiCopilotText`, preserving all other design fields. Null clears the notes.
   * Requires design-write access.
   */
  setMatchNotes: SetMatchNotesOutput;
  /**
   * Set name, shortDescription and description within `Match.design.project`. Supplied text replaces
   * existing values; null or omitted fields are preserved. Use an empty string to clear a field.
   * Attached documents and other design fields remain unchanged. Requires design-write access.
   */
  setMatchProject: SetMatchProjectOutput;
  /**
   * Set teamSize and optionally teamCount within `Match.design`, preserving all other design fields.
   * Requires design-write access.
   */
  setMatchTeamSize: SetMatchTeamSizeOutput;
  /**
   * Sets who may read the caller's toplist of a domain, like a profile entry's sharing: omitted fields keep their
   * value, an explicit empty sharedWith revokes Group readership, and a sharedWith without allGroups leaves All mode.
   * The toplist must exist, i.e. have been finished once.
   */
  setMyToplistSharing: Toplist;
  setPersonalSharing: PersonalSharing;
  /**
   * Replaces the powers one of the caller's IN_PROGRESS roleplay sessions evaluates with this list, in this order:
   * remove, exchange, add and reorder are all this one call with the whole new list. The list must be 1 to 5 different
   * powers of the 30 (GENESIS001345). Refused once the powers are locked, by `lockRoleplaySessionPowers` or by the first
   * readings (GENESIS001344), for a session that is no longer open (GENESIS001287), and for any id that is not one of
   * the caller's roleplay sessions (GENESIS001343). Sending the list the session already has changes nothing.
   */
  setRoleplaySessionPowers: RoleplaySession;
  signUpSharedProject?: Maybe<SignUpSharedProjectOutput>;
  /**
   * Start powers and skills analysis and return a QUEUED job immediately. Progress and the final result
   * are available through `documentsExtractionEvents` and `extractionJob`. Completion or failure also
   * produces a notification. Runs for a person are serialized; already-analyzed evidence is skipped.
   * Powers are processed before skills.
   */
  startDocumentsExtraction: ExtractionJob;
  /**
   *   Start a YAML file import and return a QUEUED job immediately. File extension, declared MIME type
   *   and content must agree. Empty, unknown or unsupported files are rejected before creating a job.
   *   PDF and DOCX are recognized but currently rejected with a validation error.
   *
   * Requires `write:reference-data`. Payload size is checked before inspecting content; import
   *   permissions and document-count limits also apply. Follow progress through `importJobEvents` or
   *   `fileImportJob`; completion or failure produces a notification.
   */
  startFileImport: FileImportJob;
  /**
   * Returns the caller's open session of this game, or starts one. Expired sessions do not count as open. Returning
   * the open session works while the game is paused; starting a new one is refused then (GENESIS001288).
   */
  startGameSession: GameSession;
  /** Starts the same YAML import as a detached background job and returns immediately. */
  startImportDocuments: ImportJob;
  startOrganizationalPowerAnalysis: OrganizationalPowerAnalysis;
  /**
   * Returns the caller's open session of this roleplay game, or starts one, with the powers it evaluates. A new session
   * draws five of the 30 powers at random, every power equally likely; the open session is returned as it is, with the
   * powers it has. Returning the open session works while the game is paused; starting a new one is refused then
   * (GENESIS001288). A key that names no roleplay game is refused as a validation error. Records no activity.
   */
  startRoleplaySession: RoleplaySession;
  /**
   * Copy a shared item's name, shortDescription and description into `Match.design.project` and set
   * `Match.sharedItem`. Existing project text is replaced. Existing match project documents are
   * preserved; shared-item documents are not copied.
   */
  takeOverSharedItem: TakeOverSharedItemOutput;
  /**
   * Records activity on a roleplay session: an open session's `lastActivityAt` moves to now, while `timeTakenMs` stays
   * as it is. `reportRoleplayReadings` records activity itself; this report is kept for clients that send it. A session
   * that is no longer open is returned unchanged. An unknown id, or a subject that is not the session's person, is
   * refused (GENESIS001343). Requires `report:roleplay-session`, a permission held by a service account, not by people.
   */
  touchRoleplaySession: GameSession;
  /**
   * Unlink a match from a listing. Requires `feature:share.listings` and WRITE on `candidates`, but not match
   * visibility because the link belongs to the listing. Preserves the match. Unlinking an absent relation has
   * no effect.
   */
  unlinkListingMatch: UnlinkListingMatchOutput;
  /** Removes the link again. The match itself stays untouched. */
  unlinkProjectMatch: UnlinkProjectMatchOutput;
  /** Takes a group back to DRAFT, hiding it from every user including those mid-questionnaire. Answers already given are kept and keep counting towards the score. Requires the `write:questionnaire` permission. */
  unpublishQuestionnaireGroup: QuestionnaireGroup;
  /** Removes a device token. Called on logout. */
  unregisterDeviceToken: Scalars['Boolean']['output'];
  updateAccessGroup: AccessGroup;
  updateAccessRole: AccessRole;
  /** Updates an existing agent instance */
  updateAgent: UpdateAgentOutput;
  /** Updates an existing certificate instance */
  updateCertificate: UpdateCertificateOutput;
  /** Updates an existing company instance */
  updateCompany: UpdateCompanyOutput;
  /** Updates an existing contracttype instance */
  updateContractType: UpdateContractTypeOutput;
  /** Updates an existing curriculumvitae instance */
  updateCurriculumVitae: UpdateCurriculumVitaeOutput;
  /** Updates an existing degree instance */
  updateDegree: UpdateDegreeOutput;
  /** Updates an existing discoverycategory instance */
  updateDiscoveryCategory: UpdateDiscoveryCategoryOutput;
  /** Updates an existing document instance */
  updateDocument: UpdateDocumentOutput;
  /** Updates an existing documentgroup instance */
  updateDocumentGroup: UpdateDocumentGroupOutput;
  /** Updates an existing education instance */
  updateEducation: UpdateEducationOutput;
  updateEmailTemplate: EmailTemplate;
  /** Updates an existing experience instance */
  updateExperience: UpdateExperienceOutput;
  /** Updates an existing expertise instance */
  updateExpertise: UpdateExpertiseOutput;
  /** Updates an existing gender instance */
  updateGender: UpdateGenderOutput;
  /** Updates an existing industry instance */
  updateIndustry: UpdateIndustryOutput;
  /** Updates an existing jobdepartment instance */
  updateJobDepartment: UpdateJobDepartmentOutput;
  /** Updates an existing joblocation instance */
  updateJobLocation: UpdateJobLocationOutput;
  /** Updates an existing languageskill instance */
  updateLanguageSkill: UpdateLanguageSkillOutput;
  /** Updates an existing listing instance */
  updateListing: UpdateListingOutput;
  /** Updates an existing maritalstatus instance */
  updateMaritalStatus: UpdateMaritalStatusOutput;
  /** Updates an existing match instance */
  updateMatch: UpdateMatchOutput;
  /** Updates an existing matchcandidate instance */
  updateMatchCandidate: UpdateMatchCandidateOutput;
  /** Updates an existing matchresult instance */
  updateMatchResult: UpdateMatchResultOutput;
  /** Updates an existing orgunit instance */
  updateOrgUnit: UpdateOrgUnitOutput;
  updateOrganizationalRecordComment: OrganizationalRecordComment;
  updateOrganizationalRecordDocument: OrganizationalRecordDocument;
  updateOrganizationalRecordEntry: OrganizationalRecordEntry;
  /** Updates an existing person instance */
  updatePerson: UpdatePersonOutput;
  /** Updates an existing persongroup instance */
  updatePersonGroup: UpdatePersonGroupOutput;
  /** Updates an existing pingroup instance */
  updatePinGroup: UpdatePinGroupOutput;
  /** Updates an existing project instance */
  updateProject: UpdateProjectOutput;
  /**
   * Merge a JSON object into the selected person's settings. Omit person to target the caller.
   * Requires permission to edit that person. Supplied top-level keys replace existing values, including
   * nested objects; omitted keys remain unchanged. An empty object changes nothing. A null value for a
   * key is retained as a value, not removed. Supply an object for settings.
   */
  updateSettings?: Maybe<Scalars['Boolean']['output']>;
  /** Updates an existing shareditem instance */
  updateSharedItem: UpdateSharedItemOutput;
  /** Updates an existing shareditemcomment instance */
  updateSharedItemComment: UpdateSharedItemCommentOutput;
  /** Updates an existing studionotebook instance */
  updateStudioNotebook: UpdateStudioNotebookOutput;
  updateSystemSettings: Scalars['Boolean']['output'];
  /** Updates an existing teamprofile instance */
  updateTeamProfile: UpdateTeamProfileOutput;
  /** Updates an existing workingtimemodel instance */
  updateWorkingTimeModel: UpdateWorkingTimeModelOutput;
  /** Validate person requirements without saving, for a session draft. */
  validateListingConditions: Scalars['Boolean']['output'];
  viewSharedItem?: Maybe<ViewSharedItemOutput>;
  viewUserProfile?: Maybe<ViewUserProfileOutput>;
  /** Withdraw the caller's own application from RECEIVED or IN_REVIEW. Requires `feature:share.applications`. */
  withdrawListingApplication: WithdrawListingApplicationOutput;
};


export type MutationActOnNotificationArgs = {
  input: ActOnNotificationInput;
};


export type MutationAddAccessGroupMemberArgs = {
  input: AccessGroupMemberInput;
};


export type MutationAddCompanyMemberArgs = {
  input: CompanyMembershipInput;
};


export type MutationAddContactsArgs = {
  input: AddContactsInput;
};


export type MutationAddPinsArgs = {
  input: AddPinsInput;
};


export type MutationApplyOrganizationalPowerAnalysisArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationApplyToListingArgs = {
  input: ApplyToListingInput;
};


export type MutationAssignAccessGroupRoleArgs = {
  input: AssignAccessGroupRoleInput;
};


export type MutationAssignManagerArgs = {
  input: AssignManagerInput;
};


export type MutationAssignOrgUnitArgs = {
  input: AssignOrgUnitInput;
};


export type MutationAssignQuestionnaireToGroupArgs = {
  input: AssignQuestionnaireToGroupInput;
};


export type MutationAttachProjectDocumentArgs = {
  input: AttachProjectDocumentInput;
};


export type MutationBulkImportPersonArgs = {
  input: BulkImportPersonInput;
};


export type MutationCheckMicrosoftCalendarArgs = {
  accountKind?: InputMaybe<Scalars['String']['input']>;
};


export type MutationClaimListingApplicationArgs = {
  input: ClaimListingApplicationInput;
};


export type MutationCompleteRoleplaySessionArgs = {
  input: RoleplayStoryReportInput;
};


export type MutationConnectMicrosoftCalendarArgs = {
  accountKind?: InputMaybe<Scalars['String']['input']>;
  code: Scalars['String']['input'];
  verifier: Scalars['String']['input'];
};


export type MutationCreateAccessGroupArgs = {
  input: CreateAccessGroupInput;
};


export type MutationCreateAccessRoleArgs = {
  input: CreateAccessRoleInput;
};


export type MutationCreateAgentArgs = {
  input: CreateAgentInput;
};


export type MutationCreateCertificateArgs = {
  input: CreateCertificateInput;
};


export type MutationCreateCompanyArgs = {
  input: CreateCompanyInput;
};


export type MutationCreateContractTypeArgs = {
  input: CreateContractTypeInput;
};


export type MutationCreateConversationArgs = {
  input: CreateConversationInput;
};


export type MutationCreateCurriculumVitaeArgs = {
  input: CreateCurriculumVitaeInput;
};


export type MutationCreateDegreeArgs = {
  input: CreateDegreeInput;
};


export type MutationCreateDiscoveryCategoryArgs = {
  input: CreateDiscoveryCategoryInput;
};


export type MutationCreateDocumentArgs = {
  input: CreateDocumentInput;
};


export type MutationCreateDocumentGroupArgs = {
  input: CreateDocumentGroupInput;
};


export type MutationCreateEducationArgs = {
  input: CreateEducationInput;
};


export type MutationCreateExperienceArgs = {
  input: CreateExperienceInput;
};


export type MutationCreateExpertiseArgs = {
  input: CreateExpertiseInput;
};


export type MutationCreateGenderArgs = {
  input: CreateGenderInput;
};


export type MutationCreateIndustryArgs = {
  input: CreateIndustryInput;
};


export type MutationCreateJobDepartmentArgs = {
  input: CreateJobDepartmentInput;
};


export type MutationCreateJobLocationArgs = {
  input: CreateJobLocationInput;
};


export type MutationCreateLanguageSkillArgs = {
  input: CreateLanguageSkillInput;
};


export type MutationCreateListingArgs = {
  input: CreateListingInput;
};


export type MutationCreateListingMatchVersionArgs = {
  input: CreateListingMatchVersionInput;
};


export type MutationCreateMaritalStatusArgs = {
  input: CreateMaritalStatusInput;
};


export type MutationCreateMatchArgs = {
  input: CreateMatchInput;
};


export type MutationCreateMatchCandidateArgs = {
  input: CreateMatchCandidateInput;
};


export type MutationCreateMatchCandidatesArgs = {
  input: CreateMatchCandidatesInput;
};


export type MutationCreateMatchCompaniesArgs = {
  input: CreateMatchCompaniesInput;
};


export type MutationCreateMatchCompanyArgs = {
  input: CreateMatchCompanyInput;
};


export type MutationCreateMatchResultArgs = {
  input: CreateMatchResultInput;
};


export type MutationCreateOrgUnitArgs = {
  input: CreateOrgUnitInput;
};


export type MutationCreateOrganizationalRecordArgs = {
  companyId?: InputMaybe<Scalars['ID']['input']>;
  personId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationCreateOrganizationalRecordCommentArgs = {
  input: CreateOrganizationalRecordCommentInput;
};


export type MutationCreateOrganizationalRecordDocumentArgs = {
  input: CreateOrganizationalRecordDocumentInput;
};


export type MutationCreateOrganizationalRecordEntryArgs = {
  input: CreateOrganizationalRecordEntryInput;
};


export type MutationCreatePersonArgs = {
  input: CreatePersonInput;
};


export type MutationCreatePersonGroupArgs = {
  input: CreatePersonGroupInput;
};


export type MutationCreatePinGroupArgs = {
  input: CreatePinGroupInput;
};


export type MutationCreateProjectArgs = {
  input: CreateProjectInput;
};


export type MutationCreateSharedItemArgs = {
  input: CreateSharedItemInput;
};


export type MutationCreateSharedItemCommentArgs = {
  input: CreateSharedItemCommentInput;
};


export type MutationCreateStudioNotebookArgs = {
  input: CreateStudioNotebookInput;
};


export type MutationCreateTeamProfileArgs = {
  input: CreateTeamProfileInput;
};


export type MutationCreateWorkingTimeModelArgs = {
  input: CreateWorkingTimeModelInput;
};


export type MutationDeleteAccessGroupArgs = {
  input: DeleteAccessGroupInput;
};


export type MutationDeleteAccessRoleArgs = {
  input: DeleteAccessRoleInput;
};


export type MutationDeleteAgentArgs = {
  input: DeleteAgentInput;
};


export type MutationDeleteAllNotificationsArgs = {
  input?: InputMaybe<SupportedNotificationTypesInput>;
};


export type MutationDeleteCertificateArgs = {
  input: DeleteCertificateInput;
};


export type MutationDeleteCompanyArgs = {
  input: DeleteCompanyInput;
};


export type MutationDeleteContractTypeArgs = {
  input: DeleteContractTypeInput;
};


export type MutationDeleteConversationArgs = {
  conversationId: Scalars['UUID']['input'];
};


export type MutationDeleteCurriculumVitaeArgs = {
  input: DeleteCurriculumVitaeInput;
};


export type MutationDeleteDegreeArgs = {
  input: DeleteDegreeInput;
};


export type MutationDeleteDiscoveryCategoryArgs = {
  input: DeleteDiscoveryCategoryInput;
};


export type MutationDeleteDocumentArgs = {
  input: DeleteDocumentInput;
};


export type MutationDeleteDocumentGroupArgs = {
  input: DeleteDocumentGroupInput;
};


export type MutationDeleteEducationArgs = {
  input: DeleteEducationInput;
};


export type MutationDeleteExperienceArgs = {
  input: DeleteExperienceInput;
};


export type MutationDeleteExpertiseArgs = {
  input: DeleteExpertiseInput;
};


export type MutationDeleteGenderArgs = {
  input: DeleteGenderInput;
};


export type MutationDeleteIndustryArgs = {
  input: DeleteIndustryInput;
};


export type MutationDeleteJobDepartmentArgs = {
  input: DeleteJobDepartmentInput;
};


export type MutationDeleteJobLocationArgs = {
  input: DeleteJobLocationInput;
};


export type MutationDeleteLanguageSkillArgs = {
  input: DeleteLanguageSkillInput;
};


export type MutationDeleteListingArgs = {
  input: DeleteListingInput;
};


export type MutationDeleteMaritalStatusArgs = {
  input: DeleteMaritalStatusInput;
};


export type MutationDeleteMatchArgs = {
  input: DeleteMatchInput;
};


export type MutationDeleteMatchCandidateArgs = {
  input: DeleteMatchCandidateInput;
};


export type MutationDeleteMatchCandidatesArgs = {
  input: DeleteMatchCandidatesInput;
};


export type MutationDeleteMatchCompaniesArgs = {
  input: DeleteMatchCompaniesInput;
};


export type MutationDeleteMatchCompanyArgs = {
  input: DeleteMatchCompanyInput;
};


export type MutationDeleteMatchResultArgs = {
  input: DeleteMatchResultInput;
};


export type MutationDeleteMyFavoriteArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDeleteNotificationArgs = {
  notificationId: Scalars['UUID']['input'];
};


export type MutationDeleteOrgUnitArgs = {
  input: DeleteOrgUnitInput;
};


export type MutationDeleteOrganizationalRecordCommentArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteOrganizationalRecordDocumentArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteOrganizationalRecordEntryArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeletePersonArgs = {
  input: DeletePersonInput;
};


export type MutationDeletePersonGroupArgs = {
  input: DeletePersonGroupInput;
};


export type MutationDeletePinGroupArgs = {
  input: DeletePinGroupInput;
};


export type MutationDeleteProjectArgs = {
  input: DeleteProjectInput;
};


export type MutationDeleteQuestionnaireArgs = {
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  questionnaireId: Scalars['UUID']['input'];
};


export type MutationDeleteQuestionnaireGroupArgs = {
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  questionnaireGroupId: Scalars['UUID']['input'];
};


export type MutationDeleteRoleplaySessionArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDeleteSharedItemArgs = {
  input: DeleteSharedItemInput;
};


export type MutationDeleteSharedItemCommentArgs = {
  input: DeleteSharedItemCommentInput;
};


export type MutationDeleteStudioNotebookArgs = {
  input: DeleteStudioNotebookInput;
};


export type MutationDeleteTeamProfileArgs = {
  input: DeleteTeamProfileInput;
};


export type MutationDeleteWorkingTimeModelArgs = {
  input: DeleteWorkingTimeModelInput;
};


export type MutationDetachProjectDocumentArgs = {
  input: DetachProjectDocumentInput;
};


export type MutationDisconnectMicrosoftCalendarArgs = {
  accountKind?: InputMaybe<Scalars['String']['input']>;
};


export type MutationExpireRoleplaySessionArgs = {
  input: RoleplaySessionReportInput;
};


export type MutationExtractProfileFromDocumentArgs = {
  file: Scalars['Binary']['input'];
  fileName: Scalars['String']['input'];
};


export type MutationFinishToplistSessionArgs = {
  entries: Array<ToplistEntryInput>;
  id: Scalars['UUID']['input'];
};


export type MutationGenerateAiListingRequirementsArgs = {
  listingId: Scalars['UUID']['input'];
};


export type MutationGenerateAiRequirementsArgs = {
  input: GenerateAiRequirementsInput;
};


export type MutationGenerateTransientMatchResultArgs = {
  input: GenerateTransientMatchResultInput;
};


export type MutationHeartbeatConversationPresenceArgs = {
  input: HeartbeatConversationPresenceInput;
};


export type MutationImportCvBatchArgs = {
  files: Array<CvFileInput>;
  importPhoto?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationImportDocumentsArgs = {
  options?: InputMaybe<ImportOptionsInput>;
  yaml: Scalars['String']['input'];
};


export type MutationImportLinkedInProfileArgs = {
  input: LinkedInImportInput;
};


export type MutationInviteExistingPersonArgs = {
  input: InviteExistingPersonInput;
};


export type MutationLinkListingMatchArgs = {
  input: LinkListingMatchInput;
};


export type MutationLinkProjectMatchArgs = {
  input: LinkProjectMatchInput;
};


export type MutationLockRoleplaySessionPowersArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationMarkAllNotificationsReadArgs = {
  input?: InputMaybe<SupportedNotificationTypesInput>;
};


export type MutationMarkConversationReadArgs = {
  input: MarkConversationReadInput;
};


export type MutationMarkNotificationReadArgs = {
  notificationId: Scalars['UUID']['input'];
};


export type MutationPreviewLinkedInImportArgs = {
  input: LinkedInImportInput;
};


export type MutationPreviewListingApplicationMailArgs = {
  input: PreviewListingApplicationMailInput;
};


export type MutationProcessDocumentsArgs = {
  input: ProcessDocumentsInput;
};


export type MutationProvisionInviteeArgs = {
  input: ProvisionInviteeInput;
};


export type MutationPublishQuestionnaireGroupArgs = {
  questionnaireGroupId: Scalars['UUID']['input'];
};


export type MutationRateSharedItemArgs = {
  input: RateSharedItemInput;
};


export type MutationRegisterDeviceTokenArgs = {
  input: RegisterDeviceTokenInput;
};


export type MutationRegisterRoleplayStoryArgs = {
  input: RoleplayStoryReportInput;
};


export type MutationRemoveAccessGroupMemberArgs = {
  input: AccessGroupMemberInput;
};


export type MutationRemoveAccessGroupRoleArgs = {
  input: RemoveAccessGroupRoleInput;
};


export type MutationRemoveCompanyCompetencyArgs = {
  input: RemoveCompanyCompetencyInput;
};


export type MutationRemoveCompanyMemberArgs = {
  input: RemoveCompanyMemberInput;
};


export type MutationRemoveContactsArgs = {
  input: RemoveContactsInput;
};


export type MutationRemovePinsArgs = {
  input: RemovePinsInput;
};


export type MutationReportRoleplayReadingsArgs = {
  input: RoleplayReadingsReportInput;
};


export type MutationRequestContactArgs = {
  contactId: Scalars['UUID']['input'];
  justification?: InputMaybe<Scalars['String']['input']>;
  personGroupIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
};


export type MutationRequestContactsArgs = {
  contactIds: Array<Scalars['UUID']['input']>;
  justification?: InputMaybe<Scalars['String']['input']>;
  personGroupIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
};


export type MutationRequestListingApplicationPowerQuizArgs = {
  input: RequestListingApplicationPowerQuizInput;
};


export type MutationResendExistingPersonInvitationArgs = {
  input: ResendExistingPersonInvitationInput;
};


export type MutationRestartGameSessionArgs = {
  gameKey: Scalars['String']['input'];
};


export type MutationRestartRoleplaySessionArgs = {
  gameKey: Scalars['String']['input'];
};


export type MutationRetryListingMatchVersionArgs = {
  input: RetryListingMatchVersionInput;
};


export type MutationRetryMatchAutoRunArgs = {
  input: RetryMatchAutoRunInput;
};


export type MutationSaveQuestionnaireArgs = {
  input: SaveQuestionnaireInput;
};


export type MutationSaveQuestionnaireGroupArgs = {
  input: SaveQuestionnaireGroupInput;
};


export type MutationSaveQuestionnaireResultsArgs = {
  input: SaveQuestionnaireResultsInput;
};


export type MutationSaveSelfAssessmentResultsArgs = {
  input: SaveSelfAssessmentResultsInput;
};


export type MutationSaveToplistProgressArgs = {
  id: Scalars['UUID']['input'];
  snapshot: Scalars['Object']['input'];
  snapshotVersion: Scalars['Int']['input'];
  timeTakenMs: Scalars['Int']['input'];
};


export type MutationSendChatMessageArgs = {
  input: SendChatMessageInput;
};


export type MutationSendListingApplicationMailArgs = {
  input: SendListingApplicationMailInput;
};


export type MutationSendMicrosoftMessageArgs = {
  input: MicrosoftMessageInput;
};


export type MutationSetCompanyCompetencyArgs = {
  input: SetCompanyCompetencyInput;
};


export type MutationSetCompanyContactPersonArgs = {
  input: SetCompanyContactPersonInput;
};


export type MutationSetCompanyMemberRoleArgs = {
  input: CompanyMembershipInput;
};


export type MutationSetConversationTypingArgs = {
  input: SetConversationTypingInput;
};


export type MutationSetGameActiveArgs = {
  active: Scalars['Boolean']['input'];
  gameKey: Scalars['String']['input'];
};


export type MutationSetGroupSharingEligibilityArgs = {
  input: SetGroupSharingEligibilityInput;
};


export type MutationSetListingAccessArgs = {
  input: SetListingAccessInput;
};


export type MutationSetListingApplicationProcessArgs = {
  input: SetListingApplicationProcessInput;
};


export type MutationSetListingApplicationStageArgs = {
  input: SetListingApplicationStageInput;
};


export type MutationSetListingApplicationStateArgs = {
  input: SetListingApplicationStateInput;
};


export type MutationSetListingCompanyConditionsArgs = {
  input: SetListingCompanyConditionsInput;
};


export type MutationSetListingConditionsArgs = {
  input: SetListingConditionsInput;
};


export type MutationSetListingMailNotificationArgs = {
  input: SetListingMailNotificationInput;
};


export type MutationSetListingStateArgs = {
  input: SetListingStateInput;
};


export type MutationSetMatchAutoMatchArgs = {
  input: SetMatchAutoMatchInput;
};


export type MutationSetMatchCompanyConditionsArgs = {
  input: SetMatchCompanyConditionsInput;
};


export type MutationSetMatchConditionsArgs = {
  input: SetMatchConditionsInput;
};


export type MutationSetMatchNotesArgs = {
  input: SetMatchNotesInput;
};


export type MutationSetMatchProjectArgs = {
  input: SetMatchProjectInput;
};


export type MutationSetMatchTeamSizeArgs = {
  input: SetMatchTeamSizeInput;
};


export type MutationSetMyToplistSharingArgs = {
  input: SetMyToplistSharingInput;
};


export type MutationSetPersonalSharingArgs = {
  input: SetPersonalSharingInput;
};


export type MutationSetRoleplaySessionPowersArgs = {
  input: RoleplaySessionPowersInput;
};


export type MutationSignUpSharedProjectArgs = {
  input: SignUpSharedProjectInput;
};


export type MutationStartDocumentsExtractionArgs = {
  input: ProcessDocumentsInput;
};


export type MutationStartFileImportArgs = {
  batch?: InputMaybe<ImportBatchInput>;
  file: Scalars['Binary']['input'];
  fileName: Scalars['String']['input'];
  mimeType?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<ImportOptionsInput>;
};


export type MutationStartGameSessionArgs = {
  gameKey: Scalars['String']['input'];
};


export type MutationStartImportDocumentsArgs = {
  fileName: Scalars['String']['input'];
  options?: InputMaybe<ImportOptionsInput>;
  yaml: Scalars['String']['input'];
};


export type MutationStartOrganizationalPowerAnalysisArgs = {
  documentIds: Array<Scalars['UUID']['input']>;
  recordId: Scalars['UUID']['input'];
};


export type MutationStartRoleplaySessionArgs = {
  gameKey: Scalars['String']['input'];
};


export type MutationTakeOverSharedItemArgs = {
  input: TakeOverSharedItemInput;
};


export type MutationTouchRoleplaySessionArgs = {
  input: RoleplaySessionReportInput;
};


export type MutationUnlinkListingMatchArgs = {
  input: UnlinkListingMatchInput;
};


export type MutationUnlinkProjectMatchArgs = {
  input: UnlinkProjectMatchInput;
};


export type MutationUnpublishQuestionnaireGroupArgs = {
  questionnaireGroupId: Scalars['UUID']['input'];
};


export type MutationUnregisterDeviceTokenArgs = {
  token: Scalars['String']['input'];
};


export type MutationUpdateAccessGroupArgs = {
  input: UpdateAccessGroupInput;
};


export type MutationUpdateAccessRoleArgs = {
  input: UpdateAccessRoleInput;
};


export type MutationUpdateAgentArgs = {
  id: Scalars['ID']['input'];
  input: UpdateAgentInput;
};


export type MutationUpdateCertificateArgs = {
  id: Scalars['ID']['input'];
  input: UpdateCertificateInput;
};


export type MutationUpdateCompanyArgs = {
  id: Scalars['ID']['input'];
  input: UpdateCompanyInput;
};


export type MutationUpdateContractTypeArgs = {
  id: Scalars['ID']['input'];
  input: UpdateContractTypeInput;
};


export type MutationUpdateCurriculumVitaeArgs = {
  id: Scalars['ID']['input'];
  input: UpdateCurriculumVitaeInput;
};


export type MutationUpdateDegreeArgs = {
  id: Scalars['ID']['input'];
  input: UpdateDegreeInput;
};


export type MutationUpdateDiscoveryCategoryArgs = {
  id: Scalars['ID']['input'];
  input: UpdateDiscoveryCategoryInput;
};


export type MutationUpdateDocumentArgs = {
  id: Scalars['ID']['input'];
  input: UpdateDocumentInput;
};


export type MutationUpdateDocumentGroupArgs = {
  id: Scalars['ID']['input'];
  input: UpdateDocumentGroupInput;
};


export type MutationUpdateEducationArgs = {
  id: Scalars['ID']['input'];
  input: UpdateEducationInput;
};


export type MutationUpdateEmailTemplateArgs = {
  input: EmailTemplateInput;
};


export type MutationUpdateExperienceArgs = {
  id: Scalars['ID']['input'];
  input: UpdateExperienceInput;
};


export type MutationUpdateExpertiseArgs = {
  id: Scalars['ID']['input'];
  input: UpdateExpertiseInput;
};


export type MutationUpdateGenderArgs = {
  id: Scalars['ID']['input'];
  input: UpdateGenderInput;
};


export type MutationUpdateIndustryArgs = {
  id: Scalars['ID']['input'];
  input: UpdateIndustryInput;
};


export type MutationUpdateJobDepartmentArgs = {
  id: Scalars['ID']['input'];
  input: UpdateJobDepartmentInput;
};


export type MutationUpdateJobLocationArgs = {
  id: Scalars['ID']['input'];
  input: UpdateJobLocationInput;
};


export type MutationUpdateLanguageSkillArgs = {
  id: Scalars['ID']['input'];
  input: UpdateLanguageSkillInput;
};


export type MutationUpdateListingArgs = {
  id: Scalars['ID']['input'];
  input: UpdateListingInput;
};


export type MutationUpdateMaritalStatusArgs = {
  id: Scalars['ID']['input'];
  input: UpdateMaritalStatusInput;
};


export type MutationUpdateMatchArgs = {
  id: Scalars['ID']['input'];
  input: UpdateMatchInput;
};


export type MutationUpdateMatchCandidateArgs = {
  id: Scalars['ID']['input'];
  input: UpdateMatchCandidateInput;
};


export type MutationUpdateMatchResultArgs = {
  id: Scalars['ID']['input'];
  input: UpdateMatchResultInput;
};


export type MutationUpdateOrgUnitArgs = {
  id: Scalars['ID']['input'];
  input: UpdateOrgUnitInput;
};


export type MutationUpdateOrganizationalRecordCommentArgs = {
  content: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  links?: InputMaybe<Array<OrganizationalRecordLinkTargetInput>>;
};


export type MutationUpdateOrganizationalRecordDocumentArgs = {
  id: Scalars['ID']['input'];
  title: Scalars['String']['input'];
};


export type MutationUpdateOrganizationalRecordEntryArgs = {
  id: Scalars['ID']['input'];
  input: UpdateOrganizationalRecordEntryInput;
};


export type MutationUpdatePersonArgs = {
  id: Scalars['ID']['input'];
  input: UpdatePersonInput;
};


export type MutationUpdatePersonGroupArgs = {
  id: Scalars['ID']['input'];
  input: UpdatePersonGroupInput;
};


export type MutationUpdatePinGroupArgs = {
  id: Scalars['ID']['input'];
  input: UpdatePinGroupInput;
};


export type MutationUpdateProjectArgs = {
  id: Scalars['ID']['input'];
  input: UpdateProjectInput;
};


export type MutationUpdateSettingsArgs = {
  person?: InputMaybe<Scalars['UUID']['input']>;
  settings?: InputMaybe<Scalars['Object']['input']>;
};


export type MutationUpdateSharedItemArgs = {
  id: Scalars['ID']['input'];
  input: UpdateSharedItemInput;
};


export type MutationUpdateSharedItemCommentArgs = {
  id: Scalars['ID']['input'];
  input: UpdateSharedItemCommentInput;
};


export type MutationUpdateStudioNotebookArgs = {
  id: Scalars['ID']['input'];
  input: UpdateStudioNotebookInput;
};


export type MutationUpdateSystemSettingsArgs = {
  input: SystemSettingsInput;
};


export type MutationUpdateTeamProfileArgs = {
  id: Scalars['ID']['input'];
  input: UpdateTeamProfileInput;
};


export type MutationUpdateWorkingTimeModelArgs = {
  id: Scalars['ID']['input'];
  input: UpdateWorkingTimeModelInput;
};


export type MutationValidateListingConditionsArgs = {
  input: SetListingConditionsInput;
};


export type MutationViewSharedItemArgs = {
  input: ViewSharedItemInput;
};


export type MutationViewUserProfileArgs = {
  input: ViewUserProfileInput;
};


export type MutationWithdrawListingApplicationArgs = {
  input: WithdrawListingApplicationInput;
};

/** The filterable fields of type Mutation */
export type MutationFilterInput = {
  and?: InputMaybe<Array<MutationFilterInput>>;
  not?: InputMaybe<MutationFilterInput>;
  or?: InputMaybe<Array<MutationFilterInput>>;
};

export type MyCompaniesResult = {
  __typename?: 'MyCompaniesResult';
  memberships: Array<MyCompanyMembership>;
};

/** The filterable fields of type MyCompaniesResult */
export type MyCompaniesResultFilterInput = {
  and?: InputMaybe<Array<MyCompaniesResultFilterInput>>;
  not?: InputMaybe<MyCompaniesResultFilterInput>;
  or?: InputMaybe<Array<MyCompaniesResultFilterInput>>;
};

/** One of the caller's own company memberships. Supported role strings are `admin` and `member`. */
export type MyCompanyMembership = {
  __typename?: 'MyCompanyMembership';
  /** Company identity and logo. The summary and employeeCount are null on this reference. */
  company: Company;
  role: Scalars['String']['output'];
};

/** The filterable fields of type MyCompanyMembership */
export type MyCompanyMembershipFilterInput = {
  and?: InputMaybe<Array<MyCompanyMembershipFilterInput>>;
  not?: InputMaybe<MyCompanyMembershipFilterInput>;
  or?: InputMaybe<Array<MyCompanyMembershipFilterInput>>;
};

export type MyFavoritesInput = {
  /** All domains when absent. */
  domain?: InputMaybe<FavoriteDomain>;
};

/**
 * Permission codes held by the current principal for internal access. Use these codes to check
 * permission eligibility, such as `provision:invitee`. Resource-specific authorization still applies.
 * `reachableFeatures` separately reports feature eligibility.
 */
export type MyPermissionsResult = {
  __typename?: 'MyPermissionsResult';
  permissionCodes: Array<Scalars['String']['output']>;
};

/** The filterable fields of type MyPermissionsResult */
export type MyPermissionsResultFilterInput = {
  and?: InputMaybe<Array<MyPermissionsResultFilterInput>>;
  not?: InputMaybe<MyPermissionsResultFilterInput>;
  or?: InputMaybe<Array<MyPermissionsResultFilterInput>>;
};

export type MyPowersDevStatsInput = {
  amount: Scalars['Int']['input'];
};

export enum NameUse {
  Anonymous = 'ANONYMOUS',
  Maiden = 'MAIDEN',
  Nickname = 'NICKNAME',
  Official = 'OFFICIAL',
  Old = 'OLD',
  Temp = 'TEMP',
  Usual = 'USUAL'
}

export type Node = {
  id: Scalars['ID']['output'];
};

/** The filterable fields of type Node */
export type NodeFilterInput = {
  and?: InputMaybe<Array<NodeFilterInput>>;
  not?: InputMaybe<NodeFilterInput>;
  or?: InputMaybe<Array<NodeFilterInput>>;
};

/** A user-scoped inbox item delivered by the notification subsystem. */
export type Notification = Node & {
  __typename?: 'Notification';
  /** Actions currently associated with the notification. */
  actions: Array<NotificationAction>;
  /** Localized body text for the notification. */
  body: LocalizedText;
  /** When the notification was created. */
  createdAt: Scalars['DateTime']['output'];
  /** User who triggered the notification, if applicable. */
  createdBy?: Maybe<Person>;
  /** Optional client route or deep link for navigation. */
  deepLink?: Maybe<Scalars['String']['output']>;
  /** True when this notification can be deleted. False while it still awaits a decision from the user, such as an unanswered contact request. */
  deletable: Scalars['Boolean']['output'];
  /**
   * Names of the documents a background analysis is working on, in the order they were submitted.
   * Empty for every notification that is not about a documents analysis.
   */
  documentNames: Array<Scalars['String']['output']>;
  /** Optional domain entity referenced by the notification. */
  entityId?: Maybe<Scalars['UUID']['output']>;
  /** When the notification expires automatically. */
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  /**
   * True while the background job this notification announces is still running, so a client can show
   * a live indicator on it and drop that indicator the moment the job stops. Always false for
   * notifications that do not announce a job, and for one that does it turns false on its own if the
   * runner dies without reporting a terminal state. Do not infer this from the presence of a later
   * notification: an interrupted job never sends one.
   */
  jobActive: Scalars['Boolean']['output'];
  /**
   * Counters of the batch this notification tracks, for rendering a progress reporting. Null for every
   * notification that does not track a batch (which today is everything except IMPORT_BATCH).
   */
  progress?: Maybe<NotificationProgress>;
  /** When the user marked the notification as read. */
  readAt?: Maybe<Scalars['DateTime']['output']>;
  /** The current lifecycle state of the notification. */
  state: NotificationState;
  /** Localized title for the notification. */
  title: LocalizedText;
  /** The category of the notification. */
  type: NotificationType;
};

/** An action rendered together with a notification. */
export type NotificationAction = {
  __typename?: 'NotificationAction';
  /** Localized action label. */
  label: LocalizedText;
  /** Whether the action can still be executed. */
  status: NotificationActionStatus;
  /** The action to perform. */
  type: NotificationActionType;
};

/** The filterable fields of type NotificationAction */
export type NotificationActionFilterInput = {
  and?: InputMaybe<Array<NotificationActionFilterInput>>;
  not?: InputMaybe<NotificationActionFilterInput>;
  or?: InputMaybe<Array<NotificationActionFilterInput>>;
};

/** Availability state of a notification action. */
export enum NotificationActionStatus {
  /** The action is currently available to the user. */
  Available = 'AVAILABLE',
  /** The action was executed. */
  Completed = 'COMPLETED',
  /** The action can no longer be executed. */
  Unavailable = 'UNAVAILABLE'
}

/** Action that can be performed from an actionable notification. */
export enum NotificationActionType {
  /** Accept the incoming contact request. */
  AcceptContactRequest = 'ACCEPT_CONTACT_REQUEST',
  /** Reject the incoming contact request. */
  RejectContactRequest = 'REJECT_CONTACT_REQUEST',
  /** View the post related to this notification */
  ViewPostContent = 'VIEW_POST_CONTENT',
  /** View the project related to this notification */
  ViewProjectContent = 'VIEW_PROJECT_CONTENT'
}

/** Realtime wrapper around a notification change event. */
export type NotificationEvent = {
  __typename?: 'NotificationEvent';
  /** The current notification snapshot after the change. */
  notification: Notification;
  /** The affected notification id. */
  notificationId: Scalars['UUID']['output'];
  /** The kind of notification change. */
  type: NotificationEventType;
};

/** The filterable fields of type NotificationEvent */
export type NotificationEventFilterInput = {
  and?: InputMaybe<Array<NotificationEventFilterInput>>;
  not?: InputMaybe<NotificationEventFilterInput>;
  or?: InputMaybe<Array<NotificationEventFilterInput>>;
};

/** Type of realtime change emitted for a notification. */
export enum NotificationEventType {
  /** A notification action was executed. */
  Actioned = 'ACTIONED',
  /** A new notification was created. */
  Created = 'CREATED',
  /** A notification was deleted from the inbox. */
  Deleted = 'DELETED',
  /** A notification expired. */
  Expired = 'EXPIRED',
  /** A notification was marked as read. */
  Read = 'READ',
  /** An existing notification changed in place, e.g. a batch progress tick. */
  Updated = 'UPDATED'
}

/** The filterable fields of type Notification */
export type NotificationFilterInput = {
  and?: InputMaybe<Array<NotificationFilterInput>>;
  not?: InputMaybe<NotificationFilterInput>;
  or?: InputMaybe<Array<NotificationFilterInput>>;
};

/** Running counters of a multi-file import batch. done includes the failed jobs. */
export type NotificationProgress = {
  __typename?: 'NotificationProgress';
  done: Scalars['Int']['output'];
  failed: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

/** The filterable fields of type NotificationProgress */
export type NotificationProgressFilterInput = {
  and?: InputMaybe<Array<NotificationProgressFilterInput>>;
  not?: InputMaybe<NotificationProgressFilterInput>;
  or?: InputMaybe<Array<NotificationProgressFilterInput>>;
};

/** Lifecycle state of a notification in the user's inbox. */
export enum NotificationState {
  /** A user action was executed for this notification. */
  Actioned = 'ACTIONED',
  /** The notification is visible and may still be actionable. */
  Active = 'ACTIVE',
  /** The notification was removed from the user's inbox. */
  Deleted = 'DELETED',
  /** The notification expired automatically and is no longer shown by default. */
  Expired = 'EXPIRED'
}

/** Domain-specific category of a notification. */
export enum NotificationType {
  /**
   * A listing the recipient runs received an application. Sent to its creator and members who hold
   * `feature:share.listings`; `entityId` is the application, `deepLink` the listing.
   */
  ApplicationReceived = 'APPLICATION_RECEIVED',
  /** Another user wants to add the current user as a contact. */
  ContactRequest = 'CONTACT_REQUEST',
  /** A previously sent contact request was accepted. */
  ContactRequestAccepted = 'CONTACT_REQUEST_ACCEPTED',
  /** A background documents extraction (powers/skills) finished successfully. */
  ExtractionCompleted = 'EXTRACTION_COMPLETED',
  /** A background documents extraction (powers/skills) failed. */
  ExtractionFailed = 'EXTRACTION_FAILED',
  /** A background documents extraction (powers/skills) was accepted and is running in the background. */
  ExtractionStarted = 'EXTRACTION_STARTED',
  /**
   * One notification for a whole multi-file drop. Created with the first file's job and updated in
   * place as the batch's jobs finish; `Notification.progress` carries the counters for a progress reporting.
   */
  ImportBatch = 'IMPORT_BATCH',
  /** A YAML import finished successfully. */
  ImportCompleted = 'IMPORT_COMPLETED',
  /** A YAML import failed and was rolled back. */
  ImportFailed = 'IMPORT_FAILED',
  /** A YAML import was accepted and is running in the background. */
  ImportStarted = 'IMPORT_STARTED',
  /** A time-bounded maintenance or downtime notice. */
  MaintenanceWindow = 'MAINTENANCE_WINDOW',
  /**
   * An auto run appended a new applicant to a saved result of a match the recipient sees. Sent to members of the
   * listing who also see the match; `entityId` is the match, `deepLink` the saved result the row was appended to, on
   * the result step of the match (`/match/<matchId>?step=result&result=<resultId>`).
   */
  MatchResultAvailable = 'MATCH_RESULT_AVAILABLE',
  /** A post was published that might be of interest to the current user. */
  PostPublished = 'POST_PUBLISHED',
  /** A project was published that might be of interest to the current user. */
  ProjectPublished = 'PROJECT_PUBLISHED',
  /** A newer client version is available; refresh to use it. */
  SystemUpdate = 'SYSTEM_UPDATE'
}

/** Pagination and filtering options for the notification inbox query. */
export type NotificationsInput = {
  /** Return notifications created before this notification id. */
  afterNotificationId?: InputMaybe<Scalars['UUID']['input']>;
  /** If true, include expired notifications in the result. */
  includeExpired?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Notification types this client understands. Notifications of other types are filtered out
   * of the result. When absent or empty, only the six original types
   * (CONTACT_REQUEST … SYSTEM_UPDATE) are returned, so clients built against an older schema
   * never receive enum values they cannot deserialize. Clients should pass the full set of
   * types they support.
   */
  supportedTypes?: InputMaybe<Array<NotificationType>>;
  /** Maximum number of notifications to return. */
  take?: InputMaybe<Scalars['Int']['input']>;
  /** If true, only unread notifications are returned. */
  unreadOnly?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NumberOfPinsOutput = NumberOfPinsResult;

export type NumberOfPinsResult = {
  __typename?: 'NumberOfPinsResult';
  pinnedPersons?: Maybe<Scalars['Int']['output']>;
  pinnedPosts?: Maybe<Scalars['Int']['output']>;
  pinnedProjects?: Maybe<Scalars['Int']['output']>;
};

/** The filterable fields of type NumberOfPinsResult */
export type NumberOfPinsResultFilterInput = {
  and?: InputMaybe<Array<NumberOfPinsResultFilterInput>>;
  not?: InputMaybe<NumberOfPinsResultFilterInput>;
  or?: InputMaybe<Array<NumberOfPinsResultFilterInput>>;
};

/**
 * Progress of one long-running operation, streamed beside it through operationProgress. It never carries
 * the operation's result; the operation still returns that itself. The first snapshot already has its
 * shape: either stages (planned in order and complete from the start; a stage that does not run is
 * SKIPPED, never removed) or continuous progress (stages empty, done and total on this type).
 */
export type OperationProgress = {
  __typename?: 'OperationProgress';
  /** Facts of a continuous progress; empty when the operation reports stages. */
  details: Array<ProgressDetail>;
  /** Continuous progress only (stages empty); total null means indeterminate. */
  done?: Maybe<Scalars['Int']['output']>;
  progressId: Scalars['UUID']['output'];
  /** Increases with every stored snapshot. Clients drop a snapshot older than the last one they saw. */
  revision: Scalars['Int']['output'];
  stages: Array<ProgressStageState>;
  status: OperationProgressStatus;
  total?: Maybe<Scalars['Int']['output']>;
};

/** The filterable fields of type OperationProgress */
export type OperationProgressFilterInput = {
  and?: InputMaybe<Array<OperationProgressFilterInput>>;
  not?: InputMaybe<OperationProgressFilterInput>;
  or?: InputMaybe<Array<OperationProgressFilterInput>>;
};

/** State of an operation reported through operationProgress. */
export enum OperationProgressStatus {
  Failed = 'FAILED',
  Running = 'RUNNING',
  Succeeded = 'SUCCEEDED'
}

/**
 * A unit in the organization's hierarchy. Maintaining units requires `write:access-config`.
 * A root has no parent. A unit cannot be its own ancestor; changes that would create a cycle are
 * rejected. Person assignments are managed separately with `assignOrgUnit` and `assignManager`.
 */
export type OrgUnit = Node & {
  __typename?: 'OrgUnit';
  /**
   * Whether the unit is retired. Hidden units are excluded from `orgUnits` and cannot receive new
   * assignments. A unit with children or assigned people cannot be deleted; retire it instead.
   */
  hidden?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  localizedName?: Maybe<LocalizedText>;
  name?: Maybe<Scalars['String']['output']>;
  /** The parent unit, or null for a root. Setting a parent that would form a cycle is refused. */
  parent?: Maybe<OrgUnit>;
};

/** The filterable fields of type OrgUnit */
export type OrgUnitFilterInput = {
  and?: InputMaybe<Array<OrgUnitFilterInput>>;
  /**
   * Whether the unit is retired. Hidden units are excluded from `orgUnits` and cannot receive new
   * assignments. A unit with children or assigned people cannot be deleted; retire it instead.
   */
  hidden?: InputMaybe<BooleanFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<OrgUnitFilterInput>;
  or?: InputMaybe<Array<OrgUnitFilterInput>>;
};

/** Contains information for linking 'OrgUnit' to other entities */
export type OrgUnitRelationInput = {
  /** The identifier of 'OrgUnit' */
  id: Scalars['ID']['input'];
};

export type OrgUnitSortInput = {
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
};

/** The OrgUnit tree of this deployment — retired units excluded. */
export type OrgUnitsResult = {
  __typename?: 'OrgUnitsResult';
  orgUnits: Array<OrgUnit>;
};

/** The filterable fields of type OrgUnitsResult */
export type OrgUnitsResultFilterInput = {
  and?: InputMaybe<Array<OrgUnitsResultFilterInput>>;
  not?: InputMaybe<OrgUnitsResultFilterInput>;
  or?: InputMaybe<Array<OrgUnitsResultFilterInput>>;
};

/** A protected organizational-document analysis; only explicit application changes profile scores. */
export type OrganizationalPowerAnalysis = {
  __typename?: 'OrganizationalPowerAnalysis';
  id: Scalars['UUID']['output'];
  recordId: Scalars['UUID']['output'];
  status: OrganizationalPowerAnalysisStatus;
  subjectPersonId: Scalars['UUID']['output'];
  traits: Array<OrganizationalPowerTrait>;
};

/** The filterable fields of type OrganizationalPowerAnalysis */
export type OrganizationalPowerAnalysisFilterInput = {
  and?: InputMaybe<Array<OrganizationalPowerAnalysisFilterInput>>;
  not?: InputMaybe<OrganizationalPowerAnalysisFilterInput>;
  or?: InputMaybe<Array<OrganizationalPowerAnalysisFilterInput>>;
};

export enum OrganizationalPowerAnalysisStatus {
  Applied = 'APPLIED',
  Failed = 'FAILED',
  Ready = 'READY',
  Running = 'RUNNING'
}

export type OrganizationalPowerTrait = {
  __typename?: 'OrganizationalPowerTrait';
  confidence: Scalars['Float']['output'];
  element: CreativityElement;
  rationale: Scalars['String']['output'];
  score: Scalars['Int']['output'];
};

/** The filterable fields of type OrganizationalPowerTrait */
export type OrganizationalPowerTraitFilterInput = {
  and?: InputMaybe<Array<OrganizationalPowerTraitFilterInput>>;
  not?: InputMaybe<OrganizationalPowerTraitFilterInput>;
  or?: InputMaybe<Array<OrganizationalPowerTraitFilterInput>>;
};

/**
 * Organisational record about a person or a company; it has no personal-owner self-scope. Exactly one of
 * `subjectPersonId` and `subjectCompanyId` is set.
 */
export type OrganizationalRecord = Node & {
  __typename?: 'OrganizationalRecord';
  id: Scalars['ID']['output'];
  subjectCompanyId?: Maybe<Scalars['UUID']['output']>;
  subjectPersonId?: Maybe<Scalars['UUID']['output']>;
};

export type OrganizationalRecordAccess = {
  __typename?: 'OrganizationalRecordAccess';
  canAnalyzePowers: Scalars['Boolean']['output'];
  canRead: Scalars['Boolean']['output'];
  canWrite: Scalars['Boolean']['output'];
  /** Effective read scope, or null when denied. GLOBAL includes records beyond departmental applications. */
  readScope?: Maybe<AccessScope>;
  /** Effective write scope, or null when denied. Write includes read; only GLOBAL is currently supported. */
  writeScope?: Maybe<AccessScope>;
};

/** The filterable fields of type OrganizationalRecordAccess */
export type OrganizationalRecordAccessFilterInput = {
  and?: InputMaybe<Array<OrganizationalRecordAccessFilterInput>>;
  not?: InputMaybe<OrganizationalRecordAccessFilterInput>;
  or?: InputMaybe<Array<OrganizationalRecordAccessFilterInput>>;
};

export type OrganizationalRecordBacklink = Node & {
  __typename?: 'OrganizationalRecordBacklink';
  id: Scalars['ID']['output'];
  source: OrganizationalRecordItemReference;
};

export type OrganizationalRecordBacklinkConnection = {
  __typename?: 'OrganizationalRecordBacklinkConnection';
  nodes: Array<OrganizationalRecordBacklink>;
  pageInfo: PageInfo;
};

/** The filterable fields of type OrganizationalRecordBacklinkConnection */
export type OrganizationalRecordBacklinkConnectionFilterInput = {
  and?: InputMaybe<Array<OrganizationalRecordBacklinkConnectionFilterInput>>;
  not?: InputMaybe<OrganizationalRecordBacklinkConnectionFilterInput>;
  or?: InputMaybe<Array<OrganizationalRecordBacklinkConnectionFilterInput>>;
};

/** The filterable fields of type OrganizationalRecordBacklink */
export type OrganizationalRecordBacklinkFilterInput = {
  and?: InputMaybe<Array<OrganizationalRecordBacklinkFilterInput>>;
  not?: InputMaybe<OrganizationalRecordBacklinkFilterInput>;
  or?: InputMaybe<Array<OrganizationalRecordBacklinkFilterInput>>;
};

export type OrganizationalRecordBacklinksInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  recordId: Scalars['ID']['input'];
  target: OrganizationalRecordLinkTargetInput;
};

/** Uses SharedItemComment's content/person/postedAt convention. */
export type OrganizationalRecordComment = Node & {
  __typename?: 'OrganizationalRecordComment';
  content: Scalars['String']['output'];
  entryId?: Maybe<Scalars['UUID']['output']>;
  id: Scalars['ID']['output'];
  links: Array<OrganizationalRecordItemReference>;
  person?: Maybe<Person>;
  postedAt: Scalars['DateTime']['output'];
  recordId: Scalars['UUID']['output'];
};

export type OrganizationalRecordCommentConnection = {
  __typename?: 'OrganizationalRecordCommentConnection';
  nodes: Array<OrganizationalRecordComment>;
  pageInfo: PageInfo;
};

/** The filterable fields of type OrganizationalRecordCommentConnection */
export type OrganizationalRecordCommentConnectionFilterInput = {
  and?: InputMaybe<Array<OrganizationalRecordCommentConnectionFilterInput>>;
  not?: InputMaybe<OrganizationalRecordCommentConnectionFilterInput>;
  or?: InputMaybe<Array<OrganizationalRecordCommentConnectionFilterInput>>;
};

/** The filterable fields of type OrganizationalRecordComment */
export type OrganizationalRecordCommentFilterInput = {
  and?: InputMaybe<Array<OrganizationalRecordCommentFilterInput>>;
  not?: InputMaybe<OrganizationalRecordCommentFilterInput>;
  or?: InputMaybe<Array<OrganizationalRecordCommentFilterInput>>;
};

/** Chronological order of comments, applied consistently across cursor pages. */
export type OrganizationalRecordCommentSortInput = {
  order?: SortOrder;
};

export type OrganizationalRecordDocument = Node & {
  __typename?: 'OrganizationalRecordDocument';
  content: File;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<Person>;
  fileName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  mimeType: Scalars['String']['output'];
  preview?: Maybe<File>;
  recordId: Scalars['UUID']['output'];
  title: Scalars['String']['output'];
};


export type OrganizationalRecordDocumentPreviewArgs = {
  profile: Scalars['String']['input'];
};

export type OrganizationalRecordDocumentConnection = {
  __typename?: 'OrganizationalRecordDocumentConnection';
  nodes: Array<OrganizationalRecordDocument>;
  pageInfo: PageInfo;
};

/** The filterable fields of type OrganizationalRecordDocumentConnection */
export type OrganizationalRecordDocumentConnectionFilterInput = {
  and?: InputMaybe<Array<OrganizationalRecordDocumentConnectionFilterInput>>;
  not?: InputMaybe<OrganizationalRecordDocumentConnectionFilterInput>;
  or?: InputMaybe<Array<OrganizationalRecordDocumentConnectionFilterInput>>;
};

/** The filterable fields of type OrganizationalRecordDocument */
export type OrganizationalRecordDocumentFilterInput = {
  and?: InputMaybe<Array<OrganizationalRecordDocumentFilterInput>>;
  not?: InputMaybe<OrganizationalRecordDocumentFilterInput>;
  or?: InputMaybe<Array<OrganizationalRecordDocumentFilterInput>>;
};

export type OrganizationalRecordEntry = Node & {
  __typename?: 'OrganizationalRecordEntry';
  content: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<Person>;
  id: Scalars['ID']['output'];
  kind: OrganizationalRecordEntryKind;
  links: Array<OrganizationalRecordItemReference>;
  recordId: Scalars['UUID']['output'];
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<Person>;
};

export type OrganizationalRecordEntryConnection = {
  __typename?: 'OrganizationalRecordEntryConnection';
  nodes: Array<OrganizationalRecordEntry>;
  pageInfo: PageInfo;
};

/** The filterable fields of type OrganizationalRecordEntryConnection */
export type OrganizationalRecordEntryConnectionFilterInput = {
  and?: InputMaybe<Array<OrganizationalRecordEntryConnectionFilterInput>>;
  not?: InputMaybe<OrganizationalRecordEntryConnectionFilterInput>;
  or?: InputMaybe<Array<OrganizationalRecordEntryConnectionFilterInput>>;
};

/** The filterable fields of type OrganizationalRecordEntry */
export type OrganizationalRecordEntryFilterInput = {
  and?: InputMaybe<Array<OrganizationalRecordEntryFilterInput>>;
  not?: InputMaybe<OrganizationalRecordEntryFilterInput>;
  or?: InputMaybe<Array<OrganizationalRecordEntryFilterInput>>;
};

export enum OrganizationalRecordEntryKind {
  Note = 'NOTE',
  Report = 'REPORT'
}

/** The filterable fields of type OrganizationalRecord */
export type OrganizationalRecordFilterInput = {
  and?: InputMaybe<Array<OrganizationalRecordFilterInput>>;
  not?: InputMaybe<OrganizationalRecordFilterInput>;
  or?: InputMaybe<Array<OrganizationalRecordFilterInput>>;
};

export enum OrganizationalRecordItemKind {
  Comment = 'COMMENT',
  Document = 'DOCUMENT',
  Entry = 'ENTRY'
}

/** A current title and stable identity within one organizational record. entryId locates an entry's comment thread. */
export type OrganizationalRecordItemReference = {
  __typename?: 'OrganizationalRecordItemReference';
  entryId?: Maybe<Scalars['UUID']['output']>;
  id: Scalars['ID']['output'];
  kind: OrganizationalRecordItemKind;
  title: Scalars['String']['output'];
};

/** The filterable fields of type OrganizationalRecordItemReference */
export type OrganizationalRecordItemReferenceFilterInput = {
  and?: InputMaybe<Array<OrganizationalRecordItemReferenceFilterInput>>;
  not?: InputMaybe<OrganizationalRecordItemReferenceFilterInput>;
  or?: InputMaybe<Array<OrganizationalRecordItemReferenceFilterInput>>;
};

/** Targets may be DOCUMENT or ENTRY. COMMENT is only returned as a backlink source. */
export type OrganizationalRecordLinkTargetInput = {
  id: Scalars['ID']['input'];
  kind: OrganizationalRecordItemKind;
};

/** Forward cursor pagination. Null entryId selects the organizational record's general discussion. */
export type OrganizationalRecordPageInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  entryId?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  recordId: Scalars['ID']['input'];
};

export type OrganizationalRecordReferenceInput = {
  id: Scalars['ID']['input'];
};

/** Provides additional information for paged data. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** The cursor of the current page's last item. To be used when fetching the next page. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** True if there is at least one more page available, otherwise false */
  hasNextPage: Scalars['Boolean']['output'];
  /** True if the is a previous page available, otherwise false */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** The cursor of the current page's first item. To be used when fetching the previous page. */
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type Period = {
  __typename?: 'Period';
  end?: Maybe<Scalars['DateTime']['output']>;
  /** Start of the period, including time and UTC offset. */
  start?: Maybe<Scalars['DateTime']['output']>;
};

/** The filterable fields of type Period */
export type PeriodFilterInput = {
  and?: InputMaybe<Array<PeriodFilterInput>>;
  not?: InputMaybe<PeriodFilterInput>;
  or?: InputMaybe<Array<PeriodFilterInput>>;
};

export type Person = Node & {
  __typename?: 'Person';
  administrativeGender?: Maybe<AdministrativeGender>;
  ageInYears?: Maybe<Scalars['Int']['output']>;
  alternativeAvatar?: Maybe<File>;
  apartment?: Maybe<Scalars['String']['output']>;
  avatar?: Maybe<File>;
  bio?: Maybe<Scalars['String']['output']>;
  birthDate?: Maybe<Scalars['Date']['output']>;
  /**
   * Whether the caller may read this person’s provided documents and raw questionnaire answers:
   * self or an explicit External-information or managed-people override.
   */
  canReadProvidedInformation: Scalars['Boolean']['output'];
  /** Whether the acting Person may edit this profile. Field consent is independent. */
  canUpdate: Scalars['Boolean']['output'];
  certifications?: Maybe<Array<Certificate>>;
  childCount?: Maybe<Scalars['Int']['output']>;
  citizenships?: Maybe<Array<Country>>;
  city?: Maybe<Scalars['String']['output']>;
  contractType?: Maybe<ContractType>;
  country?: Maybe<Country>;
  countryState?: Maybe<CountryState>;
  currentActivity?: Maybe<Scalars['String']['output']>;
  currentEmployer?: Maybe<Scalars['String']['output']>;
  currentTasks?: Maybe<Scalars['String']['output']>;
  deceased?: Maybe<Deceased>;
  drivingLicence?: Maybe<Scalars['String']['output']>;
  educations?: Maybe<Array<Education>>;
  email?: Maybe<Scalars['String']['output']>;
  emailPrimary: Scalars['String']['output'];
  experiences?: Maybe<Array<Experience>>;
  expertises?: Maybe<Array<Expertise>>;
  formattedName?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Gender>;
  houseNumber?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isContact?: Maybe<Scalars['Boolean']['output']>;
  isPinned?: Maybe<Scalars['Boolean']['output']>;
  jobDepartment?: Maybe<JobDepartment>;
  jobLocation?: Maybe<JobLocation>;
  jobTitle?: Maybe<Scalars['String']['output']>;
  languageSkills?: Maybe<Array<LanguageSkill>>;
  maritalStatus?: Maybe<MaritalStatus>;
  miscellaneous?: Maybe<Scalars['String']['output']>;
  name: HumanName;
  nationality?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  /**
   * Self-assessment results restricted to the 30 powers belonging to an ElementGroup.
   * Visibility follows Person.selfAssessmentResults: null means access is denied; a null result within
   * an entry means that power is unscored. An empty list means no relevant assessments are configured.
   */
  powersEvaluationResults?: Maybe<Array<ElementEvaluationResult>>;
  profession?: Maybe<Scalars['String']['output']>;
  pronouns?: Maybe<Scalars['String']['output']>;
  /**
   *   The person's self-assessment results — the person-scoped counterpart of the principal-scoped
   *   `selfAssessmentResults` root query, and it returns the same rows that query would for that person.
   *
   * Visibility: the own profile always resolves. A foreign profile resolves when the person shares
   *   POWERS with a Group the caller currently belongs to, or the caller holds the explicit
   *   External-information or managed-people read override for that person. Picker eligibility does not supply consent.
   *   Use `setPersonalSharing` with recipient Group ids in `input.data.sharedPowers`; an empty list revokes
   *   third-party consent. Row visibility and feature permissions remain independent.
   *
   * `null` = the caller may not see this person's powers. Otherwise one entry per configured
   *   self-assessment, exactly like the root query: an entry whose `result` is null means that element
   *   has not been scored yet, so "permitted but nothing assessed" is a list of entries with null
   *   `result` — not an empty list. `[]` only occurs if no self-assessments are configured at all.
   *
   * Never resolves to a GraphQL error for an unauthorized caller — clients select this alongside the
   *   rest of the profile and must not lose the whole payload to a permission outcome.
   */
  selfAssessmentResults?: Maybe<Array<ElementEvaluationResult>>;
  /**
   *   The person's smart-analysis scores, derived rather than self-reported: from their uploaded documents,
   *   from an applied organisational power analysis, or from a finished roleplay session. Per power the newest
   *   value counts, whichever of the three wrote it. Same visibility rule and same `null`-means-not-permitted
   *   semantics as `selfAssessmentResults`.
   *
   * Ordinary powers sharing leaves `evidences` empty and `rationale` null: both describe the owner's
   *   documents. Self-access and explicit personal-information read overrides return both, because
   *   they also authorize the underlying documents. A value from a roleplay session has neither, for any reader.
   */
  smartAnalysisResults?: Maybe<Array<SmartAnalysisResult>>;
  street?: Maybe<Scalars['String']['output']>;
  /**
   * The person's toplists from the toplist game, ordered by domain code. The own profile lists every one; a foreign
   * profile lists those shared with a Group the caller belongs to, with all eligible Groups or publicly, exactly like
   * the profile entries above. Empty when nothing is visible.
   */
  toplists?: Maybe<Array<Toplist>>;
  userRank?: Maybe<UserRank>;
  website?: Maybe<Scalars['String']['output']>;
  workingTimeModel?: Maybe<WorkingTimeModel>;
  zipCode?: Maybe<Scalars['String']['output']>;
};


export type PersonAlternativeAvatarArgs = {
  profile: Scalars['String']['input'];
};


export type PersonAvatarArgs = {
  profile: Scalars['String']['input'];
  useAlternative: Scalars['Boolean']['input'];
};

export type PersonConnection = {
  __typename?: 'PersonConnection';
  edges: Array<PersonEdge>;
  nodes: Array<Person>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/**
 * Proposed change to a profile field. `existingValue` is the current value and `incomingValue` the
 * proposed value; either can be null when absent. `key` identifies the field, for example "bio".
 * Blank or absent incoming values do not propose destructive replacement. `additive` means the
 * incoming value includes existing set members, for example citizenships, rather than replacing them.
 */
export type PersonDetailFieldDiff = {
  __typename?: 'PersonDetailFieldDiff';
  action: ImportDiffAction;
  additive: Scalars['Boolean']['output'];
  existingValue?: Maybe<Scalars['String']['output']>;
  field: Scalars['String']['output'];
  incomingValue?: Maybe<Scalars['String']['output']>;
  key: Scalars['String']['output'];
};

/** The filterable fields of type PersonDetailFieldDiff */
export type PersonDetailFieldDiffFilterInput = {
  and?: InputMaybe<Array<PersonDetailFieldDiffFilterInput>>;
  not?: InputMaybe<PersonDetailFieldDiffFilterInput>;
  or?: InputMaybe<Array<PersonDetailFieldDiffFilterInput>>;
};

export type PersonEdge = {
  __typename?: 'PersonEdge';
  cursor: Scalars['String']['output'];
  node: Person;
};

/** The filterable fields of type Person */
export type PersonFilterInput = {
  ageInYears?: InputMaybe<IntFilterInput>;
  and?: InputMaybe<Array<PersonFilterInput>>;
  childCount?: InputMaybe<IntFilterInput>;
  citizenships?: InputMaybe<CountryListFilterInput>;
  city?: InputMaybe<StringFilterInput>;
  contractType?: InputMaybe<ContractTypeFilterInput>;
  country?: InputMaybe<CountryFilterInput>;
  countryState?: InputMaybe<CountryStateFilterInput>;
  experiences?: InputMaybe<ExperienceListFilterInput>;
  expertises?: InputMaybe<ExpertiseListFilterInput>;
  formattedName?: InputMaybe<StringFilterInput>;
  gender?: InputMaybe<GenderFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  isContact?: InputMaybe<BooleanFilterInput>;
  isInAnyPersonGroup?: InputMaybe<BooleanFilterInput>;
  isInAnyPinGroup?: InputMaybe<BooleanFilterInput>;
  isPinned?: InputMaybe<BooleanFilterInput>;
  jobDepartment?: InputMaybe<JobDepartmentFilterInput>;
  jobLocation?: InputMaybe<JobLocationFilterInput>;
  jobTitle?: InputMaybe<StringFilterInput>;
  languageSkills?: InputMaybe<LanguageSkillListFilterInput>;
  maritalStatus?: InputMaybe<MaritalStatusFilterInput>;
  name?: InputMaybe<HumanNameFilterInput>;
  nationality?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<PersonFilterInput>;
  or?: InputMaybe<Array<PersonFilterInput>>;
  personGroupId?: InputMaybe<UuidFilterInput>;
  pinGroupId?: InputMaybe<UuidFilterInput>;
  workingTimeModel?: InputMaybe<WorkingTimeModelFilterInput>;
};

export type PersonGroup = Category & Node & {
  __typename?: 'PersonGroup';
  id: Scalars['ID']['output'];
  itemCount?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
};

/** The filterable fields of type PersonGroup */
export type PersonGroupFilterInput = {
  and?: InputMaybe<Array<PersonGroupFilterInput>>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<PersonGroupFilterInput>;
  or?: InputMaybe<Array<PersonGroupFilterInput>>;
};

export type PersonGroupInput = {
  person?: InputMaybe<Scalars['String']['input']>;
};

export type PersonGroupMembershipInput = {
  personId: Scalars['UUID']['input'];
};

export type PersonGroupMembershipOutput = PersonGroupMembershipResult;

export type PersonGroupMembershipResult = {
  __typename?: 'PersonGroupMembershipResult';
  personGroups: Array<PersonGroup>;
};

/** The filterable fields of type PersonGroupMembershipResult */
export type PersonGroupMembershipResultFilterInput = {
  and?: InputMaybe<Array<PersonGroupMembershipResultFilterInput>>;
  not?: InputMaybe<PersonGroupMembershipResultFilterInput>;
  or?: InputMaybe<Array<PersonGroupMembershipResultFilterInput>>;
};

export type PersonGroupOutput = PersonGroupResult;

export type PersonGroupRecipient = Node & Recipient & {
  __typename?: 'PersonGroupRecipient';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

/** The filterable fields of type PersonGroupRecipient */
export type PersonGroupRecipientFilterInput = {
  and?: InputMaybe<Array<PersonGroupRecipientFilterInput>>;
  not?: InputMaybe<PersonGroupRecipientFilterInput>;
  or?: InputMaybe<Array<PersonGroupRecipientFilterInput>>;
};

export type PersonGroupResult = {
  __typename?: 'PersonGroupResult';
  personGroups: Array<PersonGroup>;
};

/** The filterable fields of type PersonGroupResult */
export type PersonGroupResultFilterInput = {
  and?: InputMaybe<Array<PersonGroupResultFilterInput>>;
  not?: InputMaybe<PersonGroupResultFilterInput>;
  or?: InputMaybe<Array<PersonGroupResultFilterInput>>;
};

export type PersonGroupSortInput = {
  name?: InputMaybe<SortOrder>;
};

export type PersonLean = {
  __typename?: 'PersonLean';
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
};

/** The filterable fields of type PersonLean */
export type PersonLeanFilterInput = {
  and?: InputMaybe<Array<PersonLeanFilterInput>>;
  not?: InputMaybe<PersonLeanFilterInput>;
  or?: InputMaybe<Array<PersonLeanFilterInput>>;
};

/** What the administrator may do with this row right now. The server re-checks regardless. */
export enum PersonLoginAction {
  /** Invite a person who has no account binding. */
  Invite = 'INVITE',
  /** Resend a previous invitation; current account eligibility is checked again. */
  Resend = 'RESEND'
}

/**
 * Account binding and invitation status for one Person. `suggestedEmail` is the person's saved
 * address, or null for a reserved placeholder; it is not a confirmed invitation recipient.
 * `invitationEmail` is the recipient used for the last invitation and requires `provision:invitee`.
 */
export type PersonLoginAssignment = Node & {
  __typename?: 'PersonLoginAssignment';
  /** What this row offers now. Empty for a row whose state does not permit anything. */
  actions: Array<PersonLoginAction>;
  /** First authenticated Genesis access observed since tracking began. Null means no access recorded, not an unaccepted invitation. */
  firstAuthenticatedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  /** The recipient of the last invitation request. Administrators only. */
  invitationEmail?: Maybe<Scalars['String']['output']>;
  /** The last invitation attempt's step, or null when this Person was never invited from here. */
  invitationStep?: Maybe<PersonLoginInvitationStep>;
  /** Invitation history, newest first. Every page is authorized against the target person. */
  invitations: PersonLoginInvitationConnection;
  lastInvitation?: Maybe<PersonLoginInvitation>;
  /** The Person's formatted name. */
  name: Scalars['String']['output'];
  personId: Scalars['UUID']['output'];
  status: PersonLoginStatus;
  /** A suggested recipient address requiring confirmation. Null when the stored address is a placeholder or missing. */
  suggestedEmail?: Maybe<Scalars['String']['output']>;
};


/**
 * Account binding and invitation status for one Person. `suggestedEmail` is the person's saved
 * address, or null for a reserved placeholder; it is not a confirmed invitation recipient.
 * `invitationEmail` is the recipient used for the last invitation and requires `provision:invitee`.
 */
export type PersonLoginAssignmentInvitationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};

/** A page of visible active people and their account bindings. No total count is returned. */
export type PersonLoginAssignmentConnection = {
  __typename?: 'PersonLoginAssignmentConnection';
  nodes: Array<PersonLoginAssignment>;
  pageInfo: PageInfo;
};

/** The filterable fields of type PersonLoginAssignmentConnection */
export type PersonLoginAssignmentConnectionFilterInput = {
  and?: InputMaybe<Array<PersonLoginAssignmentConnectionFilterInput>>;
  not?: InputMaybe<PersonLoginAssignmentConnectionFilterInput>;
  or?: InputMaybe<Array<PersonLoginAssignmentConnectionFilterInput>>;
};

/** The filterable fields of type PersonLoginAssignment */
export type PersonLoginAssignmentFilterInput = {
  and?: InputMaybe<Array<PersonLoginAssignmentFilterInput>>;
  not?: InputMaybe<PersonLoginAssignmentFilterInput>;
  or?: InputMaybe<Array<PersonLoginAssignmentFilterInput>>;
};

/** One person's saved account binding. */
export type PersonLoginAssignmentInput = {
  personId: Scalars['UUID']['input'];
};

/** Filter and page the login-assignment list. Filters are applied before paging. */
export type PersonLoginAssignmentsInput = {
  /** Cursor from a previous page's `pageInfo.endCursor`. */
  after?: InputMaybe<Scalars['String']['input']>;
  /** Page size, 1..100. Omitted means 25. */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** Matches the Person's names and their stored address. Trimmed; blank means no search. */
  search?: InputMaybe<Scalars['String']['input']>;
  /** Restrict to these states. Omitted or empty means every state. */
  status?: InputMaybe<Array<PersonLoginStatus>>;
};

/** One invitation request. sentAt means identity provider accepted the send, not delivery or onboarding completion. */
export type PersonLoginInvitation = {
  __typename?: 'PersonLoginInvitation';
  operation: PersonLoginInvitationOperation;
  outcome?: Maybe<PersonLoginInvitationOutcome>;
  recipient: Scalars['String']['output'];
  requestId: Scalars['UUID']['output'];
  requestedAt: Scalars['DateTime']['output'];
  requestedBy: Scalars['UUID']['output'];
  sentAt?: Maybe<Scalars['DateTime']['output']>;
  step: PersonLoginInvitationStep;
};

export type PersonLoginInvitationConnection = {
  __typename?: 'PersonLoginInvitationConnection';
  nodes: Array<PersonLoginInvitation>;
  pageInfo: PageInfo;
};

/** The filterable fields of type PersonLoginInvitationConnection */
export type PersonLoginInvitationConnectionFilterInput = {
  and?: InputMaybe<Array<PersonLoginInvitationConnectionFilterInput>>;
  not?: InputMaybe<PersonLoginInvitationConnectionFilterInput>;
  or?: InputMaybe<Array<PersonLoginInvitationConnectionFilterInput>>;
};

/** The filterable fields of type PersonLoginInvitation */
export type PersonLoginInvitationFilterInput = {
  and?: InputMaybe<Array<PersonLoginInvitationFilterInput>>;
  not?: InputMaybe<PersonLoginInvitationFilterInput>;
  or?: InputMaybe<Array<PersonLoginInvitationFilterInput>>;
};

export enum PersonLoginInvitationOperation {
  Invite = 'INVITE',
  Resend = 'RESEND'
}

/** What the invitation actually did. Every value is a normal business result, not an error. */
export enum PersonLoginInvitationOutcome {
  /** The account changed under us (established, disabled or re-bound). Nothing was sent. */
  AccountChanged = 'ACCOUNT_CHANGED',
  /** The Person already has a login. Nothing was created, changed or sent. */
  AlreadyAssigned = 'ALREADY_ASSIGNED',
  /**
   * Creating the account ended ambiguously: an account may or may not exist at the identity provider, nothing is bound
   * and nothing was sent. Needs a fresh check by a human; a blind repeat is what produces the second
   * account.
   */
  CreateUncertain = 'CREATE_UNCERTAIN',
  /** Another account already uses this address. No merge happens by email; nothing was changed. */
  EmailConflict = 'EMAIL_CONFLICT',
  /** A new account was created, bound to this Person, and the onboarding link sent. */
  Invited = 'INVITED',
  /** The pending invitation's recipient was changed and the link sent to the new address. */
  RecipientUpdated = 'RECIPIENT_UPDATED',
  /** A still-pending invitation was re-sent to the same address. */
  Resent = 'RESENT',
  /**
   * The identity provider refused the email request. Nothing was delivered and the binding stands, so a resend is the repair -
   * this is the one failure that may safely be repeated.
   */
  SendFailed = 'SEND_FAILED',
  /**
   * The binding is durable but the send ended ambiguously. It may well have arrived, so the client must
   * report the uncertainty for operational repair; automatic replay is blocked.
   */
  SendUncertain = 'SEND_UNCERTAIN'
}

/** The invitation's result together with the refreshed row, so a client need not re-query. */
export type PersonLoginInvitationOutput = {
  __typename?: 'PersonLoginInvitationOutput';
  assignment: PersonLoginAssignment;
  outcome: PersonLoginInvitationOutcome;
};

/** The filterable fields of type PersonLoginInvitationOutput */
export type PersonLoginInvitationOutputFilterInput = {
  and?: InputMaybe<Array<PersonLoginInvitationOutputFilterInput>>;
  not?: InputMaybe<PersonLoginInvitationOutputFilterInput>;
  or?: InputMaybe<Array<PersonLoginInvitationOutputFilterInput>>;
};

/** How far the last invitation attempt for this Person got. A dispatch record, never proof of a login. */
export enum PersonLoginInvitationStep {
  /** An identity provider account was created but is not yet bound to the Person. */
  AccountCreated = 'ACCOUNT_CREATED',
  /** The account is bound to the Person; the mail has not gone out yet. */
  Bound = 'BOUND',
  /** Finished without sending an invitation, for example because of an email conflict. */
  Completed = 'COMPLETED',
  /** An external write is in flight or ambiguous. Requires operational repair, never automatic replay. */
  OutcomeUncertain = 'OUTCOME_UNCERTAIN',
  /** The attempt is claimed with a confirmed recipient; nothing has been created yet. */
  Reserved = 'RESERVED',
  /** Sending failed in a way that says it did not happen. Resend is safe. */
  SendFailed = 'SEND_FAILED',
  /** identity provider accepted the onboarding email. */
  Sent = 'SENT'
}

/** Account association stored by Genesis. This does not describe onboarding or account enablement. */
export enum PersonLoginStatus {
  /** The person has an account subject. */
  Assigned = 'ASSIGNED',
  /** The person has no account binding. */
  Unassigned = 'UNASSIGNED'
}

/** The parameters for requesting multiple instances of Person. Mixing fields of cursor-based and offset-based pagination will result in an error. */
export type PersonQueryInput = {
  /** Cursor-based pagination: The immediate successor of this cursor will be the first entry of the requested page */
  after?: InputMaybe<Scalars['String']['input']>;
  /** Cursor-based pagination: The immediate predecessor of this cursor will be last entry of the requested page */
  before?: InputMaybe<Scalars['String']['input']>;
  /** Cursor-based pagination: Number of rows to be returned. Use in conjunction with 'after' */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** Cursor-based pagination: Number of rows to be returned. Use in conjunction with 'before' */
  last?: InputMaybe<Scalars['Int']['input']>;
  /** The sorting order of the instances */
  order?: InputMaybe<PersonSortInput>;
  /** Offset-based pagination: Number of rows to skip */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Offset-based pagination: Number of rows to be returned */
  take?: InputMaybe<Scalars['Int']['input']>;
  /** The filter to be applied */
  where?: InputMaybe<PersonFilterInput>;
};

export type PersonRecipient = Node & Recipient & {
  __typename?: 'PersonRecipient';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  personName?: Maybe<HumanName>;
  thumbnail?: Maybe<File>;
};


export type PersonRecipientThumbnailArgs = {
  profile: Scalars['String']['input'];
  useAlternative: Scalars['Boolean']['input'];
};

/** The filterable fields of type PersonRecipient */
export type PersonRecipientFilterInput = {
  and?: InputMaybe<Array<PersonRecipientFilterInput>>;
  not?: InputMaybe<PersonRecipientFilterInput>;
  or?: InputMaybe<Array<PersonRecipientFilterInput>>;
};

/** Contains information for linking 'Person' to other entities */
export type PersonRelationInput = {
  /** The identifier of 'Person' */
  id: Scalars['ID']['input'];
};

export enum PersonSearchScope {
  Identity = 'IDENTITY',
  Profile = 'PROFILE'
}

export type PersonSharedAttributes = {
  __typename?: 'PersonSharedAttributes';
  sharedAge?: Maybe<Array<Scalars['String']['output']>>;
  sharedApartmentNumber?: Maybe<Array<Scalars['String']['output']>>;
  sharedBio?: Maybe<Array<Scalars['String']['output']>>;
  sharedBirthdate?: Maybe<Array<Scalars['String']['output']>>;
  sharedChildCount?: Maybe<Array<Scalars['String']['output']>>;
  sharedCitizenships?: Maybe<Array<Scalars['String']['output']>>;
  sharedCity?: Maybe<Array<Scalars['String']['output']>>;
  sharedContractType?: Maybe<Array<Scalars['String']['output']>>;
  sharedCountry?: Maybe<Array<Scalars['String']['output']>>;
  sharedCurrentActivity?: Maybe<Array<Scalars['String']['output']>>;
  sharedCurrentEmployer?: Maybe<Array<Scalars['String']['output']>>;
  sharedCurrentTasks?: Maybe<Array<Scalars['String']['output']>>;
  sharedDriversLicense?: Maybe<Array<Scalars['String']['output']>>;
  sharedEmail?: Maybe<Array<Scalars['String']['output']>>;
  sharedGender?: Maybe<Array<Scalars['String']['output']>>;
  sharedHouseNumber?: Maybe<Array<Scalars['String']['output']>>;
  sharedMaritalStatus?: Maybe<Array<Scalars['String']['output']>>;
  sharedMiscellaneous?: Maybe<Array<Scalars['String']['output']>>;
  sharedNationality?: Maybe<Array<Scalars['String']['output']>>;
  sharedPhone?: Maybe<Array<Scalars['String']['output']>>;
  /** Recipient Group IDs for powers consent. An empty list selects no recipients. */
  sharedPowers?: Maybe<Array<Scalars['String']['output']>>;
  sharedProfession?: Maybe<Array<Scalars['String']['output']>>;
  sharedState?: Maybe<Array<Scalars['String']['output']>>;
  sharedStreet?: Maybe<Array<Scalars['String']['output']>>;
  sharedWebsite?: Maybe<Array<Scalars['String']['output']>>;
  sharedWorkingTimeModel?: Maybe<Array<Scalars['String']['output']>>;
  sharedZipCode?: Maybe<Array<Scalars['String']['output']>>;
};

/** The filterable fields of type PersonSharedAttributes */
export type PersonSharedAttributesFilterInput = {
  and?: InputMaybe<Array<PersonSharedAttributesFilterInput>>;
  not?: InputMaybe<PersonSharedAttributesFilterInput>;
  or?: InputMaybe<Array<PersonSharedAttributesFilterInput>>;
};

export type PersonSortInput = {
  contactSince?: InputMaybe<SortOrder>;
  formattedName?: InputMaybe<SortOrder>;
  name?: InputMaybe<HumanNameSortInput>;
};

export type PersonWithDate = {
  __typename?: 'PersonWithDate';
  dateTime: Scalars['DateTime']['output'];
  person: Person;
};

/** The filterable fields of type PersonWithDate */
export type PersonWithDateFilterInput = {
  and?: InputMaybe<Array<PersonWithDateFilterInput>>;
  not?: InputMaybe<PersonWithDateFilterInput>;
  or?: InputMaybe<Array<PersonWithDateFilterInput>>;
};

/** The caller's Group choices, including selected Groups retired from the recipient picker. */
export type PersonalSharing = {
  __typename?: 'PersonalSharing';
  /** Attribute names (for example sharedEmail) explicitly shared with all current and future eligible Groups. */
  allGroupsAttributes: Array<Scalars['String']['output']>;
  /** Each list contains Group IDs. An empty or null list means no ordinary third-party consent. */
  attributes: PersonSharedAttributes;
  recipients: Array<PersonalSharingRecipient>;
};

/** The filterable fields of type PersonalSharing */
export type PersonalSharingFilterInput = {
  and?: InputMaybe<Array<PersonalSharingFilterInput>>;
  not?: InputMaybe<PersonalSharingFilterInput>;
  or?: InputMaybe<Array<PersonalSharingFilterInput>>;
};

/** A named Group available for personal attribute sharing. Eligibility itself grants no access. */
export type PersonalSharingRecipient = {
  __typename?: 'PersonalSharingRecipient';
  eligible: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

/** The filterable fields of type PersonalSharingRecipient */
export type PersonalSharingRecipientFilterInput = {
  and?: InputMaybe<Array<PersonalSharingRecipientFilterInput>>;
  not?: InputMaybe<PersonalSharingRecipientFilterInput>;
  or?: InputMaybe<Array<PersonalSharingRecipientFilterInput>>;
};

export type PinGroup = Category & Node & {
  __typename?: 'PinGroup';
  id: Scalars['ID']['output'];
  itemCount?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  pinType: PinType;
};

/** The filterable fields of type PinGroup */
export type PinGroupFilterInput = {
  and?: InputMaybe<Array<PinGroupFilterInput>>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<PinGroupFilterInput>;
  or?: InputMaybe<Array<PinGroupFilterInput>>;
};

export type PinGroupInput = {
  person?: InputMaybe<Scalars['String']['input']>;
  pinTypes?: InputMaybe<Array<PinType>>;
};

export type PinGroupMembershipInput = {
  personId?: InputMaybe<Scalars['UUID']['input']>;
  sharedItemId?: InputMaybe<Scalars['UUID']['input']>;
};

export type PinGroupMembershipOutput = PinGroupMembershipResult;

export type PinGroupMembershipResult = {
  __typename?: 'PinGroupMembershipResult';
  pinGroups: Array<PinGroup>;
};

/** The filterable fields of type PinGroupMembershipResult */
export type PinGroupMembershipResultFilterInput = {
  and?: InputMaybe<Array<PinGroupMembershipResultFilterInput>>;
  not?: InputMaybe<PinGroupMembershipResultFilterInput>;
  or?: InputMaybe<Array<PinGroupMembershipResultFilterInput>>;
};

export type PinGroupOutput = PinGroupResult;

export type PinGroupResult = {
  __typename?: 'PinGroupResult';
  pinGroups: Array<PinGroup>;
};

/** The filterable fields of type PinGroupResult */
export type PinGroupResultFilterInput = {
  and?: InputMaybe<Array<PinGroupResultFilterInput>>;
  not?: InputMaybe<PinGroupResultFilterInput>;
  or?: InputMaybe<Array<PinGroupResultFilterInput>>;
};

export type PinGroupSortInput = {
  name?: InputMaybe<SortOrder>;
};

export enum PinType {
  Person = 'PERSON',
  Post = 'POST',
  Project = 'PROJECT'
}

export type PlayableGrowElement = {
  lengthMilliseconds?: Maybe<Scalars['Int']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<LocalizedText>;
};

/** The filterable fields of type PlayableGrowElement */
export type PlayableGrowElementFilterInput = {
  and?: InputMaybe<Array<PlayableGrowElementFilterInput>>;
  not?: InputMaybe<PlayableGrowElementFilterInput>;
  or?: InputMaybe<Array<PlayableGrowElementFilterInput>>;
};

/**
 * How central a power is in the documents of the analysis that scored it, compared with the person's other powers
 * scored there: PRIMARY the most central (ranks 1-2), SECONDARY the next ones (ranks 3-6), BACKGROUND the rest. A
 * document analysis scores far more powers than a document clearly shows; PRIMARY and SECONDARY are the ones it shows.
 */
export enum PowerTier {
  Background = 'BACKGROUND',
  Primary = 'PRIMARY',
  Secondary = 'SECONDARY'
}

export type PowersDevStat = {
  __typename?: 'PowersDevStat';
  currentValue: Scalars['Int']['output'];
  element: CreativityElement;
  person?: Maybe<PersonLean>;
  previousValue: Scalars['Int']['output'];
};

/** The filterable fields of type PowersDevStat */
export type PowersDevStatFilterInput = {
  and?: InputMaybe<Array<PowersDevStatFilterInput>>;
  not?: InputMaybe<PowersDevStatFilterInput>;
  or?: InputMaybe<Array<PowersDevStatFilterInput>>;
};

export type PresenceIndicator = {
  __typename?: 'PresenceIndicator';
  conversationId: Scalars['UUID']['output'];
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  observedAt: Scalars['DateTime']['output'];
  online: Scalars['Boolean']['output'];
  personId: Scalars['UUID']['output'];
};

/** The filterable fields of type PresenceIndicator */
export type PresenceIndicatorFilterInput = {
  and?: InputMaybe<Array<PresenceIndicatorFilterInput>>;
  not?: InputMaybe<PresenceIndicatorFilterInput>;
  or?: InputMaybe<Array<PresenceIndicatorFilterInput>>;
};

export type PreviewListingApplicationMailInput = {
  applicationId: Scalars['UUID']['input'];
  /** INTERVIEW template drafts only: appointment details on one line, at most 200 characters. */
  appointment?: InputMaybe<Scalars['String']['input']>;
  /**
   * Null together with a null `subject` uses the template draft. Otherwise the edited body is sent exactly as
   * supplied.
   */
  body?: InputMaybe<Scalars['String']['input']>;
  /** A kind from `actions.mailKinds`. RECEIPT is rejected like any other unavailable kind. */
  kind: ListingApplicationMailKind;
  /** INTERVIEW template drafts only: HTTPS meeting link, at most 500 characters. */
  meetingLink?: InputMaybe<Scalars['String']['input']>;
  /**
   * Null together with a null `body` uses the template draft. Otherwise the edited subject is sent exactly as
   * supplied.
   */
  subject?: InputMaybe<Scalars['String']['input']>;
};

export type ProcessDocumentInput = {
  content?: InputMaybe<Scalars['Binary']['input']>;
  documentId?: InputMaybe<Scalars['UUID']['input']>;
  fileName: Scalars['String']['input'];
};

export type ProcessDocumentsInput = {
  /**
   * Supply between 1 and 10 documents. Empty lists and lists exceeding 10 documents are rejected
   * with a validation error.
   */
  documents: Array<ProcessDocumentInput>;
  extractPowers: Scalars['Boolean']['input'];
  extractProfile: Scalars['Boolean']['input'];
  extractSkills: Scalars['Boolean']['input'];
};

export type ProcessDocumentsOutput = ProcessDocumentsResult;

export type ProcessDocumentsResult = {
  __typename?: 'ProcessDocumentsResult';
  documents: Array<ProcessedDocumentResult>;
  /** First fatal message of the run. Diagnostic — not user-facing copy. */
  message?: Maybe<Scalars['String']['output']>;
  /** Overall: `success`, `partial` (some documents unusable, some not) or `error` (all unusable). */
  status: Scalars['String']['output'];
  /** Non-fatal pipeline diagnostics. Diagnostic — not user-facing copy. */
  warnings?: Maybe<Array<Scalars['String']['output']>>;
};

/** The filterable fields of type ProcessDocumentsResult */
export type ProcessDocumentsResultFilterInput = {
  and?: InputMaybe<Array<ProcessDocumentsResultFilterInput>>;
  not?: InputMaybe<ProcessDocumentsResultFilterInput>;
  or?: InputMaybe<Array<ProcessDocumentsResultFilterInput>>;
};

/**
 * What one extraction run did with one document. The list of these is the run's only accounting —
 * there are no per-pipeline totals beside it, so a caller that wants a summary counts this list.
 */
export type ProcessedDocumentResult = {
  __typename?: 'ProcessedDocumentResult';
  documentId?: Maybe<Scalars['UUID']['output']>;
  /** File name at the time of the run, also for documents sent as `content` and never stored. */
  fileName?: Maybe<Scalars['String']['output']>;
  ref: Scalars['String']['output'];
  /**
   * One of `analysed` (evidence was found in this document), `already_analysed` (evidence for it
   * existed before this run), `nothing_found` (read, contributed no evidence — the next run offers it
   * again), `unreadable` (no text could be extracted) or `failed` (the extraction call, the
   * persistence, or the job deadline ended it). Treat an unknown value as `failed`.
   */
  status: Scalars['String']['output'];
};

/** The filterable fields of type ProcessedDocumentResult */
export type ProcessedDocumentResultFilterInput = {
  and?: InputMaybe<Array<ProcessedDocumentResultFilterInput>>;
  not?: InputMaybe<ProcessedDocumentResultFilterInput>;
  or?: InputMaybe<Array<ProcessedDocumentResultFilterInput>>;
};

/** Selects the areas included in a self-service YAML export. At least one area must be selected. */
export type ProfileExportInput = {
  /** The caller's document groups, documents, metadata, tags and file content. Without `profile`, the target Person must already exist when this YAML is imported. */
  documents?: Scalars['Boolean']['input'];
  /** Core profile, details, portraits, experiences, educations, expertises, language skills and certificates. */
  profile?: Scalars['Boolean']['input'];
};

/**
 * Non-destructive preview of a profile import — nothing is written. The importer fetches
 * and maps the source (LinkedIn) data, diffs it against the caller's existing profile, and
 * returns the per-field / per-row diff. The client reviews and edits the proposals, then
 * persists the accepted ones through the ordinary profile mutations (updatePerson,
 * createExperience, …) — the same write path as manual editing. Genesis holds no import
 * state between preview and save.
 */
export type ProfileImportPreview = {
  __typename?: 'ProfileImportPreview';
  certificates: CollectionDiff;
  educations: CollectionDiff;
  experiences: CollectionDiff;
  expertises: CollectionDiff;
  languageSkills: CollectionDiff;
  personDetail: Array<PersonDetailFieldDiff>;
  warnings: Array<Scalars['String']['output']>;
};

/** The filterable fields of type ProfileImportPreview */
export type ProfileImportPreviewFilterInput = {
  and?: InputMaybe<Array<ProfileImportPreviewFilterInput>>;
  not?: InputMaybe<ProfileImportPreviewFilterInput>;
  or?: InputMaybe<Array<ProfileImportPreviewFilterInput>>;
};

/** One fact under a stage: a key plus numbers, never a sentence. */
export type ProgressDetail = {
  __typename?: 'ProgressDetail';
  count?: Maybe<Scalars['Int']['output']>;
  key: ProgressDetailKey;
  total?: Maybe<Scalars['Int']['output']>;
};

/** The filterable fields of type ProgressDetail */
export type ProgressDetailFilterInput = {
  and?: InputMaybe<Array<ProgressDetailFilterInput>>;
  not?: InputMaybe<ProgressDetailFilterInput>;
  or?: InputMaybe<Array<ProgressDetailFilterInput>>;
};

/** Facts an operation may report under a stage. A closed vocabulary like ProgressStage. */
export enum ProgressDetailKey {
  /** count = candidate assessments that failed. */
  MatchAssessmentsFailed = 'MATCH_ASSESSMENTS_FAILED',
  /** count = candidates in the pool. */
  MatchCandidatesLoaded = 'MATCH_CANDIDATES_LOADED',
  /** count = checks that needed an AI decision so far. */
  MatchChecksWithAi = 'MATCH_CHECKS_WITH_AI',
  /** count = companies in the pool. */
  MatchCompaniesLoaded = 'MATCH_COMPANIES_LOADED',
  /** count = active criteria. */
  MatchCriteriaActive = 'MATCH_CRITERIA_ACTIVE',
  /** count = candidates whose residence was resolved, total = candidates. */
  MatchLocationsResolved = 'MATCH_LOCATIONS_RESOLVED'
}

/**
 * Stages an operation may report. A closed vocabulary: the server sends the key, clients word it. Each
 * key is prefixed by the operation that reports it.
 */
export enum ProgressStage {
  /** Assess each candidate with AI (RANK with AI only); counts completed assessments, including failures reported separately under MATCH_ASSESSMENTS_FAILED. */
  MatchAssessment = 'MATCH_ASSESSMENT',
  /** Check every candidate against every active criterion; counts candidate x criterion checks. */
  MatchCriteria = 'MATCH_CRITERIA',
  /** Build the result and store it as the unsaved draft. */
  MatchFinalize = 'MATCH_FINALIZE',
  /** Load the match, its candidates and their profiles. */
  MatchPrepare = 'MATCH_PREPARE',
  /** Compose the teams with the solver (OPTIMIZE only). */
  MatchSolve = 'MATCH_SOLVE'
}

/**
 * One stage of an operation's progress. total is set only when the denominator was known before the
 * stage's work began and never changes afterwards; null means indeterminate. done never decreases.
 */
export type ProgressStageState = {
  __typename?: 'ProgressStageState';
  /** Facts of this stage, not a log: a key appears once and updates in place. */
  details: Array<ProgressDetail>;
  done?: Maybe<Scalars['Int']['output']>;
  key: ProgressStage;
  status: ProgressStageStatus;
  total?: Maybe<Scalars['Int']['output']>;
};

/** The filterable fields of type ProgressStageState */
export type ProgressStageStateFilterInput = {
  and?: InputMaybe<Array<ProgressStageStateFilterInput>>;
  not?: InputMaybe<ProgressStageStateFilterInput>;
  or?: InputMaybe<Array<ProgressStageStateFilterInput>>;
};

/** State of one stage of an operation's progress. */
export enum ProgressStageStatus {
  Active = 'ACTIVE',
  Done = 'DONE',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Skipped = 'SKIPPED'
}

/**
 * An undertaking with planning data, requirements, linked matches and a timeline. Creating requires
 * `feature:share.projects`; existing own and shared projects remain readable without that feature. Deleting
 * permanently removes the project, its access grants and its match links but preserves the matches. A personal
 * project can be deleted only by its creator; a company project only by a current admin acting as its company.
 * Inactive companies freeze their projects. Project operations serve ordinary projects only. Listings are read
 * and written through `Listing`; `project(id)` with a listing id responds as for an unknown id.
 */
export type Project = Node & {
  __typename?: 'Project';
  /**
   * Complete replacement of project access grants on update. Omitted or null preserves them; an empty
   * list removes them. A personal project's creator always retains WRITE on all surfaces and supplied
   * entries for that creator are ignored. A company project's creator has no such protected grant.
   */
  access?: Maybe<Array<ProjectAccess>>;
  actions: ProjectActions;
  /**
   * Company owning the project, or null for a personal project. Set only at creation, by an admin of
   * an active company; ownership cannot later change. Company admins can read the project and, acting
   * as the company, change or delete it. Other access grants remain independent. Inactive companies
   * freeze project writes. `createdBy` identifies the creator without granting company administration.
   */
  company?: Maybe<Company>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<Person>;
  /**
   *   Planning data as a JSON object. Updates merge top-level keys; supplied values replace complete
   *   nested objects or lists, and omitted keys remain unchanged. Null or an empty object leaves existing
   *   keys unchanged. Explicit null values inside the object are retained. New objects default to
   *   `version: 1` when version is omitted.
   *
   * Common members are `anlass` and `status` (strings), `sections` (string list), `packages` and `events`
   *   (lists), `requirements` (object), and `documentStorageIds` (UUID string list). Packages contain
   *   id, name, start, end and tasks; tasks contain id, title, assigneeId, start and end. Events contain
   *   id, title, date and kind. Dates use YYYY-MM-DD. Requirements can contain expertise entries
   *   (id, description, level, requirement, personCount) and elementWeights keyed by CreativityElement.
   *   Expertise level uses 1–7, or 0 for no minimum; requirement is MUST or OPTIONAL. Power weights use
   *   0–1000. Additional client-defined members are retained. Links in this object are not validated as
   *   relationships; use `linkProjectMatch` for match relationships.
   *
   * Example: {"version":1,"packages":[],"events":[],"requirements":{"expertise":[],"elementWeights":{}}}.
   */
  data?: Maybe<Scalars['Object']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  matches?: Maybe<Array<Match>>;
  name?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<Person>;
};

/**
 * A person's access levels for a project. Personal project creators, listed people and company project admins
 * can read the project. WRITE on `plan` permits project edits and match linking; `candidates` and `timeline`
 * are reported separately but do not currently have independent write gates. The `applications` area belongs
 * exclusively to listings and is absent here. Levels on another project's kind of area grant no rights and
 * cannot be written.
 */
export type ProjectAccess = {
  __typename?: 'ProjectAccess';
  /** Who is asked and who accepts. */
  candidates: AccessLevel;
  person: Person;
  /** Occasion, breakdown, classification, requirements. */
  plan: AccessLevel;
  /** Entries in the timeline - the editor role. */
  timeline: AccessLevel;
};

/** The filterable fields of type ProjectAccess */
export type ProjectAccessFilterInput = {
  and?: InputMaybe<Array<ProjectAccessFilterInput>>;
  not?: InputMaybe<ProjectAccessFilterInput>;
  or?: InputMaybe<Array<ProjectAccessFilterInput>>;
};

/**
 * What the caller may do on this project, following the pattern of `MatchActions`. The same rule
 * applies as for writing: `updateProject`, `linkProjectMatch` and `unlinkProjectMatch` require WRITE on
 * `plan`; the creator of a personal project always may, on a company project the company's admins may,
 * but only in the company context (`actingAsCompanyId`). For an inactive company everything is false.
 * The server does not check `candidates` and `timeline` separately, so there are no rights of their own
 * for them.
 */
export type ProjectActions = {
  __typename?: 'ProjectActions';
  /** The creator of a personal project, on a company project the company's admins; exactly what `deleteProject` checks. */
  canDelete: Scalars['Boolean']['output'];
  /** Change the access list (`updateProject` with `access`). */
  canManageAccess: Scalars['Boolean']['output'];
  /** Change name, description and planning; link and unlink matches. */
  canUpdate: Scalars['Boolean']['output'];
};

/** The filterable fields of type ProjectActions */
export type ProjectActionsFilterInput = {
  and?: InputMaybe<Array<ProjectActionsFilterInput>>;
  not?: InputMaybe<ProjectActionsFilterInput>;
  or?: InputMaybe<Array<ProjectActionsFilterInput>>;
};

export type ProjectConnection = {
  __typename?: 'ProjectConnection';
  edges: Array<ProjectEdge>;
  nodes: Array<Project>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ProjectEdge = {
  __typename?: 'ProjectEdge';
  cursor: Scalars['String']['output'];
  node: Project;
};

/** The filterable fields of type Project */
export type ProjectFilterInput = {
  and?: InputMaybe<Array<ProjectFilterInput>>;
  description?: InputMaybe<StringFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ProjectFilterInput>;
  or?: InputMaybe<Array<ProjectFilterInput>>;
};

/** The parameters for requesting multiple instances of Project. Mixing fields of cursor-based and offset-based pagination will result in an error. */
export type ProjectQueryInput = {
  /** Cursor-based pagination: The immediate successor of this cursor will be the first entry of the requested page */
  after?: InputMaybe<Scalars['String']['input']>;
  /** Cursor-based pagination: The immediate predecessor of this cursor will be last entry of the requested page */
  before?: InputMaybe<Scalars['String']['input']>;
  /** Cursor-based pagination: Number of rows to be returned. Use in conjunction with 'after' */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** Cursor-based pagination: Number of rows to be returned. Use in conjunction with 'before' */
  last?: InputMaybe<Scalars['Int']['input']>;
  /** The sorting order of the instances */
  order?: InputMaybe<ProjectSortInput>;
  /** Offset-based pagination: Number of rows to skip */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Offset-based pagination: Number of rows to be returned */
  take?: InputMaybe<Scalars['Int']['input']>;
  /** The filter to be applied */
  where?: InputMaybe<ProjectFilterInput>;
};

export type ProjectSortInput = {
  createdAt?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

/** A saved answer supplied by a Person; readable by its owner or an explicit personal-information override. */
export type ProvidedQuestionnaireAnswer = {
  __typename?: 'ProvidedQuestionnaireAnswer';
  answer: Scalars['String']['output'];
  answerChoiceId: Scalars['UUID']['output'];
  id: Scalars['ID']['output'];
  question: Scalars['String']['output'];
  questionId: Scalars['UUID']['output'];
  questionnaireId: Scalars['UUID']['output'];
  timeTakenMs: Scalars['Int']['output'];
};

/** The filterable fields of type ProvidedQuestionnaireAnswer */
export type ProvidedQuestionnaireAnswerFilterInput = {
  and?: InputMaybe<Array<ProvidedQuestionnaireAnswerFilterInput>>;
  not?: InputMaybe<ProvidedQuestionnaireAnswerFilterInput>;
  or?: InputMaybe<Array<ProvidedQuestionnaireAnswerFilterInput>>;
};

/** Input for provisionInvitee — a single email to provision as an external invitee. */
export type ProvisionInviteeInput = {
  /** Email address of the person to provision. Becomes the invitee's identity provider username. */
  email: Scalars['String']['input'];
};

/** Classification of what provisionInvitee did with the submitted email. */
export enum ProvisionInviteeOutcome {
  /** The email belongs to an established account; nothing was sent and the account was left untouched. */
  Conflict = 'CONFLICT',
  /** No such user existed: an enabled, credential-less invitee was created and a fresh onboarding link sent. */
  Created = 'CREATED',
  /** A still-pending invitee already existed (no credentials set): the link was re-sent (idempotent). */
  Resent = 'RESENT'
}

/** Result of provisionInvitee. */
export type ProvisionInviteeOutput = {
  __typename?: 'ProvisionInviteeOutput';
  outcome: ProvisionInviteeOutcome;
};

/** The filterable fields of type ProvisionInviteeOutput */
export type ProvisionInviteeOutputFilterInput = {
  and?: InputMaybe<Array<ProvisionInviteeOutputFilterInput>>;
  not?: InputMaybe<ProvisionInviteeOutputFilterInput>;
  or?: InputMaybe<Array<ProvisionInviteeOutputFilterInput>>;
};

export type QnrAnswerChoiceSaveInput = {
  answer: Scalars['String']['input'];
  position: Scalars['Int']['input'];
  qnrAnswerChoiceId?: InputMaybe<Scalars['UUID']['input']>;
  status?: InputMaybe<QuestionnaireStatus>;
  weight: Scalars['Int']['input'];
};

export type QnrQuestionSaveInput = {
  answerChoices: Array<QnrAnswerChoiceSaveInput>;
  creativityElement: CreativityElement;
  position: Scalars['Int']['input'];
  qnrQuestionId?: InputMaybe<Scalars['UUID']['input']>;
  question: Scalars['String']['input'];
  status?: InputMaybe<QuestionnaireStatus>;
};

export type Query = {
  __typename?: 'Query';
  accessGroup: AccessGroup;
  accessGroupMembers: AccessGroupMembersResult;
  /** Access administration only; each person appears once with all independent membership sources. */
  accessGroupRoleAssignments: Array<AccessGroupRoleAssignment>;
  /** Access administration only; bounded keyset pages of at most 50 groups. */
  accessGroups: AccessGroupsResult;
  /** Requires access-configuration administration permission. Does not change membership or configuration. */
  accessMembershipPolicy: AccessMembershipPolicy;
  /** Read-only Permission catalog, guarded by write:access-config. */
  accessPermissions: AccessPermissionsResult;
  accessPersonInspection: AccessPersonInspection;
  /** Bounded impact for a proposed Role edit. Groups and people each have independent 50-entry pages. */
  accessRoleImpact: AccessRoleImpact;
  /** Members of a Group receiving this Role. Loaded separately, 50 Persons per page, ordered by id. */
  accessRoleMembers: AccessRoleMembersResult;
  /** System and custom Roles with their Permission bundles, guarded by write:access-config. */
  accessRoles: AccessRolesResult;
  /** Returns ACTIVE questionnaires whose creativityElement equals the given value, each carrying a per-row flag indicating whether the current user has answered every ACTIVE question of that questionnaire. */
  activeQuestionnairesByElement: Array<QuestionnaireResult>;
  /** Returns ACTIVE questionnaires that have no creativityElement set, each carrying a per-row flag indicating whether the current user has answered every ACTIVE question of that questionnaire. */
  activeQuestionnairesWithoutElement: Array<QuestionnaireResult>;
  agent?: Maybe<Agent>;
  agents: AgentConnection;
  /** The catalogue the toplist game offers for a domain: its active items, best known first. */
  catalogItems: Array<CatalogItem>;
  companies: CompanyConnection;
  company: CompanyResult;
  /**
   * Requires compare:companies; uses the ordinary Company read and logo handling, but answers an unknown
   * company with a null company instead of an error.
   */
  companyComparison: CompanyResult;
  /** The expertise a company lists, alphabetically. Free text owned by that company — see CompanyCompetency. */
  companyCompetencies: CompanyCompetencyResult;
  /**
   *   Fingerprint of every company's expertise, including companies with no labels. Use it to identify
   *   changed labels before reading them through `companyCompetencies`. This result is not paginated.
   *
   * The hash is SHA-256 encoded as hexadecimal. Labels are sorted case-insensitively with a
   *   case-sensitive tie-break, joined with NUL and encoded as UTF-8. Case in label content is preserved,
   *   so a case-only rename changes the hash. A company with no labels hashes the empty string.
   */
  companyCompetencyHashes: CompanyCompetencyHashesResult;
  /**
   * All contact persons of a company, at most ten and not paginated. Uses the same visibility as
   * `companyMembers`: active members, excluding the system default account, regardless of personal
   * profile-sharing choices. An unknown company is an error.
   */
  companyContactPersons: CompanyContactPersonsResult;
  /**
   * Company identities and logos for at most 50 supplied ids. Inactive companies are included;
   * unknown ids are skipped. Larger lists are rejected.
   */
  companyIdentities: CompanyIdentitiesResult;
  /**
   * Active members of the specified company, visible to every authenticated caller independently of
   * members' profile-sharing choices. Inactive accounts and the system default account are excluded
   * before pagination and counting. An unknown company is an error. Use `companyContactPersons` for the
   * complete contact-person set, which may span multiple roster pages.
   */
  companyMembers: CompanyMembershipConnection;
  /**
   * Shared items owned by this company, excluding personal items authored by its members. Inactive
   * companies' items remain readable here, although excluded from search and frozen for writes.
   * Uses the same pagination, ordering and filters as `sharedItems`. Matches are not included.
   * Deleting an active company's shared item permanently removes it and its dependent content.
   */
  companyOwnedSharedItems: SharedItemConnection;
  contactPowersDevStats: Array<PowersDevStat>;
  contactsWithHighestScore: Array<ContactWithGrowScore>;
  /** Administrator-selected Groups available for new ordinary content shares. */
  contentSharingRecipients: Array<ContentSharingRecipient>;
  contractTypes: ContractTypesResult;
  conversation?: Maybe<Conversation>;
  conversationMessages: Array<ChatMessage>;
  conversationPresence: Array<PresenceIndicator>;
  conversationReadReceipts: Array<ConversationReadReceipt>;
  conversations: Array<Conversation>;
  countries: CountriesResult;
  countryState?: Maybe<CountryState>;
  countryStatesByCountry: CountryStatesByCountryResult;
  curriculumVitae?: Maybe<CurriculumVitae>;
  curriculumVitaes: CurriculumVitaeConnection;
  defaultCandidateAssessmentPrompt: Scalars['String']['output'];
  /** Configured default Groups for new content shares. */
  defaultContentSharingRecipients: Array<ContentSharingRecipient>;
  degrees: DegreesResult;
  discoveryCategories: DiscoveryCategoriesResult;
  document?: Maybe<Document>;
  documentGroup?: Maybe<DocumentGroup>;
  documentGroups: DocumentGroupOutput;
  /**
   * The text of one of the caller's OWN documents, page by page, as the documents extraction reads it:
   * OCR for PDFs and images, text extraction for office formats. The first read runs that extraction and
   * caches the pages per document; every later read comes from the cache without touching the file again.
   * Another person's document is refused as not found, whatever the caller's permissions.
   */
  documentText: DocumentText;
  documents: DocumentConnection;
  /**
   * Renders a draft of one language variant as it would be sent. Same gate as `emailTemplates`. Only the kinds Genesis
   * sends itself have language variants; the invitation keeps the client-side approximation, because Keycloak renders it.
   */
  emailTemplatePreview: EmailTemplatePreview;
  emailTemplates: Array<EmailTemplate>;
  /** Whether this installation permits external ESCO lookups. Stored references remain usable when disabled. */
  escoEnabled: Scalars['Boolean']['output'];
  /**
   * Returns up to 150 distinct essential and optional skills for one ESCO occupation, essential first.
   * Requires authentication. Sends only the occupation URI and language (de/en) as lookup input to the
   * external service. The URI must be an http://data.europa.eu/esco/occupation/{UUID} reference.
   * Returns UNAVAILABLE when lookups are disabled or unavailable; no profile is read or changed.
   */
  escoOccupationSkills: EscoSearchResult;
  /**
   * Searches ESCO occupations or skills for an authenticated caller. Sends the supplied search text and
   * language to the European Commission's ESCO service. No profile is read. Returns UNAVAILABLE if
   * lookups are disabled, temporarily busy, or the external service cannot be reached. Search text is
   * trimmed, limited to 200 characters, and yields EMPTY below two characters. Languages: de, en.
   */
  escoSearch: EscoSearchResult;
  /**
   * Exports the selected parts of the caller's own data as a multi-document YAML payload in
   * the importer format (see `importDocuments`). `profile` includes the Person document,
   * details, portraits and profile collections; `documents` includes DocumentGroups and
   * Documents with file content inline as base64. Every document carries `operation: merge`.
   * Contacts, group memberships and shared items are not part of the export. Note the
   * importer's admission limits (payload size, document count) when re-importing profiles
   * with many documents.
   */
  exportMyProfile: Scalars['String']['output'];
  /**
   * Returns the current status of a documents-extraction job started by the caller. Serves as
   * the polling fallback when the events subscription is unavailable, or when a job was
   * interrupted (e.g. by a deployment) and never emitted its terminal event, and the way back to a
   * finished run's result from its notification. Job state is retained for 30 days after the last
   * transition; older jobs report as not found.
   */
  extractionJob: ExtractionJob;
  /**
   * The supported feature catalog and each feature's explicit Role Permission.
   * Guarded by `write:access-config`; callers read their effective eligibility through reachableFeatures.
   */
  features: FeaturesResult;
  /** Returns all files belonging to one YAML import batch, in submission order. */
  fileImportBatch: Array<FileImportJob>;
  /**
   * Status of a file import started by the caller. Use the same id regardless of processing route.
   * Retention follows the route-specific job; expired jobs are reported as not found.
   */
  fileImportJob: FileImportJob;
  /** Every game of Grow · Play's catalogue, by key, and whether it is paused. Readable by every authenticated principal. */
  gameCatalog: Array<GameCatalogEntry>;
  genders: GendersResult;
  /** Full-text search across all indexed entity types with audience-based visibility filtering. */
  globalSearch: GlobalSearchOutput;
  growRanking: GrowRanking;
  growResource?: Maybe<GrowResource>;
  /** Returns a restorable YAML import progress/result snapshot owned by the caller. */
  importJob: ImportJob;
  /**
   * The accepted YAML import format: version, JSON Schema, Markdown and examples. This query does
   * not start or change an import job.
   */
  importSpecification: ImportSpecification;
  industries: IndustriesResult;
  jobDepartments: JobDepartmentsResult;
  jobLocations: JobLocationsResult;
  listing?: Maybe<Listing>;
  listingApplications: ListingApplicationConnection;
  /** Text of this listing's attached documents, with each document's ordinary access check. */
  listingRequirementDocuments: Array<DocumentText>;
  /** Editable listing requirements, normalized from legacy data without persisting. Requires PLAN write access. */
  listingRequirements: Listing;
  listings: ListingConnection;
  maritalStatuses: MaritalStatusesResult;
  match?: Maybe<Match>;
  matchCandidate?: Maybe<MatchCandidate>;
  matchCandidates: MatchCandidateConnection;
  matchCompanies: MatchCompanyConnection;
  matchCompany?: Maybe<MatchCompany>;
  /**
   * Returns the content of a document in this match's design.project.documents, with its stored name.
   * Requires match visibility and design-read access. Files outside this match are treated as not found.
   */
  matchProjectDocumentContent: File;
  matchResult?: Maybe<MatchResult>;
  matchResults: MatchResultConnection;
  matches: MatchConnection;
  microsoftCalendarConfiguration: MicrosoftCalendarConfiguration;
  microsoftCalendarConnection: MicrosoftCalendarConnection;
  microsoftCalendarView: MicrosoftCalendarView;
  myAvatar?: Maybe<File>;
  /**
   * The authenticated caller's own company memberships and roles, independent of employer-sharing
   * consent. Returns an empty list for inactive callers or callers with no memberships. Company logos
   * are available here; summary and employeeCount are null.
   */
  myCompanies: MyCompaniesResult;
  myContactCount: Scalars['Int']['output'];
  /** The caller's favourites, best first per domain; of one domain when the input names it. */
  myFavorites: Array<Favorite>;
  /** The caller's own game sessions, newest first and at most 50; filtered to one game when gameKey is given. */
  myGameSessions: Array<GameSession>;
  /** The caller's own applications in every state. Requires `feature:share.applications`. */
  myListingApplications: ListingApplicationConnection;
  /**
   * Permission codes held by the authenticated caller for internal access. Reports only the caller's
   * own permissions. Resource-specific checks still apply; feature keys are in `reachableFeatures`.
   */
  myPermissions: MyPermissionsResult;
  myPersonalSharing: PersonalSharing;
  myPowersDevStats: Array<PowersDevStat>;
  /**
   * One of the caller's own roleplay sessions with its bars. Null for any id that is not one of the caller's roleplay
   * sessions, another person's included, so nobody learns that it exists.
   */
  myRoleplaySession?: Maybe<RoleplaySession>;
  /** The caller's own roleplay sessions with their bars, newest first and at most 50. */
  myRoleplaySessions: Array<RoleplaySession>;
  /** One of the caller's toplist sessions with its snapshot; null when the caller has no toplist session with this id. */
  myToplistSession?: Maybe<ToplistSession>;
  myself: Person;
  /** Returns the current user's notifications ordered from newest to oldest. */
  notifications: Array<Notification>;
  numberOfPinnedItems: NumberOfPinsOutput;
  /** One listing under the same rules as `openListings`, or null. Requires `feature:share.applications`. */
  openListing?: Maybe<Listing>;
  /**
   * Effectively OPEN listings readable by the caller from outside their membership through a group or public
   * access. Returns only content, as for group recipients, and never creates membership. Requires
   * `feature:share.applications`, not `feature:share.listings`. Filtering, sorting and pagination follow
   * `listings`.
   */
  openListings: ListingConnection;
  /**
   * Active organizational units. Readable by authenticated callers; maintaining the hierarchy requires
   * `write:access-config`.
   */
  orgUnits: OrgUnitsResult;
  organizationalPowerAnalysis: OrganizationalPowerAnalysis;
  /**
   * The organisational record about one subject: exactly one of `personId` and `companyId` must be set. Reached by
   * capability, not by sight (see `organizationalRecordAccess`); the subject has to be ACTIVE, an inactive one reads
   * as absent.
   */
  organizationalRecord?: Maybe<OrganizationalRecord>;
  organizationalRecordAccess: OrganizationalRecordAccess;
  organizationalRecordBacklinks: OrganizationalRecordBacklinkConnection;
  organizationalRecordComment?: Maybe<OrganizationalRecordComment>;
  organizationalRecordComments: OrganizationalRecordCommentConnection;
  organizationalRecordDocument?: Maybe<OrganizationalRecordDocument>;
  organizationalRecordDocuments: OrganizationalRecordDocumentConnection;
  organizationalRecordEntries: OrganizationalRecordEntryConnection;
  organizationalRecordEntry?: Maybe<OrganizationalRecordEntry>;
  person?: Maybe<Person>;
  personGroup?: Maybe<PersonGroup>;
  personGroupMemberships?: Maybe<PersonGroupMembershipOutput>;
  personGroups: PersonGroupOutput;
  /** One person's account binding and latest invitation, read only from Genesis. */
  personLoginAssignment?: Maybe<PersonLoginAssignment>;
  /**
   * Visible active people, filtered by their Genesis account binding. Requires `provision:invitee`.
   * Binding filters and visibility are applied before pagination.
   */
  personLoginAssignments: PersonLoginAssignmentConnection;
  personalSharingRecipients: Array<PersonalSharingRecipient>;
  persons: PersonConnection;
  pinGroup?: Maybe<PinGroup>;
  pinGroupMemberships?: Maybe<PinGroupMembershipOutput>;
  pinGroups: PinGroupOutput;
  /**
   * Shared items with the caller's pin-board visibility. Unlike `sharedItems`, this can return
   * inactive-company items the caller has pinned. Uses the same pagination, ordering and filters as
   * `sharedItems`. Supply the pinned filter to select pins: `pinned: {eq: false}` is also accepted and
   * selects unpinned items subject to visibility; it does not expose unpinned inactive-company items.
   */
  pinnedSharedItems: SharedItemConnection;
  powersEvaluationResults: Array<ElementEvaluationResult>;
  /** Requires compare:profiles; preserves ordinary Person visibility and field consent. */
  profileComparisonPerson?: Maybe<Person>;
  project?: Maybe<Project>;
  projects: ProjectConnection;
  /** Published questionnaire groups in position, then name order. Drafts are excluded. */
  publishedQuestionnaireGroups: Array<QuestionnaireGroup>;
  /**
   * Saved answers for this Person, including before application submission. Requires self-access or
   * an explicit personal-information override. first must be 1–100.
   */
  questionnaireAnswers: QuestionnaireAnswerPage;
  /**
   * Power evaluation for one questionnaire group. quizResult, quizResultText, itemCount and
   * answeredItemCount are group-specific. selfScoreBefore and selfScoreWithQuiz remain person-wide.
   * Draft groups are accepted by id; catalogue publication does not restrict this query.
   */
  questionnaireGroupEvaluation: Array<QuizElementEvaluation>;
  /** Administration path: every questionnaire group including drafts, in (position, name) order. Requires the `write:questionnaire` permission. */
  questionnaireGroups: Array<QuestionnaireGroup>;
  questionnaireQuestions: Array<QuestionnaireQuestion>;
  questionnaires: Array<Questionnaire>;
  /**
   * One result per power, ordered by element group and element. Includes every ACTIVE questionnaire
   * without a creativityElement. Use `questionnaireGroupEvaluation` to restrict quiz results to one group.
   */
  quizEvaluation: Array<QuizElementEvaluation>;
  /**
   * Effective feature keys from the current principal's Role Permissions. Open to any authenticated
   * principal, including immediately after registration. Content sharing never enables a feature.
   */
  reachableFeatures: ReachableFeaturesResult;
  recentInterestedInitiatives: Array<SharedItemWithDate>;
  recentProfileVisitors: Array<PersonWithDate>;
  recentSharedItemsCreatedByUser: Array<SharedItemWithDate>;
  recentlyReadSharedItems: Array<SharedItemWithDate>;
  recipients?: Maybe<Array<Recipient>>;
  /**
   * Administration path: every person's roleplay sessions, newest first, without readings or values. Requires
   * `read:roleplay-session`.
   */
  roleplaySessions: RoleplaySessionConnection;
  selfAssessment?: Maybe<SelfAssessment>;
  selfAssessmentResult: ElementEvaluationResult;
  selfAssessmentResults: Array<ElementEvaluationResult>;
  selfAssessmentSavedAnswers: Array<SelfAssessmentSavedAnswer>;
  selfAssessmentStatements: Array<SelfAssessmentStatement>;
  settings: Settings;
  sharedItem?: Maybe<SharedItem>;
  sharedItemComments: SharedItemCommentConnection;
  sharedItemRatings: SharedItemRatingConnection;
  sharedItemSignUps: PersonConnection;
  sharedItems: SharedItemConnection;
  smartAnalysisResults: Array<SmartAnalysisResult>;
  studioNotebook?: Maybe<StudioNotebook>;
  studioNotebooks: StudioNotebookConnection;
  /** Suggests activity descriptions for a given job position. Does not read the caller's profile. */
  suggestActivityDescriptions: SuggestionResult;
  /** Suggests skill (Expertise.description) values for the caller, informed by their profile. */
  suggestExpertiseDescriptions: SuggestionResult;
  /**
   * Suggests how open requirements of a match result split into listing roles. Requires `feature:share.listings`
   * and sight of the match, whose project description genesis reads itself. Only the supplied requirement keys
   * are assigned; unknown keys, duplicates and roles without requirements are dropped. Never persists and never
   * creates a listing.
   */
  suggestListingRoles: ListingRoleSuggestion;
  /** Suggests a profile summary (Person.bio) for the caller, informed by their profile. Returns a single-paragraph suggestion in `suggestions[0]`. */
  suggestProfileSummary: SuggestionResult;
  systemSettings?: Maybe<SystemSettings>;
  teamProfiles: TeamProfileConnection;
  topElementsForContacts: Array<ContactTopElements>;
  unreadChatMessageCount: Scalars['Int']['output'];
  /** Returns the unread notification count for the current user, restricted to the types the client declares (see SupportedNotificationTypesInput). */
  unreadNotificationCount: Scalars['Int']['output'];
  usedDocumentTags?: Maybe<UsedDocumentTagsOutput>;
  /**
   * Checks a complete candidate requirement set with the same conversion and match-mode rules as
   * setMatchConditions, without saving it. Requires design-write access to the match.
   */
  validateMatchConditions: Scalars['Boolean']['output'];
  workingTimeModels: WorkingTimeModelsResult;
};


export type QueryAccessGroupArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAccessGroupMembersArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  groupId: Scalars['ID']['input'];
};


export type QueryAccessGroupRoleAssignmentsArgs = {
  groupId: Scalars['ID']['input'];
};


export type QueryAccessGroupsArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryAccessPersonInspectionArgs = {
  personId: Scalars['ID']['input'];
};


export type QueryAccessRoleImpactArgs = {
  groupsAfter?: InputMaybe<Scalars['ID']['input']>;
  peopleAfter?: InputMaybe<Scalars['ID']['input']>;
  permissionIds: Array<Scalars['ID']['input']>;
  roleId: Scalars['ID']['input'];
};


export type QueryAccessRoleMembersArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  groupId: Scalars['ID']['input'];
  roleId: Scalars['ID']['input'];
};


export type QueryActiveQuestionnairesByElementArgs = {
  input: ActiveQuestionnairesByElementInput;
};


export type QueryAgentArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAgentsArgs = {
  input: AgentQueryInput;
};


export type QueryCatalogItemsArgs = {
  input: CatalogItemsInput;
};


export type QueryCompaniesArgs = {
  input: CompanyQueryInput;
};


export type QueryCompanyArgs = {
  input: CompanyInput;
};


export type QueryCompanyComparisonArgs = {
  input: CompanyInput;
};


export type QueryCompanyCompetenciesArgs = {
  input: CompanyCompetenciesInput;
};


export type QueryCompanyContactPersonsArgs = {
  input: CompanyContactPersonsInput;
};


export type QueryCompanyIdentitiesArgs = {
  input: CompanyIdentitiesInput;
};


export type QueryCompanyMembersArgs = {
  input: CompanyMembersInput;
};


export type QueryCompanyOwnedSharedItemsArgs = {
  companyId: Scalars['ID']['input'];
  input?: InputMaybe<SharedItemQueryInput>;
};


export type QueryContactPowersDevStatsArgs = {
  input: ContactPowersDevStatsInput;
};


export type QueryContactsWithHighestScoreArgs = {
  input: ContactsWithHighestScoreInput;
};


export type QueryConversationArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryConversationMessagesArgs = {
  input: ConversationMessagesInput;
};


export type QueryConversationPresenceArgs = {
  conversationId: Scalars['UUID']['input'];
};


export type QueryConversationReadReceiptsArgs = {
  conversationId: Scalars['UUID']['input'];
};


export type QueryCountryStateArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCountryStatesByCountryArgs = {
  input: CountryStatesByCountryInput;
};


export type QueryCurriculumVitaeArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCurriculumVitaesArgs = {
  input: CurriculumVitaeQueryInput;
};


export type QueryDocumentArgs = {
  id: Scalars['ID']['input'];
};


export type QueryDocumentGroupArgs = {
  id: Scalars['ID']['input'];
};


export type QueryDocumentGroupsArgs = {
  input?: InputMaybe<DocumentGroupInput>;
};


export type QueryDocumentTextArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryDocumentsArgs = {
  input: DocumentQueryInput;
};


export type QueryEmailTemplatePreviewArgs = {
  input: EmailTemplatePreviewInput;
};


export type QueryEscoOccupationSkillsArgs = {
  language: Scalars['String']['input'];
  uri: Scalars['String']['input'];
};


export type QueryEscoSearchArgs = {
  input: EscoSearchInput;
};


export type QueryExportMyProfileArgs = {
  input: ProfileExportInput;
};


export type QueryExtractionJobArgs = {
  jobId: Scalars['UUID']['input'];
};


export type QueryFileImportBatchArgs = {
  batchId: Scalars['UUID']['input'];
};


export type QueryFileImportJobArgs = {
  jobId: Scalars['UUID']['input'];
};


export type QueryGlobalSearchArgs = {
  input: GlobalSearchInput;
};


export type QueryGrowResourceArgs = {
  input: GrowResourceQueryInput;
};


export type QueryImportJobArgs = {
  jobId: Scalars['UUID']['input'];
};


export type QueryListingArgs = {
  id: Scalars['ID']['input'];
};


export type QueryListingApplicationsArgs = {
  input: ListingApplicationQueryInput;
};


export type QueryListingRequirementDocumentsArgs = {
  listingId: Scalars['UUID']['input'];
};


export type QueryListingRequirementsArgs = {
  listingId: Scalars['UUID']['input'];
};


export type QueryListingsArgs = {
  input: ListingQueryInput;
};


export type QueryMatchArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMatchCandidateArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMatchCandidatesArgs = {
  input: MatchCandidateQueryInput;
};


export type QueryMatchCompaniesArgs = {
  input: MatchCompanyQueryInput;
};


export type QueryMatchCompanyArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMatchProjectDocumentContentArgs = {
  backdropFileId: Scalars['UUID']['input'];
  matchId: Scalars['UUID']['input'];
};


export type QueryMatchResultArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMatchResultsArgs = {
  input: MatchResultQueryInput;
};


export type QueryMatchesArgs = {
  input: MatchQueryInput;
};


export type QueryMicrosoftCalendarConnectionArgs = {
  accountKind?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMicrosoftCalendarViewArgs = {
  accountKind?: InputMaybe<Scalars['String']['input']>;
  end: Scalars['String']['input'];
  organizerEmail: Scalars['String']['input'];
  start: Scalars['String']['input'];
};


export type QueryMyFavoritesArgs = {
  input: MyFavoritesInput;
};


export type QueryMyGameSessionsArgs = {
  gameKey?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMyListingApplicationsArgs = {
  input: ListingApplicationQueryInput;
};


export type QueryMyPowersDevStatsArgs = {
  input: MyPowersDevStatsInput;
};


export type QueryMyRoleplaySessionArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryMyToplistSessionArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryNotificationsArgs = {
  input?: InputMaybe<NotificationsInput>;
};


export type QueryOpenListingArgs = {
  id: Scalars['ID']['input'];
};


export type QueryOpenListingsArgs = {
  input: ListingQueryInput;
};


export type QueryOrganizationalPowerAnalysisArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryOrganizationalRecordArgs = {
  companyId?: InputMaybe<Scalars['ID']['input']>;
  personId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryOrganizationalRecordBacklinksArgs = {
  input: OrganizationalRecordBacklinksInput;
};


export type QueryOrganizationalRecordCommentArgs = {
  id: Scalars['ID']['input'];
};


export type QueryOrganizationalRecordCommentsArgs = {
  input: OrganizationalRecordPageInput;
  sort?: InputMaybe<OrganizationalRecordCommentSortInput>;
};


export type QueryOrganizationalRecordDocumentArgs = {
  id: Scalars['ID']['input'];
};


export type QueryOrganizationalRecordDocumentsArgs = {
  input: OrganizationalRecordPageInput;
};


export type QueryOrganizationalRecordEntriesArgs = {
  input: OrganizationalRecordPageInput;
};


export type QueryOrganizationalRecordEntryArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPersonArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPersonGroupArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPersonGroupMembershipsArgs = {
  input: PersonGroupMembershipInput;
};


export type QueryPersonGroupsArgs = {
  input?: InputMaybe<PersonGroupInput>;
};


export type QueryPersonLoginAssignmentArgs = {
  input: PersonLoginAssignmentInput;
};


export type QueryPersonLoginAssignmentsArgs = {
  input?: InputMaybe<PersonLoginAssignmentsInput>;
};


export type QueryPersonsArgs = {
  input: PersonQueryInput;
};


export type QueryPinGroupArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPinGroupMembershipsArgs = {
  input: PinGroupMembershipInput;
};


export type QueryPinGroupsArgs = {
  input: PinGroupInput;
};


export type QueryPinnedSharedItemsArgs = {
  input: SharedItemQueryInput;
};


export type QueryProfileComparisonPersonArgs = {
  id: Scalars['ID']['input'];
};


export type QueryProjectArgs = {
  id: Scalars['ID']['input'];
};


export type QueryProjectsArgs = {
  input: ProjectQueryInput;
};


export type QueryQuestionnaireAnswersArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  personId: Scalars['ID']['input'];
};


export type QueryQuestionnaireGroupEvaluationArgs = {
  questionnaireGroupId: Scalars['UUID']['input'];
};


export type QueryQuestionnaireQuestionsArgs = {
  questionnaireId: Scalars['UUID']['input'];
};


export type QueryQuestionnairesArgs = {
  input?: InputMaybe<QuestionnairesInput>;
};


export type QueryRecentInterestedInitiativesArgs = {
  input: RecentInterestedInitiativesInput;
};


export type QueryRecentProfileVisitorsArgs = {
  limit: Scalars['Int']['input'];
};


export type QueryRecentSharedItemsCreatedByUserArgs = {
  input: RecentSharedItemsCreatedByUserInput;
};


export type QueryRecentlyReadSharedItemsArgs = {
  input: RecentlyReadSharedItemsInput;
};


export type QueryRecipientsArgs = {
  input: RecipientQueryInput;
};


export type QueryRoleplaySessionsArgs = {
  input?: InputMaybe<RoleplaySessionsInput>;
};


export type QuerySelfAssessmentArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySelfAssessmentResultArgs = {
  input: SelfAssessmentResultsQueryInput;
};


export type QuerySelfAssessmentSavedAnswersArgs = {
  input: SelfAssessmentStatementsInput;
};


export type QuerySelfAssessmentStatementsArgs = {
  input: SelfAssessmentStatementsInput;
};


export type QuerySettingsArgs = {
  person?: InputMaybe<Scalars['UUID']['input']>;
};


export type QuerySharedItemArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySharedItemCommentsArgs = {
  input: SharedItemCommentQueryInput;
};


export type QuerySharedItemRatingsArgs = {
  input: SharedItemRatingQueryInput;
};


export type QuerySharedItemSignUpsArgs = {
  input: SharedItemSignUpQueryInput;
};


export type QuerySharedItemsArgs = {
  input: SharedItemQueryInput;
};


export type QueryStudioNotebookArgs = {
  id: Scalars['ID']['input'];
};


export type QueryStudioNotebooksArgs = {
  input: StudioNotebookQueryInput;
};


export type QuerySuggestActivityDescriptionsArgs = {
  input: SuggestActivityDescriptionsInput;
};


export type QuerySuggestExpertiseDescriptionsArgs = {
  input: SuggestExpertiseDescriptionsInput;
};


export type QuerySuggestListingRolesArgs = {
  input: SuggestListingRolesInput;
};


export type QuerySuggestProfileSummaryArgs = {
  input: SuggestProfileSummaryInput;
};


export type QueryTeamProfilesArgs = {
  input: TeamProfileQueryInput;
};


export type QueryTopElementsForContactsArgs = {
  input: ContactTopElementsInput;
};


export type QueryUnreadChatMessageCountArgs = {
  conversationId?: InputMaybe<Scalars['UUID']['input']>;
};


export type QueryUnreadNotificationCountArgs = {
  input?: InputMaybe<SupportedNotificationTypesInput>;
};


export type QueryUsedDocumentTagsArgs = {
  input: UsedDocumentTagsInput;
};


export type QueryValidateMatchConditionsArgs = {
  input: SetMatchConditionsInput;
};

/** The filterable fields of type Query */
export type QueryFilterInput = {
  and?: InputMaybe<Array<QueryFilterInput>>;
  not?: InputMaybe<QueryFilterInput>;
  or?: InputMaybe<Array<QueryFilterInput>>;
};

export type Questionnaire = {
  __typename?: 'Questionnaire';
  creativityElement?: Maybe<CreativityElement>;
  instructions?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  /** Order within its group. Null exactly when questionnaireGroupId is null. */
  position?: Maybe<Scalars['Int']['output']>;
  /**
   * The group containing this questionnaire, or null when unassigned. Unassigned questionnaires are
   * absent from the published group catalogue.
   */
  questionnaireGroupId?: Maybe<Scalars['UUID']['output']>;
  questionnaireId: Scalars['UUID']['output'];
  status: QuestionnaireStatus;
};

export type QuestionnaireAnswerChoice = {
  __typename?: 'QuestionnaireAnswerChoice';
  answer: Scalars['String']['output'];
  position: Scalars['Int']['output'];
  qnrAnswerChoiceId: Scalars['UUID']['output'];
  status: QuestionnaireStatus;
  weight: Scalars['Int']['output'];
};

/** The filterable fields of type QuestionnaireAnswerChoice */
export type QuestionnaireAnswerChoiceFilterInput = {
  and?: InputMaybe<Array<QuestionnaireAnswerChoiceFilterInput>>;
  not?: InputMaybe<QuestionnaireAnswerChoiceFilterInput>;
  or?: InputMaybe<Array<QuestionnaireAnswerChoiceFilterInput>>;
};

export type QuestionnaireAnswerPage = {
  __typename?: 'QuestionnaireAnswerPage';
  answers: Array<ProvidedQuestionnaireAnswer>;
  hasNextPage: Scalars['Boolean']['output'];
  nextAfter?: Maybe<Scalars['ID']['output']>;
};

/** The filterable fields of type QuestionnaireAnswerPage */
export type QuestionnaireAnswerPageFilterInput = {
  and?: InputMaybe<Array<QuestionnaireAnswerPageFilterInput>>;
  not?: InputMaybe<QuestionnaireAnswerPageFilterInput>;
  or?: InputMaybe<Array<QuestionnaireAnswerPageFilterInput>>;
};

/** The filterable fields of type Questionnaire */
export type QuestionnaireFilterInput = {
  and?: InputMaybe<Array<QuestionnaireFilterInput>>;
  not?: InputMaybe<QuestionnaireFilterInput>;
  or?: InputMaybe<Array<QuestionnaireFilterInput>>;
};

/** A named bundle of questionnaires. Published groups are available through `publishedQuestionnaireGroups`. */
export type QuestionnaireGroup = {
  __typename?: 'QuestionnaireGroup';
  /** Localized description of the questionnaire group. */
  description?: Maybe<LocalizedText>;
  /**
   * Group artwork, or null when none was uploaded. `profile` accepts "card" (maximum height 140 pixels)
   * or "share_preview" (maximum height 250 pixels); omit it for the original.
   */
  image?: Maybe<File>;
  /**
   * Number of ACTIVE questions across the group's ACTIVE questionnaires. Zero means there are no
   * active questions; this is a count, not an estimated duration.
   */
  itemCount: Scalars['Int']['output'];
  name: LocalizedText;
  /** ACTIVE members in (position, name) order, each carrying the flag whether the current user has answered every ACTIVE question of that part. */
  parts: Array<QuestionnaireResult>;
  /** Order of this group in the play catalogue. Distinct from Questionnaire.position, which orders parts within a group. */
  position: Scalars['Int']['output'];
  questionnaireGroupId: Scalars['UUID']['output'];
  status: QuestionnaireGroupStatus;
};


/** A named bundle of questionnaires. Published groups are available through `publishedQuestionnaireGroups`. */
export type QuestionnaireGroupImageArgs = {
  profile?: InputMaybe<Scalars['String']['input']>;
};

/** The filterable fields of type QuestionnaireGroup */
export type QuestionnaireGroupFilterInput = {
  and?: InputMaybe<Array<QuestionnaireGroupFilterInput>>;
  not?: InputMaybe<QuestionnaireGroupFilterInput>;
  or?: InputMaybe<Array<QuestionnaireGroupFilterInput>>;
};

/** Artwork being uploaded for a questionnaire group, inlined base64 on the wire. */
export type QuestionnaireGroupImageInput = {
  content: Scalars['Binary']['input'];
  fileExtension?: InputMaybe<Scalars['String']['input']>;
  mimeType?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Visibility of a questionnaire group. Deliberately not QuestionnaireStatus: that one carries DELETED as a
 * soft-delete state, while deleting a group ungroups its members instead. Publishing is a stated editorial
 * intent, not a side effect of somebody activating a questionnaire.
 */
export enum QuestionnaireGroupStatus {
  /** Invisible in Grow. Editors build the group up - name it, describe it, add artwork, assign and sort parts. */
  Draft = 'DRAFT',
  /** Visible in the Grow play catalogue. */
  Published = 'PUBLISHED'
}

export type QuestionnaireQuestion = {
  __typename?: 'QuestionnaireQuestion';
  answerChoices: Array<QuestionnaireAnswerChoice>;
  creativityElement: CreativityElement;
  position: Scalars['Int']['output'];
  qnrQuestionId: Scalars['UUID']['output'];
  question: Scalars['String']['output'];
  status: QuestionnaireStatus;
};

/** The filterable fields of type QuestionnaireQuestion */
export type QuestionnaireQuestionFilterInput = {
  and?: InputMaybe<Array<QuestionnaireQuestionFilterInput>>;
  not?: InputMaybe<QuestionnaireQuestionFilterInput>;
  or?: InputMaybe<Array<QuestionnaireQuestionFilterInput>>;
};

export type QuestionnaireResult = {
  __typename?: 'QuestionnaireResult';
  /**
   * True when the current user has answered every ACTIVE question with an ACTIVE answer choice.
   * True also when the questionnaire has no ACTIVE questions.
   */
  answered: Scalars['Boolean']['output'];
  questionnaire: Questionnaire;
};

/** The filterable fields of type QuestionnaireResult */
export type QuestionnaireResultFilterInput = {
  and?: InputMaybe<Array<QuestionnaireResultFilterInput>>;
  not?: InputMaybe<QuestionnaireResultFilterInput>;
  or?: InputMaybe<Array<QuestionnaireResultFilterInput>>;
};

export type QuestionnaireSaveInput = {
  creativityElement?: InputMaybe<CreativityElement>;
  instructions?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  questionnaireId?: InputMaybe<Scalars['UUID']['input']>;
  status: QuestionnaireStatus;
};

export enum QuestionnaireStatus {
  Active = 'ACTIVE',
  Deleted = 'DELETED',
  Inactive = 'INACTIVE'
}

export type QuestionnairesInput = {
  status?: InputMaybe<QuestionnaireStatus>;
};

/**
 * Per-element view of the Power Quiz for the current user. The only place that keeps the two self-report
 * instruments apart: selfScoreBefore is the self-assessment alone, quizResult the quiz alone, selfScoreWithQuiz
 * both of them weighted by answered items. ElementEvaluationResult.result carries the same merged value but no
 * provenance, which is why this type exists; its questionCount/answeredQuestionCount stay self-assessment-only,
 * because they describe the progress of the per-element assessment and no questionnaire advances that.
 */
export type QuizElementEvaluation = {
  __typename?: 'QuizElementEvaluation';
  /** Quiz items of itemCount the current user has answered. */
  answeredItemCount: Scalars['Int']['output'];
  element: CreativityElement;
  /** Quiz items for this element in ACTIVE questionnaires without a creativityElement. */
  itemCount: Scalars['Int']['output'];
  /** Latest quiz score, null when the element has no quiz answer yet. */
  quizResult?: Maybe<Scalars['Int']['output']>;
  /** Band text for quizResult, from the same scale. Null when quizResult is null. */
  quizResultText?: Maybe<Scalars['String']['output']>;
  /** Band text for selfScoreWithQuiz, from the element's self-assessment scale. Null when the score is null. */
  resultText?: Maybe<Scalars['String']['output']>;
  /** Latest self-assessment score, null when the element has no self-assessment answer yet. */
  selfScoreBefore?: Maybe<Scalars['Int']['output']>;
  /** Both instruments merged, weighted by answered items. Null only when neither instrument contributes. */
  selfScoreWithQuiz?: Maybe<Scalars['Int']['output']>;
};

/** The filterable fields of type QuizElementEvaluation */
export type QuizElementEvaluationFilterInput = {
  and?: InputMaybe<Array<QuizElementEvaluationFilterInput>>;
  not?: InputMaybe<QuizElementEvaluationFilterInput>;
  or?: InputMaybe<Array<QuizElementEvaluationFilterInput>>;
};

export type RateSharedItemInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  fiveStarRating?: InputMaybe<Scalars['Float']['input']>;
  person?: InputMaybe<Scalars['UUID']['input']>;
  sharedItemId: Scalars['UUID']['input'];
};

export type RateSharedItemOutput = RateSharedItemResult;

export type RateSharedItemResult = {
  __typename?: 'RateSharedItemResult';
  sharedItemId?: Maybe<Scalars['UUID']['output']>;
};

/** The filterable fields of type RateSharedItemResult */
export type RateSharedItemResultFilterInput = {
  and?: InputMaybe<Array<RateSharedItemResultFilterInput>>;
  not?: InputMaybe<RateSharedItemResultFilterInput>;
  or?: InputMaybe<Array<RateSharedItemResultFilterInput>>;
};

/** Effective feature keys from the caller's Role Permissions. Never inferred from content sharing. */
export type ReachableFeaturesResult = {
  __typename?: 'ReachableFeaturesResult';
  featureKeys: Array<Scalars['String']['output']>;
};

/** The filterable fields of type ReachableFeaturesResult */
export type ReachableFeaturesResultFilterInput = {
  and?: InputMaybe<Array<ReachableFeaturesResultFilterInput>>;
  not?: InputMaybe<ReachableFeaturesResultFilterInput>;
  or?: InputMaybe<Array<ReachableFeaturesResultFilterInput>>;
};

export type RecentInterestedInitiativesInput = {
  limit: Scalars['Int']['input'];
};

export type RecentSharedItemsCreatedByUserInput = {
  limit: Scalars['Int']['input'];
};

export type RecentlyReadSharedItemsInput = {
  limit: Scalars['Int']['input'];
};

export type Recipient = {
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type RecipientFilterInput = {
  and?: InputMaybe<Array<RecipientFilterInput>>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<RecipientFilterInput>;
  or?: InputMaybe<Array<RecipientFilterInput>>;
};

export type RecipientQueryInput = {
  order?: InputMaybe<RecipientSortInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RecipientFilterInput>;
};

export type RecipientSortInput = {
  name?: InputMaybe<SortOrder>;
};

export type ReferenceConditionInput = {
  id: Scalars['UUID']['input'];
  kind: ReferenceConditionKind;
};

export enum ReferenceConditionKind {
  Citizenship = 'CITIZENSHIP',
  Country = 'COUNTRY',
  Gender = 'GENDER',
  JobDepartment = 'JOB_DEPARTMENT',
  JobLocation = 'JOB_LOCATION',
  Marital = 'MARITAL'
}

export type RegisterDeviceTokenInput = {
  platform: DevicePlatform;
  token: Scalars['String']['input'];
};

export type RemoveAccessGroupRoleInput = {
  assignmentId: Scalars['ID']['input'];
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  groupId: Scalars['ID']['input'];
};

/**
 * Removes one expertise from a company, matched case-insensitively and ignoring surrounding whitespace.
 *
 * Answers whether a row was actually removed, so removing an expertise the company never listed is
 * `false` rather than an error.
 */
export type RemoveCompanyCompetencyInput = {
  companyId: Scalars['ID']['input'];
  label: Scalars['String']['input'];
};

export type RemoveCompanyMemberInput = {
  companyId: Scalars['ID']['input'];
  personId: Scalars['ID']['input'];
};

export type RemoveContactsInput = {
  contacts: Array<Scalars['UUID']['input']>;
  person?: InputMaybe<Scalars['UUID']['input']>;
};

export type RemoveContactsOutput = RemoveContactsResult;

export type RemoveContactsResult = {
  __typename?: 'RemoveContactsResult';
  contactsRemoved: Array<Scalars['UUID']['output']>;
};

/** The filterable fields of type RemoveContactsResult */
export type RemoveContactsResultFilterInput = {
  and?: InputMaybe<Array<RemoveContactsResultFilterInput>>;
  not?: InputMaybe<RemoveContactsResultFilterInput>;
  or?: InputMaybe<Array<RemoveContactsResultFilterInput>>;
};

export type RemovePinsInput = {
  person?: InputMaybe<Scalars['UUID']['input']>;
  persons?: InputMaybe<Array<Scalars['UUID']['input']>>;
  sharedItems?: InputMaybe<Array<Scalars['UUID']['input']>>;
};

export type RemovePinsOutput = RemovePinsResult;

export type RemovePinsResult = {
  __typename?: 'RemovePinsResult';
  personsUnpinned?: Maybe<Array<Scalars['UUID']['output']>>;
  sharedItemsUnpinned?: Maybe<Array<Scalars['UUID']['output']>>;
};

/** The filterable fields of type RemovePinsResult */
export type RemovePinsResultFilterInput = {
  and?: InputMaybe<Array<RemovePinsResultFilterInput>>;
  not?: InputMaybe<RemovePinsResultFilterInput>;
  or?: InputMaybe<Array<RemovePinsResultFilterInput>>;
};

export type RequestListingApplicationPowerQuizInput = {
  id: Scalars['UUID']['input'];
  requestId: Scalars['UUID']['input'];
};

/** Re-send or re-address a still-pending invitation for an existing Person. */
export type ResendExistingPersonInvitationInput = {
  /** The confirmed recipient for this request. May differ from the previous attempt's. */
  email: Scalars['String']['input'];
  personId: Scalars['UUID']['input'];
  requestId: Scalars['UUID']['input'];
};

export type RetryListingMatchVersionInput = {
  matchId: Scalars['UUID']['input'];
};

/** Runs one auto run again, on behalf of the caller. */
export type RetryMatchAutoRunInput = {
  runId: Scalars['UUID']['input'];
};

export type RetryMatchAutoRunOutput = RetryMatchAutoRunResult;

export type RetryMatchAutoRunResult = {
  __typename?: 'RetryMatchAutoRunResult';
  run: MatchAutoRun;
};

/** The filterable fields of type RetryMatchAutoRunResult */
export type RetryMatchAutoRunResultFilterInput = {
  and?: InputMaybe<Array<RetryMatchAutoRunResultFilterInput>>;
  not?: InputMaybe<RetryMatchAutoRunResultFilterInput>;
  or?: InputMaybe<Array<RetryMatchAutoRunResultFilterInput>>;
};

export type RoleplayPowerCoverage = {
  __typename?: 'RoleplayPowerCoverage';
  element: CreativityElement;
  /** Share of the power's statements that hold a reading, in whole percent rounded down. */
  percent: Scalars['Int']['output'];
  /**
   * Whether the readings reach `thresholdPercent`, so that the power gets a value when the session is completed.
   * Compared on the counts, never on the rounded `percent`: at 15 percent, 3 of 20 statements are enough and 3 of 25
   * are not.
   */
  reached: Scalars['Boolean']['output'];
};

/** The filterable fields of type RoleplayPowerCoverage */
export type RoleplayPowerCoverageFilterInput = {
  and?: InputMaybe<Array<RoleplayPowerCoverageFilterInput>>;
  not?: InputMaybe<RoleplayPowerCoverageFilterInput>;
  or?: InputMaybe<Array<RoleplayPowerCoverageFilterInput>>;
};

/** One reading: how far the player's answers agree with one statement of a chosen power. */
export type RoleplayReadingInput = {
  /** Agreement with the statement as worded: 0, 25, 50, 75 or 100. */
  agreement: Scalars['Int']['input'];
  /** Above 0 and at most 1. */
  confidence: Scalars['Float']['input'];
  /** A statement (as `SelfAssessmentStatement.id`) of one of the session's chosen powers. */
  statement: Scalars['UUID']['input'];
};

/** The readings one assessed turn of a roleplay story produced, for one session. */
export type RoleplayReadingsReportInput = {
  /** The roleplay session the story belongs to. */
  id: Scalars['UUID']['input'];
  /** At most 200 readings, each of a different statement. May be empty: the report then only records activity. */
  readings: Array<RoleplayReadingInput>;
  /** The identifier of the story, as registered with `registerRoleplayStory`. */
  story: Scalars['UUID']['input'];
  /**
   * The account subject (the `sub` claim of the owner's access token) of the story's owner. It must be the account of
   * the session's person, or the report is refused like an unknown id (GENESIS001343).
   */
  subject: Scalars['UUID']['input'];
  /** The turn the readings were assessed in, 0 or more. A reading replaces a stored one only when its turn is newer. */
  turn: Scalars['Int']['input'];
};

/**
 * One roleplay session of Grow · Play: its game session, the 1 to 5 powers it evaluates, and how far play has covered
 * them. While the story is played, the session collects readings, each a measurement against one statement of a chosen
 * power. The story itself (scenes, inventory, characters, clock) is not available through this API.
 *
 * Deliberately without values, readings and the story's identifier: the player sees how far each chosen power is
 * covered, never what was measured. When the story ends, the session is completed and writes a Smart Analysis value for
 * every chosen power whose coverage reaches `thresholdPercent`, visible in `smartAnalysisResults`; a power below it gets
 * no value. A session changes nothing in the questionnaire's progress.
 */
export type RoleplaySession = {
  __typename?: 'RoleplaySession';
  /**
   * One entry per chosen power, in the order of `powers`: how much of the power's statements the session holds a
   * reading for. A plain count; which statements are covered does not matter. Empty when `powers` is.
   */
  coverage: Array<RoleplayPowerCoverage>;
  /**
   * The powers this session evaluates, 1 to 5 of the 30, in the order the player sees them: five drawn at random when
   * the session started, every power equally likely, then changed by the player until they were locked. Empty for an
   * ABANDONED or EXPIRED session, whose content was deleted when a new game replaced it or when its story was deleted.
   */
  powers: Array<CreativityElement>;
  /**
   * True once the powers can no longer be changed: from the first move (`lockRoleplaySessionPowers`), from the first
   * readings delivered for the session, and for every session that is no longer IN_PROGRESS.
   */
  powersLocked: Scalars['Boolean']['output'];
  /** The underlying game session: id, game key (for example roleplay.window-seat), status and times. */
  session: GameSession;
  /**
   * The share of a power's statements its readings must cover for the power to get a value when the session is
   * completed, in whole percent. Configured per installation; 15 unless configured otherwise.
   */
  thresholdPercent: Scalars['Int']['output'];
};

/** Newest first. No population count. */
export type RoleplaySessionConnection = {
  __typename?: 'RoleplaySessionConnection';
  nodes: Array<RoleplaySessionOverview>;
  pageInfo: PageInfo;
};

/** The filterable fields of type RoleplaySessionConnection */
export type RoleplaySessionConnectionFilterInput = {
  and?: InputMaybe<Array<RoleplaySessionConnectionFilterInput>>;
  not?: InputMaybe<RoleplaySessionConnectionFilterInput>;
  or?: InputMaybe<Array<RoleplaySessionConnectionFilterInput>>;
};

/** The filterable fields of type RoleplaySession */
export type RoleplaySessionFilterInput = {
  and?: InputMaybe<Array<RoleplaySessionFilterInput>>;
  not?: InputMaybe<RoleplaySessionFilterInput>;
  or?: InputMaybe<Array<RoleplaySessionFilterInput>>;
};

/** One entry of the administrator's list: the game session of a roleplay session and whose it is. Never a reading or a value. */
export type RoleplaySessionOverview = {
  __typename?: 'RoleplaySessionOverview';
  /** The person who plays it. Resolve the person through the queries the caller's own rights allow. */
  personId: Scalars['UUID']['output'];
  /**
   * The powers the session evaluates, in the player's order; empty once an ABANDONED or EXPIRED session's content was
   * deleted.
   */
  powers: Array<CreativityElement>;
  session: GameSession;
};

/** The filterable fields of type RoleplaySessionOverview */
export type RoleplaySessionOverviewFilterInput = {
  and?: InputMaybe<Array<RoleplaySessionOverviewFilterInput>>;
  not?: InputMaybe<RoleplaySessionOverviewFilterInput>;
  or?: InputMaybe<Array<RoleplaySessionOverviewFilterInput>>;
};

/** The new list of powers for one of the caller's roleplay sessions. */
export type RoleplaySessionPowersInput = {
  /** One of the caller's own roleplay sessions. */
  id: Scalars['UUID']['input'];
  /** The whole new list, 1 to 5 different powers of the 30, in the order the player sees them. */
  powers: Array<CreativityElement>;
};

/** Identifies the roleplay session a report is about and the account that owns its story. */
export type RoleplaySessionReportInput = {
  /** The roleplay session the story belongs to. */
  id: Scalars['UUID']['input'];
  /**
   * The account subject (the `sub` claim of the owner's access token) of the story's owner. It must be the account of
   * the session's person, or the report is refused like an unknown id (GENESIS001343).
   */
  subject: Scalars['UUID']['input'];
};

/** Filter and page the administrator's list of roleplay sessions. Every filter given must match, and filtering happens before paging, so each page holds only matching sessions. */
export type RoleplaySessionsInput = {
  /** Cursor from a previous page's `pageInfo.endCursor`. */
  after?: InputMaybe<Scalars['String']['input']>;
  /** Page size, 1..100. Omitted means 50. */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** Only the sessions of this game, for example roleplay.window-seat. A key that names no game matches no session. */
  gameKey?: InputMaybe<Scalars['String']['input']>;
  /** Only this person's sessions. */
  personId?: InputMaybe<Scalars['UUID']['input']>;
  /** Only sessions in these states. Omitted or empty means every state. */
  status?: InputMaybe<Array<GameSessionStatus>>;
};

/** Identifies the roleplay session a report is about, the account that owns its story, and the story. */
export type RoleplayStoryReportInput = {
  /** The roleplay session the story belongs to. */
  id: Scalars['UUID']['input'];
  /** The identifier of the story, as registered with `registerRoleplayStory`. */
  story: Scalars['UUID']['input'];
  /**
   * The account subject (the `sub` claim of the owner's access token) of the story's owner. It must be the account of
   * the session's person, or the report is refused like an unknown id (GENESIS001343).
   */
  subject: Scalars['UUID']['input'];
};

/**
 * Preview diff for one field of a collection row. `existingValue` / `incomingValue` are
 * MACHINE values (ISO `YYYY[-MM]` for MONTH, a CEFR enum name or `NATIVE` for CEFR, plain
 * text for TEXT) so the client can both render and edit them; the client localizes labels
 * and formats values. `editable` is false for fields the import can show but not accept an
 * edit for (e.g. a language tag).
 */
export type RowFieldDiff = {
  __typename?: 'RowFieldDiff';
  editable: Scalars['Boolean']['output'];
  existingValue?: Maybe<Scalars['String']['output']>;
  field: Scalars['String']['output'];
  incomingValue?: Maybe<Scalars['String']['output']>;
  kind: RowFieldKind;
};

/** The filterable fields of type RowFieldDiff */
export type RowFieldDiffFilterInput = {
  and?: InputMaybe<Array<RowFieldDiffFilterInput>>;
  not?: InputMaybe<RowFieldDiffFilterInput>;
  or?: InputMaybe<Array<RowFieldDiffFilterInput>>;
};

/**
 * The input kind of one collection-row field — tells the client how to render and edit
 * it. TEXT = free text; MONTH = a year-or-month date carried as `YYYY` or `YYYY-MM`
 * (blank end date = ongoing / "present"); CEFR = a language proficiency level
 * (`A1`..`C2`, or `NATIVE`).
 */
export enum RowFieldKind {
  Cefr = 'CEFR',
  Month = 'MONTH',
  Text = 'TEXT'
}

export type SaveQuestionnaireGroupInput = {
  descriptionDe?: InputMaybe<Scalars['String']['input']>;
  descriptionEn?: InputMaybe<Scalars['String']['input']>;
  /**
   * If true, validate without saving changes or uploading artwork. Image size and format are still
   * checked. The response contains the existing artwork, not the proposed image. An id returned for a
   * dry-run create is not reserved and must not be reused as an existing group's id.
   */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  /** Uploads new artwork and replaces any existing one. Null leaves the current artwork untouched. */
  image?: InputMaybe<QuestionnaireGroupImageInput>;
  nameDe: Scalars['String']['input'];
  nameEn: Scalars['String']['input'];
  /** Null appends the group at the end of the catalogue on create, and keeps the current position on update. */
  position?: InputMaybe<Scalars['Int']['input']>;
  /** Null creates a group. A new group always starts as DRAFT; publishing is its own mutation. */
  questionnaireGroupId?: InputMaybe<Scalars['UUID']['input']>;
  /** Removes the current artwork. Ignored when image is set. */
  removeImage?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * Result of a questionnaire group save. Success returns the group directly. Exceeding the creation
 * limit returns TooManyRecordsResult. Invalid input currently returns GraphQL errors rather than
 * ValidateQuestionnaireGroupResult. A dry run returns the proposed group without saving changes.
 */
export type SaveQuestionnaireGroupOutput = QuestionnaireGroup | TooManyRecordsResult | ValidateQuestionnaireGroupResult;

export type SaveQuestionnaireInput = {
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  questionnaire: QuestionnaireSaveInput;
  questions: Array<QnrQuestionSaveInput>;
};

export type SaveQuestionnaireOutput = {
  __typename?: 'SaveQuestionnaireOutput';
  questionnaire: Questionnaire;
  questions: Array<QuestionnaireQuestion>;
};

/** The filterable fields of type SaveQuestionnaireOutput */
export type SaveQuestionnaireOutputFilterInput = {
  and?: InputMaybe<Array<SaveQuestionnaireOutputFilterInput>>;
  not?: InputMaybe<SaveQuestionnaireOutputFilterInput>;
  or?: InputMaybe<Array<SaveQuestionnaireOutputFilterInput>>;
};

export type SaveQuestionnaireResultItem = {
  qnrAnswerChoiceId: Scalars['UUID']['input'];
  timeTakenMs?: InputMaybe<Scalars['Int']['input']>;
};

export type SaveQuestionnaireResultsInput = {
  results: Array<SaveQuestionnaireResultItem>;
};

export type SaveSelfAssessmentResultItem = {
  questionId: Scalars['UUID']['input'];
  scorePercent: Scalars['Int']['input'];
};

export type SaveSelfAssessmentResultsInput = {
  results: Array<SaveSelfAssessmentResultItem>;
};

export enum SearchEntityType {
  /**
   * An AI agent of the instance, as its own result. Visible to every caller who can reach the search feature,
   * like COMPANY; `personId` is null.
   * Indexed: name (highest weight); vendor and role; covers, tool names, tool descriptions and integrations;
   * guardrails; prose in both languages. A text search restricted to exactly [AGENT] that finds nothing by full
   * text falls back to name similarity, so a typo still finds the agent.
   */
  Agent = 'AGENT',
  Certificate = 'CERTIFICATE',
  /**
   * A company result. Search considers name, expertise labels and industry, with name weighted highest.
   * The company summary is excluded.
   */
  Company = 'COMPANY',
  Document = 'DOCUMENT',
  Education = 'EDUCATION',
  Experience = 'EXPERIENCE',
  Expertise = 'EXPERTISE',
  Match = 'MATCH',
  Person = 'PERSON',
  SharedItemPost = 'SHARED_ITEM_POST',
  SharedItemProject = 'SHARED_ITEM_PROJECT'
}

export type SelfAssessment = Node & {
  __typename?: 'SelfAssessment';
  id: Scalars['ID']['output'];
  questions: Array<SelfAssessmentStatement>;
};

/** The filterable fields of type SelfAssessment */
export type SelfAssessmentFilterInput = {
  and?: InputMaybe<Array<SelfAssessmentFilterInput>>;
  not?: InputMaybe<SelfAssessmentFilterInput>;
  or?: InputMaybe<Array<SelfAssessmentFilterInput>>;
};

export type SelfAssessmentResultsQueryInput = {
  element: CreativityElement;
};

export type SelfAssessmentSavedAnswer = {
  __typename?: 'SelfAssessmentSavedAnswer';
  questionId: Scalars['UUID']['output'];
  scorePercent: Scalars['Int']['output'];
};

/** The filterable fields of type SelfAssessmentSavedAnswer */
export type SelfAssessmentSavedAnswerFilterInput = {
  and?: InputMaybe<Array<SelfAssessmentSavedAnswerFilterInput>>;
  not?: InputMaybe<SelfAssessmentSavedAnswerFilterInput>;
  or?: InputMaybe<Array<SelfAssessmentSavedAnswerFilterInput>>;
};

export type SelfAssessmentStatement = Node & {
  __typename?: 'SelfAssessmentStatement';
  content: LocalizedText;
  element: CreativityElement;
  id: Scalars['ID']['output'];
  invertResult: Scalars['Boolean']['output'];
};

/** The filterable fields of type SelfAssessmentStatement */
export type SelfAssessmentStatementFilterInput = {
  and?: InputMaybe<Array<SelfAssessmentStatementFilterInput>>;
  not?: InputMaybe<SelfAssessmentStatementFilterInput>;
  or?: InputMaybe<Array<SelfAssessmentStatementFilterInput>>;
};

export type SelfAssessmentStatementsInput = {
  element: CreativityElement;
};

export type SendChatMessageInput = {
  content: Scalars['String']['input'];
  conversationId: Scalars['UUID']['input'];
};

export type SendListingApplicationMailInput = {
  applicationId: Scalars['UUID']['input'];
  previewId: Scalars['UUID']['input'];
  /** Generated by the client for each confirmation. The same id sends at most once. */
  requestId: Scalars['UUID']['input'];
};

export type SendListingApplicationMailOutput = SendListingApplicationMailResult;

export type SendListingApplicationMailResult = {
  __typename?: 'SendListingApplicationMailResult';
  application: ListingApplication;
  mail: ListingApplicationMail;
};

/** The filterable fields of type SendListingApplicationMailResult */
export type SendListingApplicationMailResultFilterInput = {
  and?: InputMaybe<Array<SendListingApplicationMailResultFilterInput>>;
  not?: InputMaybe<SendListingApplicationMailResultFilterInput>;
  or?: InputMaybe<Array<SendListingApplicationMailResultFilterInput>>;
};

/**
 * Add one expertise label. Requires company admin membership. A duplicate within that company,
 * ignoring case and surrounding whitespace, is rejected with `GENESIS001247`; it is not an update.
 * The same label may occur independently at other companies.
 */
export type SetCompanyCompetencyInput = {
  companyId: Scalars['ID']['input'];
  /** 1..255 characters after trimming. Blank is refused (GENESIS001228), over-length is refused (GENESIS001229). */
  label: Scalars['String']['input'];
};

/**
 * Mark or unmark an existing company member as a contact person. An unknown person or a non-member
 * is rejected; this operation does not create membership.
 */
export type SetCompanyContactPersonInput = {
  companyId: Scalars['ID']['input'];
  contactPerson: Scalars['Boolean']['input'];
  personId: Scalars['ID']['input'];
};

export type SetConversationTypingInput = {
  conversationId: Scalars['UUID']['input'];
  typing: Scalars['Boolean']['input'];
};

export type SetGroupSharingEligibilityInput = {
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  eligible: Scalars['Boolean']['input'];
  groupId: Scalars['ID']['input'];
};

/**
 * Complete desired listing access list. Omitted people lose access. Entries for the creator are ignored and
 * the creator's own entry remains.
 */
export type SetListingAccessInput = {
  access: Array<ListingAccessInput>;
  /**
   * The `Listing.accessRevision` used to prepare this list. If access changed since then, the request is
   * rejected without writing anything. Read the list again before deciding on a new update.
   */
  expectedRevision: Scalars['String']['input'];
  listingId: Scalars['UUID']['input'];
};

export type SetListingAccessOutput = SetListingAccessResult;

export type SetListingAccessResult = {
  __typename?: 'SetListingAccessResult';
  listing: Listing;
};

/** The filterable fields of type SetListingAccessResult */
export type SetListingAccessResultFilterInput = {
  and?: InputMaybe<Array<SetListingAccessResultFilterInput>>;
  not?: InputMaybe<SetListingAccessResultFilterInput>;
  or?: InputMaybe<Array<SetListingAccessResultFilterInput>>;
};

export type SetListingApplicationProcessInput = {
  listingId: Scalars['UUID']['input'];
  process: Scalars['Object']['input'];
};

export type SetListingApplicationStageInput = {
  id: Scalars['UUID']['input'];
  stageId: Scalars['String']['input'];
};

/**
 * Change an application's effective state: RECEIVED to IN_REVIEW, IN_REVIEW to ACCEPTED or REJECTED and either
 * of those decisions back to IN_REVIEW. Repeating the current state has no effect. Other transitions,
 * including every transition from WITHDRAWN, are rejected.
 */
export type SetListingApplicationStateInput = {
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['UUID']['input'];
  state: ListingApplicationState;
};

export type SetListingApplicationStateOutput = SetListingApplicationStateResult;

export type SetListingApplicationStateResult = {
  __typename?: 'SetListingApplicationStateResult';
  application: ListingApplication;
};

/** The filterable fields of type SetListingApplicationStateResult */
export type SetListingApplicationStateResultFilterInput = {
  and?: InputMaybe<Array<SetListingApplicationStateResultFilterInput>>;
  not?: InputMaybe<SetListingApplicationStateResultFilterInput>;
  or?: InputMaybe<Array<SetListingApplicationStateResultFilterInput>>;
};

export type SetListingCompanyConditionsInput = {
  conditions: Array<CompanyMatchConditionInput>;
  listingId: Scalars['UUID']['input'];
};

export type SetListingConditionsInput = {
  conditions: Array<MatchConditionInput>;
  listingId: Scalars['UUID']['input'];
};

export type SetListingMailNotificationInput = {
  applicationReceived: Scalars['Boolean']['input'];
  listingId: Scalars['UUID']['input'];
  matchResultAvailable: Scalars['Boolean']['input'];
};

/**
 * Listing state transition from its effective current state. OPEN publishes a DRAFT or reopens CLOSED or
 * CONCLUDED; DRAFT withdraws OPEN; CLOSED closes OPEN; CONCLUDED concludes CLOSED. Choosing the current state
 * has no effect. All other transitions are rejected.
 */
export type SetListingStateInput = {
  /**
   * Deadline change applied before validating the transition. Omission preserves it; null removes it. Opening
   * with an expired deadline requires moving or removing that deadline in this request, otherwise the request
   * is rejected because it would immediately close the listing again.
   */
  deadline?: InputMaybe<Scalars['DateTime']['input']>;
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['UUID']['input'];
  state: ListingState;
};

export type SetListingStateOutput = SetListingStateResult;

export type SetListingStateResult = {
  __typename?: 'SetListingStateResult';
  listing: Listing;
};

/** The filterable fields of type SetListingStateResult */
export type SetListingStateResultFilterInput = {
  and?: InputMaybe<Array<SetListingStateResultFilterInput>>;
  not?: InputMaybe<SetListingStateResultFilterInput>;
  or?: InputMaybe<Array<SetListingStateResultFilterInput>>;
};

/**
 * Switches auto-match on or off. Switching on records the caller as the person every automatic run acts for;
 * switching it on again while it is on changes nothing.
 */
export type SetMatchAutoMatchInput = {
  enabled: Scalars['Boolean']['input'];
  matchId: Scalars['UUID']['input'];
};

export type SetMatchAutoMatchOutput = SetMatchAutoMatchResult;

export type SetMatchAutoMatchResult = {
  __typename?: 'SetMatchAutoMatchResult';
  match: Match;
};

/** The filterable fields of type SetMatchAutoMatchResult */
export type SetMatchAutoMatchResultFilterInput = {
  and?: InputMaybe<Array<SetMatchAutoMatchResultFilterInput>>;
  not?: InputMaybe<SetMatchAutoMatchResultFilterInput>;
  or?: InputMaybe<Array<SetMatchAutoMatchResultFilterInput>>;
};

export type SetMatchCompanyConditionsInput = {
  conditions: Array<CompanyMatchConditionInput>;
  matchId: Scalars['UUID']['input'];
};

export type SetMatchCompanyConditionsOutput = SetMatchCompanyConditionsResult;

export type SetMatchCompanyConditionsResult = {
  __typename?: 'SetMatchCompanyConditionsResult';
  match: Match;
};

/** The filterable fields of type SetMatchCompanyConditionsResult */
export type SetMatchCompanyConditionsResultFilterInput = {
  and?: InputMaybe<Array<SetMatchCompanyConditionsResultFilterInput>>;
  not?: InputMaybe<SetMatchCompanyConditionsResultFilterInput>;
  or?: InputMaybe<Array<SetMatchCompanyConditionsResultFilterInput>>;
};

export type SetMatchConditionsInput = {
  conditions: Array<MatchConditionInput>;
  matchId: Scalars['UUID']['input'];
};

export type SetMatchConditionsOutput = SetMatchConditionsResult;

export type SetMatchConditionsResult = {
  __typename?: 'SetMatchConditionsResult';
  match: Match;
};

/** The filterable fields of type SetMatchConditionsResult */
export type SetMatchConditionsResultFilterInput = {
  and?: InputMaybe<Array<SetMatchConditionsResultFilterInput>>;
  not?: InputMaybe<SetMatchConditionsResultFilterInput>;
  or?: InputMaybe<Array<SetMatchConditionsResultFilterInput>>;
};

export type SetMatchNotesInput = {
  aiCopilotText?: InputMaybe<Scalars['String']['input']>;
  matchId: Scalars['UUID']['input'];
};

export type SetMatchNotesOutput = SetMatchNotesResult;

export type SetMatchNotesResult = {
  __typename?: 'SetMatchNotesResult';
  match: Match;
};

/** The filterable fields of type SetMatchNotesResult */
export type SetMatchNotesResultFilterInput = {
  and?: InputMaybe<Array<SetMatchNotesResultFilterInput>>;
  not?: InputMaybe<SetMatchNotesResultFilterInput>;
  or?: InputMaybe<Array<SetMatchNotesResultFilterInput>>;
};

export type SetMatchProjectInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  matchId: Scalars['UUID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  shortDescription?: InputMaybe<Scalars['String']['input']>;
};

export type SetMatchProjectOutput = SetMatchProjectResult;

export type SetMatchProjectResult = {
  __typename?: 'SetMatchProjectResult';
  match: Match;
};

/** The filterable fields of type SetMatchProjectResult */
export type SetMatchProjectResultFilterInput = {
  and?: InputMaybe<Array<SetMatchProjectResultFilterInput>>;
  not?: InputMaybe<SetMatchProjectResultFilterInput>;
  or?: InputMaybe<Array<SetMatchProjectResultFilterInput>>;
};

export type SetMatchTeamSizeInput = {
  matchId: Scalars['UUID']['input'];
  teamCount?: InputMaybe<Scalars['Int']['input']>;
  teamSize: Scalars['Int']['input'];
};

export type SetMatchTeamSizeOutput = SetMatchTeamSizeResult;

export type SetMatchTeamSizeResult = {
  __typename?: 'SetMatchTeamSizeResult';
  match: Match;
};

/** The filterable fields of type SetMatchTeamSizeResult */
export type SetMatchTeamSizeResultFilterInput = {
  and?: InputMaybe<Array<SetMatchTeamSizeResultFilterInput>>;
  not?: InputMaybe<SetMatchTeamSizeResultFilterInput>;
  or?: InputMaybe<Array<SetMatchTeamSizeResultFilterInput>>;
};

/**
 * Partial replacement, as on a profile entry: omitted fields keep their value. sharedWith takes Group IDs from
 * contentSharingRecipients; new toplists start with allGroups enabled and publiclyReadable disabled.
 */
export type SetMyToplistSharingInput = {
  allGroups?: InputMaybe<Scalars['Boolean']['input']>;
  domain: FavoriteDomain;
  publiclyReadable?: InputMaybe<Scalars['Boolean']['input']>;
  sharedWith?: InputMaybe<Array<ContentSharingRecipientRelationInput>>;
};

export type SetPersonalSharingInput = {
  /** Partial replacement: omitted attributes remain unchanged; empty lists revoke their consent. IDs identify Groups. */
  data: CreatePersonSharedAttributesDataInput;
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Settings = {
  __typename?: 'Settings';
  /**
   * Client-defined JSON object of preference keys and values. Read using `settings`; change keys
   * using `updateSettings`. Supplied top-level values replace the corresponding preferences.
   */
  settings?: Maybe<Scalars['Object']['output']>;
};

/** The filterable fields of type Settings */
export type SettingsFilterInput = {
  and?: InputMaybe<Array<SettingsFilterInput>>;
  not?: InputMaybe<SettingsFilterInput>;
  or?: InputMaybe<Array<SettingsFilterInput>>;
};

export type SharableEntity = {
  /** Public readership, independent of Group recipients. Company and HR publication rules still apply. */
  publiclyReadable?: Maybe<Scalars['Boolean']['output']>;
  /** Group recipients; an empty list grants no ordinary Group readership. */
  sharedWith?: Maybe<Array<ContentSharingRecipient>>;
};

/** The filterable fields of type SharableEntity */
export type SharableEntityFilterInput = {
  and?: InputMaybe<Array<SharableEntityFilterInput>>;
  not?: InputMaybe<SharableEntityFilterInput>;
  or?: InputMaybe<Array<SharableEntityFilterInput>>;
};

export type SharedItem = Node & SharableEntity & {
  __typename?: 'SharedItem';
  /** Applicant-facing classification. Never changes sharing, responsibility or publication. */
  categories: Array<DiscoveryCategory>;
  commented?: Maybe<Scalars['Boolean']['output']>;
  comments?: Maybe<Scalars['Int']['output']>;
  /**
   *   Company that owns this item, or null for personal content. Set only at creation by an admin of
   *   that company; ownership cannot be transferred later. `createdBy` still identifies the human author.
   *   The company must be active; inactive-company content writes are rejected with `GENESIS001250`.
   *
   * The nested company filter supports these example criteria:
   *   - `{company: {name: {any: true}}}` selects company-owned items.
   *   - `{company: {name: {any: false}}}` selects personal items.
   *   - `{company: {name: {contains: "Example Company"}}}` selects by company name.
   *   - `{company: {id: {eq: "123e4567-e89b-12d3-a456-426614174000"}}}` selects by id.
   *
   * Filtering does not widen visibility. `sharedItems` excludes inactive-company content even when a
   *   company is explicitly selected; `companyOwnedSharedItems` can still return that company's items.
   */
  company?: Maybe<Company>;
  /**
   *   Human author, including when the item belongs to a company. Authorship does not grant permission
   *   to change company-owned content. Null when the author is unavailable or not visible to the caller.
   *
   * The nested Person filter selects by author, for example
   *   `{createdBy: {id: {eq: "123e4567-e89b-12d3-a456-426614174000"}}}`. It includes company-owned items;
   *   combine it with `{company: {name: {any: false}}}` to select only personal items. Filtering by an
   *   author does not bypass byline visibility: a caller lacking that visibility receives an empty page.
   */
  createdBy?: Maybe<Person>;
  darkMode?: Maybe<Colors>;
  description?: Maybe<Scalars['String']['output']>;
  files?: Maybe<Array<File>>;
  filesToDelete?: Maybe<Array<Maybe<Scalars['UUID']['output']>>>;
  id: Scalars['ID']['output'];
  images?: Maybe<Array<File>>;
  imagesToDelete?: Maybe<Array<Maybe<Scalars['UUID']['output']>>>;
  /**
   *   Whether the caller currently administers this item's company; false for personal items. Company
   *   items require current admin membership to edit or delete, even for their original author. Personal
   *   items use their own ownership and permission checks. This field does not itself authorize a write.
   *
   * Editing or deleting company items also requires `actingAsCompanyId` to identify that company.
   *   For personal items, omit the declaration. Inactive-company content remains frozen.
   */
  isAdminOfCompany?: Maybe<Scalars['Boolean']['output']>;
  itemType?: Maybe<SharedItemType>;
  lightMode?: Maybe<Colors>;
  mainImage?: Maybe<File>;
  name?: Maybe<Scalars['String']['output']>;
  /**
   *   Whether the caller authored this item, including company-owned items. The filter of the same name
   *   instead selects the caller's personal items and excludes company-owned items. Thus an item's owner
   *   field can be true while the owner filter excludes it.
   *
   * For personal items, ownership is relevant to write authorization. For company-owned items, current
   *   company admin membership is required; authorship alone is insufficient. Writes also validate
   *   `actingAsCompanyId` and the company's active status.
   */
  owner?: Maybe<Scalars['Boolean']['output']>;
  pinned?: Maybe<Scalars['Boolean']['output']>;
  /** Public readership, independent of Group recipients. Company and HR publication rules still apply. */
  publiclyReadable?: Maybe<Scalars['Boolean']['output']>;
  publishedOn?: Maybe<Scalars['DateTime']['output']>;
  rated?: Maybe<Scalars['Boolean']['output']>;
  rating?: Maybe<Scalars['Float']['output']>;
  ratings?: Maybe<Scalars['Int']['output']>;
  /** Group recipients; an empty list grants no ordinary Group readership. */
  sharedWith?: Maybe<Array<ContentSharingRecipient>>;
  shortDescription?: Maybe<Scalars['String']['output']>;
  signUps?: Maybe<Scalars['Int']['output']>;
  signedUp?: Maybe<Scalars['Boolean']['output']>;
  views?: Maybe<Scalars['Int']['output']>;
  watches?: Maybe<Scalars['Int']['output']>;
};


export type SharedItemMainImageArgs = {
  profile?: InputMaybe<Scalars['String']['input']>;
};

export type SharedItemComment = Node & {
  __typename?: 'SharedItemComment';
  /**
   * Company on whose behalf this comment was written, or null for a personal comment. Set at creation
   * by a company admin and cannot be changed. Current admins can edit company comments regardless of
   * who authored them. `person` identifies the author independently; the company remains identifiable
   * if the author is erased. The company's logo is always null on this reference.
   */
  company?: Maybe<Company>;
  content?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /**
   * Whether the caller currently administers the comment's company; false for personal comments.
   * Company comments require current admin membership to edit or delete, including for their author,
   * and a matching `actingAsCompanyId`. Personal comments require authorship or `write:person` and no
   * acting-company declaration. Writes are rejected when the comment's company or the item's company
   * is inactive. This field alone does not authorize a write.
   */
  isAdminOfCompany?: Maybe<Scalars['Boolean']['output']>;
  person?: Maybe<Person>;
  postedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The item receiving this comment. Set at creation and cannot be changed. */
  sharedItem?: Maybe<SharedItem>;
  sharedItemId?: Maybe<Scalars['UUID']['output']>;
  /** When this comment was last edited, or null if it has never been edited. */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * Person who last edited this comment. Null if never edited, if the person has been erased,
   * or if that person is not visible to the caller.
   */
  updatedBy?: Maybe<Person>;
};

export type SharedItemCommentConnection = {
  __typename?: 'SharedItemCommentConnection';
  edges: Array<SharedItemCommentEdge>;
  nodes: Array<SharedItemComment>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type SharedItemCommentEdge = {
  __typename?: 'SharedItemCommentEdge';
  cursor: Scalars['String']['output'];
  node: SharedItemComment;
};

/** The filterable fields of type SharedItemComment */
export type SharedItemCommentFilterInput = {
  and?: InputMaybe<Array<SharedItemCommentFilterInput>>;
  content?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  not?: InputMaybe<SharedItemCommentFilterInput>;
  or?: InputMaybe<Array<SharedItemCommentFilterInput>>;
  person?: InputMaybe<PersonFilterInput>;
  /** The item receiving this comment. Set at creation and cannot be changed. */
  sharedItem?: InputMaybe<SharedItemFilterInput>;
  sharedItemId?: InputMaybe<UuidFilterInput>;
};

/** The parameters for requesting multiple instances of SharedItemComment. Mixing fields of cursor-based and offset-based pagination will result in an error. */
export type SharedItemCommentQueryInput = {
  /** Cursor-based pagination: The immediate successor of this cursor will be the first entry of the requested page */
  after?: InputMaybe<Scalars['String']['input']>;
  /** Cursor-based pagination: The immediate predecessor of this cursor will be last entry of the requested page */
  before?: InputMaybe<Scalars['String']['input']>;
  /** Cursor-based pagination: Number of rows to be returned. Use in conjunction with 'after' */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** Cursor-based pagination: Number of rows to be returned. Use in conjunction with 'before' */
  last?: InputMaybe<Scalars['Int']['input']>;
  /** The sorting order of the instances */
  order?: InputMaybe<SharedItemCommentSortInput>;
  /** Offset-based pagination: Number of rows to skip */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Offset-based pagination: Number of rows to be returned */
  take?: InputMaybe<Scalars['Int']['input']>;
  /** The filter to be applied */
  where?: InputMaybe<SharedItemCommentFilterInput>;
};

export type SharedItemCommentSortInput = {
  postedAt?: InputMaybe<SortOrder>;
};

export type SharedItemConnection = {
  __typename?: 'SharedItemConnection';
  edges: Array<SharedItemEdge>;
  nodes: Array<SharedItem>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type SharedItemEdge = {
  __typename?: 'SharedItemEdge';
  cursor: Scalars['String']['output'];
  node: SharedItem;
};

/** The filterable fields of type SharedItem */
export type SharedItemFilterInput = {
  and?: InputMaybe<Array<SharedItemFilterInput>>;
  /** Applicant-facing classification. Never changes sharing, responsibility or publication. */
  categories?: InputMaybe<DiscoveryCategoryListFilterInput>;
  commented?: InputMaybe<BooleanFilterInput>;
  /**
   * Company that owns this item, or null for personal content. Set only at creation by an admin of
   * that company; ownership cannot be transferred later. `createdBy` still identifies the human author.
   * The company must be active; inactive-company content writes are rejected with `GENESIS001250`.
   *
   * The nested company filter supports these example criteria:
   * - `{company: {name: {any: true}}}` selects company-owned items.
   * - `{company: {name: {any: false}}}` selects personal items.
   * - `{company: {name: {contains: "Example Company"}}}` selects by company name.
   * - `{company: {id: {eq: "123e4567-e89b-12d3-a456-426614174000"}}}` selects by id.
   *
   * Filtering does not widen visibility. `sharedItems` excludes inactive-company content even when a
   * company is explicitly selected; `companyOwnedSharedItems` can still return that company's items.
   */
  company?: InputMaybe<CompanyFilterInput>;
  /**
   * Human author, including when the item belongs to a company. Authorship does not grant permission
   * to change company-owned content. Null when the author is unavailable or not visible to the caller.
   *
   * The nested Person filter selects by author, for example
   * `{createdBy: {id: {eq: "123e4567-e89b-12d3-a456-426614174000"}}}`. It includes company-owned items;
   * combine it with `{company: {name: {any: false}}}` to select only personal items. Filtering by an
   * author does not bypass byline visibility: a caller lacking that visibility receives an empty page.
   */
  createdBy?: InputMaybe<PersonFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  isInAnyPinGroup?: InputMaybe<BooleanFilterInput>;
  itemType?: InputMaybe<SharedItemTypeFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<SharedItemFilterInput>;
  or?: InputMaybe<Array<SharedItemFilterInput>>;
  /**
   * Whether the caller authored this item, including company-owned items. The filter of the same name
   * instead selects the caller's personal items and excludes company-owned items. Thus an item's owner
   * field can be true while the owner filter excludes it.
   *
   * For personal items, ownership is relevant to write authorization. For company-owned items, current
   * company admin membership is required; authorship alone is insufficient. Writes also validate
   * `actingAsCompanyId` and the company's active status.
   */
  owner?: InputMaybe<BooleanFilterInput>;
  pinGroupId?: InputMaybe<UuidFilterInput>;
  pinned?: InputMaybe<BooleanFilterInput>;
  rated?: InputMaybe<BooleanFilterInput>;
  shortDescription?: InputMaybe<StringFilterInput>;
  signedUp?: InputMaybe<BooleanFilterInput>;
};

/** The parameters for requesting multiple instances of SharedItem. Mixing fields of cursor-based and offset-based pagination will result in an error. */
export type SharedItemQueryInput = {
  /** Cursor-based pagination: The immediate successor of this cursor will be the first entry of the requested page */
  after?: InputMaybe<Scalars['String']['input']>;
  /** Cursor-based pagination: The immediate predecessor of this cursor will be last entry of the requested page */
  before?: InputMaybe<Scalars['String']['input']>;
  /** Cursor-based pagination: Number of rows to be returned. Use in conjunction with 'after' */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** Cursor-based pagination: Number of rows to be returned. Use in conjunction with 'before' */
  last?: InputMaybe<Scalars['Int']['input']>;
  /** The sorting order of the instances */
  order?: InputMaybe<SharedItemSortInput>;
  /** Offset-based pagination: Number of rows to skip */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Offset-based pagination: Number of rows to be returned */
  take?: InputMaybe<Scalars['Int']['input']>;
  /** The filter to be applied */
  where?: InputMaybe<SharedItemFilterInput>;
};

export type SharedItemRating = {
  __typename?: 'SharedItemRating';
  comment?: Maybe<Scalars['String']['output']>;
  fiveStarRating?: Maybe<Scalars['Float']['output']>;
  person?: Maybe<Person>;
  ratedAt?: Maybe<Scalars['DateTime']['output']>;
  sharedItem?: Maybe<SharedItem>;
  sharedItemId?: Maybe<Scalars['UUID']['output']>;
};

export type SharedItemRatingConnection = {
  __typename?: 'SharedItemRatingConnection';
  edges: Array<SharedItemRatingEdge>;
  nodes: Array<SharedItemRating>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type SharedItemRatingEdge = {
  __typename?: 'SharedItemRatingEdge';
  cursor: Scalars['String']['output'];
  node: SharedItemRating;
};

/** The filterable fields of type SharedItemRating */
export type SharedItemRatingFilterInput = {
  and?: InputMaybe<Array<SharedItemRatingFilterInput>>;
  comment?: InputMaybe<StringFilterInput>;
  fiveStarRating?: InputMaybe<FloatFilterInput>;
  not?: InputMaybe<SharedItemRatingFilterInput>;
  or?: InputMaybe<Array<SharedItemRatingFilterInput>>;
  ratedAt?: InputMaybe<DateTimeFilterInput>;
  sharedItem?: InputMaybe<SharedItemFilterInput>;
  sharedItemId?: InputMaybe<UuidFilterInput>;
};

/** The parameters for requesting multiple instances of SharedItemRating. Mixing fields of cursor-based and offset-based pagination will result in an error. */
export type SharedItemRatingQueryInput = {
  /** Cursor-based pagination: The immediate successor of this cursor will be the first entry of the requested page */
  after?: InputMaybe<Scalars['String']['input']>;
  /** Cursor-based pagination: The immediate predecessor of this cursor will be last entry of the requested page */
  before?: InputMaybe<Scalars['String']['input']>;
  /** Cursor-based pagination: Number of rows to be returned. Use in conjunction with 'after' */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** Cursor-based pagination: Number of rows to be returned. Use in conjunction with 'before' */
  last?: InputMaybe<Scalars['Int']['input']>;
  /** The sorting order of the instances */
  order?: InputMaybe<SharedItemRatingSortInput>;
  /** Offset-based pagination: Number of rows to skip */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Offset-based pagination: Number of rows to be returned */
  take?: InputMaybe<Scalars['Int']['input']>;
  /** The filter to be applied */
  where?: InputMaybe<SharedItemRatingFilterInput>;
};

export type SharedItemRatingSortInput = {
  comment?: InputMaybe<SortOrder>;
  fiveStarRating?: InputMaybe<SortOrder>;
  ratedAt?: InputMaybe<SortOrder>;
};

/** Contains information for linking 'SharedItem' to other entities */
export type SharedItemRelationInput = {
  /** The identifier of 'SharedItem' */
  id: Scalars['ID']['input'];
};

export type SharedItemSignUpQueryInput = {
  /** Cursor-based pagination: The immediate successor of this cursor will be the first entry of the requested page */
  after?: InputMaybe<Scalars['String']['input']>;
  /** Cursor-based pagination: The immediate predecessor of this cursor will be last entry of the requested page */
  before?: InputMaybe<Scalars['String']['input']>;
  /** Cursor-based pagination: Number of rows to be returned. Use in conjunction with 'after' */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** Cursor-based pagination: Number of rows to be returned. Use in conjunction with 'before' */
  last?: InputMaybe<Scalars['Int']['input']>;
  sharedItemId: Scalars['UUID']['input'];
  /** Offset-based pagination: Number of rows to skip */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Offset-based pagination: Number of rows to be returned */
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type SharedItemSortInput = {
  comments?: InputMaybe<SortOrder>;
  /**
   * Human author, including when the item belongs to a company. Authorship does not grant permission
   * to change company-owned content. Null when the author is unavailable or not visible to the caller.
   *
   * The nested Person filter selects by author, for example
   * `{createdBy: {id: {eq: "123e4567-e89b-12d3-a456-426614174000"}}}`. It includes company-owned items;
   * combine it with `{company: {name: {any: false}}}` to select only personal items. Filtering by an
   * author does not bypass byline visibility: a caller lacking that visibility receives an empty page.
   */
  createdBy?: InputMaybe<PersonSortInput>;
  description?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  publishedOn?: InputMaybe<SortOrder>;
  rating?: InputMaybe<SortOrder>;
  shortDescription?: InputMaybe<SortOrder>;
  signUps?: InputMaybe<SortOrder>;
};

export enum SharedItemType {
  Post = 'POST',
  Project = 'PROJECT'
}

export type SharedItemTypeFilterInput = {
  /** Logical 'and' of one or more predicates */
  and?: InputMaybe<Array<SharedItemTypeFilterInput>>;
  /** Checks if the field has a value or not */
  any?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks if the field's value is equal to the given value */
  eq?: InputMaybe<SharedItemType>;
  /** Checks if the field's value is in the list of the given values */
  in?: InputMaybe<Array<SharedItemType>>;
  /** Checks if the field's value is not equal to the given value */
  ne?: InputMaybe<SharedItemType>;
  /** Negates the predicate */
  not?: InputMaybe<SharedItemTypeFilterInput>;
  /** Logical 'or' of one or more predicates */
  or?: InputMaybe<Array<SharedItemTypeFilterInput>>;
};

export type SharedItemWithDate = {
  __typename?: 'SharedItemWithDate';
  dateTime: Scalars['DateTime']['output'];
  sharedItem: SharedItem;
};

/** The filterable fields of type SharedItemWithDate */
export type SharedItemWithDateFilterInput = {
  and?: InputMaybe<Array<SharedItemWithDateFilterInput>>;
  not?: InputMaybe<SharedItemWithDateFilterInput>;
  or?: InputMaybe<Array<SharedItemWithDateFilterInput>>;
};

export type SignUpSharedProjectInput = {
  person?: InputMaybe<Scalars['UUID']['input']>;
  sharedItemId: Scalars['UUID']['input'];
  signedUp?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SignUpSharedProjectOutput = SignUpSharedProjectResult;

export type SignUpSharedProjectResult = {
  __typename?: 'SignUpSharedProjectResult';
  sharedItemId?: Maybe<Scalars['UUID']['output']>;
};

/** The filterable fields of type SignUpSharedProjectResult */
export type SignUpSharedProjectResultFilterInput = {
  and?: InputMaybe<Array<SignUpSharedProjectResultFilterInput>>;
  not?: InputMaybe<SignUpSharedProjectResultFilterInput>;
  or?: InputMaybe<Array<SignUpSharedProjectResultFilterInput>>;
};

export type SmartAnalysisEvidence = {
  __typename?: 'SmartAnalysisEvidence';
  /** Source document id; null when unavailable, including when evidence outlives its document. */
  documentId?: Maybe<Scalars['UUID']['output']>;
  documentName: Scalars['String']['output'];
  pageNumber: Scalars['Int']['output'];
  quote: Scalars['String']['output'];
  stance: EvidencePolarity;
  support: EvidenceStrength;
};

/** The filterable fields of type SmartAnalysisEvidence */
export type SmartAnalysisEvidenceFilterInput = {
  and?: InputMaybe<Array<SmartAnalysisEvidenceFilterInput>>;
  not?: InputMaybe<SmartAnalysisEvidenceFilterInput>;
  or?: InputMaybe<Array<SmartAnalysisEvidenceFilterInput>>;
};

export type SmartAnalysisResult = {
  __typename?: 'SmartAnalysisResult';
  /**
   * The power's centrality rank in that analysis, 1 = the most central. Null whenever `tier` is, and when the analysis
   * tiered its powers without ranking them by centrality.
   */
  centralityRank?: Maybe<Scalars['Int']['output']>;
  confidence: Scalars['Float']['output'];
  element: CreativityElement;
  evidences: Array<SmartAnalysisEvidence>;
  rationale?: Maybe<Scalars['String']['output']>;
  score: Scalars['Int']['output'];
  /**
   * The power's tier in the document analysis that wrote this value. Null for values from other sources (roleplay) and
   * for analyses stored before tiers were kept.
   */
  tier?: Maybe<PowerTier>;
};

/** The filterable fields of type SmartAnalysisResult */
export type SmartAnalysisResultFilterInput = {
  and?: InputMaybe<Array<SmartAnalysisResultFilterInput>>;
  not?: InputMaybe<SmartAnalysisResultFilterInput>;
  or?: InputMaybe<Array<SmartAnalysisResultFilterInput>>;
};

/** Defines the sorting order of a field. */
export enum SortOrder {
  /** Sort ascending, null values first */
  Asc = 'ASC',
  /** Sort descending, null values last */
  Desc = 'DESC'
}

export type StringConditionInput = {
  kind: StringConditionKind;
  value: Scalars['String']['input'];
};

export enum StringConditionKind {
  DriversLicense = 'DRIVERS_LICENSE',
  Nationality = 'NATIONALITY'
}

/** Defines case-sensitivity for a string based filter. */
export enum StringFilterCaseSensitivity {
  /** Case insensitive comparisons (a == A) */
  CaseInsensitive = 'CASE_INSENSITIVE',
  /** Case sensitive comparisons (a != A) */
  CaseSensitive = 'CASE_SENSITIVE'
}

/** Filtering for fields of type String */
export type StringFilterInput = {
  /** Logical 'and' of one or more predicates */
  and?: InputMaybe<Array<StringFilterInput>>;
  /** If true, checks if the field has a value, or, if false, checks if the field is missing a value */
  any?: InputMaybe<Scalars['Boolean']['input']>;
  /** Indicates if comparisons should be case-sensitive or not */
  caseSensitivity?: InputMaybe<StringFilterCaseSensitivity>;
  /** Checks if the field's value contains the given value */
  contains?: InputMaybe<Scalars['String']['input']>;
  /** Checks if the field's value ends with the given suffix */
  endsWith?: InputMaybe<Scalars['String']['input']>;
  /** Checks if the field's value is equal to the given value */
  eq?: InputMaybe<Scalars['String']['input']>;
  /** Checks if the field's value is greater than or equal to the given value */
  ge?: InputMaybe<Scalars['String']['input']>;
  /** Checks if the field's value is greater than to the given value */
  gt?: InputMaybe<Scalars['String']['input']>;
  /** Checks if the field's value is in the list of the given values */
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Checks if the field's value is less than or equal to the given value */
  le?: InputMaybe<Scalars['String']['input']>;
  /** Checks if the field's value is less than to the given value */
  lt?: InputMaybe<Scalars['String']['input']>;
  /** Checks if the field's value is not equal to the given value */
  ne?: InputMaybe<Scalars['String']['input']>;
  /** Negates the predicate */
  not?: InputMaybe<StringFilterInput>;
  /** Logical 'or' of one or more predicates */
  or?: InputMaybe<Array<StringFilterInput>>;
  /** Checks if the field's value begins with the given prefix */
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

/** Filtering options for a list of elements with type String */
export type StringListFilterInput = {
  /** All list items must match the predicate */
  all?: InputMaybe<StringFilterInput>;
  /** If true, there should exist at least list item */
  any?: InputMaybe<Scalars['Boolean']['input']>;
  /** None of list items must match the predicate */
  none?: InputMaybe<StringFilterInput>;
  /** At least one of list items must match the predicate */
  some?: InputMaybe<StringFilterInput>;
};

/**
 * A private Markdown notebook. Only its creator can read, update or delete it, including when other
 * callers have administrative permissions. Saving replaces the complete text. The API exposes no
 * client version token; a later successful save can replace an earlier edit.
 */
export type StudioNotebook = Node & {
  __typename?: 'StudioNotebook';
  /** Complete notebook text in Markdown. */
  content?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type StudioNotebookConnection = {
  __typename?: 'StudioNotebookConnection';
  edges: Array<StudioNotebookEdge>;
  nodes: Array<StudioNotebook>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type StudioNotebookEdge = {
  __typename?: 'StudioNotebookEdge';
  cursor: Scalars['String']['output'];
  node: StudioNotebook;
};

/** The filterable fields of type StudioNotebook */
export type StudioNotebookFilterInput = {
  and?: InputMaybe<Array<StudioNotebookFilterInput>>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<StudioNotebookFilterInput>;
  or?: InputMaybe<Array<StudioNotebookFilterInput>>;
};

/** The parameters for requesting multiple instances of StudioNotebook. Mixing fields of cursor-based and offset-based pagination will result in an error. */
export type StudioNotebookQueryInput = {
  /** Cursor-based pagination: The immediate successor of this cursor will be the first entry of the requested page */
  after?: InputMaybe<Scalars['String']['input']>;
  /** Cursor-based pagination: The immediate predecessor of this cursor will be last entry of the requested page */
  before?: InputMaybe<Scalars['String']['input']>;
  /** Cursor-based pagination: Number of rows to be returned. Use in conjunction with 'after' */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** Cursor-based pagination: Number of rows to be returned. Use in conjunction with 'before' */
  last?: InputMaybe<Scalars['Int']['input']>;
  /** The sorting order of the instances */
  order?: InputMaybe<StudioNotebookSortInput>;
  /** Offset-based pagination: Number of rows to skip */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Offset-based pagination: Number of rows to be returned */
  take?: InputMaybe<Scalars['Int']['input']>;
  /** The filter to be applied */
  where?: InputMaybe<StudioNotebookFilterInput>;
};

export type StudioNotebookSortInput = {
  createdAt?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type Subscription = {
  __typename?: 'Subscription';
  conversationEvents: ConversationEvent;
  conversationLifecycleEvents: ConversationLifecycleEvent;
  /**
   * Streams lifecycle events of a documents-extraction job started via startDocumentsExtraction.
   * Emits a snapshot of the current job state first (QUEUED/STARTED, or the terminal event with
   * result for an already-finished job), then live events; the stream completes after a terminal
   * COMPLETED/FAILED event. Only the person who started the job may subscribe. Note: if processing is interrupted, no terminal event is ever emitted — clients should pair the
   * subscription with a timeout and fall back to the extractionJob status query.
   */
  documentsExtractionEvents: DocumentsExtractionEvent;
  /**
   * Streams complete progress snapshots for a detached YAML import until it reaches a terminal state.
   * Only the person who started the job may subscribe. Note: if processing is interrupted, the
   * job stays QUEUED/RUNNING and no terminal snapshot is ever emitted — clients should pair the
   * subscription with a timeout and fall back to the importJob status query.
   */
  importJobEvents: ImportJob;
  /**
   * Subscribes to realtime notification changes for the current user. Events for notification
   * types outside input.supportedTypes are filtered out; when the input is absent only the six
   * original types are delivered (see NotificationsInput.supportedTypes).
   */
  notificationEvents: NotificationEvent;
  /**
   * Streams progress snapshots of one long-running operation the caller started with this progressId
   * (for example generateTransientMatchResult). The id is client generated and fresh per start; only the
   * person who started the operation receives anything. Snapshots are complete and arrive at most about
   * twice a second. The stream completes after a SUCCEEDED or FAILED snapshot, when the stored snapshot
   * expires, or when none appears within a minute of subscribing. Progress is best-effort: if processing is interrupted, no terminal snapshot follows, so clients bind the display to the
   * operation itself, not to this stream.
   */
  operationProgress: OperationProgress;
  unreadChatMessageCountUpdates: UnreadChatMessageCount;
  /** Subscribes to unread notification count changes for the current user. */
  unreadNotificationCountUpdates: UnreadNotificationCount;
};


export type SubscriptionConversationEventsArgs = {
  afterMessageId?: InputMaybe<Scalars['UUID']['input']>;
  conversationId: Scalars['UUID']['input'];
};


export type SubscriptionDocumentsExtractionEventsArgs = {
  jobId: Scalars['UUID']['input'];
};


export type SubscriptionImportJobEventsArgs = {
  jobId: Scalars['UUID']['input'];
};


export type SubscriptionNotificationEventsArgs = {
  input?: InputMaybe<SupportedNotificationTypesInput>;
};


export type SubscriptionOperationProgressArgs = {
  progressId: Scalars['UUID']['input'];
};


export type SubscriptionUnreadChatMessageCountUpdatesArgs = {
  conversationId?: InputMaybe<Scalars['UUID']['input']>;
};


export type SubscriptionUnreadNotificationCountUpdatesArgs = {
  input?: InputMaybe<SupportedNotificationTypesInput>;
};

/** The filterable fields of type Subscription */
export type SubscriptionFilterInput = {
  and?: InputMaybe<Array<SubscriptionFilterInput>>;
  not?: InputMaybe<SubscriptionFilterInput>;
  or?: InputMaybe<Array<SubscriptionFilterInput>>;
};

export type SuggestActivityDescriptionsInput = {
  /** Optional department context. */
  department?: InputMaybe<Scalars['String']['input']>;
  /** Job title to generate activities for. */
  jobTitle: Scalars['String']['input'];
  /** BCP-47 language tag identifying the response language (e.g., "en", "de"). */
  locale: Scalars['String']['input'];
  /** Optional focus area to bias the suggestions (free-text). */
  search?: InputMaybe<Scalars['String']['input']>;
};

export type SuggestExpertiseDescriptionsInput = {
  /** BCP-47 language tag identifying the response language (e.g., "en", "de"). */
  locale: Scalars['String']['input'];
  /** Optional focus area to bias the suggestions (free-text). */
  search?: InputMaybe<Scalars['String']['input']>;
};

export type SuggestListingRolesInput = {
  /** Optional free-text hint, at most 1000 characters. */
  hint?: InputMaybe<Scalars['String']['input']>;
  /** BCP-47 language tag identifying the response language (e.g., "en", "de"). */
  locale: Scalars['String']['input'];
  /** The match whose result the requirements come from. Must be visible to the caller. */
  matchId: Scalars['UUID']['input'];
  /** The selected requirements, 1 to 50. Keys must be unique; the suggestion refers to them only. */
  requirements: Array<ListingRoleRequirementInput>;
  /** Role titles the user already named, at most 10. The suggestion keeps them where they fit. */
  roleTitles?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type SuggestProfileSummaryInput = {
  /** BCP-47 language tag identifying the response language (e.g., "en", "de"). */
  locale: Scalars['String']['input'];
  /** Optional focus area to bias the summary (free-text), e.g. "emphasize leadership". */
  search?: InputMaybe<Scalars['String']['input']>;
};

export type SuggestedListingRole = {
  __typename?: 'SuggestedListingRole';
  /** Keys from the input, each at most once per role. A key may appear in several roles. */
  requirementKeys: Array<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

/** The filterable fields of type SuggestedListingRole */
export type SuggestedListingRoleFilterInput = {
  and?: InputMaybe<Array<SuggestedListingRoleFilterInput>>;
  not?: InputMaybe<SuggestedListingRoleFilterInput>;
  or?: InputMaybe<Array<SuggestedListingRoleFilterInput>>;
};

/** Result of a suggestion query. `suggestions` is empty for `EMPTY` and `UNAVAILABLE`. */
export type SuggestionResult = {
  __typename?: 'SuggestionResult';
  status: SuggestionStatus;
  suggestions: Array<Scalars['String']['output']>;
};

/** The filterable fields of type SuggestionResult */
export type SuggestionResultFilterInput = {
  and?: InputMaybe<Array<SuggestionResultFilterInput>>;
  not?: InputMaybe<SuggestionResultFilterInput>;
  or?: InputMaybe<Array<SuggestionResultFilterInput>>;
};

/**
 * Outcome of an AI suggestion request. OK means suggestions were returned; EMPTY means none were
 * found. UNAVAILABLE means generation or response validation failed and suggestions is empty.
 * Generation failures are returned as this status rather than GraphQL errors.
 */
export enum SuggestionStatus {
  Empty = 'EMPTY',
  Ok = 'OK',
  Unavailable = 'UNAVAILABLE'
}

/**
 * Declares which notification types the calling client understands. Shared by the
 * notification queries, mutations and subscriptions for backward compatibility with clients
 * built against an older schema.
 */
export type SupportedNotificationTypesInput = {
  /**
   * Notification types this client understands. Notifications and events of other types are
   * filtered out, and counts only include declared types. When absent, only the six original
   * types are considered (see NotificationsInput.supportedTypes for the rationale). The read
   * operations treat an empty list the same way; the bulk mutations take it literally and
   * affect nothing, since deleting or clearing "no types" must never mean "clear six of them".
   */
  supportedTypes?: InputMaybe<Array<NotificationType>>;
};

export type SystemSettings = {
  __typename?: 'SystemSettings';
  accentColor?: Maybe<Scalars['String']['output']>;
  appName?: Maybe<Scalars['String']['output']>;
  backgroundColor?: Maybe<Scalars['String']['output']>;
  backgroundImage?: Maybe<File>;
  candidateAssessmentPrompt?: Maybe<Scalars['String']['output']>;
  /**
   * The instance language: every mail is written in it except one to an applicant whose application form recorded a
   * language. DE until an
   * administrator chooses; never the language of whoever triggers the mail. Null only when the stored value is not a
   * supported language, a configuration error: the rest of the settings stay readable, Genesis sends no mail that would
   * need the instance language, and choosing DE or EN repairs it.
   */
  communicationLanguage?: Maybe<CommunicationLanguage>;
  logo?: Maybe<File>;
  /** Whether the installation allows anonymous Share access. Defaults to false until an administrator enables it. */
  publicShareEnabled: Scalars['Boolean']['output'];
  /** Ordinary SharedItems always include the default internal recipients when true. Defaults to true. */
  sharedItemsRequireDefaultRecipients: Scalars['Boolean']['output'];
  surfaceColor?: Maybe<Scalars['String']['output']>;
  welcomeMessage?: Maybe<Scalars['String']['output']>;
};

export type SystemSettingsDataInput = {
  accentColor?: InputMaybe<Scalars['String']['input']>;
  appName?: InputMaybe<Scalars['String']['input']>;
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  backgroundImage?: InputMaybe<SystemSettingsFileInput>;
  candidateAssessmentPrompt?: InputMaybe<Scalars['String']['input']>;
  /** Null restores DE, the built-in default. */
  communicationLanguage?: InputMaybe<CommunicationLanguage>;
  logo?: InputMaybe<SystemSettingsFileInput>;
  /** Enable or disable anonymous Share access; omission preserves the setting, null is rejected. */
  publicShareEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Controls new items and explicit sharing edits, without rewriting saved items. Null restores true. */
  sharedItemsRequireDefaultRecipients?: InputMaybe<Scalars['Boolean']['input']>;
  surfaceColor?: InputMaybe<Scalars['String']['input']>;
  welcomeMessage?: InputMaybe<Scalars['String']['input']>;
};

export type SystemSettingsFileInput = {
  content?: InputMaybe<Scalars['Binary']['input']>;
  fileExtension?: InputMaybe<Scalars['String']['input']>;
  mimeType?: InputMaybe<Scalars['String']['input']>;
};

/** The filterable fields of type SystemSettings */
export type SystemSettingsFilterInput = {
  and?: InputMaybe<Array<SystemSettingsFilterInput>>;
  not?: InputMaybe<SystemSettingsFilterInput>;
  or?: InputMaybe<Array<SystemSettingsFilterInput>>;
};

export type SystemSettingsInput = {
  data: SystemSettingsDataInput;
};

export type TakeOverSharedItemInput = {
  matchId: Scalars['UUID']['input'];
  sharedItemId: Scalars['UUID']['input'];
};

export type TakeOverSharedItemOutput = TakeOverSharedItemResult;

export type TakeOverSharedItemResult = {
  __typename?: 'TakeOverSharedItemResult';
  match: Match;
};

/** The filterable fields of type TakeOverSharedItemResult */
export type TakeOverSharedItemResultFilterInput = {
  and?: InputMaybe<Array<TakeOverSharedItemResultFilterInput>>;
  not?: InputMaybe<TakeOverSharedItemResultFilterInput>;
  or?: InputMaybe<Array<TakeOverSharedItemResultFilterInput>>;
};

/**
 * A named weight vector over the 30 powers. It defines priorities and has no team members.
 * Default profiles are editable through the API under the same permissions as other profiles.
 */
export type TeamProfile = Node & {
  __typename?: 'TeamProfile';
  id: Scalars['ID']['output'];
  localizedName?: Maybe<LocalizedText>;
  name?: Maybe<Scalars['String']['output']>;
  weights: Array<ElementWeight>;
};

export type TeamProfileConnection = {
  __typename?: 'TeamProfileConnection';
  edges: Array<TeamProfileEdge>;
  nodes: Array<TeamProfile>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TeamProfileEdge = {
  __typename?: 'TeamProfileEdge';
  cursor: Scalars['String']['output'];
  node: TeamProfile;
};

/** The filterable fields of type TeamProfile */
export type TeamProfileFilterInput = {
  and?: InputMaybe<Array<TeamProfileFilterInput>>;
  id?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<TeamProfileFilterInput>;
  or?: InputMaybe<Array<TeamProfileFilterInput>>;
};

/** The parameters for requesting multiple instances of TeamProfile. Mixing fields of cursor-based and offset-based pagination will result in an error. */
export type TeamProfileQueryInput = {
  /** Cursor-based pagination: The immediate successor of this cursor will be the first entry of the requested page */
  after?: InputMaybe<Scalars['String']['input']>;
  /** Cursor-based pagination: The immediate predecessor of this cursor will be last entry of the requested page */
  before?: InputMaybe<Scalars['String']['input']>;
  /** Cursor-based pagination: Number of rows to be returned. Use in conjunction with 'after' */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** Cursor-based pagination: Number of rows to be returned. Use in conjunction with 'before' */
  last?: InputMaybe<Scalars['Int']['input']>;
  /** The sorting order of the instances */
  order?: InputMaybe<TeamProfileSortInput>;
  /** Offset-based pagination: Number of rows to skip */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Offset-based pagination: Number of rows to be returned */
  take?: InputMaybe<Scalars['Int']['input']>;
  /** The filter to be applied */
  where?: InputMaybe<TeamProfileFilterInput>;
};

export type TeamProfileSortInput = {
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
};

export type TextConditionInput = {
  aiMode: ConditionAiMode;
  kind: TextConditionKind;
  value: Scalars['String']['input'];
};

export enum TextConditionKind {
  Certificate = 'CERTIFICATE',
  Education = 'EDUCATION',
  Experience = 'EXPERIENCE'
}

export type TextElement = GrowElement & {
  __typename?: 'TextElement';
  content?: Maybe<Scalars['Binary']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<LocalizedText>;
};

/** The filterable fields of type TextElement */
export type TextElementFilterInput = {
  and?: InputMaybe<Array<TextElementFilterInput>>;
  not?: InputMaybe<TextElementFilterInput>;
  or?: InputMaybe<Array<TextElementFilterInput>>;
};

export type TooManyRecordsResult = {
  __typename?: 'TooManyRecordsResult';
  /** The maximum number of records allowed */
  limit?: Maybe<Scalars['Int']['output']>;
};

/** The filterable fields of type TooManyRecordsResult */
export type TooManyRecordsResultFilterInput = {
  and?: InputMaybe<Array<TooManyRecordsResultFilterInput>>;
  not?: InputMaybe<TooManyRecordsResultFilterInput>;
  or?: InputMaybe<Array<TooManyRecordsResultFilterInput>>;
};

/**
 * A person's toplist of one domain: their ranked favourites, shared with all eligible Groups on first creation.
 * The owner can change this per list. A replay replaces the entries and keeps the saved sharing.
 */
export type Toplist = Node & SharableEntity & {
  __typename?: 'Toplist';
  /** Dynamic consent to all current and future eligible Groups, independent of public readership. */
  allGroups?: Maybe<Scalars['Boolean']['output']>;
  domain: FavoriteDomain;
  /** Best first: ten after a finished game, fewer after deleteMyFavorite. */
  entries: Array<Favorite>;
  id: Scalars['ID']['output'];
  /** Public readership, independent of Group recipients. */
  publiclyReadable?: Maybe<Scalars['Boolean']['output']>;
  /** Selected Group recipients; allGroups independently grants dynamic Group readership. */
  sharedWith?: Maybe<Array<ContentSharingRecipient>>;
};

/**
 * One entry of a finished toplist: a catalogue item of the session's domain or a title of the player's own, exactly one
 * of the two. An own title is trimmed and then 1 to 120 characters long without control characters; it stays with the
 * player's favourite and never enters the catalogue.
 */
export type ToplistEntryInput = {
  catalogItemId?: InputMaybe<Scalars['UUID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** The filterable fields of type Toplist */
export type ToplistFilterInput = {
  and?: InputMaybe<Array<ToplistFilterInput>>;
  not?: InputMaybe<ToplistFilterInput>;
  or?: InputMaybe<Array<ToplistFilterInput>>;
};

/** A toplist game session with a saved snapshot for resuming play. */
export type ToplistSession = {
  __typename?: 'ToplistSession';
  session: GameSession;
  /**
   * Client-defined JSON object for resuming this session, or null before any snapshot is saved.
   * Its format is identified by snapshotVersion; the server does not interpret its members.
   */
  snapshot?: Maybe<Scalars['Object']['output']>;
  snapshotVersion?: Maybe<Scalars['Int']['output']>;
};

/** The filterable fields of type ToplistSession */
export type ToplistSessionFilterInput = {
  and?: InputMaybe<Array<ToplistSessionFilterInput>>;
  not?: InputMaybe<ToplistSessionFilterInput>;
  or?: InputMaybe<Array<ToplistSessionFilterInput>>;
};

export type TypingIndicator = {
  __typename?: 'TypingIndicator';
  conversationId: Scalars['UUID']['output'];
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  observedAt: Scalars['DateTime']['output'];
  personId: Scalars['UUID']['output'];
  typing: Scalars['Boolean']['output'];
};

/** The filterable fields of type TypingIndicator */
export type TypingIndicatorFilterInput = {
  and?: InputMaybe<Array<TypingIndicatorFilterInput>>;
  not?: InputMaybe<TypingIndicatorFilterInput>;
  or?: InputMaybe<Array<TypingIndicatorFilterInput>>;
};

export type UuidFilterInput = {
  /** Logical 'and' of one or more predicates */
  and?: InputMaybe<Array<UuidFilterInput>>;
  /** If true, checks if the field has a value, or, if false, checks if the field is missing a value */
  any?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks if the field's value is equal to the given value */
  eq?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks if the field's value is in the list of the given values */
  in?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** Checks if the field's value is not equal to the given value */
  ne?: InputMaybe<Scalars['UUID']['input']>;
  /** Negates the predicate */
  not?: InputMaybe<UuidFilterInput>;
  /** Logical 'or' of one or more predicates */
  or?: InputMaybe<Array<UuidFilterInput>>;
};

/** Unlink a match from a listing, analogous to `UnlinkProjectMatchInput` for projects. */
export type UnlinkListingMatchInput = {
  listingId: Scalars['UUID']['input'];
  matchId: Scalars['UUID']['input'];
};

export type UnlinkListingMatchOutput = UnlinkListingMatchResult;

export type UnlinkListingMatchResult = {
  __typename?: 'UnlinkListingMatchResult';
  listing: Listing;
};

/** The filterable fields of type UnlinkListingMatchResult */
export type UnlinkListingMatchResultFilterInput = {
  and?: InputMaybe<Array<UnlinkListingMatchResultFilterInput>>;
  not?: InputMaybe<UnlinkListingMatchResultFilterInput>;
  or?: InputMaybe<Array<UnlinkListingMatchResultFilterInput>>;
};

export type UnlinkProjectMatchInput = {
  /**
   *   Company context for the write. On a company project, supplying a declaration uses company-admin
   *   authorization and requires an active company. Omitting it uses personal authorization: WRITE on
   *   `plan`, or ownership of a personal project. A declaration naming another company is `GENESIS001259`;
   *   any declaration on a personal project is `GENESIS001260`.
   *
   * Authorization for the chosen route is checked first. Unauthorized callers receive an authorization
   *   error, or `No such entity` for an invisible project, before context or company-status errors.
   */
  actingAsCompanyId?: InputMaybe<Scalars['UUID']['input']>;
  matchId: Scalars['UUID']['input'];
  projectId: Scalars['UUID']['input'];
};

export type UnlinkProjectMatchOutput = UnlinkProjectMatchResult;

export type UnlinkProjectMatchResult = {
  __typename?: 'UnlinkProjectMatchResult';
  project: Project;
};

/** The filterable fields of type UnlinkProjectMatchResult */
export type UnlinkProjectMatchResultFilterInput = {
  and?: InputMaybe<Array<UnlinkProjectMatchResultFilterInput>>;
  not?: InputMaybe<UnlinkProjectMatchResultFilterInput>;
  or?: InputMaybe<Array<UnlinkProjectMatchResultFilterInput>>;
};

export type UnreadChatMessageCount = {
  __typename?: 'UnreadChatMessageCount';
  conversationId?: Maybe<Scalars['UUID']['output']>;
  count: Scalars['Int']['output'];
};

/** The filterable fields of type UnreadChatMessageCount */
export type UnreadChatMessageCountFilterInput = {
  and?: InputMaybe<Array<UnreadChatMessageCountFilterInput>>;
  not?: InputMaybe<UnreadChatMessageCountFilterInput>;
  or?: InputMaybe<Array<UnreadChatMessageCountFilterInput>>;
};

/** Unread notification count for the current user. */
export type UnreadNotificationCount = {
  __typename?: 'UnreadNotificationCount';
  count: Scalars['Int']['output'];
};

/** The filterable fields of type UnreadNotificationCount */
export type UnreadNotificationCountFilterInput = {
  and?: InputMaybe<Array<UnreadNotificationCountFilterInput>>;
  not?: InputMaybe<UnreadNotificationCountFilterInput>;
  or?: InputMaybe<Array<UnreadNotificationCountFilterInput>>;
};

export type UpdateAccessGroupInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

/** Edit a custom Role for every current holder. Existing assignment scopes must remain compatible. */
export type UpdateAccessRoleInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  permissionIds: Array<Scalars['ID']['input']>;
};

export type UpdateAgentDataInput = {
  /** Capability areas described in plain text. */
  covers?: InputMaybe<Array<CreateLocalizedTextDataInput>>;
  guardrails?: InputMaybe<Array<CreateLocalizedTextDataInput>>;
  /** The integration surface as the vendor names it (MCP servers, connectors, plugins). Product tokens. */
  integrations: Array<Scalars['String']['input']>;
  /** The model, when known. */
  model?: InputMaybe<Scalars['String']['input']>;
  /** Product name. Must not be blank. `agents` orders by it unless `order` says otherwise. */
  name: Scalars['String']['input'];
  /** What the agent does. At least one of german / english must be non-blank. */
  role?: InputMaybe<CreateLocalizedTextDataInput>;
  tools?: InputMaybe<Array<CreateAgentToolDataInput>>;
  /** The vendor's product page. */
  url?: InputMaybe<Scalars['String']['input']>;
  /** The vendor's name. Must not be blank. */
  vendor: Scalars['String']['input'];
};

export type UpdateAgentInput = {
  data: UpdateAgentDataInput;
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateAgentOutput = UpdateAgentResult | ValidateAgentResult;

/** The actual data structure of updating an instance of Agent */
export type UpdateAgentResult = {
  __typename?: 'UpdateAgentResult';
  /** The actual data returned for Agent */
  result: Agent;
};

export type UpdateCertificateDataInput = {
  /** Dynamic consent to all current and future eligible Groups, independent of public readership. */
  allGroups?: InputMaybe<Scalars['Boolean']['input']>;
  date?: InputMaybe<CreateDateInstantDataInput>;
  name: Scalars['String']['input'];
  /** Public readership, independent of Group recipients. Company and HR publication rules still apply. */
  publiclyReadable?: InputMaybe<Scalars['Boolean']['input']>;
  /** Group recipients; an empty list grants no ordinary Group readership. */
  sharedWith?: InputMaybe<Array<InputMaybe<ContentSharingRecipientRelationInput>>>;
};

export type UpdateCertificateInput = {
  data: UpdateCertificateDataInput;
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Ignored. Authorization uses the certificate's existing owner; supplying another person does not
   * change ownership or the target of the update. Omit this field in new requests.
   * @deprecated Omit this field. It is ignored; authorization uses the existing owner and ownership cannot be changed here.
   */
  personId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCertificateOutput = UpdateCertificateResult | ValidateCertificateResult;

/** The actual data structure of updating an instance of Certificate */
export type UpdateCertificateResult = {
  __typename?: 'UpdateCertificateResult';
  /** The actual data returned for Certificate */
  result: Certificate;
};

export type UpdateCompanyDataInput = {
  /**
   * Headcount. Available on `company`, `companies` nodes, `MatchCompany.company` and
   * `MatchResultCompany.company`; null on other Company references, even when a headcount is known.
   */
  employeeCount?: InputMaybe<Scalars['Int']['input']>;
  /** Industry. The curated Industry reference entity, shared with Experience. */
  industry?: InputMaybe<IndustryRelationInput>;
  /**
   * Company logo. Available on `company`, `myCompanies`, `companyIdentities`, and `SharedItem.company`
   * when reading a single shared item or its create/update result. Null when no logo exists, and always
   * null on other Company references, including company membership lists and shared-item lists.
   *
   * `profile` accepts "card" (maximum height 140 pixels) or "share_preview" (maximum height 250 pixels);
   * omit it for the original. Content is returned as Base64 through File.content.
   *
   * Uploads accept PNG, JPEG, GIF, BMP, TIFF or WebP, at most 5 MiB. Actual content is checked regardless
   * of the declared MIME type; SVG is rejected. On update, omitting logo preserves it and explicit null
   * removes it.
   */
  logo?: InputMaybe<CreateFileDataInput>;
  /** Company name, non-blank and at most 255 characters after trimming. */
  name: Scalars['String']['input'];
  /**
   * Lifecycle state. New companies are ACTIVE. A company admin can set INACTIVE or reactivate it;
   * see CompanyStatus for the effects. Returned companies have a status, although this field is nullable.
   * Omitting status on update leaves it unchanged. Search and `companies` return only active companies.
   */
  status?: InputMaybe<CompanyStatus>;
  /**
   * Company profile text, up to 20,000 characters. Available on `company` and `companies` nodes;
   * null on all other Company references, even when a summary exists. On those two profile queries,
   * null means no summary is set. The summary is not searchable or filterable.
   */
  summary?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCompanyInput = {
  data: UpdateCompanyDataInput;
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateCompanyOutput = UpdateCompanyResult | ValidateCompanyResult;

/** The actual data structure of updating an instance of Company */
export type UpdateCompanyResult = {
  __typename?: 'UpdateCompanyResult';
  /** The actual data returned for Company */
  result: Company;
};

export type UpdateContractTypeDataInput = {
  localizedDesc?: InputMaybe<CreateLocalizedTextDataInput>;
  localizedName?: InputMaybe<CreateLocalizedTextDataInput>;
};

export type UpdateContractTypeInput = {
  data: UpdateContractTypeDataInput;
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateContractTypeOutput = UpdateContractTypeResult | ValidateContractTypeResult;

/** The actual data structure of updating an instance of ContractType */
export type UpdateContractTypeResult = {
  __typename?: 'UpdateContractTypeResult';
  /** The actual data returned for ContractType */
  result: ContractType;
};

export type UpdateCurriculumVitaeDataInput = {
  apiVersion: Scalars['Int']['input'];
  /**
   * Client-defined JSON object controlling CV presentation for this apiVersion. Returned as supplied;
   * the server does not interpret its members. A supplied update replaces the complete configuration.
   */
  configuration?: InputMaybe<Scalars['Object']['input']>;
  /**
   * Client-defined JSON object containing CV content for this apiVersion. Returned as supplied;
   * the server does not interpret its members. A supplied update replaces the complete content.
   */
  content?: InputMaybe<Scalars['Object']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCurriculumVitaeInput = {
  data: UpdateCurriculumVitaeDataInput;
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateCurriculumVitaeOutput = UpdateCurriculumVitaeResult | ValidateCurriculumVitaeResult;

/** The actual data structure of updating an instance of CurriculumVitae */
export type UpdateCurriculumVitaeResult = {
  __typename?: 'UpdateCurriculumVitaeResult';
  /** The actual data returned for CurriculumVitae */
  result: CurriculumVitae;
};

export type UpdateDegreeDataInput = {
  localizedName?: InputMaybe<CreateLocalizedTextDataInput>;
};

export type UpdateDegreeInput = {
  data: UpdateDegreeDataInput;
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateDegreeOutput = UpdateDegreeResult | ValidateDegreeResult;

/** The actual data structure of updating an instance of Degree */
export type UpdateDegreeResult = {
  __typename?: 'UpdateDegreeResult';
  /** The actual data returned for Degree */
  result: Degree;
};

export type UpdateDiscoveryCategoryDataInput = {
  name?: InputMaybe<CreateLocalizedTextDataInput>;
};

export type UpdateDiscoveryCategoryInput = {
  data: UpdateDiscoveryCategoryDataInput;
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateDiscoveryCategoryOutput = UpdateDiscoveryCategoryResult | ValidateDiscoveryCategoryResult;

/** The actual data structure of updating an instance of DiscoveryCategory */
export type UpdateDiscoveryCategoryResult = {
  __typename?: 'UpdateDiscoveryCategoryResult';
  /** The actual data returned for DiscoveryCategory */
  result: DiscoveryCategory;
};

export type UpdateDocumentDataInput = {
  category?: InputMaybe<DocumentClassifier>;
  group?: InputMaybe<DocumentGroupRelationInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** Public readership, independent of Group recipients. Company and HR publication rules still apply. */
  publiclyReadable?: InputMaybe<Scalars['Boolean']['input']>;
  /** Group recipients; an empty list grants no ordinary Group readership. */
  sharedWith?: InputMaybe<Array<InputMaybe<ContentSharingRecipientRelationInput>>>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateDocumentGroupDataInput = {
  name: Scalars['String']['input'];
};

export type UpdateDocumentGroupInput = {
  data: UpdateDocumentGroupDataInput;
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateDocumentGroupOutput = UpdateDocumentGroupResult | ValidateDocumentGroupResult;

/** The actual data structure of updating an instance of DocumentGroup */
export type UpdateDocumentGroupResult = {
  __typename?: 'UpdateDocumentGroupResult';
  /** The actual data returned for DocumentGroup */
  result: DocumentGroup;
};

export type UpdateDocumentInput = {
  data: UpdateDocumentDataInput;
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Ignored. Authorization uses the document's existing owner; supplying another person does not
   * change ownership or the target of the update. Omit this field in new requests.
   * @deprecated Omit this field. It is ignored; authorization uses the existing owner and ownership cannot be changed here.
   */
  personId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateDocumentOutput = UpdateDocumentResult | ValidateDocumentResult;

/** The actual data structure of updating an instance of Document */
export type UpdateDocumentResult = {
  __typename?: 'UpdateDocumentResult';
  /** The actual data returned for Document */
  result: Document;
};

export type UpdateEducationDataInput = {
  /** Dynamic consent to all current and future eligible Groups, independent of public readership. */
  allGroups?: InputMaybe<Scalars['Boolean']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<CountryRelationInput>;
  degree?: InputMaybe<DegreeRelationInput>;
  endDate?: InputMaybe<CreateDateInstantDataInput>;
  /** The field of study; null when unknown. */
  field?: InputMaybe<Scalars['String']['input']>;
  institution?: InputMaybe<Scalars['String']['input']>;
  /** Public readership, independent of Group recipients. Company and HR publication rules still apply. */
  publiclyReadable?: InputMaybe<Scalars['Boolean']['input']>;
  /** Group recipients; an empty list grants no ordinary Group readership. */
  sharedWith?: InputMaybe<Array<InputMaybe<ContentSharingRecipientRelationInput>>>;
  /** When the education started; null when unknown. */
  startDate?: InputMaybe<CreateDateInstantDataInput>;
};

export type UpdateEducationInput = {
  data: UpdateEducationDataInput;
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  personId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateEducationOutput = UpdateEducationResult | ValidateEducationResult;

/** The actual data structure of updating an instance of Education */
export type UpdateEducationResult = {
  __typename?: 'UpdateEducationResult';
  /** The actual data returned for Education */
  result: Education;
};

export type UpdateExperienceDataInput = {
  activities?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Dynamic consent to all current and future eligible Groups, independent of public readership. */
  allGroups?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Optional classification metadata, independent of proficiency and subject to this entry's sharing rules.
   * The object has integer version 1, entryOrigin (UNKNOWN, MANUAL, DOCUMENT_IMPORT, AI_SUGGESTION,
   * ESCO_SELECTION), and references. Null means no recorded metadata; updates replace the whole object,
   * omission preserves it. Each reference has uri, label, version (ESCO release, e.g. v1.2.1),
   * language (de/en), optional description, source (USER_SELECTED/AUTOMATIC), status (CONFIRMED/PROPOSED),
   * and basedOnText (the entry wording when confirmed). Changing that wording demotes the mapping to
   * PROPOSED; changing only proficiency or sharing preserves it. No competency level is inferred from ESCO.
   * Experience accepts at most five references with http://data.europa.eu/esco/occupation/{UUID} URIs.
   */
  classification?: InputMaybe<Scalars['Object']['input']>;
  country?: InputMaybe<CountryRelationInput>;
  department?: InputMaybe<Scalars['String']['input']>;
  employer?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<CreateDateInstantDataInput>;
  industry?: InputMaybe<IndustryRelationInput>;
  jobTitle: Scalars['String']['input'];
  location?: InputMaybe<Scalars['String']['input']>;
  /** Public readership, independent of Group recipients. Company and HR publication rules still apply. */
  publiclyReadable?: InputMaybe<Scalars['Boolean']['input']>;
  /** Group recipients; an empty list grants no ordinary Group readership. */
  sharedWith?: InputMaybe<Array<InputMaybe<ContentSharingRecipientRelationInput>>>;
  startDate?: InputMaybe<CreateDateInstantDataInput>;
};

export type UpdateExperienceInput = {
  data: UpdateExperienceDataInput;
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Ignored. Authorization uses the experience's existing owner; supplying another person does not
   * change ownership or the target of the update. Omit this field in new requests.
   * @deprecated Omit this field. It is ignored; authorization uses the existing owner and ownership cannot be changed here.
   */
  personId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateExperienceOutput = UpdateExperienceResult | ValidateExperienceResult;

/** The actual data structure of updating an instance of Experience */
export type UpdateExperienceResult = {
  __typename?: 'UpdateExperienceResult';
  /** The actual data returned for Experience */
  result: Experience;
};

export type UpdateExpertiseDataInput = {
  /** Dynamic consent to all current and future eligible Groups, independent of public readership. */
  allGroups?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Optional classification metadata, independent of proficiency and subject to this entry's sharing rules.
   * The object has integer version 1, entryOrigin (UNKNOWN, MANUAL, DOCUMENT_IMPORT, AI_SUGGESTION,
   * ESCO_SELECTION), and references. Null means no recorded metadata; updates replace the whole object,
   * omission preserves it. Each reference has uri, label, version (ESCO release, e.g. v1.2.1),
   * language (de/en), optional description, source (USER_SELECTED/AUTOMATIC), status (CONFIRMED/PROPOSED),
   * and basedOnText (the entry wording when confirmed). Changing that wording demotes the mapping to
   * PROPOSED; changing only proficiency or sharing preserves it. No competency level is inferred from ESCO.
   * Expertise accepts at most one reference with an http://data.europa.eu/esco/skill/{UUID} URI.
   */
  classification?: InputMaybe<Scalars['Object']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  level: Scalars['Int']['input'];
  position: Scalars['Int']['input'];
  /** Public readership, independent of Group recipients. Company and HR publication rules still apply. */
  publiclyReadable?: InputMaybe<Scalars['Boolean']['input']>;
  /** Group recipients; an empty list grants no ordinary Group readership. */
  sharedWith?: InputMaybe<Array<InputMaybe<ContentSharingRecipientRelationInput>>>;
};

export type UpdateExpertiseInput = {
  data: UpdateExpertiseDataInput;
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Ignored. Authorization uses the expertise's existing owner; supplying another person does not
   * change ownership or the target of the update. Omit this field in new requests.
   * @deprecated Omit this field. It is ignored; authorization uses the existing owner and ownership cannot be changed here.
   */
  personId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateExpertiseOutput = UpdateExpertiseResult | ValidateExpertiseResult;

/** The actual data structure of updating an instance of Expertise */
export type UpdateExpertiseResult = {
  __typename?: 'UpdateExpertiseResult';
  /** The actual data returned for Expertise */
  result: Expertise;
};

export type UpdateGenderDataInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  /** Canonical English name, independent of the requested language. Can match extracted values to ids. */
  nameEn?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateGenderInput = {
  data: UpdateGenderDataInput;
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateGenderOutput = UpdateGenderResult | ValidateGenderResult;

/** The actual data structure of updating an instance of Gender */
export type UpdateGenderResult = {
  __typename?: 'UpdateGenderResult';
  /** The actual data returned for Gender */
  result: Gender;
};

export type UpdateIndustryDataInput = {
  localizedName?: InputMaybe<CreateLocalizedTextDataInput>;
};

export type UpdateIndustryInput = {
  data: UpdateIndustryDataInput;
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateIndustryOutput = UpdateIndustryResult | ValidateIndustryResult;

/** The actual data structure of updating an instance of Industry */
export type UpdateIndustryResult = {
  __typename?: 'UpdateIndustryResult';
  /** The actual data returned for Industry */
  result: Industry;
};

export type UpdateJobDepartmentDataInput = {
  localizedName?: InputMaybe<CreateLocalizedTextDataInput>;
};

export type UpdateJobDepartmentInput = {
  data: UpdateJobDepartmentDataInput;
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateJobDepartmentOutput = UpdateJobDepartmentResult | ValidateJobDepartmentResult;

/** The actual data structure of updating an instance of JobDepartment */
export type UpdateJobDepartmentResult = {
  __typename?: 'UpdateJobDepartmentResult';
  /** The actual data returned for JobDepartment */
  result: JobDepartment;
};

export type UpdateJobLocationDataInput = {
  localizedName?: InputMaybe<CreateLocalizedTextDataInput>;
};

export type UpdateJobLocationInput = {
  data: UpdateJobLocationDataInput;
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateJobLocationOutput = UpdateJobLocationResult | ValidateJobLocationResult;

/** The actual data structure of updating an instance of JobLocation */
export type UpdateJobLocationResult = {
  __typename?: 'UpdateJobLocationResult';
  /** The actual data returned for JobLocation */
  result: JobLocation;
};

export type UpdateLanguageSkillDataInput = {
  /** Dynamic consent to all current and future eligible Groups, independent of public readership. */
  allGroups?: InputMaybe<Scalars['Boolean']['input']>;
  cefr?: InputMaybe<CefrScale>;
  /** BCP 47 language tag, for example "en" or "de". */
  languageTag: Scalars['String']['input'];
  nativeSpeaker: Scalars['Boolean']['input'];
  /** Public readership, independent of Group recipients. Company and HR publication rules still apply. */
  publiclyReadable?: InputMaybe<Scalars['Boolean']['input']>;
  selfAssessed?: InputMaybe<Scalars['Boolean']['input']>;
  /** Group recipients; an empty list grants no ordinary Group readership. */
  sharedWith?: InputMaybe<Array<InputMaybe<ContentSharingRecipientRelationInput>>>;
};

export type UpdateLanguageSkillInput = {
  data: UpdateLanguageSkillDataInput;
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  personId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateLanguageSkillOutput = UpdateLanguageSkillResult | ValidateLanguageSkillResult;

/** The actual data structure of updating an instance of LanguageSkill */
export type UpdateLanguageSkillResult = {
  __typename?: 'UpdateLanguageSkillResult';
  /** The actual data returned for LanguageSkill */
  result: LanguageSkill;
};

export type UpdateListingDataInput = {
  /**
   * Complete desired access list. A supplied list replaces existing grants; null or omission preserves them.
   * The creator retains WRITE on every listing area. Visible only to members. Updating this field requires the
   * same access-management capability and delegation checks as `setListingAccess`, independently of WRITE on
   * `plan`. A content editor without management rights is refused and nothing is written. Prefer
   * `setListingAccess`, which additionally rejects stale access revisions; this update field remains for
   * compatibility.
   */
  access?: InputMaybe<Array<CreateListingAccessDataInput>>;
  /** Replace categories. Omission preserves them; an empty list clears them. At most 100 ids. */
  categoryIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /**
   * Versioned JSON planning document containing listing text and requirements, following the same payload
   * model as `Project.data`.
   */
  data?: InputMaybe<Scalars['Object']['input']>;
  /**
   * Deadline after which an OPEN listing behaves as CLOSED; null means no deadline. Visible to all content
   * readers, including group recipients and public readers. Change through `updateListing` with WRITE on
   * `plan`.
   */
  deadline?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  /**
   * Additional images in insertion order, visible like the cover image. `updateListing` appends supplied
   * images; it does not replace existing ones. Remove with `imagesToDelete`. The cover image's format and size
   * limits apply; the number of images is not limited.
   */
  images?: InputMaybe<Array<CreateFileDataInput>>;
  /**
   * Remove additional images by `File.id` on update; ignored on creation. Ids not belonging to the listing are
   * ignored. Remove the cover separately with `mainImage: null`.
   */
  imagesToDelete?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /**
   * Cover image, visible to all permitted content readers including applicants. `profile` selects a resized
   * image (`card` or `share_preview`); omission returns the original. Set on creation or replace through
   * `updateListing` with WRITE on `plan`. Null on update removes it; omission preserves it. Raster images only
   * (PNG, JPEG, GIF, BMP, TIFF, WebP), at most 5 MiB, validated from the bytes rather than the declared MIME
   * type or filename.
   */
  mainImage?: InputMaybe<CreateFileDataInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  /**
   * Whether the listing is publicly readable, independently of group recipients and only while open. Visible
   * only to members.
   */
  publiclyReadable?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Retention period from 1 to 180 days, defaulting to 180 on creation. This is a product limit, not a legal
   * minimum. Visible only to members. Each application counts from its rejection or withdrawal; applications
   * still open at conclusion count from that conclusion. Later changes do not move deletion dates already
   * calculated.
   */
  retentionDays?: InputMaybe<Scalars['Int']['input']>;
  /** Group recipients, who read only while the listing is open. Visible only to members. */
  sharedWith?: InputMaybe<Array<InputMaybe<ContentSharingRecipientRelationInput>>>;
};

export type UpdateListingInput = {
  data: UpdateListingDataInput;
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateListingOutput = UpdateListingResult | ValidateListingResult;

/** The actual data structure of updating an instance of Listing */
export type UpdateListingResult = {
  __typename?: 'UpdateListingResult';
  /** The actual data returned for Listing */
  result: Listing;
};

export type UpdateMaritalStatusDataInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  /** Canonical English name, independent of the requested language. Can match extracted values to ids. */
  nameEn?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateMaritalStatusInput = {
  data: UpdateMaritalStatusDataInput;
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateMaritalStatusOutput = UpdateMaritalStatusResult | ValidateMaritalStatusResult;

/** The actual data structure of updating an instance of MaritalStatus */
export type UpdateMaritalStatusResult = {
  __typename?: 'UpdateMaritalStatusResult';
  /** The actual data returned for MaritalStatus */
  result: MaritalStatus;
};

export type UpdateMatchCandidateDataInput = {
  locked?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateMatchCandidateInput = {
  data: UpdateMatchCandidateDataInput;
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateMatchCandidateOutput = UpdateMatchCandidateResult | ValidateMatchCandidateResult;

/** The actual data structure of updating an instance of MatchCandidate */
export type UpdateMatchCandidateResult = {
  __typename?: 'UpdateMatchCandidateResult';
  /** The actual data returned for MatchCandidate */
  result: MatchCandidate;
};

export type UpdateMatchDataInput = {
  /**
   * Complete replacement of access grants on update. People omitted from a supplied list lose their
   * grants; an empty list revokes all grants. Omitted or null leaves existing grants unchanged.
   */
  access?: InputMaybe<Array<CreateMatchAccessDataInput>>;
  description?: InputMaybe<Scalars['String']['input']>;
  /**
   * Match configuration as a JSON object. On update, a supplied object replaces the design except for
   * attached `project.documents`, which are preserved. Omitted or null leaves the design unchanged.
   * Use the focused setMatch mutations to change individual parts without replacing unrelated data.
   *
   * The current format has `version: 2`. Version 1, including an omitted version, is accepted and
   * upgraded; version-1 power weights from 0–10 become 0–1000. Unsupported versions are rejected.
   * Common members are teamSize, teamCount (integers), teamProfile (id, name, elementWeights keyed by
   * CreativityElement), conditions and companyConditions (lists), aiCopilotText (string), and project
   * (name, shortDescription, description, documents). Document entries contain backdropFileId and name,
   * with optional size in bytes and mimeType. Maintain them through attachProjectDocument and
   * detachProjectDocument.
   *
   * Conditions contain __typename, operator, composition, active and optional requirement (MUST or
   * OPTIONAL). composition contains operator and optional value. Person-condition discriminators are
   * AgeCondition, AnnualSalaryCondition, ChildrenCountCondition, CertificateCondition,
   * CitizenshipCondition, CityCondition, CountryCondition, DriversLicenseCondition, EducationCondition,
   * ExperienceCondition, ExpertiseCondition, GenderCondition, IndustryExperienceCondition,
   * JobDepartmentCondition, JobLocationCondition, LanguageCondition, MaritalCondition and
   * NationalityCondition. Their values describe the corresponding requirement. For validated writes,
   * prefer `setMatchConditions` and its typed inputs. Company-condition discriminators are
   * CompanyIndustryCondition (industryId), CompanyEmployeeCountCondition (minimumEmployees), and
   * CompanyExpertiseCondition (expertise, aiMode); use `setMatchCompanyConditions` to replace them.
   *
   * AI options include agenticAiSupported (boolean), candidateAssessmentPrompt (string),
   * candidateAssessmentDetail (BULLETS, SENTENCES, LONG_TEXT), candidateAssessmentStrictness
   * (NORMAL, STRICT, EXTREME), candidateAssessmentOutcomeFocus (OPPORTUNITIES, BALANCED, RISKS), and
   * requirementLeniency (LENIENT, MUST_STRICT, STRICT). powerScoreLens is COMBINED (default),
   * SELF_ASSESSMENT or SMART_ANALYSIS. missingPowerScore is ZERO (default) or NEUTRAL, which uses 50
   * for an unmeasured power. Preserve members not being edited.
   *
   * Example: {"version":2,"teamSize":3,"teamCount":1,"conditions":[],"project":{"name":"Example project"}}.
   */
  design?: InputMaybe<Scalars['Object']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  sharedItem?: InputMaybe<SharedItemRelationInput>;
};

export type UpdateMatchInput = {
  data: UpdateMatchDataInput;
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateMatchOutput = UpdateMatchResult | ValidateMatchResult;

/** The actual data structure of updating an instance of Match */
export type UpdateMatchResult = {
  __typename?: 'UpdateMatchResult';
  /** The actual data returned for Match */
  result: Match;
};

export type UpdateMatchResultDataInput = {
  /**
   * Presentation section identifiers associated with this result, shared by all its readers. An empty
   * list means no sections are hidden. Reads return an empty list rather than null. Identifiers are
   * opaque strings, returned unchanged and not validated against a fixed vocabulary.
   */
  hiddenSections?: InputMaybe<Array<Scalars['String']['input']>>;
  /**
   * Whether this result is saved. False denotes a draft visible only to its creator; set true to save
   * it and make it available to the match's authorized readers. Saved results cannot be changed back to
   * drafts. Later runs can replace drafts. Filter by true when requesting saved history.
   */
  kept?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  teams?: InputMaybe<Array<CreateMatchResultTeamDataInput>>;
};

export type UpdateMatchResultInput = {
  data: UpdateMatchResultDataInput;
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateMatchResultOutput = UpdateMatchResultResult | ValidateMatchResultResult;

/** The actual data structure of updating an instance of MatchResult */
export type UpdateMatchResultResult = {
  __typename?: 'UpdateMatchResultResult';
  /** The actual data returned for MatchResult */
  result: MatchResult;
};

export type UpdateOrgUnitDataInput = {
  /**
   * Whether the unit is retired. Hidden units are excluded from `orgUnits` and cannot receive new
   * assignments. A unit with children or assigned people cannot be deleted; retire it instead.
   */
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  localizedName?: InputMaybe<CreateLocalizedTextDataInput>;
  /** The parent unit, or null for a root. Setting a parent that would form a cycle is refused. */
  parent?: InputMaybe<OrgUnitRelationInput>;
};

export type UpdateOrgUnitInput = {
  data: UpdateOrgUnitDataInput;
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateOrgUnitOutput = UpdateOrgUnitResult | ValidateOrgUnitResult;

/** The actual data structure of updating an instance of OrgUnit */
export type UpdateOrgUnitResult = {
  __typename?: 'UpdateOrgUnitResult';
  /** The actual data returned for OrgUnit */
  result: OrgUnit;
};

export type UpdateOrganizationalRecordEntryInput = {
  content: Scalars['String']['input'];
  kind: OrganizationalRecordEntryKind;
  /** Omitted/null preserves references; [] removes them. Saved atomically with the content. */
  links?: InputMaybe<Array<OrganizationalRecordLinkTargetInput>>;
  title: Scalars['String']['input'];
};

export type UpdatePersonDataInput = {
  administrativeGender?: InputMaybe<AdministrativeGender>;
  alternativeAvatar?: InputMaybe<CreateFileDataInput>;
  apartment?: InputMaybe<Scalars['String']['input']>;
  avatar?: InputMaybe<CreateFileDataInput>;
  bio?: InputMaybe<Scalars['String']['input']>;
  birthDate?: InputMaybe<Scalars['Date']['input']>;
  childCount?: InputMaybe<Scalars['Int']['input']>;
  citizenships?: InputMaybe<Array<InputMaybe<CountryRelationInput>>>;
  city?: InputMaybe<Scalars['String']['input']>;
  contractType?: InputMaybe<ContractTypeRelationInput>;
  country?: InputMaybe<CountryRelationInput>;
  countryState?: InputMaybe<CountryStateRelationInput>;
  currentActivity?: InputMaybe<Scalars['String']['input']>;
  currentEmployer?: InputMaybe<Scalars['String']['input']>;
  currentTasks?: InputMaybe<Scalars['String']['input']>;
  deceased?: InputMaybe<CreateDeceasedDataInput>;
  drivingLicence?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<GenderRelationInput>;
  houseNumber?: InputMaybe<Scalars['String']['input']>;
  jobDepartment?: InputMaybe<JobDepartmentRelationInput>;
  jobLocation?: InputMaybe<JobLocationRelationInput>;
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  maritalStatus?: InputMaybe<MaritalStatusRelationInput>;
  miscellaneous?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<CreateHumanNameDataInput>;
  nationality?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  profession?: InputMaybe<Scalars['String']['input']>;
  pronouns?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
  workingTimeModel?: InputMaybe<WorkingTimeModelRelationInput>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePersonGroupDataInput = {
  name: Scalars['String']['input'];
};

export type UpdatePersonGroupInput = {
  data: UpdatePersonGroupDataInput;
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdatePersonGroupOutput = UpdatePersonGroupResult | ValidatePersonGroupResult;

/** The actual data structure of updating an instance of PersonGroup */
export type UpdatePersonGroupResult = {
  __typename?: 'UpdatePersonGroupResult';
  /** The actual data returned for PersonGroup */
  result: PersonGroup;
};

/** Profile edits and owner consent commit atomically. Omitted consent leaves saved sharing unchanged. */
export type UpdatePersonInput = {
  data: UpdatePersonDataInput;
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  /** Owner-only Group selections. Omitted attributes preserve their saved recipients. */
  personalSharing?: InputMaybe<CreatePersonSharedAttributesDataInput>;
};

export type UpdatePersonOutput = UpdatePersonResult | ValidatePersonResult;

/** The actual data structure of updating an instance of Person */
export type UpdatePersonResult = {
  __typename?: 'UpdatePersonResult';
  /** The actual data returned for Person */
  result: Person;
};

export type UpdatePinGroupDataInput = {
  name: Scalars['String']['input'];
};

export type UpdatePinGroupInput = {
  data: UpdatePinGroupDataInput;
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdatePinGroupOutput = UpdatePinGroupResult | ValidatePinGroupResult;

/** The actual data structure of updating an instance of PinGroup */
export type UpdatePinGroupResult = {
  __typename?: 'UpdatePinGroupResult';
  /** The actual data returned for PinGroup */
  result: PinGroup;
};

export type UpdateProjectDataInput = {
  /**
   * Complete replacement of project access grants on update. Omitted or null preserves them; an empty
   * list removes them. A personal project's creator always retains WRITE on all surfaces and supplied
   * entries for that creator are ignored. A company project's creator has no such protected grant.
   */
  access?: InputMaybe<Array<CreateProjectAccessDataInput>>;
  /**
   * Planning data as a JSON object. Updates merge top-level keys; supplied values replace complete
   * nested objects or lists, and omitted keys remain unchanged. Null or an empty object leaves existing
   * keys unchanged. Explicit null values inside the object are retained. New objects default to
   * `version: 1` when version is omitted.
   *
   * Common members are `anlass` and `status` (strings), `sections` (string list), `packages` and `events`
   * (lists), `requirements` (object), and `documentStorageIds` (UUID string list). Packages contain
   * id, name, start, end and tasks; tasks contain id, title, assigneeId, start and end. Events contain
   * id, title, date and kind. Dates use YYYY-MM-DD. Requirements can contain expertise entries
   * (id, description, level, requirement, personCount) and elementWeights keyed by CreativityElement.
   * Expertise level uses 1–7, or 0 for no minimum; requirement is MUST or OPTIONAL. Power weights use
   * 0–1000. Additional client-defined members are retained. Links in this object are not validated as
   * relationships; use `linkProjectMatch` for match relationships.
   *
   * Example: {"version":1,"packages":[],"events":[],"requirements":{"expertise":[],"elementWeights":{}}}.
   */
  data?: InputMaybe<Scalars['Object']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Update a project. */
export type UpdateProjectInput = {
  /**
   *   Company context for the write. On a company project, supplying a declaration uses company-admin
   *   authorization and requires an active company. Omitting it uses personal authorization: WRITE on
   *   `plan`, or ownership of a personal project. A declaration naming another company is `GENESIS001259`;
   *   any declaration on a personal project is `GENESIS001260`.
   *
   * Authorization for the chosen route is checked first. Unauthorized callers receive an authorization
   *   error, or `No such entity` for an invisible project, before context or company-status errors.
   */
  actingAsCompanyId?: InputMaybe<Scalars['UUID']['input']>;
  data: UpdateProjectDataInput;
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateProjectOutput = UpdateProjectResult | ValidateProjectResult;

/** The actual data structure of updating an instance of Project */
export type UpdateProjectResult = {
  __typename?: 'UpdateProjectResult';
  /** The actual data returned for Project */
  result: Project;
};

export type UpdateSharedItemCommentDataInput = {
  content?: InputMaybe<Scalars['String']['input']>;
};

/** Update a shared item comment. */
export type UpdateSharedItemCommentInput = {
  /**
   *   Required for a company-owned comment and must identify that company; omitted or mismatched values
   *   are rejected with `GENESIS001259`. Omit for a personal comment; a declaration there is rejected with
   *   `GENESIS001260`. This declaration does not grant permission to update the comment.
   *
   * Authorization is checked first: company content requires current company admin membership;
   *   personal content requires authorship or `write:person`. An unknown comment, or one on an item the caller cannot see, is
   *   reported as `No such entity`. Other unauthorized callers receive an authorization error before
   *   context or company-status errors.
   */
  actingAsCompanyId?: InputMaybe<Scalars['UUID']['input']>;
  data: UpdateSharedItemCommentDataInput;
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateSharedItemCommentOutput = UpdateSharedItemCommentResult | ValidateSharedItemCommentResult;

/** The actual data structure of updating an instance of SharedItemComment */
export type UpdateSharedItemCommentResult = {
  __typename?: 'UpdateSharedItemCommentResult';
  /** The actual data returned for SharedItemComment */
  result: SharedItemComment;
};

export type UpdateSharedItemDataInput = {
  /** Replace classification IDs; omitted preserves them, an empty list clears them. PROJECT items only. */
  categoryIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  darkMode?: InputMaybe<CreateColorsDataInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  files?: InputMaybe<Array<CreateFileDataInput>>;
  filesToDelete?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  images?: InputMaybe<Array<CreateFileDataInput>>;
  imagesToDelete?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  lightMode?: InputMaybe<CreateColorsDataInput>;
  mainImage?: InputMaybe<CreateFileDataInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** Public readership, independent of Group recipients. Company and HR publication rules still apply. */
  publiclyReadable?: InputMaybe<Scalars['Boolean']['input']>;
  /** Group recipients; an empty list grants no ordinary Group readership. */
  sharedWith?: InputMaybe<Array<InputMaybe<ContentSharingRecipientRelationInput>>>;
  shortDescription?: InputMaybe<Scalars['String']['input']>;
};

/** Update a shared item. */
export type UpdateSharedItemInput = {
  /**
   *   Required for a company-owned item and must identify that company; omitted or mismatched values
   *   are rejected with `GENESIS001259`. Omit for a personal item; a declaration there is rejected with
   *   `GENESIS001260`. This declaration does not grant permission to update the item.
   *
   * Authorization is checked first: company content requires current company admin membership;
   *   personal content requires authorship or `write:person`. An unknown item is
   *   reported as `No such entity`. Other unauthorized callers receive an authorization error before
   *   context or company-status errors.
   */
  actingAsCompanyId?: InputMaybe<Scalars['UUID']['input']>;
  data: UpdateSharedItemDataInput;
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateSharedItemOutput = UpdateSharedItemResult | ValidateSharedItemResult;

/** The actual data structure of updating an instance of SharedItem */
export type UpdateSharedItemResult = {
  __typename?: 'UpdateSharedItemResult';
  /** The actual data returned for SharedItem */
  result: SharedItem;
};

export type UpdateStudioNotebookDataInput = {
  /** Complete notebook text in Markdown. */
  content?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateStudioNotebookInput = {
  data: UpdateStudioNotebookDataInput;
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateStudioNotebookOutput = UpdateStudioNotebookResult | ValidateStudioNotebookResult;

/** The actual data structure of updating an instance of StudioNotebook */
export type UpdateStudioNotebookResult = {
  __typename?: 'UpdateStudioNotebookResult';
  /** The actual data returned for StudioNotebook */
  result: StudioNotebook;
};

export type UpdateTeamProfileDataInput = {
  localizedName?: InputMaybe<CreateLocalizedTextDataInput>;
  weights?: InputMaybe<Array<CreateElementWeightDataInput>>;
};

export type UpdateTeamProfileInput = {
  data: UpdateTeamProfileDataInput;
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateTeamProfileOutput = UpdateTeamProfileResult | ValidateTeamProfileResult;

/** The actual data structure of updating an instance of TeamProfile */
export type UpdateTeamProfileResult = {
  __typename?: 'UpdateTeamProfileResult';
  /** The actual data returned for TeamProfile */
  result: TeamProfile;
};

export type UpdateWorkingTimeModelDataInput = {
  localizedDesc?: InputMaybe<CreateLocalizedTextDataInput>;
  localizedName?: InputMaybe<CreateLocalizedTextDataInput>;
};

export type UpdateWorkingTimeModelInput = {
  data: UpdateWorkingTimeModelDataInput;
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateWorkingTimeModelOutput = UpdateWorkingTimeModelResult | ValidateWorkingTimeModelResult;

/** The actual data structure of updating an instance of WorkingTimeModel */
export type UpdateWorkingTimeModelResult = {
  __typename?: 'UpdateWorkingTimeModelResult';
  /** The actual data returned for WorkingTimeModel */
  result: WorkingTimeModel;
};

export type UsedDocumentTagsInput = {
  max?: InputMaybe<Scalars['Int']['input']>;
};

export type UsedDocumentTagsOutput = UsedDocumentTagsResult;

export type UsedDocumentTagsResult = {
  __typename?: 'UsedDocumentTagsResult';
  tags: Array<Scalars['String']['output']>;
};

/** The filterable fields of type UsedDocumentTagsResult */
export type UsedDocumentTagsResultFilterInput = {
  and?: InputMaybe<Array<UsedDocumentTagsResultFilterInput>>;
  not?: InputMaybe<UsedDocumentTagsResultFilterInput>;
  or?: InputMaybe<Array<UsedDocumentTagsResultFilterInput>>;
};

export enum UserRank {
  Rank1 = 'RANK1',
  Rank2 = 'RANK2',
  Rank3 = 'RANK3',
  Rank4 = 'RANK4',
  Rank5 = 'RANK5',
  Rank6 = 'RANK6',
  Rank7 = 'RANK7',
  Rank8 = 'RANK8'
}

export type ValidateAgentIssue = ValidationIssue & {
  __typename?: 'ValidateAgentIssue';
  error: ValidationError;
  field: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type ValidateAgentResult = ValidationIssues & {
  __typename?: 'ValidateAgentResult';
  issues: Array<ValidationIssue>;
};

export type ValidateCertificateIssue = ValidationIssue & {
  __typename?: 'ValidateCertificateIssue';
  error: ValidationError;
  field: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type ValidateCertificateResult = ValidationIssues & {
  __typename?: 'ValidateCertificateResult';
  issues: Array<ValidationIssue>;
};

export type ValidateCompanyIssue = ValidationIssue & {
  __typename?: 'ValidateCompanyIssue';
  error: ValidationError;
  field: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type ValidateCompanyResult = ValidationIssues & {
  __typename?: 'ValidateCompanyResult';
  issues: Array<ValidationIssue>;
};

export type ValidateContractTypeIssue = ValidationIssue & {
  __typename?: 'ValidateContractTypeIssue';
  error: ValidationError;
  field: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type ValidateContractTypeResult = ValidationIssues & {
  __typename?: 'ValidateContractTypeResult';
  issues: Array<ValidationIssue>;
};

export type ValidateCurriculumVitaeIssue = ValidationIssue & {
  __typename?: 'ValidateCurriculumVitaeIssue';
  error: ValidationError;
  field: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type ValidateCurriculumVitaeResult = ValidationIssues & {
  __typename?: 'ValidateCurriculumVitaeResult';
  issues: Array<ValidationIssue>;
};

export type ValidateDegreeIssue = ValidationIssue & {
  __typename?: 'ValidateDegreeIssue';
  error: ValidationError;
  field: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type ValidateDegreeResult = ValidationIssues & {
  __typename?: 'ValidateDegreeResult';
  issues: Array<ValidationIssue>;
};

export type ValidateDiscoveryCategoryIssue = ValidationIssue & {
  __typename?: 'ValidateDiscoveryCategoryIssue';
  error: ValidationError;
  field: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type ValidateDiscoveryCategoryResult = ValidationIssues & {
  __typename?: 'ValidateDiscoveryCategoryResult';
  issues: Array<ValidationIssue>;
};

export type ValidateDocumentGroupIssue = ValidationIssue & {
  __typename?: 'ValidateDocumentGroupIssue';
  error: ValidationError;
  field: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type ValidateDocumentGroupResult = ValidationIssues & {
  __typename?: 'ValidateDocumentGroupResult';
  issues: Array<ValidationIssue>;
};

export type ValidateDocumentIssue = ValidationIssue & {
  __typename?: 'ValidateDocumentIssue';
  error: ValidationError;
  field: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type ValidateDocumentResult = ValidationIssues & {
  __typename?: 'ValidateDocumentResult';
  issues: Array<ValidationIssue>;
};

export type ValidateEducationIssue = ValidationIssue & {
  __typename?: 'ValidateEducationIssue';
  error: ValidationError;
  field: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type ValidateEducationResult = ValidationIssues & {
  __typename?: 'ValidateEducationResult';
  issues: Array<ValidationIssue>;
};

export type ValidateExperienceIssue = ValidationIssue & {
  __typename?: 'ValidateExperienceIssue';
  error: ValidationError;
  field: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type ValidateExperienceResult = ValidationIssues & {
  __typename?: 'ValidateExperienceResult';
  issues: Array<ValidationIssue>;
};

export type ValidateExpertiseIssue = ValidationIssue & {
  __typename?: 'ValidateExpertiseIssue';
  error: ValidationError;
  field: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type ValidateExpertiseResult = ValidationIssues & {
  __typename?: 'ValidateExpertiseResult';
  issues: Array<ValidationIssue>;
};

export type ValidateGenderIssue = ValidationIssue & {
  __typename?: 'ValidateGenderIssue';
  error: ValidationError;
  field: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type ValidateGenderResult = ValidationIssues & {
  __typename?: 'ValidateGenderResult';
  issues: Array<ValidationIssue>;
};

export type ValidateIndustryIssue = ValidationIssue & {
  __typename?: 'ValidateIndustryIssue';
  error: ValidationError;
  field: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type ValidateIndustryResult = ValidationIssues & {
  __typename?: 'ValidateIndustryResult';
  issues: Array<ValidationIssue>;
};

export type ValidateJobDepartmentIssue = ValidationIssue & {
  __typename?: 'ValidateJobDepartmentIssue';
  error: ValidationError;
  field: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type ValidateJobDepartmentResult = ValidationIssues & {
  __typename?: 'ValidateJobDepartmentResult';
  issues: Array<ValidationIssue>;
};

export type ValidateJobLocationIssue = ValidationIssue & {
  __typename?: 'ValidateJobLocationIssue';
  error: ValidationError;
  field: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type ValidateJobLocationResult = ValidationIssues & {
  __typename?: 'ValidateJobLocationResult';
  issues: Array<ValidationIssue>;
};

export type ValidateLanguageSkillIssue = ValidationIssue & {
  __typename?: 'ValidateLanguageSkillIssue';
  error: ValidationError;
  field: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type ValidateLanguageSkillResult = ValidationIssues & {
  __typename?: 'ValidateLanguageSkillResult';
  issues: Array<ValidationIssue>;
};

export type ValidateListingIssue = ValidationIssue & {
  __typename?: 'ValidateListingIssue';
  error: ValidationError;
  field: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type ValidateListingResult = ValidationIssues & {
  __typename?: 'ValidateListingResult';
  issues: Array<ValidationIssue>;
};

export type ValidateMaritalStatusIssue = ValidationIssue & {
  __typename?: 'ValidateMaritalStatusIssue';
  error: ValidationError;
  field: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type ValidateMaritalStatusResult = ValidationIssues & {
  __typename?: 'ValidateMaritalStatusResult';
  issues: Array<ValidationIssue>;
};

export type ValidateMatchCandidateIssue = ValidationIssue & {
  __typename?: 'ValidateMatchCandidateIssue';
  error: ValidationError;
  field: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type ValidateMatchCandidateResult = ValidationIssues & {
  __typename?: 'ValidateMatchCandidateResult';
  issues: Array<ValidationIssue>;
};

export type ValidateMatchCompanyIssue = ValidationIssue & {
  __typename?: 'ValidateMatchCompanyIssue';
  error: ValidationError;
  field: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type ValidateMatchCompanyResult = ValidationIssues & {
  __typename?: 'ValidateMatchCompanyResult';
  issues: Array<ValidationIssue>;
};

export type ValidateMatchIssue = ValidationIssue & {
  __typename?: 'ValidateMatchIssue';
  error: ValidationError;
  field: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type ValidateMatchResult = ValidationIssues & {
  __typename?: 'ValidateMatchResult';
  issues: Array<ValidationIssue>;
};

export type ValidateMatchResultIssue = ValidationIssue & {
  __typename?: 'ValidateMatchResultIssue';
  error: ValidationError;
  field: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type ValidateMatchResultResult = ValidationIssues & {
  __typename?: 'ValidateMatchResultResult';
  issues: Array<ValidationIssue>;
};

export type ValidateOrgUnitIssue = ValidationIssue & {
  __typename?: 'ValidateOrgUnitIssue';
  error: ValidationError;
  field: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type ValidateOrgUnitResult = ValidationIssues & {
  __typename?: 'ValidateOrgUnitResult';
  issues: Array<ValidationIssue>;
};

export type ValidatePersonGroupIssue = ValidationIssue & {
  __typename?: 'ValidatePersonGroupIssue';
  error: ValidationError;
  field: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type ValidatePersonGroupResult = ValidationIssues & {
  __typename?: 'ValidatePersonGroupResult';
  issues: Array<ValidationIssue>;
};

export type ValidatePersonIssue = ValidationIssue & {
  __typename?: 'ValidatePersonIssue';
  error: ValidationError;
  field: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type ValidatePersonResult = ValidationIssues & {
  __typename?: 'ValidatePersonResult';
  issues: Array<ValidationIssue>;
};

export type ValidatePinGroupIssue = ValidationIssue & {
  __typename?: 'ValidatePinGroupIssue';
  error: ValidationError;
  field: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type ValidatePinGroupResult = ValidationIssues & {
  __typename?: 'ValidatePinGroupResult';
  issues: Array<ValidationIssue>;
};

export type ValidateProjectIssue = ValidationIssue & {
  __typename?: 'ValidateProjectIssue';
  error: ValidationError;
  field: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type ValidateProjectResult = ValidationIssues & {
  __typename?: 'ValidateProjectResult';
  issues: Array<ValidationIssue>;
};

/**
 * Validation issue shape for a questionnaire group. Invalid saves currently return GraphQL errors
 * rather than this result.
 */
export type ValidateQuestionnaireGroupIssue = ValidationIssue & {
  __typename?: 'ValidateQuestionnaireGroupIssue';
  error: ValidationError;
  field: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

/** The filterable fields of type ValidateQuestionnaireGroupIssue */
export type ValidateQuestionnaireGroupIssueFilterInput = {
  and?: InputMaybe<Array<ValidateQuestionnaireGroupIssueFilterInput>>;
  not?: InputMaybe<ValidateQuestionnaireGroupIssueFilterInput>;
  or?: InputMaybe<Array<ValidateQuestionnaireGroupIssueFilterInput>>;
};

export type ValidateQuestionnaireGroupResult = ValidationIssues & {
  __typename?: 'ValidateQuestionnaireGroupResult';
  issues: Array<ValidationIssue>;
};

/** The filterable fields of type ValidateQuestionnaireGroupResult */
export type ValidateQuestionnaireGroupResultFilterInput = {
  and?: InputMaybe<Array<ValidateQuestionnaireGroupResultFilterInput>>;
  not?: InputMaybe<ValidateQuestionnaireGroupResultFilterInput>;
  or?: InputMaybe<Array<ValidateQuestionnaireGroupResultFilterInput>>;
};

export type ValidateSharedItemCommentIssue = ValidationIssue & {
  __typename?: 'ValidateSharedItemCommentIssue';
  error: ValidationError;
  field: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type ValidateSharedItemCommentResult = ValidationIssues & {
  __typename?: 'ValidateSharedItemCommentResult';
  issues: Array<ValidationIssue>;
};

export type ValidateSharedItemIssue = ValidationIssue & {
  __typename?: 'ValidateSharedItemIssue';
  error: ValidationError;
  field: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type ValidateSharedItemResult = ValidationIssues & {
  __typename?: 'ValidateSharedItemResult';
  issues: Array<ValidationIssue>;
};

export type ValidateStudioNotebookIssue = ValidationIssue & {
  __typename?: 'ValidateStudioNotebookIssue';
  error: ValidationError;
  field: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type ValidateStudioNotebookResult = ValidationIssues & {
  __typename?: 'ValidateStudioNotebookResult';
  issues: Array<ValidationIssue>;
};

export type ValidateTeamProfileIssue = ValidationIssue & {
  __typename?: 'ValidateTeamProfileIssue';
  error: ValidationError;
  field: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type ValidateTeamProfileResult = ValidationIssues & {
  __typename?: 'ValidateTeamProfileResult';
  issues: Array<ValidationIssue>;
};

export type ValidateWorkingTimeModelIssue = ValidationIssue & {
  __typename?: 'ValidateWorkingTimeModelIssue';
  error: ValidationError;
  field: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type ValidateWorkingTimeModelResult = ValidationIssues & {
  __typename?: 'ValidateWorkingTimeModelResult';
  issues: Array<ValidationIssue>;
};

/** Technical description of the validation error. */
export enum ValidationError {
  /** The value of the field is supposed to be unique but it is already used elsewhere */
  AlreadyExists = 'ALREADY_EXISTS',
  /** The value of the field does not match the expected format (eg. invalid email address or URL) */
  FormatError = 'FORMAT_ERROR',
  /** The field is mandatory but either an empty value or no value was provided */
  IsMandatory = 'IS_MANDATORY',
  /** Other errors. Human-readable details can be found the message field. */
  Other = 'OTHER'
}

/** Describes an error condition that occurred during input validation */
export type ValidationIssue = {
  /** A technical description of the error */
  error?: Maybe<ValidationError>;
  /** The name of the field that caused the error */
  field?: Maybe<Scalars['String']['output']>;
  /** A human-readable description of the error. The language of the text might depend on the HTTP 'Accept-Language' header */
  message?: Maybe<Scalars['String']['output']>;
};

/** Collection of validation errors occurred during input validation */
export type ValidationIssues = {
  /** List of validation errors */
  issues: Array<ValidationIssue>;
};

export type VideoElement = GrowElement & PlayableGrowElement & {
  __typename?: 'VideoElement';
  lengthMilliseconds?: Maybe<Scalars['Int']['output']>;
  manifest: Scalars['String']['output'];
  mimeType: Scalars['String']['output'];
  order?: Maybe<Scalars['Int']['output']>;
  thumbnail?: Maybe<Scalars['Binary']['output']>;
  title: LocalizedText;
};

/** The filterable fields of type VideoElement */
export type VideoElementFilterInput = {
  and?: InputMaybe<Array<VideoElementFilterInput>>;
  not?: InputMaybe<VideoElementFilterInput>;
  or?: InputMaybe<Array<VideoElementFilterInput>>;
};

export type ViewSharedItemInput = {
  person?: InputMaybe<Scalars['UUID']['input']>;
  sharedItemId: Scalars['UUID']['input'];
  viewed?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ViewSharedItemOutput = ViewSharedItemResult;

export type ViewSharedItemResult = {
  __typename?: 'ViewSharedItemResult';
  sharedItemId?: Maybe<Scalars['UUID']['output']>;
};

/** The filterable fields of type ViewSharedItemResult */
export type ViewSharedItemResultFilterInput = {
  and?: InputMaybe<Array<ViewSharedItemResultFilterInput>>;
  not?: InputMaybe<ViewSharedItemResultFilterInput>;
  or?: InputMaybe<Array<ViewSharedItemResultFilterInput>>;
};

export type ViewUserProfileInput = {
  userProfileId: Scalars['UUID']['input'];
};

export type ViewUserProfileOutput = ViewUserProfileResult;

export type ViewUserProfileResult = {
  __typename?: 'ViewUserProfileResult';
  userProfileId?: Maybe<Scalars['UUID']['output']>;
};

/** The filterable fields of type ViewUserProfileResult */
export type ViewUserProfileResultFilterInput = {
  and?: InputMaybe<Array<ViewUserProfileResultFilterInput>>;
  not?: InputMaybe<ViewUserProfileResultFilterInput>;
  or?: InputMaybe<Array<ViewUserProfileResultFilterInput>>;
};

export type WithdrawListingApplicationInput = {
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['UUID']['input'];
};

export type WithdrawListingApplicationOutput = WithdrawListingApplicationResult;

export type WithdrawListingApplicationResult = {
  __typename?: 'WithdrawListingApplicationResult';
  application: ListingApplication;
};

/** The filterable fields of type WithdrawListingApplicationResult */
export type WithdrawListingApplicationResultFilterInput = {
  and?: InputMaybe<Array<WithdrawListingApplicationResultFilterInput>>;
  not?: InputMaybe<WithdrawListingApplicationResultFilterInput>;
  or?: InputMaybe<Array<WithdrawListingApplicationResultFilterInput>>;
};

export type WorkingTimeModel = Node & {
  __typename?: 'WorkingTimeModel';
  desc?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  localizedDesc?: Maybe<LocalizedText>;
  localizedName?: Maybe<LocalizedText>;
  name?: Maybe<Scalars['String']['output']>;
};

/** The filterable fields of type WorkingTimeModel */
export type WorkingTimeModelFilterInput = {
  and?: InputMaybe<Array<WorkingTimeModelFilterInput>>;
  desc?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<WorkingTimeModelFilterInput>;
  or?: InputMaybe<Array<WorkingTimeModelFilterInput>>;
};

/** Contains information for linking 'WorkingTimeModel' to other entities */
export type WorkingTimeModelRelationInput = {
  /** The identifier of 'WorkingTimeModel' */
  id: Scalars['ID']['input'];
};

export type WorkingTimeModelSortInput = {
  desc?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
};

export type WorkingTimeModelsResult = {
  __typename?: 'WorkingTimeModelsResult';
  workingTimeModels: Array<WorkingTimeModel>;
};

/** The filterable fields of type WorkingTimeModelsResult */
export type WorkingTimeModelsResultFilterInput = {
  and?: InputMaybe<Array<WorkingTimeModelsResultFilterInput>>;
  not?: InputMaybe<WorkingTimeModelsResultFilterInput>;
  or?: InputMaybe<Array<WorkingTimeModelsResultFilterInput>>;
};
